/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Interpals REST API
 * REST API
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import url from "url";
import portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

var BASE_PATH;
try {
    // @ts-ignore
    BASE_PATH = API_BASE_PATH;
} catch (e) {
    // Create React App passes any REACT_APP_* env variables directly into process.env
    BASE_PATH = process.env.REACT_APP_API_BASE_PATH;
}
if (BASE_PATH === undefined || BASE_PATH === '') {
    BASE_PATH = 'https://api.interpals.net/v1'
}
BASE_PATH = BASE_PATH.replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccountActivityEntity
 */
export interface AccountActivityEntity {
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    user_id?: string;
    /**
     * legacy|api
     * @type {string}
     * @memberof AccountActivityEntity
     */
    type?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountActivityEntity
     */
    login_ts?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    ip?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    ip_country_iso2?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    session_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    token_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountActivityEntity
     */
    last_activity?: Date;
    /**
     * 
     * @type {UserAgentEntity}
     * @memberof AccountActivityEntity
     */
    user_agent?: UserAgentEntity;
    /**
     * 
     * @type {string}
     * @memberof AccountActivityEntity
     */
    client_type?: AccountActivityEntityClientTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AccountActivityEntity
     */
    is_current_session?: boolean;
}

export type AccountActivityEntityClientTypeEnum = 'desktop_web' | 'mobile_web' | 'mobile_app';

/**
 * 
 * @export
 * @interface AccountEntity
 */
export interface AccountEntity {
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    id: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    name: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    birthday: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    username: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {number}
     * @memberof AccountEntity
     */
    age: number;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    country_code: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    home_country_code?: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    online: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Date}
     * @memberof AccountEntity
     */
    last_login: Date;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    sex: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {PhotoEntity}
     * @memberof AccountEntity
     */
    avatar: PhotoEntity;
    /**
     * extra:location
     * @type {LocationEntity}
     * @memberof AccountEntity
     */
    location: LocationEntity;
    /**
     * Content approval status
     * @type {string}
     * @memberof AccountEntity
     */
    mod_status?: AccountEntityModStatusEnum;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof AccountEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Array<LanguageEntity>}
     * @memberof AccountEntity
     */
    know: Array<LanguageEntity>;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Array<LanguageEntity>}
     * @memberof AccountEntity
     */
    learn: Array<LanguageEntity>;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {number}
     * @memberof AccountEntity
     */
    mutual_friends_count?: number;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    status?: AccountEntityStatusEnum;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Date}
     * @memberof AccountEntity
     */
    created: Date;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Date}
     * @memberof AccountEntity
     */
    updated: Date;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    tz: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    is_premium: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {ProfileAboutEntity}
     * @memberof AccountEntity
     */
    about: ProfileAboutEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {LookingForEntity}
     * @memberof AccountEntity
     */
    lfor: LookingForEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    occupation: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    education_desc: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    education_level: AccountEntityEducationLevelEnum;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    relationship: AccountEntityRelationshipEnum;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {ProfilePhotosEntity}
     * @memberof AccountEntity
     */
    profile_photos: ProfilePhotosEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {UserPermissionsEntity}
     * @memberof AccountEntity
     */
    permissions: UserPermissionsEntity;
    /**
     * DEPRECATED in favor of permissions field
     * @type {CanContactEntity}
     * @memberof AccountEntity
     */
    can_contact?: CanContactEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    blocked_profile: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    verified_facebook: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    verified_phone: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Array<TagEntity>}
     * @memberof AccountEntity
     */
    user_tags: Array<TagEntity>;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {number}
     * @memberof AccountEntity
     */
    reply_rate?: number;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    status_message?: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Date}
     * @memberof AccountEntity
     */
    status_message_updated?: Date;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {UserMatchSettingsEntity}
     * @memberof AccountEntity
     */
    match_settings?: UserMatchSettingsEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {PhotoEntity}
     * @memberof AccountEntity
     */
    newest_photo?: PhotoEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    is_bookmarked: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    searchable: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {EmailEntity}
     * @memberof AccountEntity
     */
    email: EmailEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {NotifyEntity}
     * @memberof AccountEntity
     */
    notify_settings: NotifyEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    changes_sex: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    changes_birth: boolean;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {OAuthEntity}
     * @memberof AccountEntity
     */
    oauth: OAuthEntity;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {string}
     * @memberof AccountEntity
     */
    lang: string;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {Date}
     * @memberof AccountEntity
     */
    changes_username_lastmod?: Date;
    /**
     * Newlines separate fields inherited from UserEntity and ProfileEntity.
     * @type {boolean}
     * @memberof AccountEntity
     */
    is_moderator: boolean;
    /**
     * extra:ips, 5 most recent IP addresses
     * @type {Array<UserIpEntity>}
     * @memberof AccountEntity
     */
    ips?: Array<UserIpEntity>;
}

export type AccountEntityModStatusEnum = 'active' | 'approved' | 'flagged' | 'owner_only' | 'pending' | 'rejected';
export type AccountEntityStatusEnum = 'active' | 'deleted';
export type AccountEntityEducationLevelEnum = 'edu_not_specified' | 'edu_high_school' | 'edu_college' | 'edu_bachelors' | 'edu_graduate';
export type AccountEntityRelationshipEnum = 'rel_not_specified' | 'rel_single' | 'rel_relationship' | 'rel_married' | 'rel_complicated';

/**
 * 
 * @export
 * @interface AccountsResponse
 */
export interface AccountsResponse {
    /**
     * 
     * @type {Array<AccountEntity>}
     * @memberof AccountsResponse
     */
    data: Array<AccountEntity>;
}


/**
 * 
 * @export
 * @interface AdConfigEntity
 */
export interface AdConfigEntity {
    /**
     * 
     * @type {string}
     * @memberof AdConfigEntity
     */
    tier: string;
}


/**
 * 
 * @export
 * @interface AffectedEntity
 */
export interface AffectedEntity {
    /**
     * 
     * @type {string}
     * @memberof AffectedEntity
     */
    affected: string;
}


/**
 * 
 * @export
 * @interface AffectedResponse
 */
export interface AffectedResponse {
    /**
     * 
     * @type {any}
     * @memberof AffectedResponse
     */
    data: any;
}


/**
 * 
 * @export
 * @interface AlbumEntity
 */
export interface AlbumEntity {
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    type: AlbumEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof AlbumEntity
     */
    updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AlbumEntity
     */
    created?: Date;
    /**
     * 
     * @type {number}
     * @memberof AlbumEntity
     */
    photo_total: number;
    /**
     * 
     * @type {number}
     * @memberof AlbumEntity
     */
    album_cover?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlbumEntity
     */
    privacy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlbumEntity
     */
    profile_photos?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    view_acl: AlbumEntityViewAclEnum;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    comment_acl: AlbumEntityCommentAclEnum;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    country_iso2?: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    cont?: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumEntity
     */
    album_cover_id?: string;
    /**
     * extra
     * @type {string}
     * @memberof AlbumEntity
     */
    album_cover_path?: string;
    /**
     * extra
     * @type {LikeCommentDataEntity}
     * @memberof AlbumEntity
     */
    likes_comments?: LikeCommentDataEntity;
    /**
     * extra
     * @type {Array<PhotoEntity>}
     * @memberof AlbumEntity
     */
    photos?: Array<PhotoEntity>;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof AlbumEntity
     */
    cover?: PhotoEntity;
    /**
     * List of photo ids
     * @type {Array<string>}
     * @memberof AlbumEntity
     */
    photo_ids?: Array<string>;
    /**
     * Can current user comment on this album's photos (according to ACL)
     * @type {boolean}
     * @memberof AlbumEntity
     */
    can_comment?: boolean;
}

export type AlbumEntityTypeEnum = 'user' | 'profile' | 'feed';
export type AlbumEntityViewAclEnum = 'users' | 'friends' | 'me';
export type AlbumEntityCommentAclEnum = 'users' | 'friends' | 'me';

/**
 * 
 * @export
 * @interface AlbumPhotosResponse
 */
export interface AlbumPhotosResponse {
    /**
     * 
     * @type {Array<PhotoEntity>}
     * @memberof AlbumPhotosResponse
     */
    data: Array<PhotoEntity>;
    /**
     * 
     * @type {number}
     * @memberof AlbumPhotosResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface AttachedMessageEntity
 */
export interface AttachedMessageEntity {
    /**
     * 
     * @type {string}
     * @memberof AttachedMessageEntity
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof AttachedMessageEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof AttachedMessageEntity
     */
    thread_id: string;
    /**
     * 
     * @type {string}
     * @memberof AttachedMessageEntity
     */
    sender_id: string;
    /**
     * 
     * @type {string}
     * @memberof AttachedMessageEntity
     */
    message: string;
    /**
     * Only when just created without supplying a thread_id
     * @type {ThreadEntity}
     * @memberof AttachedMessageEntity
     */
    thread?: ThreadEntity;
    /**
     * 
     * @type {Array<AttachmentEntityOmitMessage>}
     * @memberof AttachedMessageEntity
     */
    attachments?: Array<AttachmentEntityOmitMessage>;
}


/**
 * 
 * @export
 * @interface AttachmentEntity
 */
export interface AttachmentEntity {
    /**
     * 
     * @type {string}
     * @memberof AttachmentEntity
     */
    type: AttachmentEntityTypeEnum;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof AttachmentEntity
     */
    photo?: PhotoEntity;
    /**
     * 
     * @type {AudioEntity}
     * @memberof AttachmentEntity
     */
    audio?: AudioEntity;
    /**
     * 
     * @type {CallEntity}
     * @memberof AttachmentEntity
     */
    call?: CallEntity;
    /**
     * 
     * @type {AttachedMessageEntity}
     * @memberof AttachmentEntity
     */
    message?: AttachedMessageEntity;
    /**
     * 
     * @type {GifEntity}
     * @memberof AttachmentEntity
     */
    gif?: GifEntity;
    /**
     * Correction comment
     * @type {string}
     * @memberof AttachmentEntity
     */
    comment?: string;
    /**
     * DEPRECATED (PhotoEntity|CallEntity|AudioEntity|AttachedMessageEntity|GifEntity
     * @type {any}
     * @memberof AttachmentEntity
     */
    entity?: any;
}

export type AttachmentEntityTypeEnum = 'audio' | 'call' | 'correction' | 'gif' | 'photo' | 'reply';

/**
 * 
 * @export
 * @interface AttachmentEntityOmitMessage
 */
export interface AttachmentEntityOmitMessage {
    /**
     * 
     * @type {string}
     * @memberof AttachmentEntityOmitMessage
     */
    type: AttachmentEntityOmitMessageTypeEnum;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof AttachmentEntityOmitMessage
     */
    photo?: PhotoEntity;
    /**
     * 
     * @type {AudioEntity}
     * @memberof AttachmentEntityOmitMessage
     */
    audio?: AudioEntity;
    /**
     * 
     * @type {CallEntity}
     * @memberof AttachmentEntityOmitMessage
     */
    call?: CallEntity;
    /**
     * 
     * @type {GifEntity}
     * @memberof AttachmentEntityOmitMessage
     */
    gif?: GifEntity;
    /**
     * Correction comment
     * @type {string}
     * @memberof AttachmentEntityOmitMessage
     */
    comment?: string;
}

export type AttachmentEntityOmitMessageTypeEnum = 'audio' | 'call' | 'correction' | 'gif' | 'photo' | 'reply';

/**
 * 
 * @export
 * @interface AudioEntity
 */
export interface AudioEntity {
    /**
     * 
     * @type {string}
     * @memberof AudioEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AudioEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof AudioEntity
     */
    path: string;
    /**
     * 
     * @type {number}
     * @memberof AudioEntity
     */
    duration: number;
    /**
     * 
     * @type {Date}
     * @memberof AudioEntity
     */
    created: Date;
}


/**
 * 
 * @export
 * @interface BannedIpEntity
 */
export interface BannedIpEntity {
    /**
     * 
     * @type {string}
     * @memberof BannedIpEntity
     */
    ip: string;
    /**
     * 
     * @type {Date}
     * @memberof BannedIpEntity
     */
    created_at: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof BannedIpEntity
     */
    moderator?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof BannedIpEntity
     */
    comment?: string;
}


/**
 * 
 * @export
 * @interface BannedIpsResponse
 */
export interface BannedIpsResponse {
    /**
     * 
     * @type {Array<BannedIpEntity>}
     * @memberof BannedIpsResponse
     */
    data: Array<BannedIpEntity>;
    /**
     * 
     * @type {number}
     * @memberof BannedIpsResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface BookmarkEntity
 */
export interface BookmarkEntity {
    /**
     * 
     * @type {string}
     * @memberof BookmarkEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkEntity
     */
    target_id: string;
    /**
     * 
     * @type {Date}
     * @memberof BookmarkEntity
     */
    created: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof BookmarkEntity
     */
    user?: UserEntity;
}


/**
 * 
 * @export
 * @interface CallEntity
 */
export interface CallEntity {
    /**
     * 
     * @type {string}
     * @memberof CallEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CallEntity
     */
    uid: string;
    /**
     * 
     * @type {Array<UserEntity>}
     * @memberof CallEntity
     */
    participants: Array<UserEntity>;
    /**
     * 
     * @type {string}
     * @memberof CallEntity
     */
    type: CallEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CallEntity
     */
    status: CallEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CallEntity
     */
    duration: number;
    /**
     * 
     * @type {Date}
     * @memberof CallEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof CallEntity
     */
    room: string;
}

export type CallEntityTypeEnum = 'video' | 'audio';
export type CallEntityStatusEnum = 'pending' | 'started' | 'canceled' | 'unanswered' | 'finished' | 'rejected';

/**
 * 
 * @export
 * @interface CanContactEntity
 */
export interface CanContactEntity {
    /**
     * Can requester send message to this user
     * @type {boolean}
     * @memberof CanContactEntity
     */
    msg_recv: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CanContactEntity
     */
    chatreq_recv: boolean;
    /**
     * Can requester send friend request to this user
     * @type {boolean}
     * @memberof CanContactEntity
     */
    freq_recv: boolean;
    /**
     * Can requester write on this user's feed/wall
     * @type {boolean}
     * @memberof CanContactEntity
     */
    wall_write: boolean;
    /**
     * Can requester view this user's feed/wall
     * @type {boolean}
     * @memberof CanContactEntity
     */
    wall_view: boolean;
    /**
     * Can requester view this uers's friends
     * @type {boolean}
     * @memberof CanContactEntity
     */
    friends_view: boolean;
}


/**
 * 
 * @export
 * @interface CommentEntity
 */
export interface CommentEntity {
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    entity_type: CommentEntityEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    entity_owner_uid: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    entity_feed_owner_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    commenter_uid: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    reply_to_cid?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    reply_to_uid?: string;
    /**
     * 
     * @type {Date}
     * @memberof CommentEntity
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CommentEntity
     */
    attachments?: string;
    /**
     * 
     * @type {LikeCommentDataEntity}
     * @memberof CommentEntity
     */
    likes_comments: LikeCommentDataEntity;
    /**
     * Deprecated, use likes_comments instead
     * @type {LikeCommentDataEntity}
     * @memberof CommentEntity
     */
    likes?: LikeCommentDataEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof CommentEntity
     */
    user?: UserEntity;
    /**
     * Content moderation approval status
     * @type {string}
     * @memberof CommentEntity
     */
    mod_status?: string;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof CommentEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * Replies (array of CommentEntity)
     * @type {Array<any>}
     * @memberof CommentEntity
     */
    replies?: Array<any>;
    /**
     * Extra
     * @type {PostEntityOmitComment}
     * @memberof CommentEntity
     */
    post?: PostEntityOmitComment;
    /**
     * Extra
     * @type {PhotoEntity}
     * @memberof CommentEntity
     */
    photo?: PhotoEntity;
    /**
     * Extra
     * @type {AlbumEntity}
     * @memberof CommentEntity
     */
    album?: AlbumEntity;
    /**
     * Extra
     * @type {TripEntity}
     * @memberof CommentEntity
     */
    trip?: TripEntity;
}

export type CommentEntityEntityTypeEnum = 'post' | 'photo' | 'album' | 'trip' | 'entry';

/**
 * 
 * @export
 * @interface CommentListResponse
 */
export interface CommentListResponse {
    /**
     * 
     * @type {Array<CommentEntity>}
     * @memberof CommentListResponse
     */
    data: Array<CommentEntity>;
}


/**
 * 
 * @export
 * @interface CommentSocketNotification
 */
export interface CommentSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof CommentSocketNotification
     */
    type?: CommentSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof CommentSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof CommentSocketNotification
     */
    sender?: UserEntity;
    /**
     * 
     * @type {any}
     * @memberof CommentSocketNotification
     */
    data?: any;
}

export type CommentSocketNotificationTypeEnum = 'COMMENT_PHOTO' | 'COMMENT_POST' | 'COMMENT_ALBUM' | 'COMMENT_TRIP' | 'COMMENT_REPLY';

/**
 * 
 * @export
 * @interface CommentsResponse
 */
export interface CommentsResponse {
    /**
     * 
     * @type {Array<CommentEntity>}
     * @memberof CommentsResponse
     */
    data: Array<CommentEntity>;
}


/**
 * 
 * @export
 * @interface ConflictError
 */
export interface ConflictError {
    /**
     * 
     * @type {ConflictErrorError}
     * @memberof ConflictError
     */
    error: ConflictErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface ConflictErrorError
 */
export interface ConflictErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ConflictErrorError
     */
    type: ConflictErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ConflictErrorError
     */
    code: ConflictErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ConflictErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ConflictErrorError
     */
    extra?: string;
}

export type ConflictErrorErrorTypeEnum = 'Conflict';
export type ConflictErrorErrorCodeEnum = 'social_account_linked' | 'user_invited' | 'user_deleted' | 'email_already_confirmed' | 'email_confirmation_in_use';

/**
 * 
 * @export
 * @interface ContactLimitError
 */
export interface ContactLimitError {
    /**
     * 
     * @type {ContactLimitErrorError}
     * @memberof ContactLimitError
     */
    error: ContactLimitErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface ContactLimitErrorError
 */
export interface ContactLimitErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ContactLimitErrorError
     */
    type: ContactLimitErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ContactLimitErrorError
     */
    code: ContactLimitErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ContactLimitErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ContactLimitErrorError
     */
    extra?: string;
}

export type ContactLimitErrorErrorTypeEnum = 'ContactLimit';
export type ContactLimitErrorErrorCodeEnum = 'new_contact_limit';

/**
 * 
 * @export
 * @interface ContactRulesEntity
 */
export interface ContactRulesEntity {
    /**
     * 
     * @type {string}
     * @memberof ContactRulesEntity
     */
    sex: ContactRulesEntitySexEnum;
    /**
     * 
     * @type {number}
     * @memberof ContactRulesEntity
     */
    min_age: number;
    /**
     * 
     * @type {number}
     * @memberof ContactRulesEntity
     */
    max_age: number;
    /**
     * 
     * @type {string}
     * @memberof ContactRulesEntity
     */
    cont: string;
    /**
     * 
     * @type {string}
     * @memberof ContactRulesEntity
     */
    country: string;
}

export type ContactRulesEntitySexEnum = 'everyone' | 'male' | 'female';

/**
 * 
 * @export
 * @interface CorrectionVoteListResponse
 */
export interface CorrectionVoteListResponse {
    /**
     * 
     * @type {Array<EntryCorrectionVoteEntity>}
     * @memberof CorrectionVoteListResponse
     */
    data: Array<EntryCorrectionVoteEntity>;
}


/**
 * 
 * @export
 * @interface CountriesResponse
 */
export interface CountriesResponse {
}


/**
 * 
 * @export
 * @interface EmailDomainWhitelistEntity
 */
export interface EmailDomainWhitelistEntity {
    /**
     * 
     * @type {string}
     * @memberof EmailDomainWhitelistEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmailDomainWhitelistEntity
     */
    domain: string;
    /**
     * 
     * @type {Date}
     * @memberof EmailDomainWhitelistEntity
     */
    created_at: Date;
    /**
     * 
     * @type {number}
     * @memberof EmailDomainWhitelistEntity
     */
    count?: number;
    /**
     * 
     * @type {UserEntity}
     * @memberof EmailDomainWhitelistEntity
     */
    moderator: UserEntity;
}


/**
 * 
 * @export
 * @interface EmailDomainWhitelistResponse
 */
export interface EmailDomainWhitelistResponse {
    /**
     * 
     * @type {Array<EmailDomainWhitelistEntity>}
     * @memberof EmailDomainWhitelistResponse
     */
    data: Array<EmailDomainWhitelistEntity>;
    /**
     * 
     * @type {number}
     * @memberof EmailDomainWhitelistResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface EmailEntity
 */
export interface EmailEntity {
    /**
     * 
     * @type {string}
     * @memberof EmailEntity
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmailEntity
     */
    verified: boolean;
}


/**
 * 
 * @export
 * @interface EntryCorrectionListResponse
 */
export interface EntryCorrectionListResponse {
    /**
     * 
     * @type {Array<LangEntryCorrectionEntity>}
     * @memberof EntryCorrectionListResponse
     */
    data: Array<LangEntryCorrectionEntity>;
}


/**
 * 
 * @export
 * @interface EntryCorrectionVoteEntity
 */
export interface EntryCorrectionVoteEntity {
    /**
     * 
     * @type {string}
     * @memberof EntryCorrectionVoteEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntryCorrectionVoteEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof EntryCorrectionVoteEntity
     */
    correction_id: string;
    /**
     * 
     * @type {number}
     * @memberof EntryCorrectionVoteEntity
     */
    vote_up: number;
    /**
     * 
     * @type {Date}
     * @memberof EntryCorrectionVoteEntity
     */
    created?: Date;
}


/**
 * 
 * @export
 * @interface EntryRootEntity
 */
export interface EntryRootEntity {
    /**
     * 
     * @type {string}
     * @memberof EntryRootEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntryRootEntity
     */
    name: string;
}


/**
 * 
 * @export
 * @interface ErrorResponseItem400
 */
export interface ErrorResponseItem400 {
}


/**
 * 
 * @export
 * @interface FeedResponse
 */
export interface FeedResponse {
    /**
     * 
     * @type {Array<PostEntity>}
     * @memberof FeedResponse
     */
    data: Array<PostEntity>;
}


/**
 * 
 * @export
 * @interface ForbiddenError
 */
export interface ForbiddenError {
    /**
     * 
     * @type {ForbiddenErrorError}
     * @memberof ForbiddenError
     */
    error: ForbiddenErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface ForbiddenErrorError
 */
export interface ForbiddenErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ForbiddenErrorError
     */
    type: ForbiddenErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ForbiddenErrorError
     */
    code: ForbiddenErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ForbiddenErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ForbiddenErrorError
     */
    extra?: string;
}

export type ForbiddenErrorErrorTypeEnum = 'Forbidden';
export type ForbiddenErrorErrorCodeEnum = 'account_suspended' | 'action_not_allowed' | 'album_full' | 'asl_filters' | 'blocked' | 'bookmarks_limit' | 'call_full' | 'cannot_block_admin' | 'cannot_contact' | 'account_active' | 'friend_requests_disabled' | 'friends_limit' | 'group_requires_owner' | 'insufficient_privileges' | 'required_non_empty' | 'message_first' | 'relation_filters' | 'too_soon_delete_account' | 'unsubscribed' | 'user_in_group_block_list' | 'friends_prior_contact';

/**
 * 
 * @export
 * @interface FriendBirthdaySocketNotification
 */
export interface FriendBirthdaySocketNotification {
    /**
     * 
     * @type {string}
     * @memberof FriendBirthdaySocketNotification
     */
    type?: FriendBirthdaySocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FriendBirthdaySocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof FriendBirthdaySocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof FriendBirthdaySocketNotification
     */
    sender?: UserEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof FriendBirthdaySocketNotification
     */
    data?: UserEntity;
}

export type FriendBirthdaySocketNotificationTypeEnum = 'FRIEND_BIRTHDAY';

/**
 * 
 * @export
 * @interface FriendRequestAcceptedSocketNotification
 */
export interface FriendRequestAcceptedSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof FriendRequestAcceptedSocketNotification
     */
    type?: FriendRequestAcceptedSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FriendRequestAcceptedSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof FriendRequestAcceptedSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof FriendRequestAcceptedSocketNotification
     */
    sender?: UserEntity;
}

export type FriendRequestAcceptedSocketNotificationTypeEnum = 'FRIEND_ACCEPT_MESSAGE';

/**
 * 
 * @export
 * @interface FriendRequestSocketNotification
 */
export interface FriendRequestSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof FriendRequestSocketNotification
     */
    type?: FriendRequestSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FriendRequestSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof FriendRequestSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof FriendRequestSocketNotification
     */
    sender?: UserEntity;
}

export type FriendRequestSocketNotificationTypeEnum = 'FRIEND_REQUEST_MESSAGE';

/**
 * 
 * @export
 * @interface GeoEntity
 */
export interface GeoEntity {
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    type: GeoEntityTypeEnum;
    /**
     * 
     * @type {GeoParentNamesEntity}
     * @memberof GeoEntity
     */
    parent_names: GeoParentNamesEntity;
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    country_iso: string;
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    timezone: string;
    /**
     * 
     * @type {number}
     * @memberof GeoEntity
     */
    population: number;
    /**
     * 
     * @type {string}
     * @memberof GeoEntity
     */
    parent_id: string;
    /**
     * 
     * @type {number}
     * @memberof GeoEntity
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof GeoEntity
     */
    longitude: number;
}

export type GeoEntityTypeEnum = 'city' | 'region' | 'country';

/**
 * 
 * @export
 * @interface GeoParentNamesEntity
 */
export interface GeoParentNamesEntity {
    /**
     * 
     * @type {string}
     * @memberof GeoParentNamesEntity
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof GeoParentNamesEntity
     */
    country: string;
}


/**
 * 
 * @export
 * @interface GeoSearchResponse
 */
export interface GeoSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof GeoSearchResponse
     */
    total: number;
    /**
     * 
     * @type {Array<GeoEntity>}
     * @memberof GeoSearchResponse
     */
    data: Array<GeoEntity>;
}


/**
 * 
 * @export
 * @interface GifEntity
 */
export interface GifEntity {
    /**
     * 
     * @type {string}
     * @memberof GifEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GifEntity
     */
    url: string;
}


/**
 * 
 * @export
 * @interface GroupEntity
 */
export interface GroupEntity {
    /**
     * 
     * @type {string}
     * @memberof GroupEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEntity
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEntity
     */
    language: string;
    /**
     * 
     * @type {Date}
     * @memberof GroupEntity
     */
    updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupEntity
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupEntity
     */
    last_activity: Date;
    /**
     * 
     * @type {number}
     * @memberof GroupEntity
     */
    members_count: number;
    /**
     * 
     * @type {number}
     * @memberof GroupEntity
     */
    posts_count: number;
    /**
     * 
     * @type {string}
     * @memberof GroupEntity
     */
    category: GroupEntityCategoryEnum;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof GroupEntity
     */
    cover?: PhotoEntity;
    /**
     * 
     * @type {GeoEntity}
     * @memberof GroupEntity
     */
    location?: GeoEntity;
    /**
     * Content moderation approval status
     * @type {string}
     * @memberof GroupEntity
     */
    mod_status?: string;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof GroupEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * Membership status of requesting user
     * @type {string}
     * @memberof GroupEntity
     */
    user_member_type?: GroupEntityUserMemberTypeEnum;
    /**
     * User who created the group (only visible for moderators)
     * @type {UserEntity}
     * @memberof GroupEntity
     */
    created_by_user?: UserEntity;
}

export type GroupEntityCategoryEnum = 'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel';
export type GroupEntityUserMemberTypeEnum = 'standard' | 'moderator' | 'owner' | 'non_member';

/**
 * 
 * @export
 * @interface GroupMemberBlockListEntity
 */
export interface GroupMemberBlockListEntity {
    /**
     * 
     * @type {string}
     * @memberof GroupMemberBlockListEntity
     */
    uid: string;
    /**
     * 
     * @type {Date}
     * @memberof GroupMemberBlockListEntity
     */
    created?: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof GroupMemberBlockListEntity
     */
    user?: UserEntity;
}


/**
 * 
 * @export
 * @interface GroupMemberBlockListResponse
 */
export interface GroupMemberBlockListResponse {
    /**
     * 
     * @type {Array<GroupMemberBlockListEntity>}
     * @memberof GroupMemberBlockListResponse
     */
    data: Array<GroupMemberBlockListEntity>;
}


/**
 * 
 * @export
 * @interface GroupMemberEntity
 */
export interface GroupMemberEntity {
    /**
     * 
     * @type {string}
     * @memberof GroupMemberEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberEntity
     */
    member_type: GroupMemberEntityMemberTypeEnum;
    /**
     * In case of blocked, this is blocking date
     * @type {Date}
     * @memberof GroupMemberEntity
     */
    joined: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof GroupMemberEntity
     */
    user?: UserEntity;
}

export type GroupMemberEntityMemberTypeEnum = 'standard' | 'moderator' | 'owner' | 'blocked';

/**
 * 
 * @export
 * @interface GroupMemberTotalsEntity
 */
export interface GroupMemberTotalsEntity {
    /**
     * 
     * @type {number}
     * @memberof GroupMemberTotalsEntity
     */
    all: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberTotalsEntity
     */
    admin: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberTotalsEntity
     */
    blocked: number;
}


/**
 * 
 * @export
 * @interface GroupMembersResponse
 */
export interface GroupMembersResponse {
    /**
     * 
     * @type {Array<GroupMemberEntity>}
     * @memberof GroupMembersResponse
     */
    data: Array<GroupMemberEntity>;
    /**
     * 
     * @type {GroupMemberTotalsEntity}
     * @memberof GroupMembersResponse
     */
    totals?: GroupMemberTotalsEntity;
}


/**
 * 
 * @export
 * @interface GroupsResponse
 */
export interface GroupsResponse {
    /**
     * 
     * @type {Array<GroupEntity>}
     * @memberof GroupsResponse
     */
    data: Array<GroupEntity>;
}


/**
 * 
 * @export
 * @interface GroupsWithUserGroupsTotalResponse
 */
export interface GroupsWithUserGroupsTotalResponse {
    /**
     * 
     * @type {Array<GroupEntity>}
     * @memberof GroupsWithUserGroupsTotalResponse
     */
    data: Array<GroupEntity>;
    /**
     * Extra: Total number of groups current user is a member of
     * @type {number}
     * @memberof GroupsWithUserGroupsTotalResponse
     */
    user_groups_total?: number;
}


/**
 * 
 * @export
 * @interface IncompatibleError
 */
export interface IncompatibleError {
    /**
     * 
     * @type {IncompatibleErrorError}
     * @memberof IncompatibleError
     */
    error: IncompatibleErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface IncompatibleErrorError
 */
export interface IncompatibleErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof IncompatibleErrorError
     */
    type: IncompatibleErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof IncompatibleErrorError
     */
    code: IncompatibleErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof IncompatibleErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof IncompatibleErrorError
     */
    extra?: string;
}

export type IncompatibleErrorErrorTypeEnum = 'Incompatible';
export type IncompatibleErrorErrorCodeEnum = 'incompatible_version';

/**
 * 
 * @export
 * @interface LForEntity
 */
export interface LForEntity {
    /**
     * 
     * @type {boolean}
     * @memberof LForEntity
     */
    snail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LForEntity
     */
    langex: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LForEntity
     */
    relation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LForEntity
     */
    friend: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LForEntity
     */
    meet: boolean;
}


/**
 * 
 * @export
 * @interface LangEntryCorrectionEntity
 */
export interface LangEntryCorrectionEntity {
    /**
     * 
     * @type {string}
     * @memberof LangEntryCorrectionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryCorrectionEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryCorrectionEntity
     */
    entry_id: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryCorrectionEntity
     */
    correction: string;
    /**
     * 
     * @type {number}
     * @memberof LangEntryCorrectionEntity
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof LangEntryCorrectionEntity
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof LangEntryCorrectionEntity
     */
    created?: Date;
}


/**
 * 
 * @export
 * @interface LangEntryEntity
 */
export interface LangEntryEntity {
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    prompt_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    entry: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryEntity
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof LangEntryEntity
     */
    created?: Date;
}


/**
 * 
 * @export
 * @interface LangEntryPromptEntity
 */
export interface LangEntryPromptEntity {
    /**
     * 
     * @type {string}
     * @memberof LangEntryPromptEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryPromptEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryPromptEntity
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryPromptEntity
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof LangEntryPromptEntity
     */
    data?: string;
    /**
     * 
     * @type {number}
     * @memberof LangEntryPromptEntity
     */
    approved?: number;
    /**
     * 
     * @type {number}
     * @memberof LangEntryPromptEntity
     */
    is_public: number;
    /**
     * 
     * @type {Date}
     * @memberof LangEntryPromptEntity
     */
    created?: Date;
}


/**
 * 
 * @export
 * @interface LanguageEntity
 */
export interface LanguageEntity {
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    lang: LanguageEntityLangEnum;
    /**
     * 
     * @type {number}
     * @memberof LanguageEntity
     */
    level: number;
}

export type LanguageEntityLangEnum = 'AB' | 'AA' | 'AF' | 'AK' | 'SQ' | 'AM' | 'AR' | 'HY' | 'AS' | 'AW' | 'AY' | 'AZ' | 'BL' | 'BA' | 'EU' | 'BE' | 'BN' | 'B1' | 'DZ' | 'BH' | 'BI' | 'BR' | 'BG' | 'MY' | 'CA' | 'CB' | 'CE' | 'ZH' | 'CO' | 'HR' | 'CS' | 'DK' | 'DA' | 'NL' | 'EN' | 'EO' | 'ET' | 'FO' | 'FJ' | 'FI' | 'FR' | 'FY' | 'GL' | 'KA' | 'DE' | 'EL' | 'KL' | 'GN' | 'GU' | 'HT' | 'HA' | 'IW' | 'HI' | 'HU' | 'IS' | 'IN' | 'IA' | 'IE' | 'IK' | 'GA' | 'IT' | 'JA' | 'JW' | 'KB' | 'KN' | 'KS' | 'KK' | 'KM' | 'RW' | 'KY' | 'RN' | 'KI' | 'KO' | 'KU' | 'LO' | 'LA' | 'LV' | 'LN' | 'LT' | 'LM' | 'LB' | 'MK' | 'MU' | 'MG' | 'MS' | 'ML' | 'MT' | 'MI' | 'MR' | 'MW' | 'MO' | 'MN' | 'NA' | 'NE' | 'NO' | 'OC' | 'OR' | 'OM' | 'PS' | 'FA' | 'PL' | 'PT' | 'PA' | 'QU' | 'RM' | 'RI' | 'RO' | 'RU' | 'SM' | 'SG' | 'SA' | 'GD' | 'SR' | 'SH' | 'ST' | 'TN' | 'SN' | 'SD' | 'SI' | 'SS' | 'SK' | 'SL' | 'SO' | 'ES' | 'SU' | 'SW' | 'SV' | 'TL' | 'TG' | 'TZ' | 'TA' | 'TT' | 'TE' | 'TH' | 'BO' | 'TI' | 'TO' | 'TS' | 'TM' | 'TR' | 'TK' | 'TW' | 'UK' | 'UR' | 'UG' | 'UZ' | 'VI' | 'VO' | 'CY' | 'WO' | 'XH' | 'JI' | 'YO' | 'ZU';

/**
 * 
 * @export
 * @interface LanguageEntryListResponse
 */
export interface LanguageEntryListResponse {
    /**
     * 
     * @type {Array<LangEntryEntity>}
     * @memberof LanguageEntryListResponse
     */
    data: Array<LangEntryEntity>;
}


/**
 * 
 * @export
 * @interface LanguagesResponse
 */
export interface LanguagesResponse {
}


/**
 * 
 * @export
 * @interface LikeCommentDataEntity
 */
export interface LikeCommentDataEntity {
    /**
     * Comment count
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    comments?: number;
    /**
     * Like count
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_like?: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_adore?: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_laugh?: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_wonder?: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_tears?: number;
    /**
     * 
     * @type {number}
     * @memberof LikeCommentDataEntity
     */
    likes_anger?: number;
    /**
     * Liked by requester (if authorized)
     * @type {boolean}
     * @memberof LikeCommentDataEntity
     */
    user_liked?: boolean;
}


/**
 * 
 * @export
 * @interface LikeEntity
 */
export interface LikeEntity {
    /**
     * 
     * @type {string}
     * @memberof LikeEntity
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof LikeEntity
     */
    entity_type: LikeEntityEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LikeEntity
     */
    entity_owner_uid: string;
    /**
     * 
     * @type {string}
     * @memberof LikeEntity
     */
    liker_uid: string;
    /**
     * 
     * @type {string}
     * @memberof LikeEntity
     */
    like_type: string;
    /**
     * 
     * @type {Date}
     * @memberof LikeEntity
     */
    time: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof LikeEntity
     */
    user?: UserEntity;
}

export type LikeEntityEntityTypeEnum = 'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry';

/**
 * 
 * @export
 * @interface LikeListResponse
 */
export interface LikeListResponse {
    /**
     * 
     * @type {Array<LikeEntity>}
     * @memberof LikeListResponse
     */
    data: Array<LikeEntity>;
}


/**
 * 
 * @export
 * @interface LikeSocketNotification
 */
export interface LikeSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof LikeSocketNotification
     */
    type?: LikeSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LikeSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof LikeSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof LikeSocketNotification
     */
    sender?: UserEntity;
    /**
     * 
     * @type {any}
     * @memberof LikeSocketNotification
     */
    data?: any;
}

export type LikeSocketNotificationTypeEnum = 'LIKE_PHOTO' | 'LIKE_POST' | 'LIKE_ALBUM' | 'LIKE_TRIP' | 'LIKE_COMMENT';

/**
 * 
 * @export
 * @interface LinkEntity
 */
export interface LinkEntity {
    /**
     * 
     * @type {string}
     * @memberof LinkEntity
     */
    link: string;
}


/**
 * 
 * @export
 * @interface LocationEntity
 */
export interface LocationEntity {
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    country_code: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    home_country: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    home_country_code: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEntity
     */
    home_city: string;
    /**
     * 
     * @type {GeoEntity}
     * @memberof LocationEntity
     */
    current: GeoEntity;
    /**
     * 
     * @type {GeoEntity}
     * @memberof LocationEntity
     */
    home: GeoEntity;
}


/**
 * 
 * @export
 * @interface LookingForEntity
 */
export interface LookingForEntity {
    /**
     * 
     * @type {boolean}
     * @memberof LookingForEntity
     */
    meet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookingForEntity
     */
    friend: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookingForEntity
     */
    langex: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookingForEntity
     */
    relation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookingForEntity
     */
    snail: boolean;
}


/**
 * 
 * @export
 * @interface MediaStatusEntity
 */
export interface MediaStatusEntity {
    /**
     * Photo entity
     * @type {PhotoEntity}
     * @memberof MediaStatusEntity
     */
    payload?: PhotoEntity;
    /**
     * 
     * @type {string}
     * @memberof MediaStatusEntity
     */
    status: MediaStatusEntityStatusEnum;
}

export type MediaStatusEntityStatusEnum = 'unknown' | 'pending' | 'success' | 'failure';

/**
 * 
 * @export
 * @interface MediaTokenEntity
 */
export interface MediaTokenEntity {
    /**
     * JWT token for getting image processing job status
     * @type {string}
     * @memberof MediaTokenEntity
     */
    token: string;
}


/**
 * 
 * @export
 * @interface MessageDraftEntity
 */
export interface MessageDraftEntity {
    /**
     * 
     * @type {string}
     * @memberof MessageDraftEntity
     */
    thread_id: string;
    /**
     * 
     * @type {string}
     * @memberof MessageDraftEntity
     */
    message: string;
}


/**
 * 
 * @export
 * @interface MessageEntity
 */
export interface MessageEntity {
    /**
     * 
     * @type {string}
     * @memberof MessageEntity
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof MessageEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof MessageEntity
     */
    thread_id: string;
    /**
     * 
     * @type {string}
     * @memberof MessageEntity
     */
    sender_id: string;
    /**
     * Message body text
     * @type {string}
     * @memberof MessageEntity
     */
    message: string;
    /**
     * Optional text comment for corrections
     * @type {string}
     * @memberof MessageEntity
     */
    comment?: string;
    /**
     * 
     * @type {Array<AttachmentEntity>}
     * @memberof MessageEntity
     */
    attachments?: Array<AttachmentEntity>;
    /**
     * Only when just created without supplying a thread_id
     * @type {ThreadEntity}
     * @memberof MessageEntity
     */
    thread?: ThreadEntity;
    /**
     * Temporary id supplied in on previous send message API call
     * @type {string}
     * @memberof MessageEntity
     */
    tmp_id?: string;
}


/**
 * 
 * @export
 * @interface MessageSocketNotification
 */
export interface MessageSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof MessageSocketNotification
     */
    type?: MessageSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof MessageSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof MessageSocketNotification
     */
    sender?: UserEntity;
    /**
     * DEPRECATED
     * @type {MessageEntity}
     * @memberof MessageSocketNotification
     */
    data?: MessageEntity;
}

export type MessageSocketNotificationTypeEnum = 'THREAD_NEW_MESSAGE';

/**
 * 
 * @export
 * @interface MethodNotAllowedError
 */
export interface MethodNotAllowedError {
    /**
     * 
     * @type {MethodNotAllowedErrorError}
     * @memberof MethodNotAllowedError
     */
    error: MethodNotAllowedErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface MethodNotAllowedErrorError
 */
export interface MethodNotAllowedErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof MethodNotAllowedErrorError
     */
    type: MethodNotAllowedErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof MethodNotAllowedErrorError
     */
    code: MethodNotAllowedErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof MethodNotAllowedErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof MethodNotAllowedErrorError
     */
    extra?: string;
}

export type MethodNotAllowedErrorErrorTypeEnum = 'MethodNotAllowed';
export type MethodNotAllowedErrorErrorCodeEnum = 'method_not_found';

/**
 * 
 * @export
 * @interface MetricsEntity
 */
export interface MetricsEntity {
    /**
     * 
     * @type {number}
     * @memberof MetricsEntity
     */
    "online-total": number;
    /**
     * 
     * @type {number}
     * @memberof MetricsEntity
     */
    "users-total": number;
}


/**
 * 
 * @export
 * @interface ModActionLogEntity
 */
export interface ModActionLogEntity {
    /**
     * Log item id
     * @type {string}
     * @memberof ModActionLogEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModActionLogEntity
     */
    action: ModActionLogEntityActionEnum;
    /**
     * Log message entered by moderator
     * @type {string}
     * @memberof ModActionLogEntity
     */
    message: string;
    /**
     * Reason selected for deletion or other action
     * @type {string}
     * @memberof ModActionLogEntity
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ModActionLogEntity
     */
    content_type: ModActionLogEntityContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModActionLogEntity
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ModActionLogEntity
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ModActionLogEntity
     */
    moderator_id: string;
    /**
     * 
     * @type {Date}
     * @memberof ModActionLogEntity
     */
    executed: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof ModActionLogEntity
     */
    moderator?: UserEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ModActionLogEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {ModerationWarningEntity}
     * @memberof ModActionLogEntity
     */
    warning?: ModerationWarningEntity;
}

export type ModActionLogEntityActionEnum = 'log' | 'reinstate' | 'warn' | 'delete-reports' | 'photo-delete' | 'photo-approve' | 'delete-user-data' | 'dump-user-data' | 'restore-all-threads' | 'restore-thread' | 'reset-limits' | 'activate' | 'expire-caches' | 'resend-activation' | 'password-reset-link' | 'approve' | 'escalate' | 'delete' | 'shadowban' | 'restore' | 'clear';
export type ModActionLogEntityContentTypeEnum = 'comment' | 'entry' | 'group' | 'message' | 'photo' | 'post' | 'prompt' | 'thread' | 'user' | 'wall';

/**
 * 
 * @export
 * @interface ModActionLogResponse
 */
export interface ModActionLogResponse {
    /**
     * 
     * @type {Array<ModActionLogEntity>}
     * @memberof ModActionLogResponse
     */
    data: Array<ModActionLogEntity>;
}


/**
 * 
 * @export
 * @interface ModPhotoCollectionResponse
 */
export interface ModPhotoCollectionResponse {
    /**
     * 
     * @type {Array<ModPhotoEntity>}
     * @memberof ModPhotoCollectionResponse
     */
    data: Array<ModPhotoEntity>;
}


/**
 * 
 * @export
 * @interface ModPhotoEntity
 */
export interface ModPhotoEntity {
    /**
     * 
     * @type {string}
     * @memberof ModPhotoEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModPhotoEntity
     */
    uid: string;
    /**
     * 
     * @type {Date}
     * @memberof ModPhotoEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof ModPhotoEntity
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof ModPhotoEntity
     */
    thumb_large: string;
    /**
     * 
     * @type {PhotoMetaEntity}
     * @memberof ModPhotoEntity
     */
    meta?: PhotoMetaEntity;
}


/**
 * 
 * @export
 * @interface ModSettingsLogEntity
 */
export interface ModSettingsLogEntity {
    /**
     * 
     * @type {string}
     * @memberof ModSettingsLogEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModSettingsLogEntity
     */
    action: ModSettingsLogEntityActionEnum;
    /**
     * 
     * @type {Date}
     * @memberof ModSettingsLogEntity
     */
    created_at: Date;
    /**
     * Log message entered by moderator
     * @type {string}
     * @memberof ModSettingsLogEntity
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof ModSettingsLogEntity
     */
    ip?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof ModSettingsLogEntity
     */
    moderator?: UserEntity;
    /**
     * 
     * @type {ModerationWarningEntity}
     * @memberof ModSettingsLogEntity
     */
    warning?: ModerationWarningEntity;
    /**
     * 
     * @type {TextFilterEntity}
     * @memberof ModSettingsLogEntity
     */
    text_filter?: TextFilterEntity;
}

export type ModSettingsLogEntityActionEnum = 'ban-ip' | 'unban-ip' | 'create-warning' | 'edit-warning' | 'delete-warning' | 'create-text-filter' | 'delete-text-filter' | 'create-email-whitelist-item' | 'delete-email-whitelist-item';

/**
 * 
 * @export
 * @interface ModSettingsLogResponse
 */
export interface ModSettingsLogResponse {
    /**
     * 
     * @type {Array<ModSettingsLogEntity>}
     * @memberof ModSettingsLogResponse
     */
    data: Array<ModSettingsLogEntity>;
}


/**
 * Moderation flags are records of entities getting flagged for moderation review. This may be a  *               user account, a post, a photo, etc. and these flags are intended to be generated automatically  *               by the system based on certain criteria. Flags that are generated by other users should be  *               handled by the moderation report system.
 * @export
 * @interface ModerationFlagEntity
 */
export interface ModerationFlagEntity {
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    entity_type: ModerationFlagEntityEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    type: ModerationFlagEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModerationFlagEntity
     */
    json?: string;
    /**
     * 
     * @type {Date}
     * @memberof ModerationFlagEntity
     */
    created: Date;
}

export type ModerationFlagEntityEntityTypeEnum = '0' | '1' | '2' | '3' | '4' | '6' | '7';
export type ModerationFlagEntityTypeEnum = 'acct_ip_mismatch' | 'acct_cookie' | 'photo_nsfw';

/**
 * 
 * @export
 * @interface ModerationWarningEntity
 */
export interface ModerationWarningEntity {
    /**
     * 
     * @type {string}
     * @memberof ModerationWarningEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationWarningEntity
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationWarningEntity
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ModerationWarningEntity
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof ModerationWarningEntity
     */
    created_at: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof ModerationWarningEntity
     */
    moderator?: UserEntity;
}


/**
 * 
 * @export
 * @interface ModerationWarningsResponse
 */
export interface ModerationWarningsResponse {
    /**
     * 
     * @type {Array<ModerationWarningEntity>}
     * @memberof ModerationWarningsResponse
     */
    data: Array<ModerationWarningEntity>;
}


/**
 * 
 * @export
 * @interface ModeratorEntity
 */
export interface ModeratorEntity {
    /**
     * 
     * @type {string}
     * @memberof ModeratorEntity
     */
    user_id: string;
    /**
     * 
     * @type {ModeratorRolesEntity}
     * @memberof ModeratorEntity
     */
    roles: ModeratorRolesEntity;
    /**
     * 
     * @type {number}
     * @memberof ModeratorEntity
     */
    actions_counter: number;
    /**
     * 
     * @type {Date}
     * @memberof ModeratorEntity
     */
    last_edit?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ModeratorEntity
     */
    became_mod?: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof ModeratorEntity
     */
    user?: UserEntity;
}


/**
 * 
 * @export
 * @interface ModeratorResponse
 */
export interface ModeratorResponse {
    /**
     * 
     * @type {Array<ModeratorEntity>}
     * @memberof ModeratorResponse
     */
    data: Array<ModeratorEntity>;
}


/**
 * 
 * @export
 * @interface ModeratorRolesEntity
 */
export interface ModeratorRolesEntity {
    /**
     * 
     * @type {boolean}
     * @memberof ModeratorRolesEntity
     */
    staff: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModeratorRolesEntity
     */
    admin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModeratorRolesEntity
     */
    account: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModeratorRolesEntity
     */
    post: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModeratorRolesEntity
     */
    photo: boolean;
}


/**
 * 
 * @export
 * @interface NotificationEntity
 */
export interface NotificationEntity {
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof NotificationEntity
     */
    created: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationEntity
     */
    uread: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    type: NotificationEntityTypeEnum;
    /**
     * DEPRECATED, use photo/post instead
     * @type {any}
     * @memberof NotificationEntity
     */
    entity: any;
    /**
     * 
     * @type {UserEntity}
     * @memberof NotificationEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof NotificationEntity
     */
    photo?: PhotoEntity;
    /**
     * 
     * @type {PostEntity}
     * @memberof NotificationEntity
     */
    post?: PostEntity;
    /**
     * Relative click-through URL target
     * @type {string}
     * @memberof NotificationEntity
     */
    click_url?: string;
}

export type NotificationEntityTypeEnum = 'FRIEND_REQUEST_MESSAGE' | 'FRIEND_ACCEPT_MESSAGE' | 'FRIEND_BIRTHDAY' | 'LIKE_PHOTO' | 'LIKE_COMMENT' | 'LIKE_POST' | 'LIKE_ALBUM' | 'LIKE_TRIP' | 'LIKE_ENTRY' | 'COMMENT_PHOTO' | 'COMMENT_POST' | 'COMMENT_ALBUM' | 'COMMENT_TRIP' | 'COMMENT_REPLY' | 'FEED_NEW_POST' | 'PROFILE_VIEW';

/**
 * 
 * @export
 * @interface NotifyEntity
 */
export interface NotifyEntity {
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_likes: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_profile_views: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_comments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_messages: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_birthdays: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_feed_posts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    push_friend_requests: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_likes: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_profile_views: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_comments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_messages: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_birthdays: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_feed_posts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_friend_requests: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    email_reminders: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyEntity
     */
    onsite_alerts: boolean;
}


/**
 * 
 * @export
 * @interface OAuthEntity
 */
export interface OAuthEntity {
    /**
     * 
     * @type {boolean}
     * @memberof OAuthEntity
     */
    google: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OAuthEntity
     */
    vk: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OAuthEntity
     */
    facebook: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OAuthEntity
     */
    apple: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OAuthEntity
     */
    oauth_signin_only: boolean;
}


/**
 * 
 * @export
 * @interface ObjectNotFoundError
 */
export interface ObjectNotFoundError {
    /**
     * 
     * @type {ObjectNotFoundErrorError}
     * @memberof ObjectNotFoundError
     */
    error: ObjectNotFoundErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface ObjectNotFoundErrorError
 */
export interface ObjectNotFoundErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ObjectNotFoundErrorError
     */
    type: ObjectNotFoundErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ObjectNotFoundErrorError
     */
    code: ObjectNotFoundErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ObjectNotFoundErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ObjectNotFoundErrorError
     */
    extra?: string;
}

export type ObjectNotFoundErrorErrorTypeEnum = 'ObjectNotFound';
export type ObjectNotFoundErrorErrorCodeEnum = 'album' | 'call' | 'comment' | 'category' | 'entry' | 'entry_correction' | 'entry_correction_vote' | 'like' | 'message' | 'notification' | 'object' | 'photo' | 'post' | 'prompt' | 'push_token' | 'reply_target' | 'report' | 'tag' | 'thread' | 'trip' | 'user' | 'moderator' | 'group' | 'user_post' | 'group_member' | 'group_member_blocked' | 'city';

/**
 * 
 * @export
 * @interface PhotoEntity
 */
export interface PhotoEntity {
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    thumb_small: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    thumb_medium: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    thumb_large: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof PhotoEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof PhotoEntity
     */
    aid: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoEntity
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoEntity
     */
    width: number;
    /**
     * 
     * @type {boolean}
     * @memberof PhotoEntity
     */
    hidden: boolean;
    /**
     * Limited fields returned (url, thumb_*, width, height, uid, id) - for full object fetch by id
     * @type {boolean}
     * @memberof PhotoEntity
     */
    is_stub?: boolean;
    /**
     * extra
     * @type {LikeCommentDataEntity}
     * @memberof PhotoEntity
     */
    likes_comments: LikeCommentDataEntity;
    /**
     * Content moderation approval status
     * @type {string}
     * @memberof PhotoEntity
     */
    mod_status?: string;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof PhotoEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * extra (album entity, omitting schema here due to recursion)
     * @type {any}
     * @memberof PhotoEntity
     */
    album?: any;
    /**
     * extra: user. This is UserEntity, but since UserEntity also contains a PhotoEntity we  *          cannot specify it here as such.
     * @type {any}
     * @memberof PhotoEntity
     */
    user?: any;
}


/**
 * 
 * @export
 * @interface PhotoMetaEntity
 */
export interface PhotoMetaEntity {
    /**
     * 
     * @type {string}
     * @memberof PhotoMetaEntity
     */
    nsfw_score: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoMetaEntity
     */
    similarity_bits: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhotoMetaEntity
     */
    approved: boolean;
}


/**
 * 
 * @export
 * @interface PhotosResponse
 */
export interface PhotosResponse {
    /**
     * 
     * @type {Array<PhotoEntity>}
     * @memberof PhotosResponse
     */
    data: Array<PhotoEntity>;
}


/**
 * 
 * @export
 * @interface PostCollectionResponse
 */
export interface PostCollectionResponse {
    /**
     * 
     * @type {Array<PostEntity>}
     * @memberof PostCollectionResponse
     */
    data: Array<PostEntity>;
}


/**
 * 
 * @export
 * @interface PostEntity
 */
export interface PostEntity {
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    poster_uid: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    feed_owner_id: string;
    /**
     * Related entity id, e.g. album id for upload-photos actions
     * @type {string}
     * @memberof PostEntity
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    type?: PostEntityTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof PostEntity
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    gif_url?: string;
    /**
     * 
     * @type {LikeCommentDataEntity}
     * @memberof PostEntity
     */
    likes_comments?: LikeCommentDataEntity;
    /**
     * extra: poster user
     * @type {UserEntity}
     * @memberof PostEntity
     */
    user?: UserEntity;
    /**
     * extra: feed owner user
     * @type {UserEntity}
     * @memberof PostEntity
     */
    feed_owner?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    view_acl: PostEntityViewAclEnum;
    /**
     * Content moderation approval status
     * @type {string}
     * @memberof PostEntity
     */
    mod_status?: string;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof PostEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * Only returned for user-post types
     * @type {AlbumEntity}
     * @memberof PostEntity
     */
    album?: AlbumEntity;
    /**
     * The first 8 (Feed::MAX_DISPLAY_PHOTOS) attached photos
     * @type {Array<PhotoEntity>}
     * @memberof PostEntity
     */
    photos?: Array<PhotoEntity>;
    /**
     * List of all attached photo ids
     * @type {Array<string>}
     * @memberof PostEntity
     */
    photo_ids?: Array<string>;
    /**
     * Only returned for group-related types
     * @type {GroupEntity}
     * @memberof PostEntity
     */
    group?: GroupEntity;
    /**
     * 
     * @type {CommentEntity}
     * @memberof PostEntity
     */
    group_comment?: CommentEntity;
    /**
     * 
     * @type {TripEntity}
     * @memberof PostEntity
     */
    trip?: TripEntity;
    /**
     * Is post pinned on its feed?
     * @type {boolean}
     * @memberof PostEntity
     */
    pinned?: boolean;
    /**
     * Is poster id a group id?
     * @type {boolean}
     * @memberof PostEntity
     */
    poster_is_group?: boolean;
    /**
     * PostEntity - for group post type
     * @type {any}
     * @memberof PostEntity
     */
    group_post?: any;
    /**
     * 
     * @type {string}
     * @memberof PostEntity
     */
    language?: string;
}

export type PostEntityTypeEnum = 'user-post' | 'album-photos' | 'trip' | 'group-comment' | 'user-group-post' | 'group' | 'group-post';
export type PostEntityViewAclEnum = 'public' | 'users' | 'friends' | 'me' | 'none';

/**
 * 
 * @export
 * @interface PostEntityOmitComment
 */
export interface PostEntityOmitComment {
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    poster_uid: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    feed_owner_id: string;
    /**
     * Related entity id, e.g. album id for upload-photos actions
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    type?: PostEntityOmitCommentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof PostEntityOmitComment
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    gif_url?: string;
    /**
     * 
     * @type {LikeCommentDataEntity}
     * @memberof PostEntityOmitComment
     */
    likes_comments?: LikeCommentDataEntity;
    /**
     * extra: poster user
     * @type {UserEntity}
     * @memberof PostEntityOmitComment
     */
    user?: UserEntity;
    /**
     * extra: feed owner user
     * @type {UserEntity}
     * @memberof PostEntityOmitComment
     */
    feed_owner?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    view_acl: PostEntityOmitCommentViewAclEnum;
    /**
     * Content moderation approval status
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    mod_status?: string;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof PostEntityOmitComment
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * Only returned for user-post types
     * @type {AlbumEntity}
     * @memberof PostEntityOmitComment
     */
    album?: AlbumEntity;
    /**
     * The first 8 (Feed::MAX_DISPLAY_PHOTOS) attached photos
     * @type {Array<PhotoEntity>}
     * @memberof PostEntityOmitComment
     */
    photos?: Array<PhotoEntity>;
    /**
     * List of all attached photo ids
     * @type {Array<string>}
     * @memberof PostEntityOmitComment
     */
    photo_ids?: Array<string>;
    /**
     * Only returned for group-related types
     * @type {GroupEntity}
     * @memberof PostEntityOmitComment
     */
    group?: GroupEntity;
    /**
     * 
     * @type {any}
     * @memberof PostEntityOmitComment
     */
    group_comment?: any;
    /**
     * 
     * @type {TripEntity}
     * @memberof PostEntityOmitComment
     */
    trip?: TripEntity;
    /**
     * Is post pinned on its feed?
     * @type {boolean}
     * @memberof PostEntityOmitComment
     */
    pinned?: boolean;
    /**
     * Is poster id a group id?
     * @type {boolean}
     * @memberof PostEntityOmitComment
     */
    poster_is_group?: boolean;
    /**
     * PostEntity - for group post type
     * @type {any}
     * @memberof PostEntityOmitComment
     */
    group_post?: any;
    /**
     * 
     * @type {string}
     * @memberof PostEntityOmitComment
     */
    language?: string;
}

export type PostEntityOmitCommentTypeEnum = 'user-post' | 'album-photos' | 'trip' | 'group-comment' | 'user-group-post' | 'group' | 'group-post';
export type PostEntityOmitCommentViewAclEnum = 'public' | 'users' | 'friends' | 'me' | 'none';

/**
 * 
 * @export
 * @interface PostsResponse
 */
export interface PostsResponse {
    /**
     * 
     * @type {Array<PostEntity>}
     * @memberof PostsResponse
     */
    data: Array<PostEntity>;
}


/**
 * 
 * @export
 * @interface PremiumStatusEntity
 */
export interface PremiumStatusEntity {
    /**
     * 
     * @type {string}
     * @memberof PremiumStatusEntity
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumStatusEntity
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumStatusEntity
     */
    auto_renew: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PremiumStatusEntity
     */
    paid_until?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PremiumStatusEntity
     */
    last_paid?: Date;
}


/**
 * 
 * @export
 * @interface ProfileAboutEntity
 */
export interface ProfileAboutEntity {
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    requests: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    hobbies: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    books: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    music: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    movies: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    quotes: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    tv: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAboutEntity
     */
    langex_desc: string;
}


/**
 * 
 * @export
 * @interface ProfileEntity
 */
export interface ProfileEntity {
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    id: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    name: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    birthday: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    username: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {number}
     * @memberof ProfileEntity
     */
    age: number;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    country_code: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    home_country_code?: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    online: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Date}
     * @memberof ProfileEntity
     */
    last_login: Date;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    sex: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {PhotoEntity}
     * @memberof ProfileEntity
     */
    avatar: PhotoEntity;
    /**
     * extra:location
     * @type {LocationEntity}
     * @memberof ProfileEntity
     */
    location: LocationEntity;
    /**
     * Content approval status
     * @type {string}
     * @memberof ProfileEntity
     */
    mod_status?: ProfileEntityModStatusEnum;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof ProfileEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Array<LanguageEntity>}
     * @memberof ProfileEntity
     */
    know: Array<LanguageEntity>;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Array<LanguageEntity>}
     * @memberof ProfileEntity
     */
    learn: Array<LanguageEntity>;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {number}
     * @memberof ProfileEntity
     */
    mutual_friends_count?: number;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    status?: ProfileEntityStatusEnum;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Date}
     * @memberof ProfileEntity
     */
    created: Date;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Date}
     * @memberof ProfileEntity
     */
    updated: Date;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    tz: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    is_premium: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {ProfileAboutEntity}
     * @memberof ProfileEntity
     */
    about: ProfileAboutEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {LookingForEntity}
     * @memberof ProfileEntity
     */
    lfor: LookingForEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    occupation: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    education_desc: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    education_level: ProfileEntityEducationLevelEnum;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    relationship: ProfileEntityRelationshipEnum;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {ProfilePhotosEntity}
     * @memberof ProfileEntity
     */
    profile_photos: ProfilePhotosEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {UserPermissionsEntity}
     * @memberof ProfileEntity
     */
    permissions: UserPermissionsEntity;
    /**
     * DEPRECATED in favor of permissions field
     * @type {CanContactEntity}
     * @memberof ProfileEntity
     */
    can_contact?: CanContactEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    blocked_profile: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    verified_facebook: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    verified_phone: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Array<TagEntity>}
     * @memberof ProfileEntity
     */
    user_tags: Array<TagEntity>;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {number}
     * @memberof ProfileEntity
     */
    reply_rate?: number;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {string}
     * @memberof ProfileEntity
     */
    status_message?: string;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {Date}
     * @memberof ProfileEntity
     */
    status_message_updated?: Date;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {UserMatchSettingsEntity}
     * @memberof ProfileEntity
     */
    match_settings?: UserMatchSettingsEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {PhotoEntity}
     * @memberof ProfileEntity
     */
    newest_photo?: PhotoEntity;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {boolean}
     * @memberof ProfileEntity
     */
    is_bookmarked: boolean;
    /**
     * If you are going to change ProfileEntity, please update AccountEntity as well! Empty newlines below indicate separate fields inherited from UserEntity.
     * @type {RelationEntity}
     * @memberof ProfileEntity
     */
    relation?: RelationEntity;
}

export type ProfileEntityModStatusEnum = 'active' | 'approved' | 'flagged' | 'owner_only' | 'pending' | 'rejected';
export type ProfileEntityStatusEnum = 'active' | 'deleted';
export type ProfileEntityEducationLevelEnum = 'edu_not_specified' | 'edu_high_school' | 'edu_college' | 'edu_bachelors' | 'edu_graduate';
export type ProfileEntityRelationshipEnum = 'rel_not_specified' | 'rel_single' | 'rel_relationship' | 'rel_married' | 'rel_complicated';

/**
 * 
 * @export
 * @interface ProfileIncognitoViewSocketNotification
 */
export interface ProfileIncognitoViewSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof ProfileIncognitoViewSocketNotification
     */
    type?: ProfileIncognitoViewSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileIncognitoViewSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof ProfileIncognitoViewSocketNotification
     */
    counters?: UserCountersEntity;
}

export type ProfileIncognitoViewSocketNotificationTypeEnum = 'PROFILE_VIEW';

/**
 * 
 * @export
 * @interface ProfilePhotosEntity
 */
export interface ProfilePhotosEntity {
    /**
     * 
     * @type {AlbumEntity}
     * @memberof ProfilePhotosEntity
     */
    album: AlbumEntity;
    /**
     * 
     * @type {Array<PhotoEntity>}
     * @memberof ProfilePhotosEntity
     */
    avatars: Array<PhotoEntity>;
}


/**
 * 
 * @export
 * @interface ProfileViewEntity
 */
export interface ProfileViewEntity {
    /**
     * 
     * @type {UserEntity}
     * @memberof ProfileViewEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {Date}
     * @memberof ProfileViewEntity
     */
    viewed: Date;
    /**
     * Has user already fetched list containing this view?
     * @type {boolean}
     * @memberof ProfileViewEntity
     */
    new?: boolean;
}


/**
 * 
 * @export
 * @interface ProfileViewResponse
 */
export interface ProfileViewResponse {
    /**
     * 
     * @type {Array<ProfileViewEntity>}
     * @memberof ProfileViewResponse
     */
    data: Array<ProfileViewEntity>;
}


/**
 * 
 * @export
 * @interface ProfileViewSocketNotification
 */
export interface ProfileViewSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof ProfileViewSocketNotification
     */
    type?: ProfileViewSocketNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileViewSocketNotification
     */
    click_url?: string;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof ProfileViewSocketNotification
     */
    counters?: UserCountersEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ProfileViewSocketNotification
     */
    sender?: UserEntity;
}

export type ProfileViewSocketNotificationTypeEnum = 'PROFILE_VIEW';

/**
 * 
 * @export
 * @interface ProfilesTextEntity
 */
export interface ProfilesTextEntity {
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    requests: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    hobbies: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    books: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    music: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    movies: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    quotes: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    tv: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    langex_desc: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesTextEntity
     */
    description: string;
}


/**
 * 
 * @export
 * @interface PromptEntity
 */
export interface PromptEntity {
    /**
     * 
     * @type {string}
     * @memberof PromptEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PromptEntity
     */
    name: string;
}


/**
 * 
 * @export
 * @interface PromptListResponse
 */
export interface PromptListResponse {
    /**
     * 
     * @type {Array<LangEntryPromptEntity>}
     * @memberof PromptListResponse
     */
    data: Array<LangEntryPromptEntity>;
}


/**
 * 
 * @export
 * @interface PushTokenEntity
 */
export interface PushTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof PushTokenEntity
     */
    id: string;
}


/**
 * 
 * @export
 * @interface RateLimitError
 */
export interface RateLimitError {
    /**
     * 
     * @type {RateLimitErrorError}
     * @memberof RateLimitError
     */
    error: RateLimitErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface RateLimitErrorError
 */
export interface RateLimitErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof RateLimitErrorError
     */
    type: RateLimitErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof RateLimitErrorError
     */
    code: RateLimitErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof RateLimitErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof RateLimitErrorError
     */
    extra?: string;
}

export type RateLimitErrorErrorTypeEnum = 'RateLimit';
export type RateLimitErrorErrorCodeEnum = 'profile_view_limit_exceeded' | 'rate_limit_exceeded' | 'signup_device_limit';

/**
 * 
 * @export
 * @interface RecentlyViewedResponse
 */
export interface RecentlyViewedResponse {
    /**
     * 
     * @type {Array<UserEntity>}
     * @memberof RecentlyViewedResponse
     */
    data: Array<UserEntity>;
}


/**
 * 
 * @export
 * @interface RelationEntity
 */
export interface RelationEntity {
    /**
     * 
     * @type {string}
     * @memberof RelationEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof RelationEntity
     */
    target_id: string;
    /**
     * 
     * @type {string}
     * @memberof RelationEntity
     */
    friend_status: RelationEntityFriendStatusEnum;
    /**
     * Is target_id blocked by uid?
     * @type {boolean}
     * @memberof RelationEntity
     */
    user_blocks_target: boolean;
    /**
     * Is uid blocked by target_id?
     * @type {boolean}
     * @memberof RelationEntity
     */
    target_blocks_user: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RelationEntity
     */
    modified: Date;
    /**
     * 
     * @type {Date}
     * @memberof RelationEntity
     */
    created: Date;
    /**
     * 
     * @type {UserEntity}
     * @memberof RelationEntity
     */
    user?: UserEntity;
}

export type RelationEntityFriendStatusEnum = 'none' | 'friends' | 'outgoing' | 'active' | 'ignored';

/**
 * 
 * @export
 * @interface ReportEntity
 */
export interface ReportEntity {
    /**
     * Report id
     * @type {string}
     * @memberof ReportEntity
     */
    id: string;
    /**
     * Uid of reporting user
     * @type {string}
     * @memberof ReportEntity
     */
    reporter_uid: string;
    /**
     * Uid of reported (target) user
     * @type {string}
     * @memberof ReportEntity
     */
    reported_uid: string;
    /**
     * Id of reported entity
     * @type {string}
     * @memberof ReportEntity
     */
    entity_id: string;
    /**
     * Reported entity type
     * @type {string}
     * @memberof ReportEntity
     */
    entity_type: ReportEntityEntityTypeEnum;
    /**
     * Report creation timestamp
     * @type {Date}
     * @memberof ReportEntity
     */
    created: Date;
    /**
     * Report reason category selected by user
     * @type {string}
     * @memberof ReportEntity
     */
    reason_category: ReportEntityReasonCategoryEnum;
    /**
     * Current moderation status of report
     * @type {string}
     * @memberof ReportEntity
     */
    status?: ReportEntityStatusEnum;
    /**
     * User-entered text justifying the report
     * @type {string}
     * @memberof ReportEntity
     */
    message: string;
    /**
     * 
     * @type {GroupEntity}
     * @memberof ReportEntity
     */
    reported_group?: GroupEntity;
    /**
     * 
     * @type {PostEntity}
     * @memberof ReportEntity
     */
    reported_post?: PostEntity;
    /**
     * 
     * @type {CommentEntity}
     * @memberof ReportEntity
     */
    reported_comment?: CommentEntity;
    /**
     * 
     * @type {PhotoEntity}
     * @memberof ReportEntity
     */
    reported_photo?: PhotoEntity;
    /**
     * 
     * @type {MessageEntity}
     * @memberof ReportEntity
     */
    reported_message?: MessageEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ReportEntity
     */
    reporter?: UserEntity;
    /**
     * Recent messages between reporter and reported (if dialog exists)
     * @type {Array<MessageEntity>}
     * @memberof ReportEntity
     */
    thread_messages?: Array<MessageEntity>;
}

export type ReportEntityEntityTypeEnum = 'user' | 'photo' | 'message' | 'comment' | 'post' | 'group' | 'thread';
export type ReportEntityReasonCategoryEnum = 'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs';
export type ReportEntityStatusEnum = 'active' | 'archived' | 'pending' | 'cleared' | 'escalated';

/**
 * 
 * @export
 * @interface ReportsEntityResponse
 */
export interface ReportsEntityResponse {
    /**
     * 
     * @type {Array<ReportEntity>}
     * @memberof ReportsEntityResponse
     */
    data: Array<ReportEntity>;
}


/**
 * 
 * @export
 * @interface ReportsResponse
 */
export interface ReportsResponse {
    /**
     * 
     * @type {Array<UserReportsEntity>}
     * @memberof ReportsResponse
     */
    data: Array<UserReportsEntity>;
    /**
     * 
     * @type {number}
     * @memberof ReportsResponse
     */
    total?: number;
}


/**
 * 
 * @export
 * @interface SearchFriendResponse
 */
export interface SearchFriendResponse {
    /**
     * 
     * @type {Array<RelationEntity>}
     * @memberof SearchFriendResponse
     */
    data: Array<RelationEntity>;
}


/**
 * 
 * @export
 * @interface SearchPromptResponse
 */
export interface SearchPromptResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchPromptResponse
     */
    total: number;
    /**
     * 
     * @type {Array<LangEntryPromptEntity>}
     * @memberof SearchPromptResponse
     */
    data: Array<LangEntryPromptEntity>;
}


/**
 * 
 * @export
 * @interface SearchTravelerEntity
 */
export interface SearchTravelerEntity {
    /**
     * 
     * @type {TripEntity}
     * @memberof SearchTravelerEntity
     */
    trip: TripEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof SearchTravelerEntity
     */
    user: UserEntity;
}


/**
 * 
 * @export
 * @interface SearchTripResponse
 */
export interface SearchTripResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchTripResponse
     */
    total: number;
    /**
     * 
     * @type {Array<TripEntity>}
     * @memberof SearchTripResponse
     */
    data: Array<TripEntity>;
}


/**
 * 
 * @export
 * @interface SearchTripTravelerResponse
 */
export interface SearchTripTravelerResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchTripTravelerResponse
     */
    total: number;
    /**
     * 
     * @type {Array<SearchTravelerEntity>}
     * @memberof SearchTripTravelerResponse
     */
    data: Array<SearchTravelerEntity>;
}


/**
 * 
 * @export
 * @interface SearchUserResponse
 */
export interface SearchUserResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchUserResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ProfileEntity>}
     * @memberof SearchUserResponse
     */
    data: Array<ProfileEntity>;
}


/**
 * 
 * @export
 * @interface SelectOptionEntity
 */
export interface SelectOptionEntity {
    /**
     * 
     * @type {string}
     * @memberof SelectOptionEntity
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SelectOptionEntity
     */
    value: string;
}


/**
 * 
 * @export
 * @interface SettingsEntity
 */
export interface SettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsEntity
     */
    freq_recv: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    chatreq_recv: SettingsEntityChatreqRecvEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    msg_recv: SettingsEntityMsgRecvEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    wall_write: SettingsEntityWallWriteEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    wall_view: SettingsEntityWallViewEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    friends_view: SettingsEntityFriendsViewEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    call_recv: SettingsEntityCallRecvEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsEntity
     */
    freq_require_contact: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsEntity
     */
    noindex: boolean;
    /**
     * 
     * @type {ContactRulesEntity}
     * @memberof SettingsEntity
     */
    contact_rules: ContactRulesEntity;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    allowed_countries?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsEntity
     */
    allowed_languages?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsEntity
     */
    native_speakers_only?: boolean;
    /**
     * 
     * @type {LForEntity}
     * @memberof SettingsEntity
     */
    lfor_required?: LForEntity;
    /**
     * 
     * @type {LForEntity}
     * @memberof SettingsEntity
     */
    lfor_blocked?: LForEntity;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsEntity
     */
    incognito: boolean;
}

export type SettingsEntityChatreqRecvEnum = 'public' | 'users' | 'friends' | 'me';
export type SettingsEntityMsgRecvEnum = 'public' | 'users' | 'friends' | 'me';
export type SettingsEntityWallWriteEnum = 'public' | 'users' | 'friends' | 'me';
export type SettingsEntityWallViewEnum = 'public' | 'users' | 'friends' | 'me';
export type SettingsEntityFriendsViewEnum = 'public' | 'users' | 'friends' | 'me';
export type SettingsEntityCallRecvEnum = 'public' | 'users' | 'friends' | 'me' | 'none';

/**
 * 
 * @export
 * @interface SyncCountersSocketNotification
 */
export interface SyncCountersSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof SyncCountersSocketNotification
     */
    type?: SyncCountersSocketNotificationTypeEnum;
    /**
     * 
     * @type {UserCountersEntity}
     * @memberof SyncCountersSocketNotification
     */
    counters?: UserCountersEntity;
}

export type SyncCountersSocketNotificationTypeEnum = 'SYNC_TOTAL_COUNTER';

/**
 * 
 * @export
 * @interface TagEntity
 */
export interface TagEntity {
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    cat_id: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    name: string;
}


/**
 * 
 * @export
 * @interface TagListEntity
 */
export interface TagListEntity {
    /**
     * 
     * @type {string}
     * @memberof TagListEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagListEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagListEntity
     */
    count: string;
}


/**
 * 
 * @export
 * @interface TagSearchItemEntity
 */
export interface TagSearchItemEntity {
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntity
     */
    cat_id: string;
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntity
     */
    defaultName?: string;
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntity
     */
    user_language?: string;
    /**
     * 
     * @type {Array<TagSearchItemEntityMatches>}
     * @memberof TagSearchItemEntity
     */
    matches?: Array<TagSearchItemEntityMatches>;
}


/**
 * 
 * @export
 * @interface TagSearchItemEntityMatches
 */
export interface TagSearchItemEntityMatches {
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntityMatches
     */
    default_match?: string;
    /**
     * 
     * @type {string}
     * @memberof TagSearchItemEntityMatches
     */
    translations_suggest?: string;
}


/**
 * 
 * @export
 * @interface TagSearchResponse
 */
export interface TagSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof TagSearchResponse
     */
    total: number;
    /**
     * 
     * @type {Array<TagSearchItemEntity>}
     * @memberof TagSearchResponse
     */
    data: Array<TagSearchItemEntity>;
}


/**
 * 
 * @export
 * @interface TagsResponse
 */
export interface TagsResponse {
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof TagsResponse
     */
    data: Array<TagEntity>;
}


/**
 * 
 * @export
 * @interface TextFilterEntity
 */
export interface TextFilterEntity {
    /**
     * 
     * @type {string}
     * @memberof TextFilterEntity
     */
    id: string;
    /**
     * Type of content filter is applied to
     * @type {string}
     * @memberof TextFilterEntity
     */
    content_type: TextFilterEntityContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TextFilterEntity
     */
    rule_type: TextFilterEntityRuleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TextFilterEntity
     */
    pattern: string;
    /**
     * 
     * @type {Date}
     * @memberof TextFilterEntity
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof TextFilterEntity
     */
    comment?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof TextFilterEntity
     */
    moderator?: UserEntity;
}

export type TextFilterEntityContentTypeEnum = 'email' | 'content' | 'initial_msg' | 'msg' | 'profile';
export type TextFilterEntityRuleTypeEnum = 'regex' | 'similarity';

/**
 * 
 * @export
 * @interface TextFiltersResponse
 */
export interface TextFiltersResponse {
    /**
     * 
     * @type {Array<TextFilterEntity>}
     * @memberof TextFiltersResponse
     */
    data: Array<TextFilterEntity>;
    /**
     * 
     * @type {number}
     * @memberof TextFiltersResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface ThreadDeletedEntity
 */
export interface ThreadDeletedEntity {
    /**
     * Deleted thread id
     * @type {string}
     * @memberof ThreadDeletedEntity
     */
    thread_id?: string;
}


/**
 * 
 * @export
 * @interface ThreadEntity
 */
export interface ThreadEntity {
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    target_id: string;
    /**
     * 
     * @type {number}
     * @memberof ThreadEntity
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ThreadEntity
     */
    new: number;
    /**
     * 
     * @type {Date}
     * @memberof ThreadEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    msg_snippet?: string;
    /**
     * 
     * @type {Date}
     * @memberof ThreadEntity
     */
    last_opened?: Date;
    /**
     * extra:last msg id opened by contact
     * @type {string}
     * @memberof ThreadEntity
     */
    target_last_read_msg_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    last_msg_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    last_msg_sender_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ThreadEntity
     */
    last_msg_datetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ThreadEntity
     */
    last_msg_type?: ThreadEntityLastMsgTypeEnum;
    /**
     * 
     * @type {UserEntity}
     * @memberof ThreadEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {MessageDraftEntity}
     * @memberof ThreadEntity
     */
    draft?: MessageDraftEntity;
}

export type ThreadEntityLastMsgTypeEnum = 'text' | 'photo' | 'audio' | 'video' | 'call' | 'gif' | 'reply' | 'correction';

/**
 * 
 * @export
 * @interface ThreadMessagesResponse
 */
export interface ThreadMessagesResponse {
    /**
     * 
     * @type {Array<MessageEntity>}
     * @memberof ThreadMessagesResponse
     */
    data: Array<MessageEntity>;
}


/**
 * 
 * @export
 * @interface ThreadRestoreResponse
 */
export interface ThreadRestoreResponse {
    /**
     * 
     * @type {ThreadEntity}
     * @memberof ThreadRestoreResponse
     */
    thread: ThreadEntity;
    /**
     * 
     * @type {Array<MessageEntity>}
     * @memberof ThreadRestoreResponse
     */
    messages: Array<MessageEntity>;
}


/**
 * 
 * @export
 * @interface ThreadSyncDeletedSocketNotification
 */
export interface ThreadSyncDeletedSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof ThreadSyncDeletedSocketNotification
     */
    type?: ThreadSyncDeletedSocketNotificationTypeEnum;
    /**
     * 
     * @type {ThreadDeletedEntity}
     * @memberof ThreadSyncDeletedSocketNotification
     */
    data?: ThreadDeletedEntity;
}

export type ThreadSyncDeletedSocketNotificationTypeEnum = 'THREAD_SYNC_DELETED';

/**
 * 
 * @export
 * @interface ThreadSyncMessageSocketNotification
 */
export interface ThreadSyncMessageSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof ThreadSyncMessageSocketNotification
     */
    type?: ThreadSyncMessageSocketNotificationTypeEnum;
    /**
     * 
     * @type {MessageEntity}
     * @memberof ThreadSyncMessageSocketNotification
     */
    data?: MessageEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ThreadSyncMessageSocketNotification
     */
    contact?: UserEntity;
}

export type ThreadSyncMessageSocketNotificationTypeEnum = 'THREAD_SYNC_MESSAGE';

/**
 * 
 * @export
 * @interface ThreadSyncViewedNotification
 */
export interface ThreadSyncViewedNotification {
    /**
     * 
     * @type {string}
     * @memberof ThreadSyncViewedNotification
     */
    type?: ThreadSyncViewedNotificationTypeEnum;
    /**
     * 
     * @type {ThreadViewedEntity}
     * @memberof ThreadSyncViewedNotification
     */
    data?: ThreadViewedEntity;
}

export type ThreadSyncViewedNotificationTypeEnum = 'THREAD_VIEWED';

/**
 * 
 * @export
 * @interface ThreadTypingEntity
 */
export interface ThreadTypingEntity {
    /**
     * 
     * @type {string}
     * @memberof ThreadTypingEntity
     */
    thread_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ThreadTypingEntity
     */
    delay?: number;
}


/**
 * 
 * @export
 * @interface ThreadTypingSocketNotification
 */
export interface ThreadTypingSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof ThreadTypingSocketNotification
     */
    type?: ThreadTypingSocketNotificationTypeEnum;
    /**
     * 
     * @type {ThreadTypingEntity}
     * @memberof ThreadTypingSocketNotification
     */
    data?: ThreadTypingEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ThreadTypingSocketNotification
     */
    sender?: UserEntity;
}

export type ThreadTypingSocketNotificationTypeEnum = 'THREAD_TYPING';

/**
 * 
 * @export
 * @interface ThreadViewedEntity
 */
export interface ThreadViewedEntity {
    /**
     * 
     * @type {string}
     * @memberof ThreadViewedEntity
     */
    thread_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ThreadViewedEntity
     */
    target_last_opened?: Date;
    /**
     * 
     * @type {string}
     * @memberof ThreadViewedEntity
     */
    target_last_read_msg_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadViewedEntity
     */
    viewer_uid?: string;
    /**
     * 
     * @type {Date}
     * @memberof ThreadViewedEntity
     */
    last_opened?: Date;
    /**
     * 
     * @type {string}
     * @memberof ThreadViewedEntity
     */
    last_message_id?: string;
}


/**
 * 
 * @export
 * @interface TokenEntity
 */
export interface TokenEntity {
    /**
     * 
     * @type {string}
     * @memberof TokenEntity
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof TokenEntity
     */
    status: TokenEntityStatusEnum;
    /**
     * 
     * @type {AccountEntity}
     * @memberof TokenEntity
     */
    account?: AccountEntity;
}

export type TokenEntityStatusEnum = 'active' | 'deleted' | 'admin' | 'inactive_account';

/**
 * 
 * @export
 * @interface TotalNumberResponse
 */
export interface TotalNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof TotalNumberResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface TripEntity
 */
export interface TripEntity {
    /**
     * 
     * @type {string}
     * @memberof TripEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TripEntity
     */
    owner_uid: string;
    /**
     * 
     * @type {string}
     * @memberof TripEntity
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof TripEntity
     */
    end_date: string;
    /**
     * 
     * @type {Date}
     * @memberof TripEntity
     */
    created: Date;
    /**
     * city
     * @type {GeoEntity}
     * @memberof TripEntity
     */
    city: GeoEntity;
    /**
     * 
     * @type {string}
     * @memberof TripEntity
     */
    description?: string;
}


/**
 * 
 * @export
 * @interface TripListResponse
 */
export interface TripListResponse {
    /**
     * 
     * @type {Array<TripEntity>}
     * @memberof TripListResponse
     */
    data: Array<TripEntity>;
}


/**
 * 
 * @export
 * @interface URLNotFoundError
 */
export interface URLNotFoundError {
    /**
     * 
     * @type {URLNotFoundErrorError}
     * @memberof URLNotFoundError
     */
    error: URLNotFoundErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface URLNotFoundErrorError
 */
export interface URLNotFoundErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof URLNotFoundErrorError
     */
    type: URLNotFoundErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof URLNotFoundErrorError
     */
    code: URLNotFoundErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof URLNotFoundErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof URLNotFoundErrorError
     */
    extra?: string;
}

export type URLNotFoundErrorErrorTypeEnum = 'URLNotFound';
export type URLNotFoundErrorErrorCodeEnum = 'route_not_found';

/**
 * 
 * @export
 * @interface UnauthorizedError
 */
export interface UnauthorizedError {
    /**
     * 
     * @type {UnauthorizedErrorError}
     * @memberof UnauthorizedError
     */
    error: UnauthorizedErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface UnauthorizedErrorError
 */
export interface UnauthorizedErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof UnauthorizedErrorError
     */
    type: UnauthorizedErrorErrorTypeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof UnauthorizedErrorError
     */
    code: UnauthorizedErrorErrorCodeEnum;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof UnauthorizedErrorError
     */
    message?: string;
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof UnauthorizedErrorError
     */
    extra?: string;
}

export type UnauthorizedErrorErrorTypeEnum = 'Unauthorized';
export type UnauthorizedErrorErrorCodeEnum = 'token_missing_or_invalid' | 'token_user_not_found' | 'invalid_login_credentials' | 'must_reset_password';

/**
 * 
 * @export
 * @interface UserActivityResponse
 */
export interface UserActivityResponse {
    /**
     * 
     * @type {Array<AccountActivityEntity>}
     * @memberof UserActivityResponse
     */
    data: Array<AccountActivityEntity>;
}


/**
 * 
 * @export
 * @interface UserAgentEntity
 */
export interface UserAgentEntity {
    /**
     * 
     * @type {string}
     * @memberof UserAgentEntity
     */
    hash: string;
    /**
     * 
     * @type {string}
     * @memberof UserAgentEntity
     */
    string?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAgentEntity
     */
    short_string?: string;
}


/**
 * 
 * @export
 * @interface UserAlbumsResponse
 */
export interface UserAlbumsResponse {
    /**
     * 
     * @type {Array<AlbumEntity>}
     * @memberof UserAlbumsResponse
     */
    data: Array<AlbumEntity>;
}


/**
 * 
 * @export
 * @interface UserBookmarkResponse
 */
export interface UserBookmarkResponse {
    /**
     * 
     * @type {Array<BookmarkEntity>}
     * @memberof UserBookmarkResponse
     */
    data: Array<BookmarkEntity>;
}


/**
 * 
 * @export
 * @interface UserCountersEntity
 */
export interface UserCountersEntity {
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    new_friend_requests: number;
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    new_messages: number;
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    new_notifications: number;
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    new_views: number;
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    total_threads: number;
    /**
     * 
     * @type {number}
     * @memberof UserCountersEntity
     */
    unread_threads: number;
}


/**
 * 
 * @export
 * @interface UserDataDumpEntity
 */
export interface UserDataDumpEntity {
    /**
     * 
     * @type {ProfilesTextEntity}
     * @memberof UserDataDumpEntity
     */
    profile_texts?: ProfilesTextEntity;
    /**
     * 
     * @type {Array<UserEntity>}
     * @memberof UserDataDumpEntity
     */
    friends?: Array<UserEntity>;
    /**
     * 
     * @type {Array<WallEntity>}
     * @memberof UserDataDumpEntity
     */
    wall_posts?: Array<WallEntity>;
    /**
     * 
     * @type {Array<CommentEntity>}
     * @memberof UserDataDumpEntity
     */
    comments?: Array<CommentEntity>;
    /**
     * 
     * @type {Array<AccountActivityEntity>}
     * @memberof UserDataDumpEntity
     */
    account_activity?: Array<AccountActivityEntity>;
    /**
     * 
     * @type {Array<ThreadEntity>}
     * @memberof UserDataDumpEntity
     */
    threads?: Array<ThreadEntity>;
    /**
     * 
     * @type {Array<MessageEntity>}
     * @memberof UserDataDumpEntity
     */
    messages?: Array<MessageEntity>;
}


/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    id: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    name: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    birthday: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    username: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {number}
     * @memberof UserEntity
     */
    age: number;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    country_code: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    home_country_code?: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {boolean}
     * @memberof UserEntity
     */
    online: boolean;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {Date}
     * @memberof UserEntity
     */
    last_login: Date;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    sex: string;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {PhotoEntity}
     * @memberof UserEntity
     */
    avatar: PhotoEntity;
    /**
     * extra:location
     * @type {LocationEntity}
     * @memberof UserEntity
     */
    location?: LocationEntity;
    /**
     * Content approval status
     * @type {string}
     * @memberof UserEntity
     */
    mod_status?: UserEntityModStatusEnum;
    /**
     * Moderation flags
     * @type {Array<ModerationFlagEntity>}
     * @memberof UserEntity
     */
    mod_flags?: Array<ModerationFlagEntity>;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {Array<LanguageEntity>}
     * @memberof UserEntity
     */
    know?: Array<LanguageEntity>;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {Array<LanguageEntity>}
     * @memberof UserEntity
     */
    learn?: Array<LanguageEntity>;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {number}
     * @memberof UserEntity
     */
    mutual_friends_count?: number;
    /**
     * If you are going to update UserEntity, you must update ProfileEntity and AccounteEntity as well.
     * @type {string}
     * @memberof UserEntity
     */
    status?: UserEntityStatusEnum;
}

export type UserEntityModStatusEnum = 'active' | 'approved' | 'flagged' | 'owner_only' | 'pending' | 'rejected';
export type UserEntityStatusEnum = 'active' | 'deleted';

/**
 * 
 * @export
 * @interface UserFriendsBirthdayResponse
 */
export interface UserFriendsBirthdayResponse {
    /**
     * 
     * @type {Array<UserEntity>}
     * @memberof UserFriendsBirthdayResponse
     */
    data: Array<UserEntity>;
}


/**
 * 
 * @export
 * @interface UserGroupsResponse
 */
export interface UserGroupsResponse {
    /**
     * 
     * @type {Array<GroupEntity>}
     * @memberof UserGroupsResponse
     */
    data: Array<GroupEntity>;
}


/**
 * 
 * @export
 * @interface UserHeartbeatSocketNotification
 */
export interface UserHeartbeatSocketNotification {
    /**
     * 
     * @type {string}
     * @memberof UserHeartbeatSocketNotification
     */
    type?: UserHeartbeatSocketNotificationTypeEnum;
    /**
     * 
     * @type {UserEntity}
     * @memberof UserHeartbeatSocketNotification
     */
    data?: UserEntity;
}

export type UserHeartbeatSocketNotificationTypeEnum = 'USER_HEARTBEAT';

/**
 * 
 * @export
 * @interface UserIpEntity
 */
export interface UserIpEntity {
    /**
     * 
     * @type {string}
     * @memberof UserIpEntity
     */
    ip: string;
    /**
     * 
     * @type {Date}
     * @memberof UserIpEntity
     */
    first_activity_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserIpEntity
     */
    last_activity_at: Date;
    /**
     * 
     * @type {string}
     * @memberof UserIpEntity
     */
    country_code: string;
}


/**
 * 
 * @export
 * @interface UserIpsResponse
 */
export interface UserIpsResponse {
    /**
     * 
     * @type {Array<UserIpEntity>}
     * @memberof UserIpsResponse
     */
    data: Array<UserIpEntity>;
}


/**
 * 
 * @export
 * @interface UserMatchSettingsEntity
 */
export interface UserMatchSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof UserMatchSettingsEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof UserMatchSettingsEntity
     */
    allowed_sex?: UserMatchSettingsEntityAllowedSexEnum;
    /**
     * 
     * @type {number}
     * @memberof UserMatchSettingsEntity
     */
    min_allowed_age?: number;
    /**
     * 
     * @type {number}
     * @memberof UserMatchSettingsEntity
     */
    max_allowed_age?: number;
    /**
     * 
     * @type {string}
     * @memberof UserMatchSettingsEntity
     */
    allowed_countries?: string;
    /**
     * 
     * @type {string}
     * @memberof UserMatchSettingsEntity
     */
    allowed_languages?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserMatchSettingsEntity
     */
    native_speakers_only?: boolean;
    /**
     * 
     * @type {LForEntity}
     * @memberof UserMatchSettingsEntity
     */
    lfor?: LForEntity;
    /**
     * 
     * @type {boolean}
     * @memberof UserMatchSettingsEntity
     */
    enabled_filters?: boolean;
}

export type UserMatchSettingsEntityAllowedSexEnum = 'male' | 'female';

/**
 * 
 * @export
 * @interface UserNotificationsResponse
 */
export interface UserNotificationsResponse {
    /**
     * 
     * @type {Array<NotificationEntity>}
     * @memberof UserNotificationsResponse
     */
    data: Array<NotificationEntity>;
}


/**
 * 
 * @export
 * @interface UserPermissionsEntity
 */
export interface UserPermissionsEntity {
    /**
     * Can requester send message to this user
     * @type {boolean}
     * @memberof UserPermissionsEntity
     */
    send_message: boolean;
    /**
     * Can requester send friend request to this user
     * @type {boolean}
     * @memberof UserPermissionsEntity
     */
    add_friend: boolean;
    /**
     * Can requester write on this user's feed/wall
     * @type {boolean}
     * @memberof UserPermissionsEntity
     */
    add_feed_post: boolean;
    /**
     * Can requester view this user's feed/wall
     * @type {boolean}
     * @memberof UserPermissionsEntity
     */
    view_feed: boolean;
    /**
     * Can requester view this uers's friends
     * @type {boolean}
     * @memberof UserPermissionsEntity
     */
    view_friends: boolean;
}


/**
 * 
 * @export
 * @interface UserRelationsResponse
 */
export interface UserRelationsResponse {
    /**
     * 
     * @type {Array<RelationEntity>}
     * @memberof UserRelationsResponse
     */
    data: Array<RelationEntity>;
}


/**
 * 
 * @export
 * @interface UserReportsEntity
 */
export interface UserReportsEntity {
    /**
     * 
     * @type {AccountEntity}
     * @memberof UserReportsEntity
     */
    account: AccountEntity;
    /**
     * 
     * @type {Array<ReportEntity>}
     * @memberof UserReportsEntity
     */
    reports: Array<ReportEntity>;
}


/**
 * 
 * @export
 * @interface UserReportsResponse
 */
export interface UserReportsResponse {
    /**
     * 
     * @type {Array<ReportEntity>}
     * @memberof UserReportsResponse
     */
    data: Array<ReportEntity>;
}


/**
 * 
 * @export
 * @interface UserStatusEntity
 */
export interface UserStatusEntity {
    /**
     * 
     * @type {Date}
     * @memberof UserStatusEntity
     */
    updated?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserStatusEntity
     */
    message?: string;
}


/**
 * 
 * @export
 * @interface UserTagEntity
 */
export interface UserTagEntity {
    /**
     * 
     * @type {string}
     * @memberof UserTagEntity
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof UserTagEntity
     */
    tag_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserTagEntity
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserTagEntity
     */
    created: Date;
}


/**
 * 
 * @export
 * @interface UserTagsResponse
 */
export interface UserTagsResponse {
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof UserTagsResponse
     */
    data: Array<TagEntity>;
}


/**
 * 
 * @export
 * @interface UserThreadsResponse
 */
export interface UserThreadsResponse {
    /**
     * 
     * @type {Array<ThreadEntity>}
     * @memberof UserThreadsResponse
     */
    data: Array<ThreadEntity>;
}


/**
 * 
 * @export
 * @interface UserTripsResponse
 */
export interface UserTripsResponse {
    /**
     * 
     * @type {Array<TripEntity>}
     * @memberof UserTripsResponse
     */
    data: Array<TripEntity>;
    /**
     * Deprecated. Use getTotalNumberOfUserTrips instead
     * @type {number}
     * @memberof UserTripsResponse
     */
    total: number;
}


/**
 * 
 * @export
 * @interface UsersResponse
 */
export interface UsersResponse {
    /**
     * 
     * @type {Array<UserEntity>}
     * @memberof UsersResponse
     */
    data: Array<UserEntity>;
}


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {ValidationErrorError}
     * @memberof ValidationError
     */
    error: ValidationErrorError;
}


/**
 * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
 * @export
 * @interface ValidationErrorError
 */
export interface ValidationErrorError {
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ValidationErrorError
     */
    type: ValidationErrorErrorTypeEnum;
    /**
     * Code of first failure (deprecated, use 'errors' instead)
     * @type {string}
     * @memberof ValidationErrorError
     */
    code: string;
    /**
     * Parameter name of first failing parameter (deprecated)
     * @type {string}
     * @memberof ValidationErrorError
     */
    parameter?: string;
    /**
     * Error message of first failure (deprecated)
     * @type {string}
     * @memberof ValidationErrorError
     */
    message?: string;
    /**
     * Map of failing parameter names to translation key and message
     * @type {{ [key: string]: ValidationErrorFieldMapItem; }}
     * @memberof ValidationErrorError
     */
    errors: { [key: string]: ValidationErrorFieldMapItem; };
    /**
     * // Error schemas with codes corresponding to Interpals\\Service\\Api\\Exception classes
     * @type {string}
     * @memberof ValidationErrorError
     */
    extra?: string;
}

export type ValidationErrorErrorTypeEnum = 'Validation';

/**
 * 
 * @export
 * @interface ValidationErrorFieldMapItem
 */
export interface ValidationErrorFieldMapItem {
    /**
     * Internal error code
     * @type {string}
     * @memberof ValidationErrorFieldMapItem
     */
    code: string;
    /**
     * Localized user-facing error message
     * @type {string}
     * @memberof ValidationErrorFieldMapItem
     */
    message: string;
}


/**
 * 
 * @export
 * @interface ViewsStatEntity
 */
export interface ViewsStatEntity {
    /**
     * 
     * @type {string}
     * @memberof ViewsStatEntity
     */
    period: string;
    /**
     * 
     * @type {number}
     * @memberof ViewsStatEntity
     */
    recentCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ViewsStatEntity
     */
    since?: Date;
    /**
     * 
     * @type {number}
     * @memberof ViewsStatEntity
     */
    count?: number;
}


/**
 * 
 * @export
 * @interface WallEntity
 */
export interface WallEntity {
    /**
     * 
     * @type {string}
     * @memberof WallEntity
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof WallEntity
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof WallEntity
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof WallEntity
     */
    poster: string;
    /**
     * 
     * @type {string}
     * @memberof WallEntity
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof WallEntity
     */
    uread: boolean;
}


/**
 * 
 * @export
 * @interface ErrorResponseItem404
 */
export interface ErrorResponseItem404 {
    /**
     * 
     * @type {URLNotFoundErrorError}
     * @memberof ErrorResponseItem404
     */
    error: URLNotFoundErrorError;
}


/**
 * 
 * @export
 * @interface ErrorResponseItem429
 */
export interface ErrorResponseItem429 {
    /**
     * 
     * @type {RateLimitErrorError}
     * @memberof ErrorResponseItem429
     */
    error: RateLimitErrorError;
}



/**
 * Account - fetch parameter creator
 * @export
 */
export const AccountFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm email. Returns a login token since this is used for activation as well as email change.
         * @param {confirmEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(params: confirmEmailParams, options?: any): FetchArgs {
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling confirmEmail");
            }
            // verify required parameter "params.code" is set
            if (params.code == null) {
                throw new Error("Missing required parameter 'code' when calling confirmEmail");
            }
            const localVarPath = `/account/email-confirmation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            if (params.code !== undefined) {
                localVarFormParams.set('code', params.code as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new user
         * @param {createAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(params: createAccountParams, options?: any): FetchArgs {
            // verify required parameter "params.name" is set
            if (params.name == null) {
                throw new Error("Missing required parameter 'name' when calling createAccount");
            }
            // verify required parameter "params.email" is set
            if (params.email == null) {
                throw new Error("Missing required parameter 'email' when calling createAccount");
            }
            // verify required parameter "params.birthday" is set
            if (params.birthday == null) {
                throw new Error("Missing required parameter 'birthday' when calling createAccount");
            }
            // verify required parameter "params.city_id" is set
            if (params.city_id == null) {
                throw new Error("Missing required parameter 'city_id' when calling createAccount");
            }
            // verify required parameter "params.home_city_id" is set
            if (params.home_city_id == null) {
                throw new Error("Missing required parameter 'home_city_id' when calling createAccount");
            }
            // verify required parameter "params.sex" is set
            if (params.sex == null) {
                throw new Error("Missing required parameter 'sex' when calling createAccount");
            }
            const localVarPath = `/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            if (params.birthday !== undefined) {
                localVarFormParams.set('birthday', params.birthday as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            if (params.home_city_id !== undefined) {
                localVarFormParams.set('home_city_id', params.home_city_id as any);
            }

            if (params.sex !== undefined) {
                localVarFormParams.set('sex', params.sex as any);
            }

            if (params.password !== undefined) {
                localVarFormParams.set('password', params.password as any);
            }

            if (params.oauth_provider !== undefined) {
                localVarFormParams.set('oauth_provider', params.oauth_provider as any);
            }

            if (params.oauth_access_token !== undefined) {
                localVarFormParams.set('oauth_access_token', params.oauth_access_token as any);
            }

            if (params.oauth_id !== undefined) {
                localVarFormParams.set('oauth_id', params.oauth_id as any);
            }

            if (params.oauth_redirect_uri !== undefined) {
                localVarFormParams.set('oauth_redirect_uri', params.oauth_redirect_uri as any);
            }

            if (params.phone !== undefined) {
                localVarFormParams.set('phone', params.phone as any);
            }

            if (params.firebase_token !== undefined) {
                localVarFormParams.set('firebase_token', params.firebase_token as any);
            }

            if (params.lang !== undefined) {
                localVarFormParams.set('lang', params.lang as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete own account
         * @param {deleteAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(params: deleteAccountParams, options?: any): FetchArgs {
            const localVarPath = `/account/self`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.reason !== undefined) {
                localVarQueryParameter['reason'] = params.reason;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user account
         * @param {getAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(params: getAccountParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getAccount");
            }
            const localVarPath = `/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reactivate deleted account. Requires token from createToken to verify login info before reactivating.
         * @param {reactivateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateAccount(options?: any): FetchArgs {
            const localVarPath = `/account/self/reactivate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend verification email to address on file (not for email change)
         * @param {resendVerificationEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(params: resendVerificationEmailParams, options?: any): FetchArgs {
            const localVarPath = `/account/resend-verification-email`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password using code from email (received from forgot password screen)
         * @param {resetPasswordParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(params: resetPasswordParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resetPassword");
            }
            // verify required parameter "params.code" is set
            if (params.code == null) {
                throw new Error("Missing required parameter 'code' when calling resetPassword");
            }
            // verify required parameter "params.password" is set
            if (params.password == null) {
                throw new Error("Missing required parameter 'password' when calling resetPassword");
            }
            const localVarPath = `/account/{id}/reset-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.code !== undefined) {
                localVarFormParams.set('code', params.code as any);
            }

            if (params.password !== undefined) {
                localVarFormParams.set('password', params.password as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send password reset link to email address on file
         * @param {sendResetPasswordLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordLink(params: sendResetPasswordLinkParams, options?: any): FetchArgs {
            // verify required parameter "params.email" is set
            if (params.email == null) {
                throw new Error("Missing required parameter 'email' when calling sendResetPasswordLink");
            }
            const localVarPath = `/account/send-reset-password-link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update current user account
         * @param {updateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(params: updateAccountParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateAccount");
            }
            const localVarPath = `/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.birthday !== undefined) {
                localVarFormParams.set('birthday', params.birthday as any);
            }

            if (params.lang !== undefined) {
                localVarFormParams.set('lang', params.lang as any);
            }

            if (params.home_city_id !== undefined) {
                localVarFormParams.set('home_city_id', params.home_city_id as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.username !== undefined) {
                localVarFormParams.set('username', params.username as any);
            }

            if (params.password !== undefined) {
                localVarFormParams.set('password', params.password as any);
            }

            if (params.new_password !== undefined) {
                localVarFormParams.set('new_password', params.new_password as any);
            }

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            if (params.sex !== undefined) {
                localVarFormParams.set('sex', params.sex as any);
            }

            if (params.tz !== undefined) {
                localVarFormParams.set('tz', params.tz as any);
            }

            if (params.website !== undefined) {
                localVarFormParams.set('website', params.website as any);
            }

            if (params.lfor !== undefined) {
                localVarFormParams.set('lfor', params.lfor as any);
            }

            if (params.push_likes !== undefined) {
                localVarFormParams.set('push_likes', params.push_likes as any);
            }

            if (params.push_profile_views !== undefined) {
                localVarFormParams.set('push_profile_views', params.push_profile_views as any);
            }

            if (params.push_comments !== undefined) {
                localVarFormParams.set('push_comments', params.push_comments as any);
            }

            if (params.push_messages !== undefined) {
                localVarFormParams.set('push_messages', params.push_messages as any);
            }

            if (params.push_birthdays !== undefined) {
                localVarFormParams.set('push_birthdays', params.push_birthdays as any);
            }

            if (params.push_feed_posts !== undefined) {
                localVarFormParams.set('push_feed_posts', params.push_feed_posts as any);
            }

            if (params.push_friend_requests !== undefined) {
                localVarFormParams.set('push_friend_requests', params.push_friend_requests as any);
            }

            if (params.email_likes !== undefined) {
                localVarFormParams.set('email_likes', params.email_likes as any);
            }

            if (params.email_profile_views !== undefined) {
                localVarFormParams.set('email_profile_views', params.email_profile_views as any);
            }

            if (params.email_comments !== undefined) {
                localVarFormParams.set('email_comments', params.email_comments as any);
            }

            if (params.email_messages !== undefined) {
                localVarFormParams.set('email_messages', params.email_messages as any);
            }

            if (params.email_birthdays !== undefined) {
                localVarFormParams.set('email_birthdays', params.email_birthdays as any);
            }

            if (params.email_feed_posts !== undefined) {
                localVarFormParams.set('email_feed_posts', params.email_feed_posts as any);
            }

            if (params.email_friend_requests !== undefined) {
                localVarFormParams.set('email_friend_requests', params.email_friend_requests as any);
            }

            if (params.email_reminders !== undefined) {
                localVarFormParams.set('email_reminders', params.email_reminders as any);
            }

            if (params.onsite_alerts !== undefined) {
                localVarFormParams.set('onsite_alerts', params.onsite_alerts as any);
            }

            if (params.searchable !== undefined) {
                localVarFormParams.set('searchable', params.searchable as any);
            }

            if (params.occupation !== undefined) {
                localVarFormParams.set('occupation', params.occupation as any);
            }

            if (params.education_desc !== undefined) {
                localVarFormParams.set('education_desc', params.education_desc as any);
            }

            if (params.relationship !== undefined) {
                localVarFormParams.set('relationship', params.relationship as any);
            }

            if (params.education_level !== undefined) {
                localVarFormParams.set('education_level', params.education_level as any);
            }

            if (params.know !== undefined) {
                localVarFormParams.set('know', params.know as any);
            }

            if (params.learn !== undefined) {
                localVarFormParams.set('learn', params.learn as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Account - functional programming interface
 * @export
 */
export const AccountFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm email. Returns a login token since this is used for activation as well as email change.
         * @param {confirmEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(params: confirmEmailParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TokenEntity> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).confirmEmail(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create new user
         * @param {createAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(params: createAccountParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TokenEntity> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).createAccount(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete own account
         * @param {deleteAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(params: deleteAccountParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).deleteAccount(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get current user account
         * @param {getAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(params: getAccountParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountEntity> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).getAccount(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Reactivate deleted account. Requires token from createToken to verify login info before reactivating.
         * @param {reactivateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateAccount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TokenEntity> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).reactivateAccount(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Resend verification email to address on file (not for email change)
         * @param {resendVerificationEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(params: resendVerificationEmailParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).resendVerificationEmail(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Reset password using code from email (received from forgot password screen)
         * @param {resetPasswordParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(params: resetPasswordParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).resetPassword(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Send password reset link to email address on file
         * @param {sendResetPasswordLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordLink(params: sendResetPasswordLinkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).sendResetPasswordLink(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update current user account
         * @param {updateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(params: updateAccountParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountEntity> {
            const localVarFetchArgs = AccountFetchParamCreator(configuration).updateAccount(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} user_id User ID
 * @param {string} code Generated code from confirmation email
 * @param {string} [email] Email
*/
export type confirmEmailParams = {
    user_id: string,
    code: string,
    email?: string,
}

/**
 * @param {string} name Name
 * @param {string} email User email
 * @param {string} birthday Birthday (YYYY-MM-DD)
 * @param {string} city_id City id
 * @param {string} home_city_id Home city id
 * @param {'male' | 'female'} sex Sex (male|female)
 * @param {string} [password] Password
 * @param {'vk' | 'facebook' | 'google' | 'apple'} [oauth_provider] Oauth provider
 * @param {string} [oauth_access_token] Access token supplied in 'extra' field of error message when /oauth was called
 * @param {string} [oauth_id] Oauth provider user id, so that we can link account even if user email was changed
 * @param {string} [oauth_redirect_uri] Custom redirect URI to pass to provider
 * @param {string} [phone] phone number in E.164 format, e.g. +12534952301
 * @param {string} [firebase_token] Firebase Id token (JWT), required only if phone number is supplied
 * @param {'en-US' | 'ru-RU'} [lang] Interface language (locale)
*/
export type createAccountParams = {
    name: string,
    email: string,
    birthday: string,
    city_id: string,
    home_city_id: string,
    sex: 'male' | 'female',
    password?: string,
    oauth_provider?: 'vk' | 'facebook' | 'google' | 'apple',
    oauth_access_token?: string,
    oauth_id?: string,
    oauth_redirect_uri?: string,
    phone?: string,
    firebase_token?: string,
    lang?: 'en-US' | 'ru-RU',
}

/**
 * @param {string} [reason] Reason for deletion
*/
export type deleteAccountParams = {
    reason?: string,
}

/**
 * @param {string} id self or user id (only if moderator)
 * @param {string} [extra] return extra, non-default fields
*/
export type getAccountParams = {
    id: string,
    extra?: string,
}


/**
 * @param {string} [user_id] User id, if not logged in
*/
export type resendVerificationEmailParams = {
    user_id?: string,
}

/**
 * @param {string} id User id
 * @param {string} code Verification code (valid for one password change)
 * @param {string} password New password
*/
export type resetPasswordParams = {
    id: string,
    code: string,
    password: string,
}

/**
 * @param {string} email Email to use to look up user
*/
export type sendResetPasswordLinkParams = {
    email: string,
}

/**
 * @param {string} id self or user id (only if moderator)
 * @param {string} [birthday] Birthday (YYYY-MM-DD)
 * @param {'en-US' | 'ru-RU'} [lang] User language interface
 * @param {string} [home_city_id] Home city id
 * @param {string} [city_id] Home city id
 * @param {string} [name] name
 * @param {string} [username] username
 * @param {string} [password] password
 * @param {string} [new_password] new password
 * @param {string} [email] email; password is required to change it
 * @param {'male' | 'female'} [sex] sex (male|female)
 * @param {string} [tz] timezone
 * @param {string} [website] website
 * @param {string} [lfor] csv of: friend,langex,meet,relation,snail
 * @param {boolean} [push_likes] Enable or disable push notifications for likes
 * @param {boolean} [push_profile_views] Enable or disable push notifications for profile views
 * @param {boolean} [push_comments] Enable or disable push notifications for comments
 * @param {boolean} [push_messages] Enable or disable push notifications for messages
 * @param {boolean} [push_birthdays] Enable or disable push notifications for birthdays
 * @param {boolean} [push_feed_posts] Enable or disable about feed posts
 * @param {boolean} [push_friend_requests] Enable or disable about friend requests
 * @param {boolean} [email_likes] Enable or disable email notifications for likes
 * @param {boolean} [email_profile_views] Enable or disable email notifications for profile views
 * @param {boolean} [email_comments] Enable or disable email notifications for comments
 * @param {boolean} [email_messages] Enable or disable email notifications for messages
 * @param {boolean} [email_birthdays] Enable or disable email notifications for birthdays
 * @param {boolean} [email_feed_posts] Enable or disable email notifications for feed posts
 * @param {boolean} [email_friend_requests] Enable or disable email notifications for friend requests
 * @param {boolean} [email_reminders] Enable or disable email notifications for reminders
 * @param {boolean} [onsite_alerts] Enable or disable onsite alerts
 * @param {boolean} [searchable] searchable
 * @param {string} [occupation] occupation
 * @param {string} [education_desc] university name/etc
 * @param {'rel_not_specified' | 'rel_single' | 'rel_relationship' | 'rel_married' | 'rel_complicated'} [relationship] relationship
 * @param {'edu_not_specified' | 'edu_high_school' | 'edu_college' | 'edu_bachelors' | 'edu_graduate'} [education_level] education level
 * @param {string} [know] Comma separated language with level (en1,ru3,fr2)
 * @param {string} [learn] Comma separated language with level (en1,ru3,fr2)
*/
export type updateAccountParams = {
    id: string,
    birthday?: string,
    lang?: 'en-US' | 'ru-RU',
    home_city_id?: string,
    city_id?: string,
    name?: string,
    username?: string,
    password?: string,
    new_password?: string,
    email?: string,
    sex?: 'male' | 'female',
    tz?: string,
    website?: string,
    lfor?: string,
    push_likes?: boolean,
    push_profile_views?: boolean,
    push_comments?: boolean,
    push_messages?: boolean,
    push_birthdays?: boolean,
    push_feed_posts?: boolean,
    push_friend_requests?: boolean,
    email_likes?: boolean,
    email_profile_views?: boolean,
    email_comments?: boolean,
    email_messages?: boolean,
    email_birthdays?: boolean,
    email_feed_posts?: boolean,
    email_friend_requests?: boolean,
    email_reminders?: boolean,
    onsite_alerts?: boolean,
    searchable?: boolean,
    occupation?: string,
    education_desc?: string,
    relationship?: 'rel_not_specified' | 'rel_single' | 'rel_relationship' | 'rel_married' | 'rel_complicated',
    education_level?: 'edu_not_specified' | 'edu_high_school' | 'edu_college' | 'edu_bachelors' | 'edu_graduate',
    know?: string,
    learn?: string,
}

/**
 * Account - factory interface
 * @export
 */
export const AccountFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Confirm email. Returns a login token since this is used for activation as well as email change.
         * @param {confirmEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(params: confirmEmailParams, options?: any) {
            return AccountFp(configuration).confirmEmail(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create new user
         * @param {createAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(params: createAccountParams, options?: any) {
            return AccountFp(configuration).createAccount(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete own account
         * @param {deleteAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(params: deleteAccountParams, options?: any) {
            return AccountFp(configuration).deleteAccount(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get current user account
         * @param {getAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(params: getAccountParams, options?: any) {
            return AccountFp(configuration).getAccount(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Reactivate deleted account. Requires token from createToken to verify login info before reactivating.
         * @param {reactivateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateAccount(options?: any) {
            return AccountFp(configuration).reactivateAccount(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Resend verification email to address on file (not for email change)
         * @param {resendVerificationEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(params: resendVerificationEmailParams, options?: any) {
            return AccountFp(configuration).resendVerificationEmail(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Reset password using code from email (received from forgot password screen)
         * @param {resetPasswordParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(params: resetPasswordParams, options?: any) {
            return AccountFp(configuration).resetPassword(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Send password reset link to email address on file
         * @param {sendResetPasswordLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordLink(params: sendResetPasswordLinkParams, options?: any) {
            return AccountFp(configuration).sendResetPasswordLink(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update current user account
         * @param {updateAccountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(params: updateAccountParams, options?: any) {
            return AccountFp(configuration).updateAccount(params, options)(fetch, basePath);
        },
    };
};

/**
 * Account - object-oriented interface
 * @export
 * @class Account
 * @extends {BaseAPI}
 */
export class Account extends BaseAPI {
    /**
     * 
     * @summary Confirm email. Returns a login token since this is used for activation as well as email change.
     * @param {confirmEmailParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public confirmEmail(params: confirmEmailParams, options?: any) {
        return AccountFp(this.configuration).confirmEmail(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create new user
     * @param {createAccountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public createAccount(params: createAccountParams, options?: any) {
        return AccountFp(this.configuration).createAccount(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete own account
     * @param {deleteAccountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public deleteAccount(params: deleteAccountParams, options?: any) {
        return AccountFp(this.configuration).deleteAccount(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get current user account
     * @param {getAccountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public getAccount(params: getAccountParams, options?: any) {
        return AccountFp(this.configuration).getAccount(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Reactivate deleted account. Requires token from createToken to verify login info before reactivating.
     * @param {reactivateAccountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public reactivateAccount(options?: any) {
        return AccountFp(this.configuration).reactivateAccount(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Resend verification email to address on file (not for email change)
     * @param {resendVerificationEmailParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public resendVerificationEmail(params: resendVerificationEmailParams, options?: any) {
        return AccountFp(this.configuration).resendVerificationEmail(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Reset password using code from email (received from forgot password screen)
     * @param {resetPasswordParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public resetPassword(params: resetPasswordParams, options?: any) {
        return AccountFp(this.configuration).resetPassword(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Send password reset link to email address on file
     * @param {sendResetPasswordLinkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public sendResetPasswordLink(params: sendResetPasswordLinkParams, options?: any) {
        return AccountFp(this.configuration).sendResetPasswordLink(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update current user account
     * @param {updateAccountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Account
     */
    public updateAccount(params: updateAccountParams, options?: any) {
        return AccountFp(this.configuration).updateAccount(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Activity - fetch parameter creator
 * @export
 */
export const ActivityFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get activity by $id
         * @param {getActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(params: getActivityParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getActivity");
            }
            const localVarPath = `/activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get used ips by user id
         * @param {getUserIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIps(params: getUserIpsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserIps");
            }
            const localVarPath = `/activity/{id}/ips`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update activity
         * @param {updateActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(params: updateActivityParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateActivity");
            }
            // verify required parameter "params.action" is set
            if (params.action == null) {
                throw new Error("Missing required parameter 'action' when calling updateActivity");
            }
            const localVarPath = `/activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.action !== undefined) {
                localVarFormParams.set('action', params.action as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Activity - functional programming interface
 * @export
 */
export const ActivityFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get activity by $id
         * @param {getActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(params: getActivityParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserActivityResponse> {
            const localVarFetchArgs = ActivityFetchParamCreator(configuration).getActivity(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get used ips by user id
         * @param {getUserIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIps(params: getUserIpsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserIpsResponse> {
            const localVarFetchArgs = ActivityFetchParamCreator(configuration).getUserIps(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update activity
         * @param {updateActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(params: updateActivityParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ActivityFetchParamCreator(configuration).updateActivity(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User ID
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getActivityParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User ID
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getUserIpsParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User ID
 * @param {'force_all_logout' | 'force_other_logout'} action Desired action
*/
export type updateActivityParams = {
    id: string,
    action: 'force_all_logout' | 'force_other_logout',
}

/**
 * Activity - factory interface
 * @export
 */
export const ActivityFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get activity by $id
         * @param {getActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(params: getActivityParams, options?: any) {
            return ActivityFp(configuration).getActivity(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get used ips by user id
         * @param {getUserIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIps(params: getUserIpsParams, options?: any) {
            return ActivityFp(configuration).getUserIps(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update activity
         * @param {updateActivityParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(params: updateActivityParams, options?: any) {
            return ActivityFp(configuration).updateActivity(params, options)(fetch, basePath);
        },
    };
};

/**
 * Activity - object-oriented interface
 * @export
 * @class Activity
 * @extends {BaseAPI}
 */
export class Activity extends BaseAPI {
    /**
     * 
     * @summary Get activity by $id
     * @param {getActivityParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Activity
     */
    public getActivity(params: getActivityParams, options?: any) {
        return ActivityFp(this.configuration).getActivity(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get used ips by user id
     * @param {getUserIpsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Activity
     */
    public getUserIps(params: getUserIpsParams, options?: any) {
        return ActivityFp(this.configuration).getUserIps(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update activity
     * @param {updateActivityParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Activity
     */
    public updateActivity(params: updateActivityParams, options?: any) {
        return ActivityFp(this.configuration).updateActivity(params, options)(this.fetch, this.basePath);
    }

}

/**
 * AdTier - fetch parameter creator
 * @export
 */
export const AdTierFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get ad config for current client
         * @param {getAdConfigParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdConfig(options?: any): FetchArgs {
            const localVarPath = `/ad-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdTier - functional programming interface
 * @export
 */
export const AdTierFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get ad config for current client
         * @param {getAdConfigParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdConfig(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdConfigEntity> {
            const localVarFetchArgs = AdTierFetchParamCreator(configuration).getAdConfig(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};



/**
 * AdTier - factory interface
 * @export
 */
export const AdTierFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get ad config for current client
         * @param {getAdConfigParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdConfig(options?: any) {
            return AdTierFp(configuration).getAdConfig(options)(fetch, basePath);
        },
    };
};

/**
 * AdTier - object-oriented interface
 * @export
 * @class AdTier
 * @extends {BaseAPI}
 */
export class AdTier extends BaseAPI {
    /**
     * 
     * @summary Get ad config for current client
     * @param {getAdConfigParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdTier
     */
    public getAdConfig(options?: any) {
        return AdTierFp(this.configuration).getAdConfig(options)(this.fetch, this.basePath);
    }

}

/**
 * Album - fetch parameter creator
 * @export
 */
export const AlbumFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create album
         * @param {createAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlbum(params: createAlbumParams, options?: any): FetchArgs {
            // verify required parameter "params.title" is set
            if (params.title == null) {
                throw new Error("Missing required parameter 'title' when calling createAlbum");
            }
            // verify required parameter "params.view_acl" is set
            if (params.view_acl == null) {
                throw new Error("Missing required parameter 'view_acl' when calling createAlbum");
            }
            // verify required parameter "params.comment_acl" is set
            if (params.comment_acl == null) {
                throw new Error("Missing required parameter 'comment_acl' when calling createAlbum");
            }
            const localVarPath = `/album`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.title !== undefined) {
                localVarFormParams.set('title', params.title as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.location !== undefined) {
                localVarFormParams.set('location', params.location as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            if (params.comment_acl !== undefined) {
                localVarFormParams.set('comment_acl', params.comment_acl as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete album by $id
         * @param {deleteAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlbum(params: deleteAlbumParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteAlbum");
            }
            const localVarPath = `/album/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get album by $id
         * @param {getAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbum(params: getAlbumParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getAlbum");
            }
            const localVarPath = `/album/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get album comments
         * @param {getAlbumCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumComments(params: getAlbumCommentsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getAlbumComments");
            }
            const localVarPath = `/album/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.nest_replies !== undefined) {
                localVarQueryParameter['nest_replies'] = params.nest_replies;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get likes related to album
         * @param {getAlbumLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumLikes(params: getAlbumLikesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getAlbumLikes");
            }
            const localVarPath = `/album/{id}/likes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get photos stored in album - DEPRECATED in favor of getAlbum with extra=photos
         * @param {getAlbumPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumPhotos(params: getAlbumPhotosParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getAlbumPhotos");
            }
            const localVarPath = `/album/{id}/photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update album by $id
         * @param {updateAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlbum(params: updateAlbumParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateAlbum");
            }
            const localVarPath = `/album/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.title !== undefined) {
                localVarFormParams.set('title', params.title as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.location !== undefined) {
                localVarFormParams.set('location', params.location as any);
            }

            if (params.photo_list !== undefined) {
                localVarFormParams.set('photo_list', params.photo_list as any);
            }

            if (params.album_cover_id !== undefined) {
                localVarFormParams.set('album_cover_id', params.album_cover_id as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            if (params.comment_acl !== undefined) {
                localVarFormParams.set('comment_acl', params.comment_acl as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Album - functional programming interface
 * @export
 */
export const AlbumFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create album
         * @param {createAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlbum(params: createAlbumParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AlbumEntity> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).createAlbum(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete album by $id
         * @param {deleteAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlbum(params: deleteAlbumParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).deleteAlbum(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get album by $id
         * @param {getAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbum(params: getAlbumParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AlbumEntity> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).getAlbum(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get album comments
         * @param {getAlbumCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumComments(params: getAlbumCommentsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentListResponse> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).getAlbumComments(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get likes related to album
         * @param {getAlbumLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumLikes(params: getAlbumLikesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).getAlbumLikes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get photos stored in album - DEPRECATED in favor of getAlbum with extra=photos
         * @param {getAlbumPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumPhotos(params: getAlbumPhotosParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AlbumPhotosResponse> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).getAlbumPhotos(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update album by $id
         * @param {updateAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlbum(params: updateAlbumParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AlbumEntity> {
            const localVarFetchArgs = AlbumFetchParamCreator(configuration).updateAlbum(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} title Title of the album
 * @param {'users' | 'friends' | 'me'} view_acl view_acl
 * @param {'users' | 'friends' | 'me'} comment_acl comment_acl
 * @param {string} [description] Description of the album
 * @param {string} [location] Location of the album
*/
export type createAlbumParams = {
    title: string,
    view_acl: 'users' | 'friends' | 'me',
    comment_acl: 'users' | 'friends' | 'me',
    description?: string,
    location?: string,
}

/**
 * @param {string} id Id of the album
*/
export type deleteAlbumParams = {
    id: string,
}

/**
 * @param {string} id Id of the album
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type getAlbumParams = {
    id: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Album id
 * @param {boolean} [nest_replies] Nest replies for comments that have them up to limit (applies to sum of comments + replies)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getAlbumCommentsParams = {
    id: string,
    nest_replies?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Album id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getAlbumLikesParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Album id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getAlbumPhotosParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id id
 * @param {string} [title] Title of the album
 * @param {string} [description] Description of the album
 * @param {string} [location] Location of the album
 * @param {string} [photo_list] Ids of the photos in current album, in order; csv
 * @param {string} [album_cover_id] Cover photo for the current album
 * @param {'users' | 'friends' | 'me'} [view_acl] view_acl
 * @param {'users' | 'friends' | 'me'} [comment_acl] comment_acl
 * @param {string} [extra] return extra, non-default fields
*/
export type updateAlbumParams = {
    id: string,
    title?: string,
    description?: string,
    location?: string,
    photo_list?: string,
    album_cover_id?: string,
    view_acl?: 'users' | 'friends' | 'me',
    comment_acl?: 'users' | 'friends' | 'me',
    extra?: string,
}

/**
 * Album - factory interface
 * @export
 */
export const AlbumFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create album
         * @param {createAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlbum(params: createAlbumParams, options?: any) {
            return AlbumFp(configuration).createAlbum(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete album by $id
         * @param {deleteAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlbum(params: deleteAlbumParams, options?: any) {
            return AlbumFp(configuration).deleteAlbum(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get album by $id
         * @param {getAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbum(params: getAlbumParams, options?: any) {
            return AlbumFp(configuration).getAlbum(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get album comments
         * @param {getAlbumCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumComments(params: getAlbumCommentsParams, options?: any) {
            return AlbumFp(configuration).getAlbumComments(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get likes related to album
         * @param {getAlbumLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumLikes(params: getAlbumLikesParams, options?: any) {
            return AlbumFp(configuration).getAlbumLikes(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get photos stored in album - DEPRECATED in favor of getAlbum with extra=photos
         * @param {getAlbumPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlbumPhotos(params: getAlbumPhotosParams, options?: any) {
            return AlbumFp(configuration).getAlbumPhotos(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update album by $id
         * @param {updateAlbumParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlbum(params: updateAlbumParams, options?: any) {
            return AlbumFp(configuration).updateAlbum(params, options)(fetch, basePath);
        },
    };
};

/**
 * Album - object-oriented interface
 * @export
 * @class Album
 * @extends {BaseAPI}
 */
export class Album extends BaseAPI {
    /**
     * 
     * @summary Create album
     * @param {createAlbumParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public createAlbum(params: createAlbumParams, options?: any) {
        return AlbumFp(this.configuration).createAlbum(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete album by $id
     * @param {deleteAlbumParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public deleteAlbum(params: deleteAlbumParams, options?: any) {
        return AlbumFp(this.configuration).deleteAlbum(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get album by $id
     * @param {getAlbumParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public getAlbum(params: getAlbumParams, options?: any) {
        return AlbumFp(this.configuration).getAlbum(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get album comments
     * @param {getAlbumCommentsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public getAlbumComments(params: getAlbumCommentsParams, options?: any) {
        return AlbumFp(this.configuration).getAlbumComments(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get likes related to album
     * @param {getAlbumLikesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public getAlbumLikes(params: getAlbumLikesParams, options?: any) {
        return AlbumFp(this.configuration).getAlbumLikes(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get photos stored in album - DEPRECATED in favor of getAlbum with extra=photos
     * @param {getAlbumPhotosParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public getAlbumPhotos(params: getAlbumPhotosParams, options?: any) {
        return AlbumFp(this.configuration).getAlbumPhotos(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update album by $id
     * @param {updateAlbumParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Album
     */
    public updateAlbum(params: updateAlbumParams, options?: any) {
        return AlbumFp(this.configuration).updateAlbum(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Audio - fetch parameter creator
 * @export
 */
export const AudioFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload and create new audio
         * @param {createAudioParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAudio(params: createAudioParams, options?: any): FetchArgs {
            // verify required parameter "params.file" is set
            if (params.file == null) {
                throw new Error("Missing required parameter 'file' when calling createAudio");
            }
            const localVarPath = `/audio`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.file !== undefined) {
                localVarFormParams.set('file', params.file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Audio - functional programming interface
 * @export
 */
export const AudioFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload and create new audio
         * @param {createAudioParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAudio(params: createAudioParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AudioEntity> {
            const localVarFetchArgs = AudioFetchParamCreator(configuration).createAudio(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {any} file Audio to upload
*/
export type createAudioParams = {
    file: any,
}

/**
 * Audio - factory interface
 * @export
 */
export const AudioFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Upload and create new audio
         * @param {createAudioParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAudio(params: createAudioParams, options?: any) {
            return AudioFp(configuration).createAudio(params, options)(fetch, basePath);
        },
    };
};

/**
 * Audio - object-oriented interface
 * @export
 * @class Audio
 * @extends {BaseAPI}
 */
export class Audio extends BaseAPI {
    /**
     * 
     * @summary Upload and create new audio
     * @param {createAudioParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Audio
     */
    public createAudio(params: createAudioParams, options?: any) {
        return AudioFp(this.configuration).createAudio(params, options)(this.fetch, this.basePath);
    }

}

/**
 * BannedIps - fetch parameter creator
 * @export
 */
export const BannedIpsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {banIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banIp(params: banIpParams, options?: any): FetchArgs {
            // verify required parameter "params.ip" is set
            if (params.ip == null) {
                throw new Error("Missing required parameter 'ip' when calling banIp");
            }
            // verify required parameter "params.comment" is set
            if (params.comment == null) {
                throw new Error("Missing required parameter 'comment' when calling banIp");
            }
            const localVarPath = `/banned-ips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.ip !== undefined) {
                localVarFormParams.set('ip', params.ip as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getBannedIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannedIps(params: getBannedIpsParams, options?: any): FetchArgs {
            const localVarPath = `/banned-ips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {unbanIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanIp(params: unbanIpParams, options?: any): FetchArgs {
            // verify required parameter "params.ip" is set
            if (params.ip == null) {
                throw new Error("Missing required parameter 'ip' when calling unbanIp");
            }
            const localVarPath = `/banned-ips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.ip !== undefined) {
                localVarQueryParameter['ip'] = params.ip;
            }

            if (params.comment !== undefined) {
                localVarQueryParameter['comment'] = params.comment;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannedIps - functional programming interface
 * @export
 */
export const BannedIpsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {banIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banIp(params: banIpParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BannedIpEntity> {
            const localVarFetchArgs = BannedIpsFetchParamCreator(configuration).banIp(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getBannedIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannedIps(params: getBannedIpsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BannedIpsResponse> {
            const localVarFetchArgs = BannedIpsFetchParamCreator(configuration).getBannedIps(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {unbanIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanIp(params: unbanIpParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = BannedIpsFetchParamCreator(configuration).unbanIp(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} ip IP address (ipv4 or ipv6)
 * @param {string} comment Message to add to log
*/
export type banIpParams = {
    ip: string,
    comment: string,
}

/**
 * @param {number} [offset] Offset
 * @param {number} [limit] Limit
*/
export type getBannedIpsParams = {
    offset?: number,
    limit?: number,
}

/**
 * @param {string} ip IP address (ipv4 or ipv6)
 * @param {string} [comment] Message to add to log
*/
export type unbanIpParams = {
    ip: string,
    comment?: string,
}

/**
 * BannedIps - factory interface
 * @export
 */
export const BannedIpsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {banIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banIp(params: banIpParams, options?: any) {
            return BannedIpsFp(configuration).banIp(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getBannedIpsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBannedIps(params: getBannedIpsParams, options?: any) {
            return BannedIpsFp(configuration).getBannedIps(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {unbanIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanIp(params: unbanIpParams, options?: any) {
            return BannedIpsFp(configuration).unbanIp(params, options)(fetch, basePath);
        },
    };
};

/**
 * BannedIps - object-oriented interface
 * @export
 * @class BannedIps
 * @extends {BaseAPI}
 */
export class BannedIps extends BaseAPI {
    /**
     * 
     * @param {banIpParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannedIps
     */
    public banIp(params: banIpParams, options?: any) {
        return BannedIpsFp(this.configuration).banIp(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getBannedIpsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannedIps
     */
    public getBannedIps(params: getBannedIpsParams, options?: any) {
        return BannedIpsFp(this.configuration).getBannedIps(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {unbanIpParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannedIps
     */
    public unbanIp(params: unbanIpParams, options?: any) {
        return BannedIpsFp(this.configuration).unbanIp(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Bookmark - fetch parameter creator
 * @export
 */
export const BookmarkFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create bookmark
         * @param {createBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookmark(params: createBookmarkParams, options?: any): FetchArgs {
            // verify required parameter "params.target_id" is set
            if (params.target_id == null) {
                throw new Error("Missing required parameter 'target_id' when calling createBookmark");
            }
            const localVarPath = `/bookmark`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.target_id !== undefined) {
                localVarFormParams.set('target_id', params.target_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete bookmark by bookmark target user id
         * @param {deleteBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmark(params: deleteBookmarkParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteBookmark");
            }
            const localVarPath = `/bookmark/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bookmark by $id
         * @param {getBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmark(params: getBookmarkParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getBookmark");
            }
            const localVarPath = `/bookmark/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Bookmark - functional programming interface
 * @export
 */
export const BookmarkFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create bookmark
         * @param {createBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookmark(params: createBookmarkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BookmarkEntity> {
            const localVarFetchArgs = BookmarkFetchParamCreator(configuration).createBookmark(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete bookmark by bookmark target user id
         * @param {deleteBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmark(params: deleteBookmarkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = BookmarkFetchParamCreator(configuration).deleteBookmark(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get bookmark by $id
         * @param {getBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmark(params: getBookmarkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BookmarkEntity> {
            const localVarFetchArgs = BookmarkFetchParamCreator(configuration).getBookmark(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} target_id Id of the who user want add to bookmark
*/
export type createBookmarkParams = {
    target_id: string,
}

/**
 * @param {string} id Bookmark target user id
*/
export type deleteBookmarkParams = {
    id: string,
}

/**
 * @param {string} id Id of the bookmark
*/
export type getBookmarkParams = {
    id: string,
}

/**
 * Bookmark - factory interface
 * @export
 */
export const BookmarkFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create bookmark
         * @param {createBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookmark(params: createBookmarkParams, options?: any) {
            return BookmarkFp(configuration).createBookmark(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete bookmark by bookmark target user id
         * @param {deleteBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookmark(params: deleteBookmarkParams, options?: any) {
            return BookmarkFp(configuration).deleteBookmark(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get bookmark by $id
         * @param {getBookmarkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookmark(params: getBookmarkParams, options?: any) {
            return BookmarkFp(configuration).getBookmark(params, options)(fetch, basePath);
        },
    };
};

/**
 * Bookmark - object-oriented interface
 * @export
 * @class Bookmark
 * @extends {BaseAPI}
 */
export class Bookmark extends BaseAPI {
    /**
     * 
     * @summary Create bookmark
     * @param {createBookmarkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Bookmark
     */
    public createBookmark(params: createBookmarkParams, options?: any) {
        return BookmarkFp(this.configuration).createBookmark(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete bookmark by bookmark target user id
     * @param {deleteBookmarkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Bookmark
     */
    public deleteBookmark(params: deleteBookmarkParams, options?: any) {
        return BookmarkFp(this.configuration).deleteBookmark(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get bookmark by $id
     * @param {getBookmarkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Bookmark
     */
    public getBookmark(params: getBookmarkParams, options?: any) {
        return BookmarkFp(this.configuration).getBookmark(params, options)(this.fetch, this.basePath);
    }

}

/**
 * BrowserFingerprint - fetch parameter creator
 * @export
 */
export const BrowserFingerprintFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update browser fingerprint hash
         * @param {getBfpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfp(params: getBfpParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getBfp");
            }
            const localVarPath = `/bfp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrowserFingerprint - functional programming interface
 * @export
 */
export const BrowserFingerprintFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update browser fingerprint hash
         * @param {getBfpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfp(params: getBfpParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = BrowserFingerprintFetchParamCreator(configuration).getBfp(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Browser fingerprint value
*/
export type getBfpParams = {
    id: string,
}

/**
 * BrowserFingerprint - factory interface
 * @export
 */
export const BrowserFingerprintFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Update browser fingerprint hash
         * @param {getBfpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfp(params: getBfpParams, options?: any) {
            return BrowserFingerprintFp(configuration).getBfp(params, options)(fetch, basePath);
        },
    };
};

/**
 * BrowserFingerprint - object-oriented interface
 * @export
 * @class BrowserFingerprint
 * @extends {BaseAPI}
 */
export class BrowserFingerprint extends BaseAPI {
    /**
     * 
     * @summary Update browser fingerprint hash
     * @param {getBfpParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowserFingerprint
     */
    public getBfp(params: getBfpParams, options?: any) {
        return BrowserFingerprintFp(this.configuration).getBfp(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Call - fetch parameter creator
 * @export
 */
export const CallFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Allow call
         * @param {allowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowCall(params: allowCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling allowCall");
            }
            const localVarPath = `/call/{id}/allow`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel call
         * @param {cancelCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCall(params: cancelCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling cancelCall");
            }
            const localVarPath = `/call/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create call
         * @param {createCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(params: createCallParams, options?: any): FetchArgs {
            // verify required parameter "params.target_id" is set
            if (params.target_id == null) {
                throw new Error("Missing required parameter 'target_id' when calling createCall");
            }
            // verify required parameter "params.type" is set
            if (params.type == null) {
                throw new Error("Missing required parameter 'type' when calling createCall");
            }
            const localVarPath = `/call`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.target_id !== undefined) {
                localVarFormParams.set('target_id', params.target_id as any);
            }

            if (params.type !== undefined) {
                localVarFormParams.set('type', params.type as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disallow call
         * @param {disallowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disallowCall(params: disallowCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling disallowCall");
            }
            const localVarPath = `/call/{id}/disallow`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finish call
         * @param {finishCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCall(params: finishCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling finishCall");
            }
            const localVarPath = `/call/{id}/finish`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get call by id
         * @param {getCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCall(params: getCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getCall");
            }
            const localVarPath = `/call/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite participants join to call
         * @param {inviteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(params: inviteParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling invite");
            }
            // verify required parameter "params.uid" is set
            if (params.uid == null) {
                throw new Error("Missing required parameter 'uid' when calling invite");
            }
            const localVarPath = `/call/{id}/invite`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.uid !== undefined) {
                localVarFormParams.set('uid', params.uid as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unanswered call
         * @param {unansweredCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unansweredCall(params: unansweredCallParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling unansweredCall");
            }
            const localVarPath = `/call/{id}/unanswered`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Call - functional programming interface
 * @export
 */
export const CallFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Allow call
         * @param {allowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowCall(params: allowCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).allowCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Cancel call
         * @param {cancelCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCall(params: cancelCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).cancelCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create call
         * @param {createCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(params: createCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CallEntity> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).createCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Disallow call
         * @param {disallowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disallowCall(params: disallowCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).disallowCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Finish call
         * @param {finishCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCall(params: finishCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).finishCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get call by id
         * @param {getCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCall(params: getCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CallEntity> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).getCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Invite participants join to call
         * @param {inviteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(params: inviteParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).invite(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Unanswered call
         * @param {unansweredCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unansweredCall(params: unansweredCallParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CallFetchParamCreator(configuration).unansweredCall(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the call
*/
export type allowCallParams = {
    id: string,
}

/**
 * @param {string} id Id of the call
*/
export type cancelCallParams = {
    id: string,
}

/**
 * @param {string} target_id Id of the whom call
 * @param {'audio' | 'video'} type Type of the call
*/
export type createCallParams = {
    target_id: string,
    type: 'audio' | 'video',
}

/**
 * @param {string} id Id of the call
*/
export type disallowCallParams = {
    id: string,
}

/**
 * @param {string} id Id of the call
*/
export type finishCallParams = {
    id: string,
}

/**
 * @param {string} id Id of the call
*/
export type getCallParams = {
    id: string,
}

/**
 * @param {string} id Id of the call
 * @param {string} uid Id of the User for invite
*/
export type inviteParams = {
    id: string,
    uid: string,
}

/**
 * @param {string} id Id of the call
*/
export type unansweredCallParams = {
    id: string,
}

/**
 * Call - factory interface
 * @export
 */
export const CallFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Allow call
         * @param {allowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowCall(params: allowCallParams, options?: any) {
            return CallFp(configuration).allowCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Cancel call
         * @param {cancelCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCall(params: cancelCallParams, options?: any) {
            return CallFp(configuration).cancelCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create call
         * @param {createCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(params: createCallParams, options?: any) {
            return CallFp(configuration).createCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Disallow call
         * @param {disallowCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disallowCall(params: disallowCallParams, options?: any) {
            return CallFp(configuration).disallowCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Finish call
         * @param {finishCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCall(params: finishCallParams, options?: any) {
            return CallFp(configuration).finishCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get call by id
         * @param {getCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCall(params: getCallParams, options?: any) {
            return CallFp(configuration).getCall(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Invite participants join to call
         * @param {inviteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(params: inviteParams, options?: any) {
            return CallFp(configuration).invite(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Unanswered call
         * @param {unansweredCallParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unansweredCall(params: unansweredCallParams, options?: any) {
            return CallFp(configuration).unansweredCall(params, options)(fetch, basePath);
        },
    };
};

/**
 * Call - object-oriented interface
 * @export
 * @class Call
 * @extends {BaseAPI}
 */
export class Call extends BaseAPI {
    /**
     * 
     * @summary Allow call
     * @param {allowCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public allowCall(params: allowCallParams, options?: any) {
        return CallFp(this.configuration).allowCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Cancel call
     * @param {cancelCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public cancelCall(params: cancelCallParams, options?: any) {
        return CallFp(this.configuration).cancelCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create call
     * @param {createCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public createCall(params: createCallParams, options?: any) {
        return CallFp(this.configuration).createCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Disallow call
     * @param {disallowCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public disallowCall(params: disallowCallParams, options?: any) {
        return CallFp(this.configuration).disallowCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Finish call
     * @param {finishCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public finishCall(params: finishCallParams, options?: any) {
        return CallFp(this.configuration).finishCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get call by id
     * @param {getCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public getCall(params: getCallParams, options?: any) {
        return CallFp(this.configuration).getCall(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Invite participants join to call
     * @param {inviteParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public invite(params: inviteParams, options?: any) {
        return CallFp(this.configuration).invite(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Unanswered call
     * @param {unansweredCallParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Call
     */
    public unansweredCall(params: unansweredCallParams, options?: any) {
        return CallFp(this.configuration).unansweredCall(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Comment - fetch parameter creator
 * @export
 */
export const CommentFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create comment
         * @param {createCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(params: createCommentParams, options?: any): FetchArgs {
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling createComment");
            }
            // verify required parameter "params.entity_id" is set
            if (params.entity_id == null) {
                throw new Error("Missing required parameter 'entity_id' when calling createComment");
            }
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling createComment");
            }
            const localVarPath = `/comment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.entity_id !== undefined) {
                localVarFormParams.set('entity_id', params.entity_id as any);
            }

            if (params.reply_to !== undefined) {
                localVarFormParams.set('reply_to', params.reply_to as any);
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete comment by $id
         * @param {deleteCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(params: deleteCommentParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteComment");
            }
            const localVarPath = `/comment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_id !== undefined) {
                localVarQueryParameter['entity_id'] = params.entity_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users who liked a comment
         * @param {getCommentLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentLikes(params: getCommentLikesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getCommentLikes");
            }
            const localVarPath = `/comment/{id}/likes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get replies (next level of nesting) for a comment
         * @param {getCommentRepliesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentReplies(params: getCommentRepliesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getCommentReplies");
            }
            // verify required parameter "params.entity_id" is set
            if (params.entity_id == null) {
                throw new Error("Missing required parameter 'entity_id' when calling getCommentReplies");
            }
            const localVarPath = `/comment/{id}/replies`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_id !== undefined) {
                localVarQueryParameter['entity_id'] = params.entity_id;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Comment - functional programming interface
 * @export
 */
export const CommentFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create comment
         * @param {createCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(params: createCommentParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentEntity> {
            const localVarFetchArgs = CommentFetchParamCreator(configuration).createComment(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete comment by $id
         * @param {deleteCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(params: deleteCommentParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = CommentFetchParamCreator(configuration).deleteComment(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get users who liked a comment
         * @param {getCommentLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentLikes(params: getCommentLikesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = CommentFetchParamCreator(configuration).getCommentLikes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get replies (next level of nesting) for a comment
         * @param {getCommentRepliesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentReplies(params: getCommentRepliesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentListResponse> {
            const localVarFetchArgs = CommentFetchParamCreator(configuration).getCommentReplies(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'post' | 'photo' | 'album' | 'trip'} entity_type Type of entity being commented on
 * @param {string} entity_id Entity id being commented on
 * @param {string} message Message body, 4096 char max
 * @param {string} [reply_to] In reply to comment id
*/
export type createCommentParams = {
    entity_type: 'post' | 'photo' | 'album' | 'trip',
    entity_id: string,
    message: string,
    reply_to?: string,
}

/**
 * @param {string} id Comment id
 * @param {string} [entity_id] Deprecated
*/
export type deleteCommentParams = {
    id: string,
    entity_id?: string,
}

/**
 * @param {string} id Comment id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getCommentLikesParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Comment id
 * @param {string} entity_id Commented entity
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getCommentRepliesParams = {
    id: string,
    entity_id: string,
    limit?: number,
    offset?: number,
}

/**
 * Comment - factory interface
 * @export
 */
export const CommentFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create comment
         * @param {createCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(params: createCommentParams, options?: any) {
            return CommentFp(configuration).createComment(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete comment by $id
         * @param {deleteCommentParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(params: deleteCommentParams, options?: any) {
            return CommentFp(configuration).deleteComment(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get users who liked a comment
         * @param {getCommentLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentLikes(params: getCommentLikesParams, options?: any) {
            return CommentFp(configuration).getCommentLikes(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get replies (next level of nesting) for a comment
         * @param {getCommentRepliesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentReplies(params: getCommentRepliesParams, options?: any) {
            return CommentFp(configuration).getCommentReplies(params, options)(fetch, basePath);
        },
    };
};

/**
 * Comment - object-oriented interface
 * @export
 * @class Comment
 * @extends {BaseAPI}
 */
export class Comment extends BaseAPI {
    /**
     * 
     * @summary Create comment
     * @param {createCommentParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Comment
     */
    public createComment(params: createCommentParams, options?: any) {
        return CommentFp(this.configuration).createComment(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete comment by $id
     * @param {deleteCommentParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Comment
     */
    public deleteComment(params: deleteCommentParams, options?: any) {
        return CommentFp(this.configuration).deleteComment(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get users who liked a comment
     * @param {getCommentLikesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Comment
     */
    public getCommentLikes(params: getCommentLikesParams, options?: any) {
        return CommentFp(this.configuration).getCommentLikes(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get replies (next level of nesting) for a comment
     * @param {getCommentRepliesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Comment
     */
    public getCommentReplies(params: getCommentRepliesParams, options?: any) {
        return CommentFp(this.configuration).getCommentReplies(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Country - fetch parameter creator
 * @export
 */
export const CountryFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch all countries
         * @param {getCountriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(params: getCountriesParams, options?: any): FetchArgs {
            const localVarPath = `/country/all`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.field !== undefined) {
                localVarQueryParameter['field'] = params.field;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Country - functional programming interface
 * @export
 */
export const CountryFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch all countries
         * @param {getCountriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(params: getCountriesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CountriesResponse> {
            const localVarFetchArgs = CountryFetchParamCreator(configuration).getCountries(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'key' | 'value'} [field] By what field we should sort?
 * @param {'asc' | 'desc'} [order] What type of the sort
 * @param {string} [AcceptLanguage] Preferred locales
*/
export type getCountriesParams = {
    field?: 'key' | 'value',
    order?: 'asc' | 'desc',
    AcceptLanguage?: string,
}

/**
 * Country - factory interface
 * @export
 */
export const CountryFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Fetch all countries
         * @param {getCountriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(params: getCountriesParams, options?: any) {
            return CountryFp(configuration).getCountries(params, options)(fetch, basePath);
        },
    };
};

/**
 * Country - object-oriented interface
 * @export
 * @class Country
 * @extends {BaseAPI}
 */
export class Country extends BaseAPI {
    /**
     * 
     * @summary Fetch all countries
     * @param {getCountriesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Country
     */
    public getCountries(params: getCountriesParams, options?: any) {
        return CountryFp(this.configuration).getCountries(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Debug - fetch parameter creator
 * @export
 */
export const DebugFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return some basic server & debug info; accessible only to admin
         * @param {getDebugInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebugInfo(options?: any): FetchArgs {
            const localVarPath = `/debug`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Debug - functional programming interface
 * @export
 */
export const DebugFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return some basic server & debug info; accessible only to admin
         * @param {getDebugInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebugInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DebugFetchParamCreator(configuration).getDebugInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};



/**
 * Debug - factory interface
 * @export
 */
export const DebugFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Return some basic server & debug info; accessible only to admin
         * @param {getDebugInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebugInfo(options?: any) {
            return DebugFp(configuration).getDebugInfo(options)(fetch, basePath);
        },
    };
};

/**
 * Debug - object-oriented interface
 * @export
 * @class Debug
 * @extends {BaseAPI}
 */
export class Debug extends BaseAPI {
    /**
     * 
     * @summary Return some basic server & debug info; accessible only to admin
     * @param {getDebugInfoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Debug
     */
    public getDebugInfo(options?: any) {
        return DebugFp(this.configuration).getDebugInfo(options)(this.fetch, this.basePath);
    }

}

/**
 * EmailDomainWhitelist - fetch parameter creator
 * @export
 */
export const EmailDomainWhitelistFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailDomainWhitelistItem(params: createEmailDomainWhitelistItemParams, options?: any): FetchArgs {
            // verify required parameter "params.domain" is set
            if (params.domain == null) {
                throw new Error("Missing required parameter 'domain' when calling createEmailDomainWhitelistItem");
            }
            const localVarPath = `/email-domain-whitelist`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.domain !== undefined) {
                localVarFormParams.set('domain', params.domain as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {deleteEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailDomainWhitelistItem(params: deleteEmailDomainWhitelistItemParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteEmailDomainWhitelistItem");
            }
            const localVarPath = `/email-domain-whitelist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.comment !== undefined) {
                localVarQueryParameter['comment'] = params.comment;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getEmailDomainWhitelistParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailDomainWhitelist(params: getEmailDomainWhitelistParams, options?: any): FetchArgs {
            const localVarPath = `/email-domain-whitelist`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailDomainWhitelist - functional programming interface
 * @export
 */
export const EmailDomainWhitelistFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailDomainWhitelistItem(params: createEmailDomainWhitelistItemParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EmailDomainWhitelistEntity> {
            const localVarFetchArgs = EmailDomainWhitelistFetchParamCreator(configuration).createEmailDomainWhitelistItem(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {deleteEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailDomainWhitelistItem(params: deleteEmailDomainWhitelistItemParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = EmailDomainWhitelistFetchParamCreator(configuration).deleteEmailDomainWhitelistItem(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getEmailDomainWhitelistParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailDomainWhitelist(params: getEmailDomainWhitelistParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EmailDomainWhitelistResponse> {
            const localVarFetchArgs = EmailDomainWhitelistFetchParamCreator(configuration).getEmailDomainWhitelist(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} domain Email provider domain name, e.g. 'gmail.com'
 * @param {string} [comment] Log message
*/
export type createEmailDomainWhitelistItemParams = {
    domain: string,
    comment?: string,
}

/**
 * @param {string} id Email domain whitelist item id
 * @param {string} [comment] Message to add to log
*/
export type deleteEmailDomainWhitelistItemParams = {
    id: string,
    comment?: string,
}

/**
 * @param {string} [text] Filter domains by text
 * @param {number} [offset] Offset
 * @param {number} [limit] Limit
*/
export type getEmailDomainWhitelistParams = {
    text?: string,
    offset?: number,
    limit?: number,
}

/**
 * EmailDomainWhitelist - factory interface
 * @export
 */
export const EmailDomainWhitelistFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {createEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailDomainWhitelistItem(params: createEmailDomainWhitelistItemParams, options?: any) {
            return EmailDomainWhitelistFp(configuration).createEmailDomainWhitelistItem(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {deleteEmailDomainWhitelistItemParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailDomainWhitelistItem(params: deleteEmailDomainWhitelistItemParams, options?: any) {
            return EmailDomainWhitelistFp(configuration).deleteEmailDomainWhitelistItem(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getEmailDomainWhitelistParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailDomainWhitelist(params: getEmailDomainWhitelistParams, options?: any) {
            return EmailDomainWhitelistFp(configuration).getEmailDomainWhitelist(params, options)(fetch, basePath);
        },
    };
};

/**
 * EmailDomainWhitelist - object-oriented interface
 * @export
 * @class EmailDomainWhitelist
 * @extends {BaseAPI}
 */
export class EmailDomainWhitelist extends BaseAPI {
    /**
     * 
     * @param {createEmailDomainWhitelistItemParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailDomainWhitelist
     */
    public createEmailDomainWhitelistItem(params: createEmailDomainWhitelistItemParams, options?: any) {
        return EmailDomainWhitelistFp(this.configuration).createEmailDomainWhitelistItem(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {deleteEmailDomainWhitelistItemParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailDomainWhitelist
     */
    public deleteEmailDomainWhitelistItem(params: deleteEmailDomainWhitelistItemParams, options?: any) {
        return EmailDomainWhitelistFp(this.configuration).deleteEmailDomainWhitelistItem(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getEmailDomainWhitelistParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailDomainWhitelist
     */
    public getEmailDomainWhitelist(params: getEmailDomainWhitelistParams, options?: any) {
        return EmailDomainWhitelistFp(this.configuration).getEmailDomainWhitelist(params, options)(this.fetch, this.basePath);
    }

}

/**
 * EntryCorrectionVote - fetch parameter creator
 * @export
 */
export const EntryCorrectionVoteFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new entry correction vote
         * @param {createEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntryCorrectionVote(params: createEntryCorrectionVoteParams, options?: any): FetchArgs {
            // verify required parameter "params.vote_up" is set
            if (params.vote_up == null) {
                throw new Error("Missing required parameter 'vote_up' when calling createEntryCorrectionVote");
            }
            // verify required parameter "params.correction_id" is set
            if (params.correction_id == null) {
                throw new Error("Missing required parameter 'correction_id' when calling createEntryCorrectionVote");
            }
            const localVarPath = `/entry-correction-vote`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.vote_up !== undefined) {
                localVarFormParams.set('vote_up', params.vote_up as any);
            }

            if (params.correction_id !== undefined) {
                localVarFormParams.set('correction_id', params.correction_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entry correction vote by id
         * @param {getEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVote(params: getEntryCorrectionVoteParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntryCorrectionVote");
            }
            const localVarPath = `/entry-correction-vote/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntryCorrectionVote - functional programming interface
 * @export
 */
export const EntryCorrectionVoteFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new entry correction vote
         * @param {createEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntryCorrectionVote(params: createEntryCorrectionVoteParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EntryCorrectionVoteEntity> {
            const localVarFetchArgs = EntryCorrectionVoteFetchParamCreator(configuration).createEntryCorrectionVote(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get entry correction vote by id
         * @param {getEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVote(params: getEntryCorrectionVoteParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EntryCorrectionVoteEntity> {
            const localVarFetchArgs = EntryCorrectionVoteFetchParamCreator(configuration).getEntryCorrectionVote(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {number} vote_up is vote up
 * @param {string} correction_id related correction id
*/
export type createEntryCorrectionVoteParams = {
    vote_up: number,
    correction_id: string,
}

/**
 * @param {string} id Id of the vote
*/
export type getEntryCorrectionVoteParams = {
    id: string,
}

/**
 * EntryCorrectionVote - factory interface
 * @export
 */
export const EntryCorrectionVoteFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new entry correction vote
         * @param {createEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntryCorrectionVote(params: createEntryCorrectionVoteParams, options?: any) {
            return EntryCorrectionVoteFp(configuration).createEntryCorrectionVote(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get entry correction vote by id
         * @param {getEntryCorrectionVoteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVote(params: getEntryCorrectionVoteParams, options?: any) {
            return EntryCorrectionVoteFp(configuration).getEntryCorrectionVote(params, options)(fetch, basePath);
        },
    };
};

/**
 * EntryCorrectionVote - object-oriented interface
 * @export
 * @class EntryCorrectionVote
 * @extends {BaseAPI}
 */
export class EntryCorrectionVote extends BaseAPI {
    /**
     * 
     * @summary Create new entry correction vote
     * @param {createEntryCorrectionVoteParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryCorrectionVote
     */
    public createEntryCorrectionVote(params: createEntryCorrectionVoteParams, options?: any) {
        return EntryCorrectionVoteFp(this.configuration).createEntryCorrectionVote(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get entry correction vote by id
     * @param {getEntryCorrectionVoteParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryCorrectionVote
     */
    public getEntryCorrectionVote(params: getEntryCorrectionVoteParams, options?: any) {
        return EntryCorrectionVoteFp(this.configuration).getEntryCorrectionVote(params, options)(this.fetch, this.basePath);
    }

}

/**
 * EntryRoot - fetch parameter creator
 * @export
 */
export const EntryRootFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get entries
         * @param {getEntriesAllParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesAll(params: getEntriesAllParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntriesAll");
            }
            const localVarPath = `/entry-root/{id}/entries`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            if (params.order !== undefined) {
                localVarFormParams.set('order', params.order as any);
            }

            if (params.added_date !== undefined) {
                localVarFormParams.set('added_date', params.added_date as any);
            }

            if (params.sort !== undefined) {
                localVarFormParams.set('sort', params.sort as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entry root
         * @param {getEntryRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRoot(params: getEntryRootParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntryRoot");
            }
            const localVarPath = `/entry-root/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntryRoot - functional programming interface
 * @export
 */
export const EntryRootFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get entries
         * @param {getEntriesAllParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesAll(params: getEntriesAllParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguageEntryListResponse> {
            const localVarFetchArgs = EntryRootFetchParamCreator(configuration).getEntriesAll(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get entry root
         * @param {getEntryRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRoot(params: getEntryRootParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EntryRootEntity> {
            const localVarFetchArgs = EntryRootFetchParamCreator(configuration).getEntryRoot(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id (not used)
 * @param {string} [language] entry language
 * @param {number} [limit] limit
 * @param {number} [offset] offset
 * @param {string} [order] order
 * @param {string} [added_date] added date
 * @param {string} [sort] sort
*/
export type getEntriesAllParams = {
    id: string,
    language?: string,
    limit?: number,
    offset?: number,
    order?: string,
    added_date?: string,
    sort?: string,
}

/**
 * @param {string} id Id of the entry (not used)
*/
export type getEntryRootParams = {
    id: string,
}

/**
 * EntryRoot - factory interface
 * @export
 */
export const EntryRootFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get entries
         * @param {getEntriesAllParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesAll(params: getEntriesAllParams, options?: any) {
            return EntryRootFp(configuration).getEntriesAll(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get entry root
         * @param {getEntryRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRoot(params: getEntryRootParams, options?: any) {
            return EntryRootFp(configuration).getEntryRoot(params, options)(fetch, basePath);
        },
    };
};

/**
 * EntryRoot - object-oriented interface
 * @export
 * @class EntryRoot
 * @extends {BaseAPI}
 */
export class EntryRoot extends BaseAPI {
    /**
     * 
     * @summary Get entries
     * @param {getEntriesAllParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryRoot
     */
    public getEntriesAll(params: getEntriesAllParams, options?: any) {
        return EntryRootFp(this.configuration).getEntriesAll(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get entry root
     * @param {getEntryRootParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryRoot
     */
    public getEntryRoot(params: getEntryRootParams, options?: any) {
        return EntryRootFp(this.configuration).getEntryRoot(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Feed - fetch parameter creator
 * @export
 */
export const FeedFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch user, friend (following) or global feed
         * @param {getFeedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeed(params: getFeedParams, options?: any): FetchArgs {
            // verify required parameter "params.type" is set
            if (params.type == null) {
                throw new Error("Missing required parameter 'type' when calling getFeed");
            }
            const localVarPath = `/feed`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.type !== undefined) {
                localVarQueryParameter['type'] = params.type;
            }

            if (params.owner_id !== undefined) {
                localVarQueryParameter['owner_id'] = params.owner_id;
            }

            if (params.owner_only !== undefined) {
                localVarQueryParameter['owner_only'] = params.owner_only;
            }

            if (params.post_type !== undefined) {
                localVarQueryParameter['post_type'] = params.post_type;
            }

            if (params.languages !== undefined) {
                localVarQueryParameter['languages'] = params.languages;
            }

            if (params.countries !== undefined) {
                localVarQueryParameter['countries'] = params.countries;
            }

            if (params.min_age !== undefined) {
                localVarQueryParameter['min_age'] = params.min_age;
            }

            if (params.max_age !== undefined) {
                localVarQueryParameter['max_age'] = params.max_age;
            }

            if (params.sex !== undefined) {
                localVarQueryParameter['sex'] = params.sex;
            }

            if (params.post_id_less_than !== undefined) {
                localVarQueryParameter['post_id_less_than'] = params.post_id_less_than;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Feed - functional programming interface
 * @export
 */
export const FeedFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch user, friend (following) or global feed
         * @param {getFeedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeed(params: getFeedParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PostCollectionResponse> {
            const localVarFetchArgs = FeedFetchParamCreator(configuration).getFeed(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'global' | 'user' | 'following' | 'group'} type feed type
 * @param {string} [owner_id] Feed owner id (uid or group id). Only for user &amp; group types
 * @param {boolean} [owner_only] Only return feed items where the actor is the feed owner.      *                  In case of group feed, this returns offical group posts (poster_is_group&#x3D;true)
 * @param {'photo' | 'group' | 'trip' | 'pinned'} [post_type]       *          Filter by post type. Leave blank for all types.      *          Pinned is available only for group type and pinned posts are not      *          returned by default unless this is specified.      *     
 * @param {string} [languages] Filter post language. CSV of 2-letter language codes. Only for global type.
 * @param {string} [countries] Filter by post creator home country. CSV of 2-letter language codes. Only for global type.
 * @param {number} [min_age] Global feed only: Filter results by minimum age
 * @param {number} [max_age] Global feed only: Filter results by maximum age
 * @param {'male' | 'female'} [sex] Global feed only: Filter results by sex
 * @param {string} [post_id_less_than] Return posts with id less than supplied value. For use instead of offset.
 * @param {number} [limit] Limit
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type getFeedParams = {
    type: 'global' | 'user' | 'following' | 'group',
    owner_id?: string,
    owner_only?: boolean,
    post_type?: 'photo' | 'group' | 'trip' | 'pinned',
    languages?: string,
    countries?: string,
    min_age?: number,
    max_age?: number,
    sex?: 'male' | 'female',
    post_id_less_than?: string,
    limit?: number,
    fields?: string,
    extra?: string,
}

/**
 * Feed - factory interface
 * @export
 */
export const FeedFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Fetch user, friend (following) or global feed
         * @param {getFeedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeed(params: getFeedParams, options?: any) {
            return FeedFp(configuration).getFeed(params, options)(fetch, basePath);
        },
    };
};

/**
 * Feed - object-oriented interface
 * @export
 * @class Feed
 * @extends {BaseAPI}
 */
export class Feed extends BaseAPI {
    /**
     * 
     * @summary Fetch user, friend (following) or global feed
     * @param {getFeedParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Feed
     */
    public getFeed(params: getFeedParams, options?: any) {
        return FeedFp(this.configuration).getFeed(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Feedback - fetch parameter creator
 * @export
 */
export const FeedbackFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create feedback
         * @param {createFeedbackParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback(params: createFeedbackParams, options?: any): FetchArgs {
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling createFeedback");
            }
            const localVarPath = `/feedback`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.username !== undefined) {
                localVarFormParams.set('username', params.username as any);
            }

            if (params.topic !== undefined) {
                localVarFormParams.set('topic', params.topic as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Feedback - functional programming interface
 * @export
 */
export const FeedbackFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create feedback
         * @param {createFeedbackParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback(params: createFeedbackParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = FeedbackFetchParamCreator(configuration).createFeedback(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} message Feedback message
 * @param {string} [email] Email in case when user is not authenticated
 * @param {string} [name] Required if user is not authenticated
 * @param {string} [username] Optional username (if not authenticated)
 * @param {'general' | 'suggestion' | 'account' | 'suspension' | 'report' | 'issue' | 'security' | 'press' | 'legal' | 'partnership' | 'ads'} [topic] Fedback topic/category
*/
export type createFeedbackParams = {
    message: string,
    email?: string,
    name?: string,
    username?: string,
    topic?: 'general' | 'suggestion' | 'account' | 'suspension' | 'report' | 'issue' | 'security' | 'press' | 'legal' | 'partnership' | 'ads',
}

/**
 * Feedback - factory interface
 * @export
 */
export const FeedbackFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create feedback
         * @param {createFeedbackParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback(params: createFeedbackParams, options?: any) {
            return FeedbackFp(configuration).createFeedback(params, options)(fetch, basePath);
        },
    };
};

/**
 * Feedback - object-oriented interface
 * @export
 * @class Feedback
 * @extends {BaseAPI}
 */
export class Feedback extends BaseAPI {
    /**
     * 
     * @summary Create feedback
     * @param {createFeedbackParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Feedback
     */
    public createFeedback(params: createFeedbackParams, options?: any) {
        return FeedbackFp(this.configuration).createFeedback(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Geo - fetch parameter creator
 * @export
 */
export const GeoFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Geo object by geoname $id
         * @param {getGeoByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoById(params: getGeoByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getGeoById");
            }
            const localVarPath = `/geo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cities for by region geonameid or regions by country iso2 code
         * @param {getGeoChildrenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoChildren(params: getGeoChildrenParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getGeoChildren");
            }
            const localVarPath = `/geo/{id}/children`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Geo - functional programming interface
 * @export
 */
export const GeoFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Geo object by geoname $id
         * @param {getGeoByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoById(params: getGeoByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoEntity> {
            const localVarFetchArgs = GeoFetchParamCreator(configuration).getGeoById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get cities for by region geonameid or regions by country iso2 code
         * @param {getGeoChildrenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoChildren(params: getGeoChildrenParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoEntity> {
            const localVarFetchArgs = GeoFetchParamCreator(configuration).getGeoChildren(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Geoname id of the geo item
 * @param {string} [AcceptLanguage] Preferred locales
*/
export type getGeoByIdParams = {
    id: string,
    AcceptLanguage?: string,
}

/**
 * @param {string} id Geoname id (region) or country code (iso2) of the geo item
 * @param {string} [AcceptLanguage] Preferred locales
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getGeoChildrenParams = {
    id: string,
    AcceptLanguage?: string,
    limit?: number,
    offset?: number,
}

/**
 * Geo - factory interface
 * @export
 */
export const GeoFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get Geo object by geoname $id
         * @param {getGeoByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoById(params: getGeoByIdParams, options?: any) {
            return GeoFp(configuration).getGeoById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get cities for by region geonameid or regions by country iso2 code
         * @param {getGeoChildrenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeoChildren(params: getGeoChildrenParams, options?: any) {
            return GeoFp(configuration).getGeoChildren(params, options)(fetch, basePath);
        },
    };
};

/**
 * Geo - object-oriented interface
 * @export
 * @class Geo
 * @extends {BaseAPI}
 */
export class Geo extends BaseAPI {
    /**
     * 
     * @summary Get Geo object by geoname $id
     * @param {getGeoByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Geo
     */
    public getGeoById(params: getGeoByIdParams, options?: any) {
        return GeoFp(this.configuration).getGeoById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get cities for by region geonameid or regions by country iso2 code
     * @param {getGeoChildrenParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Geo
     */
    public getGeoChildren(params: getGeoChildrenParams, options?: any) {
        return GeoFp(this.configuration).getGeoChildren(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Group - fetch parameter creator
 * @export
 */
export const GroupFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add group member to group block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {blockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockGroupMember(params: blockGroupMemberParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling blockGroupMember");
            }
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling blockGroupMember");
            }
            const localVarPath = `/group/{id}/block-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create group
         * @param {createGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(params: createGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.name" is set
            if (params.name == null) {
                throw new Error("Missing required parameter 'name' when calling createGroup");
            }
            // verify required parameter "params.description" is set
            if (params.description == null) {
                throw new Error("Missing required parameter 'description' when calling createGroup");
            }
            // verify required parameter "params.category" is set
            if (params.category == null) {
                throw new Error("Missing required parameter 'category' when calling createGroup");
            }
            // verify required parameter "params.language" is set
            if (params.language == null) {
                throw new Error("Missing required parameter 'language' when calling createGroup");
            }
            const localVarPath = `/group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.category !== undefined) {
                localVarFormParams.set('category', params.category as any);
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete group by group ID
         * @param {deleteGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(params: deleteGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteGroup");
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of blocked group members. DEPRECATED: Use getGroupMembers
         * @param {getBlockedGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedGroupMembers(params: getBlockedGroupMembersParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getBlockedGroupMembers");
            }
            const localVarPath = `/group/{id}/blocklist`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get group by group ID
         * @param {getGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(params: getGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getGroup");
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get group members
         * @param {getGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers(params: getGroupMembersParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getGroupMembers");
            }
            const localVarPath = `/group/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.member_type !== undefined) {
                localVarQueryParameter['member_type'] = params.member_type;
            }

            if (params.name !== undefined) {
                localVarQueryParameter['name'] = params.name;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of groups.
         * @param {getGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(params: getGroupsParams, options?: any): FetchArgs {
            const localVarPath = `/group/all/groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.keywords !== undefined) {
                localVarQueryParameter['keywords'] = params.keywords;
            }

            if (params.language !== undefined) {
                localVarQueryParameter['language'] = params.language;
            }

            if (params.category !== undefined) {
                localVarQueryParameter['category'] = params.category;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join a group
         * @param {joinGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(params: joinGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling joinGroup");
            }
            const localVarPath = `/group/{id}/join`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave group (unsubscribe)
         * @param {leaveGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveGroup(params: leaveGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling leaveGroup");
            }
            const localVarPath = `/group/{id}/leave`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update group member privileges
         * @param {setGroupMemberTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupMemberType(params: setGroupMemberTypeParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling setGroupMemberType");
            }
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling setGroupMemberType");
            }
            // verify required parameter "params.member_type" is set
            if (params.member_type == null) {
                throw new Error("Missing required parameter 'member_type' when calling setGroupMemberType");
            }
            const localVarPath = `/group/{id}/member-type`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            if (params.member_type !== undefined) {
                localVarFormParams.set('member_type', params.member_type as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove group member from group the block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {unblockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockGroupMember(params: unblockGroupMemberParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling unblockGroupMember");
            }
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling unblockGroupMember");
            }
            const localVarPath = `/group/{id}/unblock-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarQueryParameter['user_id'] = params.user_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update group
         * @param {updateGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(params: updateGroupParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateGroup");
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.cover_id !== undefined) {
                localVarFormParams.set('cover_id', params.cover_id as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.category !== undefined) {
                localVarFormParams.set('category', params.category as any);
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Group - functional programming interface
 * @export
 */
export const GroupFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add group member to group block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {blockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockGroupMember(params: blockGroupMemberParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).blockGroupMember(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create group
         * @param {createGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(params: createGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupEntity> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).createGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete group by group ID
         * @param {deleteGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(params: deleteGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).deleteGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of blocked group members. DEPRECATED: Use getGroupMembers
         * @param {getBlockedGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedGroupMembers(params: getBlockedGroupMembersParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupMemberBlockListResponse> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).getBlockedGroupMembers(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get group by group ID
         * @param {getGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(params: getGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupEntity> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).getGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get group members
         * @param {getGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers(params: getGroupMembersParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupMembersResponse> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).getGroupMembers(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of groups.
         * @param {getGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(params: getGroupsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupsWithUserGroupsTotalResponse> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).getGroups(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Join a group
         * @param {joinGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(params: joinGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupEntity> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).joinGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Leave group (unsubscribe)
         * @param {leaveGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveGroup(params: leaveGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupEntity> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).leaveGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update group member privileges
         * @param {setGroupMemberTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupMemberType(params: setGroupMemberTypeParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).setGroupMemberType(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Remove group member from group the block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {unblockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockGroupMember(params: unblockGroupMemberParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).unblockGroupMember(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update group
         * @param {updateGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(params: updateGroupParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupEntity> {
            const localVarFetchArgs = GroupFetchParamCreator(configuration).updateGroup(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Group id
 * @param {string} user_id Id of user to be blocked
*/
export type blockGroupMemberParams = {
    id: string,
    user_id: string,
}

/**
 * @param {string} name Name of the group
 * @param {string} description Description of the group
 * @param {'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel'} category Group category
 * @param {string} language Group language
 * @param {string} [city_id] Specify city_id only if group type is Regional.
*/
export type createGroupParams = {
    name: string,
    description: string,
    category: 'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel',
    language: string,
    city_id?: string,
}

/**
 * @param {string} id Id of the group
*/
export type deleteGroupParams = {
    id: string,
}

/**
 * @param {string} id Group id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getBlockedGroupMembersParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the group
*/
export type getGroupParams = {
    id: string,
}

/**
 * @param {string} id Id of the group
 * @param {'moderator' | 'owner' | 'admin' | 'blocked'} [member_type] 
 * @param {string} [name] Filter by name (inexact matches allowed)
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getGroupMembersParams = {
    id: string,
    member_type?: 'moderator' | 'owner' | 'admin' | 'blocked',
    name?: string,
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} [keywords] Search name and description fields for this text (csv not necessary)
 * @param {string} [language] ISO-639-1 codes
 * @param {'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel'} [category] Filter by a group category.
 * @param {'members' | 'posts' | 'last_activity' | 'created'} [order] Order of groups (always descending)
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getGroupsParams = {
    keywords?: string,
    language?: string,
    category?: 'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel',
    order?: 'members' | 'posts' | 'last_activity' | 'created',
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Group id
*/
export type joinGroupParams = {
    id: string,
}

/**
 * @param {string} id Group ID
*/
export type leaveGroupParams = {
    id: string,
}

/**
 * @param {string} id Group id
 * @param {string} user_id User id whose privileges will be changed
 * @param {'standard' | 'moderator' | 'owner' | 'blocked'} member_type 
*/
export type setGroupMemberTypeParams = {
    id: string,
    user_id: string,
    member_type: 'standard' | 'moderator' | 'owner' | 'blocked',
}

/**
 * @param {string} id Group id
 * @param {string} user_id Id of user to be unblocked
*/
export type unblockGroupMemberParams = {
    id: string,
    user_id: string,
}

/**
 * @param {string} id id
 * @param {string} [cover_id] ID of the photo that will be used as group cover
 * @param {string} [description] Description of the group
 * @param {string} [name] Name of the group
 * @param {'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel'} [category] Group category
 * @param {string} [language] Group language
 * @param {string} [city_id] Required only if group type is Regional.
*/
export type updateGroupParams = {
    id: string,
    cover_id?: string,
    description?: string,
    name?: string,
    category?: 'advice' | 'books' | 'education' | 'food' | 'fun' | 'history' | 'hobbies' | 'interpals' | 'miscellaneous' | 'moderation' | 'movies' | 'music' | 'nature' | 'news' | 'regional' | 'religion' | 'science' | 'society' | 'sports' | 'travel',
    language?: string,
    city_id?: string,
}

/**
 * Group - factory interface
 * @export
 */
export const GroupFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Add group member to group block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {blockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockGroupMember(params: blockGroupMemberParams, options?: any) {
            return GroupFp(configuration).blockGroupMember(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create group
         * @param {createGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(params: createGroupParams, options?: any) {
            return GroupFp(configuration).createGroup(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete group by group ID
         * @param {deleteGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(params: deleteGroupParams, options?: any) {
            return GroupFp(configuration).deleteGroup(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of blocked group members. DEPRECATED: Use getGroupMembers
         * @param {getBlockedGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedGroupMembers(params: getBlockedGroupMembersParams, options?: any) {
            return GroupFp(configuration).getBlockedGroupMembers(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get group by group ID
         * @param {getGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(params: getGroupParams, options?: any) {
            return GroupFp(configuration).getGroup(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get group members
         * @param {getGroupMembersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers(params: getGroupMembersParams, options?: any) {
            return GroupFp(configuration).getGroupMembers(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of groups.
         * @param {getGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(params: getGroupsParams, options?: any) {
            return GroupFp(configuration).getGroups(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Join a group
         * @param {joinGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(params: joinGroupParams, options?: any) {
            return GroupFp(configuration).joinGroup(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Leave group (unsubscribe)
         * @param {leaveGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveGroup(params: leaveGroupParams, options?: any) {
            return GroupFp(configuration).leaveGroup(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update group member privileges
         * @param {setGroupMemberTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupMemberType(params: setGroupMemberTypeParams, options?: any) {
            return GroupFp(configuration).setGroupMemberType(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Remove group member from group the block list. DEPRECATED: Use setGroupMemberType instead.
         * @param {unblockGroupMemberParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockGroupMember(params: unblockGroupMemberParams, options?: any) {
            return GroupFp(configuration).unblockGroupMember(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update group
         * @param {updateGroupParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(params: updateGroupParams, options?: any) {
            return GroupFp(configuration).updateGroup(params, options)(fetch, basePath);
        },
    };
};

/**
 * Group - object-oriented interface
 * @export
 * @class Group
 * @extends {BaseAPI}
 */
export class Group extends BaseAPI {
    /**
     * 
     * @summary Add group member to group block list. DEPRECATED: Use setGroupMemberType instead.
     * @param {blockGroupMemberParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public blockGroupMember(params: blockGroupMemberParams, options?: any) {
        return GroupFp(this.configuration).blockGroupMember(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create group
     * @param {createGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public createGroup(params: createGroupParams, options?: any) {
        return GroupFp(this.configuration).createGroup(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete group by group ID
     * @param {deleteGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public deleteGroup(params: deleteGroupParams, options?: any) {
        return GroupFp(this.configuration).deleteGroup(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of blocked group members. DEPRECATED: Use getGroupMembers
     * @param {getBlockedGroupMembersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public getBlockedGroupMembers(params: getBlockedGroupMembersParams, options?: any) {
        return GroupFp(this.configuration).getBlockedGroupMembers(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get group by group ID
     * @param {getGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public getGroup(params: getGroupParams, options?: any) {
        return GroupFp(this.configuration).getGroup(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get group members
     * @param {getGroupMembersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public getGroupMembers(params: getGroupMembersParams, options?: any) {
        return GroupFp(this.configuration).getGroupMembers(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of groups.
     * @param {getGroupsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public getGroups(params: getGroupsParams, options?: any) {
        return GroupFp(this.configuration).getGroups(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Join a group
     * @param {joinGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public joinGroup(params: joinGroupParams, options?: any) {
        return GroupFp(this.configuration).joinGroup(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Leave group (unsubscribe)
     * @param {leaveGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public leaveGroup(params: leaveGroupParams, options?: any) {
        return GroupFp(this.configuration).leaveGroup(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update group member privileges
     * @param {setGroupMemberTypeParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public setGroupMemberType(params: setGroupMemberTypeParams, options?: any) {
        return GroupFp(this.configuration).setGroupMemberType(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Remove group member from group the block list. DEPRECATED: Use setGroupMemberType instead.
     * @param {unblockGroupMemberParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public unblockGroupMember(params: unblockGroupMemberParams, options?: any) {
        return GroupFp(this.configuration).unblockGroupMember(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update group
     * @param {updateGroupParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Group
     */
    public updateGroup(params: updateGroupParams, options?: any) {
        return GroupFp(this.configuration).updateGroup(params, options)(this.fetch, this.basePath);
    }

}

/**
 * LangEntry - fetch parameter creator
 * @export
 */
export const LangEntryFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry
         * @param {createLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntry(params: createLangEntryParams, options?: any): FetchArgs {
            // verify required parameter "params.entry" is set
            if (params.entry == null) {
                throw new Error("Missing required parameter 'entry' when calling createLangEntry");
            }
            const localVarPath = `/lang-entry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.type !== undefined) {
                localVarFormParams.set('type', params.type as any);
            }

            if (params.entry !== undefined) {
                localVarFormParams.set('entry', params.entry as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            if (params.prompt_id !== undefined) {
                localVarFormParams.set('prompt_id', params.prompt_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete lang entry
         * @param {deleteLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntry(params: deleteLangEntryParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteLangEntry");
            }
            const localVarPath = `/lang-entry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entry corrections by $id
         * @param {getEntryCorrectionsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrections(params: getEntryCorrectionsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntryCorrections");
            }
            const localVarPath = `/lang-entry/{id}/corrections`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.sort !== undefined) {
                localVarFormParams.set('sort', params.sort as any);
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lang entry by id
         * @param {getLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntry(params: getLangEntryParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getLangEntry");
            }
            const localVarPath = `/lang-entry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lang entry by $id
         * @param {updateLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntry(params: updateLangEntryParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateLangEntry");
            }
            const localVarPath = `/lang-entry/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.entry !== undefined) {
                localVarFormParams.set('entry', params.entry as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LangEntry - functional programming interface
 * @export
 */
export const LangEntryFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry
         * @param {createLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntry(params: createLangEntryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryEntity> {
            const localVarFetchArgs = LangEntryFetchParamCreator(configuration).createLangEntry(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete lang entry
         * @param {deleteLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntry(params: deleteLangEntryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = LangEntryFetchParamCreator(configuration).deleteLangEntry(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get entry corrections by $id
         * @param {getEntryCorrectionsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrections(params: getEntryCorrectionsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EntryCorrectionListResponse> {
            const localVarFetchArgs = LangEntryFetchParamCreator(configuration).getEntryCorrections(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get lang entry by id
         * @param {getLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntry(params: getLangEntryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryEntity> {
            const localVarFetchArgs = LangEntryFetchParamCreator(configuration).getLangEntry(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update lang entry by $id
         * @param {updateLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntry(params: updateLangEntryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryEntity> {
            const localVarFetchArgs = LangEntryFetchParamCreator(configuration).updateLangEntry(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} entry entry data
 * @param {string} [language] entry language
 * @param {string} [type] entry type
 * @param {string} [comment] entry comment
 * @param {string} [prompt_id] prompt id
*/
export type createLangEntryParams = {
    entry: string,
    language?: string,
    type?: string,
    comment?: string,
    prompt_id?: string,
}

/**
 * @param {string} id entry id
*/
export type deleteLangEntryParams = {
    id: string,
}

/**
 * @param {string} id Id of the entry
 * @param {string} [sort] sort
 * @param {number} [limit] limit
 * @param {number} [offset] offset
*/
export type getEntryCorrectionsParams = {
    id: string,
    sort?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the entry
*/
export type getLangEntryParams = {
    id: string,
}

/**
 * @param {string} id Id of the entry
 * @param {string} [language] entry language
 * @param {string} [entry] text of the entry
 * @param {string} [comment] comment on entry
*/
export type updateLangEntryParams = {
    id: string,
    language?: string,
    entry?: string,
    comment?: string,
}

/**
 * LangEntry - factory interface
 * @export
 */
export const LangEntryFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new lang entry
         * @param {createLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntry(params: createLangEntryParams, options?: any) {
            return LangEntryFp(configuration).createLangEntry(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete lang entry
         * @param {deleteLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntry(params: deleteLangEntryParams, options?: any) {
            return LangEntryFp(configuration).deleteLangEntry(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get entry corrections by $id
         * @param {getEntryCorrectionsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrections(params: getEntryCorrectionsParams, options?: any) {
            return LangEntryFp(configuration).getEntryCorrections(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get lang entry by id
         * @param {getLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntry(params: getLangEntryParams, options?: any) {
            return LangEntryFp(configuration).getLangEntry(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update lang entry by $id
         * @param {updateLangEntryParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntry(params: updateLangEntryParams, options?: any) {
            return LangEntryFp(configuration).updateLangEntry(params, options)(fetch, basePath);
        },
    };
};

/**
 * LangEntry - object-oriented interface
 * @export
 * @class LangEntry
 * @extends {BaseAPI}
 */
export class LangEntry extends BaseAPI {
    /**
     * 
     * @summary Create new lang entry
     * @param {createLangEntryParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntry
     */
    public createLangEntry(params: createLangEntryParams, options?: any) {
        return LangEntryFp(this.configuration).createLangEntry(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete lang entry
     * @param {deleteLangEntryParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntry
     */
    public deleteLangEntry(params: deleteLangEntryParams, options?: any) {
        return LangEntryFp(this.configuration).deleteLangEntry(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get entry corrections by $id
     * @param {getEntryCorrectionsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntry
     */
    public getEntryCorrections(params: getEntryCorrectionsParams, options?: any) {
        return LangEntryFp(this.configuration).getEntryCorrections(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get lang entry by id
     * @param {getLangEntryParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntry
     */
    public getLangEntry(params: getLangEntryParams, options?: any) {
        return LangEntryFp(this.configuration).getLangEntry(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update lang entry by $id
     * @param {updateLangEntryParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntry
     */
    public updateLangEntry(params: updateLangEntryParams, options?: any) {
        return LangEntryFp(this.configuration).updateLangEntry(params, options)(this.fetch, this.basePath);
    }

}

/**
 * LangEntryCorrection - fetch parameter creator
 * @export
 */
export const LangEntryCorrectionFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry correction
         * @param {createLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryCorrection(params: createLangEntryCorrectionParams, options?: any): FetchArgs {
            // verify required parameter "params.correction" is set
            if (params.correction == null) {
                throw new Error("Missing required parameter 'correction' when calling createLangEntryCorrection");
            }
            // verify required parameter "params.entry_id" is set
            if (params.entry_id == null) {
                throw new Error("Missing required parameter 'entry_id' when calling createLangEntryCorrection");
            }
            const localVarPath = `/lang-entry-correction`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.correction !== undefined) {
                localVarFormParams.set('correction', params.correction as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            if (params.entry_id !== undefined) {
                localVarFormParams.set('entry_id', params.entry_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete lang entry correction
         * @param {deleteLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryCorrection(params: deleteLangEntryCorrectionParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteLangEntryCorrection");
            }
            const localVarPath = `/lang-entry-correction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entry correction votes by $id
         * @param {getEntryCorrectionVotesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVotes(params: getEntryCorrectionVotesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntryCorrectionVotes");
            }
            const localVarPath = `/lang-entry-correction/{id}/votes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lang entry correction by id
         * @param {getLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryCorrection(params: getLangEntryCorrectionParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getLangEntryCorrection");
            }
            const localVarPath = `/lang-entry-correction/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LangEntryCorrection - functional programming interface
 * @export
 */
export const LangEntryCorrectionFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry correction
         * @param {createLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryCorrection(params: createLangEntryCorrectionParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryCorrectionEntity> {
            const localVarFetchArgs = LangEntryCorrectionFetchParamCreator(configuration).createLangEntryCorrection(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete lang entry correction
         * @param {deleteLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryCorrection(params: deleteLangEntryCorrectionParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = LangEntryCorrectionFetchParamCreator(configuration).deleteLangEntryCorrection(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get entry correction votes by $id
         * @param {getEntryCorrectionVotesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVotes(params: getEntryCorrectionVotesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CorrectionVoteListResponse> {
            const localVarFetchArgs = LangEntryCorrectionFetchParamCreator(configuration).getEntryCorrectionVotes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get lang entry correction by id
         * @param {getLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryCorrection(params: getLangEntryCorrectionParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryCorrectionEntity> {
            const localVarFetchArgs = LangEntryCorrectionFetchParamCreator(configuration).getLangEntryCorrection(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} correction entry correction
 * @param {string} entry_id related entry id
 * @param {string} [comment] entry comment
*/
export type createLangEntryCorrectionParams = {
    correction: string,
    entry_id: string,
    comment?: string,
}

/**
 * @param {string} id entry correction id
*/
export type deleteLangEntryCorrectionParams = {
    id: string,
}

/**
 * @param {string} id Id of the correction
*/
export type getEntryCorrectionVotesParams = {
    id: string,
}

/**
 * @param {string} id Id of the entry
*/
export type getLangEntryCorrectionParams = {
    id: string,
}

/**
 * LangEntryCorrection - factory interface
 * @export
 */
export const LangEntryCorrectionFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new lang entry correction
         * @param {createLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryCorrection(params: createLangEntryCorrectionParams, options?: any) {
            return LangEntryCorrectionFp(configuration).createLangEntryCorrection(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete lang entry correction
         * @param {deleteLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryCorrection(params: deleteLangEntryCorrectionParams, options?: any) {
            return LangEntryCorrectionFp(configuration).deleteLangEntryCorrection(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get entry correction votes by $id
         * @param {getEntryCorrectionVotesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCorrectionVotes(params: getEntryCorrectionVotesParams, options?: any) {
            return LangEntryCorrectionFp(configuration).getEntryCorrectionVotes(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get lang entry correction by id
         * @param {getLangEntryCorrectionParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryCorrection(params: getLangEntryCorrectionParams, options?: any) {
            return LangEntryCorrectionFp(configuration).getLangEntryCorrection(params, options)(fetch, basePath);
        },
    };
};

/**
 * LangEntryCorrection - object-oriented interface
 * @export
 * @class LangEntryCorrection
 * @extends {BaseAPI}
 */
export class LangEntryCorrection extends BaseAPI {
    /**
     * 
     * @summary Create new lang entry correction
     * @param {createLangEntryCorrectionParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryCorrection
     */
    public createLangEntryCorrection(params: createLangEntryCorrectionParams, options?: any) {
        return LangEntryCorrectionFp(this.configuration).createLangEntryCorrection(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete lang entry correction
     * @param {deleteLangEntryCorrectionParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryCorrection
     */
    public deleteLangEntryCorrection(params: deleteLangEntryCorrectionParams, options?: any) {
        return LangEntryCorrectionFp(this.configuration).deleteLangEntryCorrection(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get entry correction votes by $id
     * @param {getEntryCorrectionVotesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryCorrection
     */
    public getEntryCorrectionVotes(params: getEntryCorrectionVotesParams, options?: any) {
        return LangEntryCorrectionFp(this.configuration).getEntryCorrectionVotes(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get lang entry correction by id
     * @param {getLangEntryCorrectionParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryCorrection
     */
    public getLangEntryCorrection(params: getLangEntryCorrectionParams, options?: any) {
        return LangEntryCorrectionFp(this.configuration).getLangEntryCorrection(params, options)(this.fetch, this.basePath);
    }

}

/**
 * LangEntryPrompt - fetch parameter creator
 * @export
 */
export const LangEntryPromptFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry prompt
         * @param {createLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryPrompt(params: createLangEntryPromptParams, options?: any): FetchArgs {
            // verify required parameter "params.data" is set
            if (params.data == null) {
                throw new Error("Missing required parameter 'data' when calling createLangEntryPrompt");
            }
            const localVarPath = `/lang-entry-prompt`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.type !== undefined) {
                localVarFormParams.set('type', params.type as any);
            }

            if (params.data !== undefined) {
                localVarFormParams.set('data', params.data as any);
            }

            if (params.is_public !== undefined) {
                localVarFormParams.set('is_public', params.is_public as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete lang entry prompt
         * @param {deleteLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryPrompt(params: deleteLangEntryPromptParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteLangEntryPrompt");
            }
            const localVarPath = `/lang-entry-prompt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lang entry prompt by id
         * @param {getLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryPrompt(params: getLangEntryPromptParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getLangEntryPrompt");
            }
            const localVarPath = `/lang-entry-prompt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get prompt entries by $id
         * @param {getPromptEntriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptEntries(params: getPromptEntriesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPromptEntries");
            }
            const localVarPath = `/lang-entry-prompt/{id}/entries`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lang entry prompt by $id
         * @param {updateLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntryPrompt(params: updateLangEntryPromptParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateLangEntryPrompt");
            }
            const localVarPath = `/lang-entry-prompt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.data !== undefined) {
                localVarFormParams.set('data', params.data as any);
            }

            if (params.approved !== undefined) {
                localVarFormParams.set('approved', params.approved as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LangEntryPrompt - functional programming interface
 * @export
 */
export const LangEntryPromptFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new lang entry prompt
         * @param {createLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryPrompt(params: createLangEntryPromptParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryPromptEntity> {
            const localVarFetchArgs = LangEntryPromptFetchParamCreator(configuration).createLangEntryPrompt(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete lang entry prompt
         * @param {deleteLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryPrompt(params: deleteLangEntryPromptParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = LangEntryPromptFetchParamCreator(configuration).deleteLangEntryPrompt(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get lang entry prompt by id
         * @param {getLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryPrompt(params: getLangEntryPromptParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryPromptEntity> {
            const localVarFetchArgs = LangEntryPromptFetchParamCreator(configuration).getLangEntryPrompt(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get prompt entries by $id
         * @param {getPromptEntriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptEntries(params: getPromptEntriesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguageEntryListResponse> {
            const localVarFetchArgs = LangEntryPromptFetchParamCreator(configuration).getPromptEntries(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update lang entry prompt by $id
         * @param {updateLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntryPrompt(params: updateLangEntryPromptParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LangEntryPromptEntity> {
            const localVarFetchArgs = LangEntryPromptFetchParamCreator(configuration).updateLangEntryPrompt(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} data entry data
 * @param {string} [language] entry language
 * @param {string} [type] entry type
 * @param {number} [is_public] is entry public
*/
export type createLangEntryPromptParams = {
    data: string,
    language?: string,
    type?: string,
    is_public?: number,
}

/**
 * @param {string} id prompt id
*/
export type deleteLangEntryPromptParams = {
    id: string,
}

/**
 * @param {string} id Id of the prompt
*/
export type getLangEntryPromptParams = {
    id: string,
}

/**
 * @param {string} id Id of the prompt
*/
export type getPromptEntriesParams = {
    id: string,
}

/**
 * @param {string} id Id of the prompt
 * @param {string} [data] text of the prompt
 * @param {string} [approved] Message of the prompt
*/
export type updateLangEntryPromptParams = {
    id: string,
    data?: string,
    approved?: string,
}

/**
 * LangEntryPrompt - factory interface
 * @export
 */
export const LangEntryPromptFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new lang entry prompt
         * @param {createLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLangEntryPrompt(params: createLangEntryPromptParams, options?: any) {
            return LangEntryPromptFp(configuration).createLangEntryPrompt(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete lang entry prompt
         * @param {deleteLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLangEntryPrompt(params: deleteLangEntryPromptParams, options?: any) {
            return LangEntryPromptFp(configuration).deleteLangEntryPrompt(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get lang entry prompt by id
         * @param {getLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLangEntryPrompt(params: getLangEntryPromptParams, options?: any) {
            return LangEntryPromptFp(configuration).getLangEntryPrompt(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get prompt entries by $id
         * @param {getPromptEntriesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptEntries(params: getPromptEntriesParams, options?: any) {
            return LangEntryPromptFp(configuration).getPromptEntries(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update lang entry prompt by $id
         * @param {updateLangEntryPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLangEntryPrompt(params: updateLangEntryPromptParams, options?: any) {
            return LangEntryPromptFp(configuration).updateLangEntryPrompt(params, options)(fetch, basePath);
        },
    };
};

/**
 * LangEntryPrompt - object-oriented interface
 * @export
 * @class LangEntryPrompt
 * @extends {BaseAPI}
 */
export class LangEntryPrompt extends BaseAPI {
    /**
     * 
     * @summary Create new lang entry prompt
     * @param {createLangEntryPromptParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryPrompt
     */
    public createLangEntryPrompt(params: createLangEntryPromptParams, options?: any) {
        return LangEntryPromptFp(this.configuration).createLangEntryPrompt(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete lang entry prompt
     * @param {deleteLangEntryPromptParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryPrompt
     */
    public deleteLangEntryPrompt(params: deleteLangEntryPromptParams, options?: any) {
        return LangEntryPromptFp(this.configuration).deleteLangEntryPrompt(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get lang entry prompt by id
     * @param {getLangEntryPromptParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryPrompt
     */
    public getLangEntryPrompt(params: getLangEntryPromptParams, options?: any) {
        return LangEntryPromptFp(this.configuration).getLangEntryPrompt(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get prompt entries by $id
     * @param {getPromptEntriesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryPrompt
     */
    public getPromptEntries(params: getPromptEntriesParams, options?: any) {
        return LangEntryPromptFp(this.configuration).getPromptEntries(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update lang entry prompt by $id
     * @param {updateLangEntryPromptParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LangEntryPrompt
     */
    public updateLangEntryPrompt(params: updateLangEntryPromptParams, options?: any) {
        return LangEntryPromptFp(this.configuration).updateLangEntryPrompt(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Language - fetch parameter creator
 * @export
 */
export const LanguageFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch all languages
         * @param {getLanguagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(params: getLanguagesParams, options?: any): FetchArgs {
            const localVarPath = `/language/all`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.field !== undefined) {
                localVarQueryParameter['field'] = params.field;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Language - functional programming interface
 * @export
 */
export const LanguageFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch all languages
         * @param {getLanguagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(params: getLanguagesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguagesResponse> {
            const localVarFetchArgs = LanguageFetchParamCreator(configuration).getLanguages(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} [AcceptLanguage] Preferred locales
 * @param {'key' | 'value'} [field] By what field we should sort?
 * @param {'asc' | 'desc'} [order] What type of the sort
*/
export type getLanguagesParams = {
    AcceptLanguage?: string,
    field?: 'key' | 'value',
    order?: 'asc' | 'desc',
}

/**
 * Language - factory interface
 * @export
 */
export const LanguageFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Fetch all languages
         * @param {getLanguagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(params: getLanguagesParams, options?: any) {
            return LanguageFp(configuration).getLanguages(params, options)(fetch, basePath);
        },
    };
};

/**
 * Language - object-oriented interface
 * @export
 * @class Language
 * @extends {BaseAPI}
 */
export class Language extends BaseAPI {
    /**
     * 
     * @summary Fetch all languages
     * @param {getLanguagesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Language
     */
    public getLanguages(params: getLanguagesParams, options?: any) {
        return LanguageFp(this.configuration).getLanguages(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Like - fetch parameter creator
 * @export
 */
export const LikeFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Like an entity
         * @param {createLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLike(params: createLikeParams, options?: any): FetchArgs {
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling createLike");
            }
            // verify required parameter "params.entity_id" is set
            if (params.entity_id == null) {
                throw new Error("Missing required parameter 'entity_id' when calling createLike");
            }
            const localVarPath = `/like`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.entity_id !== undefined) {
                localVarFormParams.set('entity_id', params.entity_id as any);
            }

            if (params.like_type !== undefined) {
                localVarFormParams.set('like_type', params.like_type as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete like
         * @param {deleteLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLike(params: deleteLikeParams, options?: any): FetchArgs {
            // verify required parameter "params.entity_id" is set
            if (params.entity_id == null) {
                throw new Error("Missing required parameter 'entity_id' when calling deleteLike");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling deleteLike");
            }
            const localVarPath = `/like`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_id !== undefined) {
                localVarQueryParameter['entity_id'] = params.entity_id;
            }

            if (params.entity_type !== undefined) {
                localVarQueryParameter['entity_type'] = params.entity_type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Like - functional programming interface
 * @export
 */
export const LikeFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Like an entity
         * @param {createLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLike(params: createLikeParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeEntity> {
            const localVarFetchArgs = LikeFetchParamCreator(configuration).createLike(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete like
         * @param {deleteLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLike(params: deleteLikeParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = LikeFetchParamCreator(configuration).deleteLike(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry'} entity_type Entity type
 * @param {string} entity_id Entity id
 * @param {'like' | 'adore' | 'laugh' | 'wonder' | 'tears' | 'anger'} [like_type] Like type
*/
export type createLikeParams = {
    entity_type: 'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry',
    entity_id: string,
    like_type?: 'like' | 'adore' | 'laugh' | 'wonder' | 'tears' | 'anger',
}

/**
 * @param {string} entity_id Id of liked entity
 * @param {'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry'} entity_type Entity type
*/
export type deleteLikeParams = {
    entity_id: string,
    entity_type: 'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry',
}

/**
 * Like - factory interface
 * @export
 */
export const LikeFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Like an entity
         * @param {createLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLike(params: createLikeParams, options?: any) {
            return LikeFp(configuration).createLike(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete like
         * @param {deleteLikeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLike(params: deleteLikeParams, options?: any) {
            return LikeFp(configuration).deleteLike(params, options)(fetch, basePath);
        },
    };
};

/**
 * Like - object-oriented interface
 * @export
 * @class Like
 * @extends {BaseAPI}
 */
export class Like extends BaseAPI {
    /**
     * 
     * @summary Like an entity
     * @param {createLikeParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Like
     */
    public createLike(params: createLikeParams, options?: any) {
        return LikeFp(this.configuration).createLike(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete like
     * @param {deleteLikeParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Like
     */
    public deleteLike(params: deleteLikeParams, options?: any) {
        return LikeFp(this.configuration).deleteLike(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Message - fetch parameter creator
 * @export
 */
export const MessageFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send message
         * @param {createMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage(params: createMessageParams, options?: any): FetchArgs {
            const localVarPath = `/message`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.EnforceRateLimits !== undefined && params.EnforceRateLimits !== null) {
                localVarHeaderParameter['ENFORCE-RATE-LIMITS'] = String(params.EnforceRateLimits);
            }

            if (params.thread_id !== undefined) {
                localVarFormParams.set('thread_id', params.thread_id as any);
            }

            if (params.target_id !== undefined) {
                localVarFormParams.set('target_id', params.target_id as any);
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            if (params.attachment_type !== undefined) {
                localVarFormParams.set('attachment_type', params.attachment_type as any);
            }

            if (params.attachment_id !== undefined) {
                localVarFormParams.set('attachment_id', params.attachment_id as any);
            }

            if (params.tmp_id !== undefined) {
                localVarFormParams.set('tmp_id', params.tmp_id as any);
            }

            if (params.fake_id !== undefined) {
                localVarFormParams.set('fake_id', params.fake_id as any);
            }

            if (params.gif_attachment_url !== undefined) {
                localVarFormParams.set('gif_attachment_url', params.gif_attachment_url as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark thread message as deleted for given user
         * @param {deleteMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage(params: deleteMessageParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteMessage");
            }
            // verify required parameter "params.thread_id" is set
            if (params.thread_id == null) {
                throw new Error("Missing required parameter 'thread_id' when calling deleteMessage");
            }
            const localVarPath = `/message/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.thread_id !== undefined) {
                localVarQueryParameter['thread_id'] = params.thread_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Message - functional programming interface
 * @export
 */
export const MessageFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send message
         * @param {createMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage(params: createMessageParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageEntity> {
            const localVarFetchArgs = MessageFetchParamCreator(configuration).createMessage(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Mark thread message as deleted for given user
         * @param {deleteMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage(params: deleteMessageParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = MessageFetchParamCreator(configuration).deleteMessage(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} [thread_id] Thread id. Required if target_id is not supplied
 * @param {string} [target_id] Target user id. Required if thread_id is not supplied, but prefer thread_id if available.
 * @param {string} [message] Text of the message, max 10k chars
 * @param {'photo' | 'audio' | 'video' | 'call' | 'correction' | 'reply' | 'gif'} [attachment_type] Attachment type
 * @param {string} [attachment_id] Attachment entity id
 * @param {string} [tmp_id] Temporary id for the message on device
 * @param {string} [fake_id] DEPRECATED: FORCE_UPGRADE remove Temporary id for the message on device
 * @param {string} [gif_attachment_url] 
 * @param {string} [comment] Optional comment for message correction, max 10k chars
 * @param {string} [EnforceRateLimits] Non-production: enforce rate limits during testing
*/
export type createMessageParams = {
    thread_id?: string,
    target_id?: string,
    message?: string,
    attachment_type?: 'photo' | 'audio' | 'video' | 'call' | 'correction' | 'reply' | 'gif',
    attachment_id?: string,
    tmp_id?: string,
    fake_id?: string,
    gif_attachment_url?: string,
    comment?: string,
    EnforceRateLimits?: string,
}

/**
 * @param {string} id Message id
 * @param {string} thread_id Thread id
*/
export type deleteMessageParams = {
    id: string,
    thread_id: string,
}

/**
 * Message - factory interface
 * @export
 */
export const MessageFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Send message
         * @param {createMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage(params: createMessageParams, options?: any) {
            return MessageFp(configuration).createMessage(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Mark thread message as deleted for given user
         * @param {deleteMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage(params: deleteMessageParams, options?: any) {
            return MessageFp(configuration).deleteMessage(params, options)(fetch, basePath);
        },
    };
};

/**
 * Message - object-oriented interface
 * @export
 * @class Message
 * @extends {BaseAPI}
 */
export class Message extends BaseAPI {
    /**
     * 
     * @summary Send message
     * @param {createMessageParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Message
     */
    public createMessage(params: createMessageParams, options?: any) {
        return MessageFp(this.configuration).createMessage(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Mark thread message as deleted for given user
     * @param {deleteMessageParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Message
     */
    public deleteMessage(params: deleteMessageParams, options?: any) {
        return MessageFp(this.configuration).deleteMessage(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Metrics - fetch parameter creator
 * @export
 */
export const MetricsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all metrics
         * @param {getMetricsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(options?: any): FetchArgs {
            const localVarPath = `/metric/all`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Metrics - functional programming interface
 * @export
 */
export const MetricsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all metrics
         * @param {getMetricsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MetricsEntity> {
            const localVarFetchArgs = MetricsFetchParamCreator(configuration).getMetrics(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};



/**
 * Metrics - factory interface
 * @export
 */
export const MetricsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get all metrics
         * @param {getMetricsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(options?: any) {
            return MetricsFp(configuration).getMetrics(options)(fetch, basePath);
        },
    };
};

/**
 * Metrics - object-oriented interface
 * @export
 * @class Metrics
 * @extends {BaseAPI}
 */
export class Metrics extends BaseAPI {
    /**
     * 
     * @summary Get all metrics
     * @param {getMetricsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Metrics
     */
    public getMetrics(options?: any) {
        return MetricsFp(this.configuration).getMetrics(options)(this.fetch, this.basePath);
    }

}

/**
 * ModAdmin - fetch parameter creator
 * @export
 */
export const ModAdminFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Mark a user's email address as verified.
         * @param {activateUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(params: activateUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling activateUser");
            }
            const localVarPath = `/user-admin/{id}/activate-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This action will permanently delete user and their data.
         * @param {deleteUserDataParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserData(params: deleteUserDataParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteUserData");
            }
            const localVarPath = `/user-admin/{id}/delete-user-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Expire all caches related to a given user.
         * @param {expireUserCacheParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireUserCache(params: expireUserCacheParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling expireUserCache");
            }
            const localVarPath = `/user-admin/{id}/expire-cache`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getResetLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResetLink(params: getResetLinkParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getResetLink");
            }
            const localVarPath = `/user-admin/{id}/reset-link`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getUserDataDumpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataDump(params: getUserDataDumpParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserDataDump");
            }
            const localVarPath = `/user-admin/{id}/dump-user-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.log_msg !== undefined) {
                localVarQueryParameter['log_msg'] = params.log_msg;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * test
         * @param {resendActivationLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivationLink(params: resendActivationLinkParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resendActivationLink");
            }
            const localVarPath = `/user-admin/resend-activation-link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.id !== undefined) {
                localVarFormParams.set('id', params.id as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {resetUserLimitParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserLimit(params: resetUserLimitParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resetUserLimit");
            }
            const localVarPath = `/user-admin/{id}/reset-limit`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore thread with user.
         * @param {restoreThreadWithUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadWithUser(params: restoreThreadWithUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling restoreThreadWithUser");
            }
            // verify required parameter "params.thread_contact" is set
            if (params.thread_contact == null) {
                throw new Error("Missing required parameter 'thread_contact' when calling restoreThreadWithUser");
            }
            const localVarPath = `/user-admin/{id}/restore-thread-with-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.thread_contact !== undefined) {
                localVarFormParams.set('thread_contact', params.thread_contact as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore all messages in all threads including deleted.
         * @param {restoreThreadsByUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadsByUid(params: restoreThreadsByUidParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling restoreThreadsByUid");
            }
            const localVarPath = `/user-admin/{id}/restore-threads-by-uid`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.two_way_restore !== undefined) {
                localVarFormParams.set('two_way_restore', params.two_way_restore as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModAdmin - functional programming interface
 * @export
 */
export const ModAdminFp = function(configuration?: Configuration) {
    return {
        /**
         * Mark a user's email address as verified.
         * @param {activateUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(params: activateUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).activateUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This action will permanently delete user and their data.
         * @param {deleteUserDataParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserData(params: deleteUserDataParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).deleteUserData(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Expire all caches related to a given user.
         * @param {expireUserCacheParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireUserCache(params: expireUserCacheParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).expireUserCache(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getResetLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResetLink(params: getResetLinkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LinkEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).getResetLink(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getUserDataDumpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataDump(params: getUserDataDumpParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDataDumpEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).getUserDataDump(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * test
         * @param {resendActivationLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivationLink(params: resendActivationLinkParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).resendActivationLink(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {resetUserLimitParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserLimit(params: resetUserLimitParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).resetUserLimit(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Restore thread with user.
         * @param {restoreThreadWithUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadWithUser(params: restoreThreadWithUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).restoreThreadWithUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Restore all messages in all threads including deleted.
         * @param {restoreThreadsByUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadsByUid(params: restoreThreadsByUidParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModAdminFetchParamCreator(configuration).restoreThreadsByUid(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id This value can be username or user id
 * @param {string} [log_msg] 
*/
export type activateUserParams = {
    id: string,
    log_msg?: string,
}

/**
 * @param {string} id This value can be username or user id
 * @param {string} [log_msg] 
*/
export type deleteUserDataParams = {
    id: string,
    log_msg?: string,
}

/**
 * @param {string} id This value can be username or user id
 * @param {string} [log_msg] 
*/
export type expireUserCacheParams = {
    id: string,
    log_msg?: string,
}

/**
 * @param {string} id User id for password reset link
*/
export type getResetLinkParams = {
    id: string,
}

/**
 * @param {string} id This value can be username or user id
 * @param {string} [log_msg] 
*/
export type getUserDataDumpParams = {
    id: string,
    log_msg?: string,
}

/**
 * @param {string} id User id for activation link resend
 * @param {string} [log_msg] 
*/
export type resendActivationLinkParams = {
    id: string,
    log_msg?: string,
}

/**
 * @param {string} id This value can be username or user id
 * @param {'birthday' | 'sex' | 'location' | 'username'} [limit] User limit that will reset to default value.
 * @param {string} [log_msg] 
*/
export type resetUserLimitParams = {
    id: string,
    limit?: 'birthday' | 'sex' | 'location' | 'username',
    log_msg?: string,
}

/**
 * @param {string} id Thread owner
 * @param {string} thread_contact 
 * @param {string} [log_msg] 
*/
export type restoreThreadWithUserParams = {
    id: string,
    thread_contact: string,
    log_msg?: string,
}

/**
 * @param {string} id User ID
 * @param {boolean} [two_way_restore] Also restore messages for recepient
 * @param {string} [log_msg] 
*/
export type restoreThreadsByUidParams = {
    id: string,
    two_way_restore?: boolean,
    log_msg?: string,
}

/**
 * ModAdmin - factory interface
 * @export
 */
export const ModAdminFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Mark a user's email address as verified.
         * @param {activateUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(params: activateUserParams, options?: any) {
            return ModAdminFp(configuration).activateUser(params, options)(fetch, basePath);
        },
        /**
         * This action will permanently delete user and their data.
         * @param {deleteUserDataParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserData(params: deleteUserDataParams, options?: any) {
            return ModAdminFp(configuration).deleteUserData(params, options)(fetch, basePath);
        },
        /**
         * Expire all caches related to a given user.
         * @param {expireUserCacheParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireUserCache(params: expireUserCacheParams, options?: any) {
            return ModAdminFp(configuration).expireUserCache(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getResetLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResetLink(params: getResetLinkParams, options?: any) {
            return ModAdminFp(configuration).getResetLink(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getUserDataDumpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataDump(params: getUserDataDumpParams, options?: any) {
            return ModAdminFp(configuration).getUserDataDump(params, options)(fetch, basePath);
        },
        /**
         * test
         * @param {resendActivationLinkParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivationLink(params: resendActivationLinkParams, options?: any) {
            return ModAdminFp(configuration).resendActivationLink(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {resetUserLimitParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserLimit(params: resetUserLimitParams, options?: any) {
            return ModAdminFp(configuration).resetUserLimit(params, options)(fetch, basePath);
        },
        /**
         * Restore thread with user.
         * @param {restoreThreadWithUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadWithUser(params: restoreThreadWithUserParams, options?: any) {
            return ModAdminFp(configuration).restoreThreadWithUser(params, options)(fetch, basePath);
        },
        /**
         * Restore all messages in all threads including deleted.
         * @param {restoreThreadsByUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadsByUid(params: restoreThreadsByUidParams, options?: any) {
            return ModAdminFp(configuration).restoreThreadsByUid(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModAdmin - object-oriented interface
 * @export
 * @class ModAdmin
 * @extends {BaseAPI}
 */
export class ModAdmin extends BaseAPI {
    /**
     * Mark a user's email address as verified.
     * @param {activateUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public activateUser(params: activateUserParams, options?: any) {
        return ModAdminFp(this.configuration).activateUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * This action will permanently delete user and their data.
     * @param {deleteUserDataParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public deleteUserData(params: deleteUserDataParams, options?: any) {
        return ModAdminFp(this.configuration).deleteUserData(params, options)(this.fetch, this.basePath);
    }

    /**
     * Expire all caches related to a given user.
     * @param {expireUserCacheParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public expireUserCache(params: expireUserCacheParams, options?: any) {
        return ModAdminFp(this.configuration).expireUserCache(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getResetLinkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public getResetLink(params: getResetLinkParams, options?: any) {
        return ModAdminFp(this.configuration).getResetLink(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getUserDataDumpParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public getUserDataDump(params: getUserDataDumpParams, options?: any) {
        return ModAdminFp(this.configuration).getUserDataDump(params, options)(this.fetch, this.basePath);
    }

    /**
     * test
     * @param {resendActivationLinkParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public resendActivationLink(params: resendActivationLinkParams, options?: any) {
        return ModAdminFp(this.configuration).resendActivationLink(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {resetUserLimitParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public resetUserLimit(params: resetUserLimitParams, options?: any) {
        return ModAdminFp(this.configuration).resetUserLimit(params, options)(this.fetch, this.basePath);
    }

    /**
     * Restore thread with user.
     * @param {restoreThreadWithUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public restoreThreadWithUser(params: restoreThreadWithUserParams, options?: any) {
        return ModAdminFp(this.configuration).restoreThreadWithUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * Restore all messages in all threads including deleted.
     * @param {restoreThreadsByUidParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModAdmin
     */
    public restoreThreadsByUid(params: restoreThreadsByUidParams, options?: any) {
        return ModAdminFp(this.configuration).restoreThreadsByUid(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModEntity - fetch parameter creator
 * @export
 */
export const ModEntityFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user accounts for moderation, filter by moderation status
         * @param {getAccountsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByModerationStatus(params: getAccountsByModerationStatusParams, options?: any): FetchArgs {
            const localVarPath = `/mod-entity/accounts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.mod_status) {
                localVarQueryParameter['mod_status'] = params.mod_status.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.mod_flags) {
                localVarQueryParameter['mod_flags'] = params.mod_flags.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comments for moderation, filter by moderation status
         * @param {getCommentsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsByModerationStatus(params: getCommentsByModerationStatusParams, options?: any): FetchArgs {
            const localVarPath = `/mod-entity/comments`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.mod_status) {
                localVarQueryParameter['mod_status'] = params.mod_status.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.mod_flags) {
                localVarQueryParameter['mod_flags'] = params.mod_flags.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getEntityReportsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityReports(params: getEntityReportsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntityReports");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling getEntityReports");
            }
            const localVarPath = `/mod-entity/{id}/reports`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarQueryParameter['entity_type'] = params.entity_type;
            }

            if (params.reason_category !== undefined) {
                localVarQueryParameter['reason_category'] = params.reason_category;
            }

            if (params.report_status !== undefined) {
                localVarQueryParameter['report_status'] = params.report_status;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get groups for moderation, filter by moderation status
         * @param {getGroupsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsByModerationStatus(params: getGroupsByModerationStatusParams, options?: any): FetchArgs {
            const localVarPath = `/mod-entity/groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.mod_status) {
                localVarQueryParameter['mod_status'] = params.mod_status.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.mod_flags) {
                localVarQueryParameter['mod_flags'] = params.mod_flags.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get photos for moderation, filter by moderation status, order by photo id descending
         * @param {getPhotosByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotosByModerationStatus(params: getPhotosByModerationStatusParams, options?: any): FetchArgs {
            const localVarPath = `/mod-entity/photos`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.mod_status) {
                localVarQueryParameter['mod_status'] = params.mod_status.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.mod_flags) {
                localVarQueryParameter['mod_flags'] = params.mod_flags.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get posts for moderation, filter by moderation status
         * @param {getPostsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostsByModerationStatus(params: getPostsByModerationStatusParams, options?: any): FetchArgs {
            const localVarPath = `/mod-entity/posts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.mod_status) {
                localVarQueryParameter['mod_status'] = params.mod_status.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.mod_flags) {
                localVarQueryParameter['mod_flags'] = params.mod_flags.join(COLLECTION_FORMATS["csv"]);
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModEntity - functional programming interface
 * @export
 */
export const ModEntityFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user accounts for moderation, filter by moderation status
         * @param {getAccountsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByModerationStatus(params: getAccountsByModerationStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountsResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getAccountsByModerationStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get comments for moderation, filter by moderation status
         * @param {getCommentsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsByModerationStatus(params: getCommentsByModerationStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentsResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getCommentsByModerationStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getEntityReportsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityReports(params: getEntityReportsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportsEntityResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getEntityReports(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get groups for moderation, filter by moderation status
         * @param {getGroupsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsByModerationStatus(params: getGroupsByModerationStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupsResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getGroupsByModerationStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get photos for moderation, filter by moderation status, order by photo id descending
         * @param {getPhotosByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotosByModerationStatus(params: getPhotosByModerationStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotosResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getPhotosByModerationStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get posts for moderation, filter by moderation status
         * @param {getPostsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostsByModerationStatus(params: getPostsByModerationStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PostsResponse> {
            const localVarFetchArgs = ModEntityFetchParamCreator(configuration).getPostsByModerationStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>} [mod_status] Entity moderation status. CSV allowed for multiple
 * @param {Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>} [mod_flags] Filter entities by auto-moderation flag type, 'any' will return entities that have at  *                   least some flag
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [extra] return extra, non-default fields
*/
export type getAccountsByModerationStatusParams = {
    mod_status?: Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>,
    mod_flags?: Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>,
    limit?: number,
    offset?: number,
    extra?: string,
}

/**
 * @param {Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>} [mod_status] Entity moderation status. CSV allowed for multiple
 * @param {Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>} [mod_flags] Filter entities by auto-moderation flag type, 'any' will return entities that have at  *                   least some flag
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getCommentsByModerationStatusParams = {
    mod_status?: Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>,
    mod_flags?: Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>,
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Entity id
 * @param {'user' | 'wall' | 'photo' | 'message' | 'thread' | 'prompt' | 'entry' | 'comment' | 'group'} entity_type 
 * @param {'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs'} [reason_category] Filter results by report category
 * @param {'active' | 'archived' | 'pending' | 'cleared' | 'escalated'} [report_status] Filter by report status, default is active
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getEntityReportsParams = {
    id: string,
    entity_type: 'user' | 'wall' | 'photo' | 'message' | 'thread' | 'prompt' | 'entry' | 'comment' | 'group',
    reason_category?: 'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs',
    report_status?: 'active' | 'archived' | 'pending' | 'cleared' | 'escalated',
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>} [mod_status] Entity moderation status. CSV allowed for multiple
 * @param {Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>} [mod_flags] Filter entities by auto-moderation flag type, 'any' will return entities that have at  *                   least some flag
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getGroupsByModerationStatusParams = {
    mod_status?: Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>,
    mod_flags?: Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>,
    limit?: number,
    offset?: number,
}

/**
 * @param {Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>} [mod_status] Entity moderation status. CSV allowed for multiple
 * @param {Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>} [mod_flags] Filter entities by auto-moderation flag type, 'any' will return entities that have at  *                   least some flag
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPhotosByModerationStatusParams = {
    mod_status?: Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>,
    mod_flags?: Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>,
    limit?: number,
    offset?: number,
}

/**
 * @param {Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>} [mod_status] Entity moderation status. CSV allowed for multiple
 * @param {Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>} [mod_flags] Filter entities by auto-moderation flag type, 'any' will return entities that have at  *                   least some flag
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPostsByModerationStatusParams = {
    mod_status?: Array<'pending' | 'flagged' | 'approved' | 'rejected' | 'owner_only'>,
    mod_flags?: Array<'any' | 'acct_ip_mismatch' | 'photo_nsfw' | 'acct_cookie'>,
    limit?: number,
    offset?: number,
}

/**
 * ModEntity - factory interface
 * @export
 */
export const ModEntityFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get user accounts for moderation, filter by moderation status
         * @param {getAccountsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByModerationStatus(params: getAccountsByModerationStatusParams, options?: any) {
            return ModEntityFp(configuration).getAccountsByModerationStatus(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get comments for moderation, filter by moderation status
         * @param {getCommentsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsByModerationStatus(params: getCommentsByModerationStatusParams, options?: any) {
            return ModEntityFp(configuration).getCommentsByModerationStatus(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getEntityReportsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityReports(params: getEntityReportsParams, options?: any) {
            return ModEntityFp(configuration).getEntityReports(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get groups for moderation, filter by moderation status
         * @param {getGroupsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsByModerationStatus(params: getGroupsByModerationStatusParams, options?: any) {
            return ModEntityFp(configuration).getGroupsByModerationStatus(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get photos for moderation, filter by moderation status, order by photo id descending
         * @param {getPhotosByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotosByModerationStatus(params: getPhotosByModerationStatusParams, options?: any) {
            return ModEntityFp(configuration).getPhotosByModerationStatus(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get posts for moderation, filter by moderation status
         * @param {getPostsByModerationStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostsByModerationStatus(params: getPostsByModerationStatusParams, options?: any) {
            return ModEntityFp(configuration).getPostsByModerationStatus(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModEntity - object-oriented interface
 * @export
 * @class ModEntity
 * @extends {BaseAPI}
 */
export class ModEntity extends BaseAPI {
    /**
     * 
     * @summary Get user accounts for moderation, filter by moderation status
     * @param {getAccountsByModerationStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getAccountsByModerationStatus(params: getAccountsByModerationStatusParams, options?: any) {
        return ModEntityFp(this.configuration).getAccountsByModerationStatus(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get comments for moderation, filter by moderation status
     * @param {getCommentsByModerationStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getCommentsByModerationStatus(params: getCommentsByModerationStatusParams, options?: any) {
        return ModEntityFp(this.configuration).getCommentsByModerationStatus(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getEntityReportsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getEntityReports(params: getEntityReportsParams, options?: any) {
        return ModEntityFp(this.configuration).getEntityReports(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get groups for moderation, filter by moderation status
     * @param {getGroupsByModerationStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getGroupsByModerationStatus(params: getGroupsByModerationStatusParams, options?: any) {
        return ModEntityFp(this.configuration).getGroupsByModerationStatus(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get photos for moderation, filter by moderation status, order by photo id descending
     * @param {getPhotosByModerationStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getPhotosByModerationStatus(params: getPhotosByModerationStatusParams, options?: any) {
        return ModEntityFp(this.configuration).getPhotosByModerationStatus(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get posts for moderation, filter by moderation status
     * @param {getPostsByModerationStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModEntity
     */
    public getPostsByModerationStatus(params: getPostsByModerationStatusParams, options?: any) {
        return ModEntityFp(this.configuration).getPostsByModerationStatus(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModFlaggedPhotos - fetch parameter creator
 * @export
 */
export const ModFlaggedPhotosFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DEPRECATED: Use /mod-entity/photos instead with mod_flags filters
         * @param {getModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModFlaggedPhotos(params: getModFlaggedPhotosParams, options?: any): FetchArgs {
            const localVarPath = `/flagged-photos`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moderation-related photo update
         * @param {updateModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModFlaggedPhotos(params: updateModFlaggedPhotosParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateModFlaggedPhotos");
            }
            // verify required parameter "params.approved" is set
            if (params.approved == null) {
                throw new Error("Missing required parameter 'approved' when calling updateModFlaggedPhotos");
            }
            const localVarPath = `/flagged-photos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.approved !== undefined) {
                localVarFormParams.set('approved', params.approved as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModFlaggedPhotos - functional programming interface
 * @export
 */
export const ModFlaggedPhotosFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DEPRECATED: Use /mod-entity/photos instead with mod_flags filters
         * @param {getModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModFlaggedPhotos(params: getModFlaggedPhotosParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModPhotoCollectionResponse> {
            const localVarFetchArgs = ModFlaggedPhotosFetchParamCreator(configuration).getModFlaggedPhotos(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Moderation-related photo update
         * @param {updateModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModFlaggedPhotos(params: updateModFlaggedPhotosParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModPhotoEntity> {
            const localVarFetchArgs = ModFlaggedPhotosFetchParamCreator(configuration).updateModFlaggedPhotos(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getModFlaggedPhotosParams = {
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Photo id
 * @param {boolean} approved Approve photo?
*/
export type updateModFlaggedPhotosParams = {
    id: string,
    approved: boolean,
}

/**
 * ModFlaggedPhotos - factory interface
 * @export
 */
export const ModFlaggedPhotosFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary DEPRECATED: Use /mod-entity/photos instead with mod_flags filters
         * @param {getModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModFlaggedPhotos(params: getModFlaggedPhotosParams, options?: any) {
            return ModFlaggedPhotosFp(configuration).getModFlaggedPhotos(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Moderation-related photo update
         * @param {updateModFlaggedPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModFlaggedPhotos(params: updateModFlaggedPhotosParams, options?: any) {
            return ModFlaggedPhotosFp(configuration).updateModFlaggedPhotos(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModFlaggedPhotos - object-oriented interface
 * @export
 * @class ModFlaggedPhotos
 * @extends {BaseAPI}
 */
export class ModFlaggedPhotos extends BaseAPI {
    /**
     * 
     * @summary DEPRECATED: Use /mod-entity/photos instead with mod_flags filters
     * @param {getModFlaggedPhotosParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModFlaggedPhotos
     */
    public getModFlaggedPhotos(params: getModFlaggedPhotosParams, options?: any) {
        return ModFlaggedPhotosFp(this.configuration).getModFlaggedPhotos(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Moderation-related photo update
     * @param {updateModFlaggedPhotosParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModFlaggedPhotos
     */
    public updateModFlaggedPhotos(params: updateModFlaggedPhotosParams, options?: any) {
        return ModFlaggedPhotosFp(this.configuration).updateModFlaggedPhotos(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModLogs - fetch parameter creator
 * @export
 */
export const ModLogsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogMessage(params: createLogMessageParams, options?: any): FetchArgs {
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling createLogMessage");
            }
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling createLogMessage");
            }
            const localVarPath = `/moderation-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {deleteLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogMessage(params: deleteLogMessageParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteLogMessage");
            }
            const localVarPath = `/moderation-log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getModerationLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationLogItems(params: getModerationLogItemsParams, options?: any): FetchArgs {
            const localVarPath = `/moderation-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarQueryParameter['user_id'] = params.user_id;
            }

            if (params.moderator_id !== undefined) {
                localVarQueryParameter['moderator_id'] = params.moderator_id;
            }

            if (params.entity_type !== undefined) {
                localVarQueryParameter['entity_type'] = params.entity_type;
            }

            if (params.reason_category !== undefined) {
                localVarQueryParameter['reason_category'] = params.reason_category;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModLogs - functional programming interface
 * @export
 */
export const ModLogsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogMessage(params: createLogMessageParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModLogsFetchParamCreator(configuration).createLogMessage(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {deleteLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogMessage(params: deleteLogMessageParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ModLogsFetchParamCreator(configuration).deleteLogMessage(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getModerationLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationLogItems(params: getModerationLogItemsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogResponse> {
            const localVarFetchArgs = ModLogsFetchParamCreator(configuration).getModerationLogItems(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} user_id User id of user being commented on
 * @param {string} message Message to add to log
*/
export type createLogMessageParams = {
    user_id: string,
    message: string,
}

/**
 * @param {string} id Log message item id, must be created by current user and can only be of type log message
*/
export type deleteLogMessageParams = {
    id: string,
}

/**
 * @param {string} [user_id] Filter by user id
 * @param {string} [moderator_id] Filter by moderator id
 * @param {'user' | 'wall' | 'photo' | 'message' | 'thread' | 'prompt' | 'entry' | 'comment' | 'group'} [entity_type] 
 * @param {'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other'} [reason_category] 
 * @param {string} [offset] Offset as last log item id (will return results less than this id)
 * @param {number} [limit] Limit
*/
export type getModerationLogItemsParams = {
    user_id?: string,
    moderator_id?: string,
    entity_type?: 'user' | 'wall' | 'photo' | 'message' | 'thread' | 'prompt' | 'entry' | 'comment' | 'group',
    reason_category?: 'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other',
    offset?: string,
    limit?: number,
}

/**
 * ModLogs - factory interface
 * @export
 */
export const ModLogsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {createLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogMessage(params: createLogMessageParams, options?: any) {
            return ModLogsFp(configuration).createLogMessage(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {deleteLogMessageParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogMessage(params: deleteLogMessageParams, options?: any) {
            return ModLogsFp(configuration).deleteLogMessage(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getModerationLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationLogItems(params: getModerationLogItemsParams, options?: any) {
            return ModLogsFp(configuration).getModerationLogItems(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModLogs - object-oriented interface
 * @export
 * @class ModLogs
 * @extends {BaseAPI}
 */
export class ModLogs extends BaseAPI {
    /**
     * 
     * @param {createLogMessageParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModLogs
     */
    public createLogMessage(params: createLogMessageParams, options?: any) {
        return ModLogsFp(this.configuration).createLogMessage(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {deleteLogMessageParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModLogs
     */
    public deleteLogMessage(params: deleteLogMessageParams, options?: any) {
        return ModLogsFp(this.configuration).deleteLogMessage(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getModerationLogItemsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModLogs
     */
    public getModerationLogItems(params: getModerationLogItemsParams, options?: any) {
        return ModLogsFp(this.configuration).getModerationLogItems(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModSettingsLog - fetch parameter creator
 * @export
 */
export const ModSettingsLogFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {getModSettingsLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModSettingsLogItems(params: getModSettingsLogItemsParams, options?: any): FetchArgs {
            const localVarPath = `/mod-settings-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.moderator_id !== undefined) {
                localVarQueryParameter['moderator_id'] = params.moderator_id;
            }

            if (params.action !== undefined) {
                localVarQueryParameter['action'] = params.action;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModSettingsLog - functional programming interface
 * @export
 */
export const ModSettingsLogFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {getModSettingsLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModSettingsLogItems(params: getModSettingsLogItemsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModSettingsLogResponse> {
            const localVarFetchArgs = ModSettingsLogFetchParamCreator(configuration).getModSettingsLogItems(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} [moderator_id] Filter by moderator id
 * @param {'ban-ip' | 'unban-ip' | 'create-warning' | 'edit-warning' | 'delete-warning' | 'create-text-filter' | 'delete-text-filter'} [action] 
 * @param {string} [offset] Offset as last log item id (will return results less than this id)
 * @param {number} [limit] Limit
*/
export type getModSettingsLogItemsParams = {
    moderator_id?: string,
    action?: 'ban-ip' | 'unban-ip' | 'create-warning' | 'edit-warning' | 'delete-warning' | 'create-text-filter' | 'delete-text-filter',
    offset?: string,
    limit?: number,
}

/**
 * ModSettingsLog - factory interface
 * @export
 */
export const ModSettingsLogFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {getModSettingsLogItemsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModSettingsLogItems(params: getModSettingsLogItemsParams, options?: any) {
            return ModSettingsLogFp(configuration).getModSettingsLogItems(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModSettingsLog - object-oriented interface
 * @export
 * @class ModSettingsLog
 * @extends {BaseAPI}
 */
export class ModSettingsLog extends BaseAPI {
    /**
     * 
     * @param {getModSettingsLogItemsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModSettingsLog
     */
    public getModSettingsLogItems(params: getModSettingsLogItemsParams, options?: any) {
        return ModSettingsLogFp(this.configuration).getModSettingsLogItems(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModerationAction - fetch parameter creator
 * @export
 */
export const ModerationActionFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {doModerationActionApproveParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionApprove(params: doModerationActionApproveParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling doModerationActionApprove");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling doModerationActionApprove");
            }
            // verify required parameter "params.reason_category" is set
            if (params.reason_category == null) {
                throw new Error("Missing required parameter 'reason_category' when calling doModerationActionApprove");
            }
            const localVarPath = `/mod-entity-action/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.reason_category !== undefined) {
                localVarFormParams.set('reason_category', params.reason_category as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {doModerationActionDeleteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionDelete(params: doModerationActionDeleteParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling doModerationActionDelete");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling doModerationActionDelete");
            }
            // verify required parameter "params.reason_category" is set
            if (params.reason_category == null) {
                throw new Error("Missing required parameter 'reason_category' when calling doModerationActionDelete");
            }
            const localVarPath = `/mod-entity-action/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.reason_category !== undefined) {
                localVarFormParams.set('reason_category', params.reason_category as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {doModerationActionRestoreParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionRestore(params: doModerationActionRestoreParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling doModerationActionRestore");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling doModerationActionRestore");
            }
            // verify required parameter "params.reason_category" is set
            if (params.reason_category == null) {
                throw new Error("Missing required parameter 'reason_category' when calling doModerationActionRestore");
            }
            const localVarPath = `/mod-entity-action/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.reason_category !== undefined) {
                localVarFormParams.set('reason_category', params.reason_category as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {doModerationActionShadowbanParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionShadowban(params: doModerationActionShadowbanParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling doModerationActionShadowban");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling doModerationActionShadowban");
            }
            // verify required parameter "params.reason_category" is set
            if (params.reason_category == null) {
                throw new Error("Missing required parameter 'reason_category' when calling doModerationActionShadowban");
            }
            const localVarPath = `/mod-entity-action/{id}/shadowban`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.reason_category !== undefined) {
                localVarFormParams.set('reason_category', params.reason_category as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModerationAction - functional programming interface
 * @export
 */
export const ModerationActionFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {doModerationActionApproveParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionApprove(params: doModerationActionApproveParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModerationActionFetchParamCreator(configuration).doModerationActionApprove(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {doModerationActionDeleteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionDelete(params: doModerationActionDeleteParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModerationActionFetchParamCreator(configuration).doModerationActionDelete(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {doModerationActionRestoreParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionRestore(params: doModerationActionRestoreParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModerationActionFetchParamCreator(configuration).doModerationActionRestore(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {doModerationActionShadowbanParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionShadowban(params: doModerationActionShadowbanParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = ModerationActionFetchParamCreator(configuration).doModerationActionShadowban(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Entity id
 * @param {'comment' | 'group' | 'photo' | 'post' | 'user'} entity_type 
 * @param {'no-violation' | 'empty-report' | 'user-dispute'} reason_category Reason for approval
 * @param {string} [log_msg] 
*/
export type doModerationActionApproveParams = {
    id: string,
    entity_type: 'comment' | 'group' | 'photo' | 'post' | 'user',
    reason_category: 'no-violation' | 'empty-report' | 'user-dispute',
    log_msg?: string,
}

/**
 * @param {string} id Entity id
 * @param {'user' | 'photo' | 'comment' | 'post' | 'group'} entity_type 
 * @param {'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other'} reason_category Reason for deletion
 * @param {string} [log_msg] 
*/
export type doModerationActionDeleteParams = {
    id: string,
    entity_type: 'user' | 'photo' | 'comment' | 'post' | 'group',
    reason_category: 'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other',
    log_msg?: string,
}

/**
 * @param {string} id Entity id
 * @param {'user'} entity_type 
 * @param {'restore-mistake' | 'restore-user-requested' | 'restore-id-verified' | 'restore-other'} reason_category Reason for restoring this item
 * @param {string} [log_msg] 
*/
export type doModerationActionRestoreParams = {
    id: string,
    entity_type: 'user',
    reason_category: 'restore-mistake' | 'restore-user-requested' | 'restore-id-verified' | 'restore-other',
    log_msg?: string,
}

/**
 * @param {string} id Entity id
 * @param {'user' | 'photo' | 'comment' | 'post' | 'group'} entity_type 
 * @param {'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other'} reason_category Reason for deletion
 * @param {string} [log_msg] 
*/
export type doModerationActionShadowbanParams = {
    id: string,
    entity_type: 'user' | 'photo' | 'comment' | 'post' | 'group',
    reason_category: 'advertising' | 'fake' | 'harassment' | 'nudity' | 'offensive' | 'scam' | 'self-requested' | 'sexual' | 'site-abuse' | 'user-details' | 'other',
    log_msg?: string,
}

/**
 * ModerationAction - factory interface
 * @export
 */
export const ModerationActionFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {doModerationActionApproveParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionApprove(params: doModerationActionApproveParams, options?: any) {
            return ModerationActionFp(configuration).doModerationActionApprove(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {doModerationActionDeleteParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionDelete(params: doModerationActionDeleteParams, options?: any) {
            return ModerationActionFp(configuration).doModerationActionDelete(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {doModerationActionRestoreParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionRestore(params: doModerationActionRestoreParams, options?: any) {
            return ModerationActionFp(configuration).doModerationActionRestore(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {doModerationActionShadowbanParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doModerationActionShadowban(params: doModerationActionShadowbanParams, options?: any) {
            return ModerationActionFp(configuration).doModerationActionShadowban(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModerationAction - object-oriented interface
 * @export
 * @class ModerationAction
 * @extends {BaseAPI}
 */
export class ModerationAction extends BaseAPI {
    /**
     * 
     * @param {doModerationActionApproveParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationAction
     */
    public doModerationActionApprove(params: doModerationActionApproveParams, options?: any) {
        return ModerationActionFp(this.configuration).doModerationActionApprove(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {doModerationActionDeleteParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationAction
     */
    public doModerationActionDelete(params: doModerationActionDeleteParams, options?: any) {
        return ModerationActionFp(this.configuration).doModerationActionDelete(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {doModerationActionRestoreParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationAction
     */
    public doModerationActionRestore(params: doModerationActionRestoreParams, options?: any) {
        return ModerationActionFp(this.configuration).doModerationActionRestore(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {doModerationActionShadowbanParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationAction
     */
    public doModerationActionShadowban(params: doModerationActionShadowbanParams, options?: any) {
        return ModerationActionFp(this.configuration).doModerationActionShadowban(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ModerationWarning - fetch parameter creator
 * @export
 */
export const ModerationWarningFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModerationWarning(params: createModerationWarningParams, options?: any): FetchArgs {
            // verify required parameter "params.category" is set
            if (params.category == null) {
                throw new Error("Missing required parameter 'category' when calling createModerationWarning");
            }
            // verify required parameter "params.label" is set
            if (params.label == null) {
                throw new Error("Missing required parameter 'label' when calling createModerationWarning");
            }
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling createModerationWarning");
            }
            const localVarPath = `/moderation-warning`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.category !== undefined) {
                localVarFormParams.set('category', params.category as any);
            }

            if (params.label !== undefined) {
                localVarFormParams.set('label', params.label as any);
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {deleteModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModerationWarning(params: deleteModerationWarningParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteModerationWarning");
            }
            const localVarPath = `/moderation-warning/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getModerationWarningsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationWarnings(options?: any): FetchArgs {
            const localVarPath = `/moderation-warning/all/warnings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {updateModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationWarning(params: updateModerationWarningParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateModerationWarning");
            }
            const localVarPath = `/moderation-warning/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.category !== undefined) {
                localVarFormParams.set('category', params.category as any);
            }

            if (params.label !== undefined) {
                localVarFormParams.set('label', params.label as any);
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModerationWarning - functional programming interface
 * @export
 */
export const ModerationWarningFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModerationWarning(params: createModerationWarningParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModerationWarningEntity> {
            const localVarFetchArgs = ModerationWarningFetchParamCreator(configuration).createModerationWarning(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {deleteModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModerationWarning(params: deleteModerationWarningParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ModerationWarningFetchParamCreator(configuration).deleteModerationWarning(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getModerationWarningsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationWarnings(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModerationWarningsResponse> {
            const localVarFetchArgs = ModerationWarningFetchParamCreator(configuration).getModerationWarnings(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {updateModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationWarning(params: updateModerationWarningParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModerationWarningEntity> {
            const localVarFetchArgs = ModerationWarningFetchParamCreator(configuration).updateModerationWarning(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'account' | 'behavior' | 'photo'} category 
 * @param {string} label Label of the warning
 * @param {string} message Warning message
*/
export type createModerationWarningParams = {
    category: 'account' | 'behavior' | 'photo',
    label: string,
    message: string,
}

/**
 * @param {string} id 
*/
export type deleteModerationWarningParams = {
    id: string,
}


/**
 * @param {string} id 
 * @param {'account' | 'behavior' | 'photo'} [category] 
 * @param {string} [label] Label of the warning
 * @param {string} [message] Warning message
*/
export type updateModerationWarningParams = {
    id: string,
    category?: 'account' | 'behavior' | 'photo',
    label?: string,
    message?: string,
}

/**
 * ModerationWarning - factory interface
 * @export
 */
export const ModerationWarningFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {createModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModerationWarning(params: createModerationWarningParams, options?: any) {
            return ModerationWarningFp(configuration).createModerationWarning(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {deleteModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModerationWarning(params: deleteModerationWarningParams, options?: any) {
            return ModerationWarningFp(configuration).deleteModerationWarning(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getModerationWarningsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerationWarnings(options?: any) {
            return ModerationWarningFp(configuration).getModerationWarnings(options)(fetch, basePath);
        },
        /**
         * 
         * @param {updateModerationWarningParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationWarning(params: updateModerationWarningParams, options?: any) {
            return ModerationWarningFp(configuration).updateModerationWarning(params, options)(fetch, basePath);
        },
    };
};

/**
 * ModerationWarning - object-oriented interface
 * @export
 * @class ModerationWarning
 * @extends {BaseAPI}
 */
export class ModerationWarning extends BaseAPI {
    /**
     * 
     * @param {createModerationWarningParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationWarning
     */
    public createModerationWarning(params: createModerationWarningParams, options?: any) {
        return ModerationWarningFp(this.configuration).createModerationWarning(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {deleteModerationWarningParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationWarning
     */
    public deleteModerationWarning(params: deleteModerationWarningParams, options?: any) {
        return ModerationWarningFp(this.configuration).deleteModerationWarning(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getModerationWarningsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationWarning
     */
    public getModerationWarnings(options?: any) {
        return ModerationWarningFp(this.configuration).getModerationWarnings(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {updateModerationWarningParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModerationWarning
     */
    public updateModerationWarning(params: updateModerationWarningParams, options?: any) {
        return ModerationWarningFp(this.configuration).updateModerationWarning(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Moderator - fetch parameter creator
 * @export
 */
export const ModeratorFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get moderator record by user id
         * @param {getModeratorParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerator(params: getModeratorParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getModerator");
            }
            const localVarPath = `/moderator/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of active moderators (currently assigned > 1 role), sorted by added desc
         * @param {getModeratorsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerators(params: getModeratorsParams, options?: any): FetchArgs {
            const localVarPath = `/moderators`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update moderation roles assigned to a user.      *      This will create the moderator record if the user is      *      not yet a moderator and has roles assigned to them.
         * @param {updateModerationRolesForUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationRolesForUser(params: updateModerationRolesForUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateModerationRolesForUser");
            }
            // verify required parameter "params.roles" is set
            if (params.roles == null) {
                throw new Error("Missing required parameter 'roles' when calling updateModerationRolesForUser");
            }
            const localVarPath = `/moderator/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.roles !== undefined) {
                localVarFormParams.set('roles', params.roles as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Moderator - functional programming interface
 * @export
 */
export const ModeratorFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get moderator record by user id
         * @param {getModeratorParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerator(params: getModeratorParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModeratorEntity> {
            const localVarFetchArgs = ModeratorFetchParamCreator(configuration).getModerator(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of active moderators (currently assigned > 1 role), sorted by added desc
         * @param {getModeratorsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerators(params: getModeratorsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModeratorResponse> {
            const localVarFetchArgs = ModeratorFetchParamCreator(configuration).getModerators(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update moderation roles assigned to a user.      *      This will create the moderator record if the user is      *      not yet a moderator and has roles assigned to them.
         * @param {updateModerationRolesForUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationRolesForUser(params: updateModerationRolesForUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModeratorEntity> {
            const localVarFetchArgs = ModeratorFetchParamCreator(configuration).updateModerationRolesForUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User id
*/
export type getModeratorParams = {
    id: string,
}

/**
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getModeratorsParams = {
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User id
 * @param {string} roles CSV of roles to assign a moderator
*/
export type updateModerationRolesForUserParams = {
    id: string,
    roles: string,
}

/**
 * Moderator - factory interface
 * @export
 */
export const ModeratorFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get moderator record by user id
         * @param {getModeratorParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerator(params: getModeratorParams, options?: any) {
            return ModeratorFp(configuration).getModerator(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of active moderators (currently assigned > 1 role), sorted by added desc
         * @param {getModeratorsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModerators(params: getModeratorsParams, options?: any) {
            return ModeratorFp(configuration).getModerators(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update moderation roles assigned to a user.      *      This will create the moderator record if the user is      *      not yet a moderator and has roles assigned to them.
         * @param {updateModerationRolesForUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModerationRolesForUser(params: updateModerationRolesForUserParams, options?: any) {
            return ModeratorFp(configuration).updateModerationRolesForUser(params, options)(fetch, basePath);
        },
    };
};

/**
 * Moderator - object-oriented interface
 * @export
 * @class Moderator
 * @extends {BaseAPI}
 */
export class Moderator extends BaseAPI {
    /**
     * 
     * @summary Get moderator record by user id
     * @param {getModeratorParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Moderator
     */
    public getModerator(params: getModeratorParams, options?: any) {
        return ModeratorFp(this.configuration).getModerator(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of active moderators (currently assigned > 1 role), sorted by added desc
     * @param {getModeratorsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Moderator
     */
    public getModerators(params: getModeratorsParams, options?: any) {
        return ModeratorFp(this.configuration).getModerators(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update moderation roles assigned to a user.      *      This will create the moderator record if the user is      *      not yet a moderator and has roles assigned to them.
     * @param {updateModerationRolesForUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Moderator
     */
    public updateModerationRolesForUser(params: updateModerationRolesForUserParams, options?: any) {
        return ModeratorFp(this.configuration).updateModerationRolesForUser(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Notification - fetch parameter creator
 * @export
 */
export const NotificationFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create notification (not used)
         * @param {createNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(options?: any): FetchArgs {
            const localVarPath = `/notification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification by $id
         * @param {deleteNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(params: deleteNotificationParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteNotification");
            }
            const localVarPath = `/notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get my notifications
         * @param {getMyNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotification(params: getMyNotificationParams, options?: any): FetchArgs {
            const localVarPath = `/notification/my`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notification counter
         * @param {getNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCounter(params: getNotificationCounterParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getNotificationCounter");
            }
            const localVarPath = `/notification/{id}/counter`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {markAllNotificationsReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsRead(options?: any): FetchArgs {
            const localVarPath = `/notification/self/mark-all-read`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification by notification id
         * @param {notificationMarkReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationMarkRead(params: notificationMarkReadParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling notificationMarkRead");
            }
            const localVarPath = `/notification/{id}/mark-read`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {resetNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetNotificationCounter(options?: any): FetchArgs {
            const localVarPath = `/notification/self/reset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Notification - functional programming interface
 * @export
 */
export const NotificationFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create notification (not used)
         * @param {createNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).createNotification(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete notification by $id
         * @param {deleteNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(params: deleteNotificationParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).deleteNotification(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get my notifications
         * @param {getMyNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotification(params: getMyNotificationParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserNotificationsResponse> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).getMyNotification(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get notification counter
         * @param {getNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCounter(params: getNotificationCounterParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).getNotificationCounter(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {markAllNotificationsReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsRead(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).markAllNotificationsRead(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification by notification id
         * @param {notificationMarkReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationMarkRead(params: notificationMarkReadParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NotificationEntity> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).notificationMarkRead(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {resetNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetNotificationCounter(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = NotificationFetchParamCreator(configuration).resetNotificationCounter(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};



/**
 * @param {string} id Notification id
*/
export type deleteNotificationParams = {
    id: string,
}

/**
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getMyNotificationParams = {
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User ID
*/
export type getNotificationCounterParams = {
    id: string,
}


/**
 * @param {string} id Notification id
*/
export type notificationMarkReadParams = {
    id: string,
}


/**
 * Notification - factory interface
 * @export
 */
export const NotificationFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create notification (not used)
         * @param {createNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(options?: any) {
            return NotificationFp(configuration).createNotification(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete notification by $id
         * @param {deleteNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(params: deleteNotificationParams, options?: any) {
            return NotificationFp(configuration).deleteNotification(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get my notifications
         * @param {getMyNotificationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNotification(params: getMyNotificationParams, options?: any) {
            return NotificationFp(configuration).getMyNotification(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get notification counter
         * @param {getNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCounter(params: getNotificationCounterParams, options?: any) {
            return NotificationFp(configuration).getNotificationCounter(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {markAllNotificationsReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsRead(options?: any) {
            return NotificationFp(configuration).markAllNotificationsRead(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification by notification id
         * @param {notificationMarkReadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationMarkRead(params: notificationMarkReadParams, options?: any) {
            return NotificationFp(configuration).notificationMarkRead(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Mark all notifications as read and reset notification counter
         * @param {resetNotificationCounterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetNotificationCounter(options?: any) {
            return NotificationFp(configuration).resetNotificationCounter(options)(fetch, basePath);
        },
    };
};

/**
 * Notification - object-oriented interface
 * @export
 * @class Notification
 * @extends {BaseAPI}
 */
export class Notification extends BaseAPI {
    /**
     * 
     * @summary Create notification (not used)
     * @param {createNotificationParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public createNotification(options?: any) {
        return NotificationFp(this.configuration).createNotification(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete notification by $id
     * @param {deleteNotificationParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public deleteNotification(params: deleteNotificationParams, options?: any) {
        return NotificationFp(this.configuration).deleteNotification(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get my notifications
     * @param {getMyNotificationParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public getMyNotification(params: getMyNotificationParams, options?: any) {
        return NotificationFp(this.configuration).getMyNotification(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get notification counter
     * @param {getNotificationCounterParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public getNotificationCounter(params: getNotificationCounterParams, options?: any) {
        return NotificationFp(this.configuration).getNotificationCounter(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Mark all notifications as read and reset notification counter
     * @param {markAllNotificationsReadParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public markAllNotificationsRead(options?: any) {
        return NotificationFp(this.configuration).markAllNotificationsRead(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification by notification id
     * @param {notificationMarkReadParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public notificationMarkRead(params: notificationMarkReadParams, options?: any) {
        return NotificationFp(this.configuration).notificationMarkRead(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Mark all notifications as read and reset notification counter
     * @param {resetNotificationCounterParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Notification
     */
    public resetNotificationCounter(options?: any) {
        return NotificationFp(this.configuration).resetNotificationCounter(options)(this.fetch, this.basePath);
    }

}

/**
 * OAuth - fetch parameter creator
 * @export
 */
export const OAuthFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 1) If user is already signed in, we attempt to create a new oauth integration (e.g. link FB account) for the given user.  2) If user is not signed in, we attempt to sign the user in using oauth  3) If no account exists for the given oauth data, we attempt to create a new account -- if not enough info exists for a new account or some data is invalid, it is returned in the error response and the client should fix it and subsequently call createAccount.  NOTE: On error, the exception entity 'extra' field contains json_encode(['oauthData' => \\Model\\Virtual\\OauthUser::toArray()]) Those fields currently are: name, email_verified, email, sex, birthday, latitude, longitude, timezone, city_id, city_name_en, country_code, region_id, home_city_name_en, home_city_id, home_region_id, home_country_code, oauth_access_token, oauth_id (all are optional) Todo: Consider swaggerizing:)
         * @summary Authenticate user by OAuth, create account if it doesn't exist
         * @param {createOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuth(params: createOAuthParams, options?: any): FetchArgs {
            // verify required parameter "params.provider" is set
            if (params.provider == null) {
                throw new Error("Missing required parameter 'provider' when calling createOAuth");
            }
            // verify required parameter "params.code" is set
            if (params.code == null) {
                throw new Error("Missing required parameter 'code' when calling createOAuth");
            }
            const localVarPath = `/oauth`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.provider !== undefined) {
                localVarFormParams.set('provider', params.provider as any);
            }

            if (params.code !== undefined) {
                localVarFormParams.set('code', params.code as any);
            }

            if (params.redirect_uri !== undefined) {
                localVarFormParams.set('redirect_uri', params.redirect_uri as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a user's social network integration
         * @param {deleteOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuth(params: deleteOAuthParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteOAuth");
            }
            const localVarPath = `/oauth/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Make auth url for given oauth provider
         * @param {makeOAuthUrlParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeOAuthUrl(params: makeOAuthUrlParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling makeOAuthUrl");
            }
            const localVarPath = `/oauth/{id}/make-oauth-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.redirect_uri !== undefined) {
                localVarFormParams.set('redirect_uri', params.redirect_uri as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OAuth - functional programming interface
 * @export
 */
export const OAuthFp = function(configuration?: Configuration) {
    return {
        /**
         * 1) If user is already signed in, we attempt to create a new oauth integration (e.g. link FB account) for the given user.  2) If user is not signed in, we attempt to sign the user in using oauth  3) If no account exists for the given oauth data, we attempt to create a new account -- if not enough info exists for a new account or some data is invalid, it is returned in the error response and the client should fix it and subsequently call createAccount.  NOTE: On error, the exception entity 'extra' field contains json_encode(['oauthData' => \\Model\\Virtual\\OauthUser::toArray()]) Those fields currently are: name, email_verified, email, sex, birthday, latitude, longitude, timezone, city_id, city_name_en, country_code, region_id, home_city_name_en, home_city_id, home_region_id, home_country_code, oauth_access_token, oauth_id (all are optional) Todo: Consider swaggerizing:)
         * @summary Authenticate user by OAuth, create account if it doesn't exist
         * @param {createOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuth(params: createOAuthParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TokenEntity> {
            const localVarFetchArgs = OAuthFetchParamCreator(configuration).createOAuth(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete a user's social network integration
         * @param {deleteOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuth(params: deleteOAuthParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = OAuthFetchParamCreator(configuration).deleteOAuth(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Make auth url for given oauth provider
         * @param {makeOAuthUrlParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeOAuthUrl(params: makeOAuthUrlParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = OAuthFetchParamCreator(configuration).makeOAuthUrl(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'vk' | 'facebook' | 'google' | 'apple'} provider Provider
 * @param {string} code 
 * @param {string} [redirect_uri] Custom redirect URI to pass to provider (must match the one used in makeOAuthUrl
*/
export type createOAuthParams = {
    provider: 'vk' | 'facebook' | 'google' | 'apple',
    code: string,
    redirect_uri?: string,
}

/**
 * @param {'vk' | 'facebook' | 'google' | 'apple'} id Provider
*/
export type deleteOAuthParams = {
    id: 'vk' | 'facebook' | 'google' | 'apple',
}

/**
 * @param {'vk' | 'facebook' | 'google' | 'apple'} id Provider
 * @param {string} [redirect_uri] Custom redirect URI to pass to provider
*/
export type makeOAuthUrlParams = {
    id: 'vk' | 'facebook' | 'google' | 'apple',
    redirect_uri?: string,
}

/**
 * OAuth - factory interface
 * @export
 */
export const OAuthFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 1) If user is already signed in, we attempt to create a new oauth integration (e.g. link FB account) for the given user.  2) If user is not signed in, we attempt to sign the user in using oauth  3) If no account exists for the given oauth data, we attempt to create a new account -- if not enough info exists for a new account or some data is invalid, it is returned in the error response and the client should fix it and subsequently call createAccount.  NOTE: On error, the exception entity 'extra' field contains json_encode(['oauthData' => \\Model\\Virtual\\OauthUser::toArray()]) Those fields currently are: name, email_verified, email, sex, birthday, latitude, longitude, timezone, city_id, city_name_en, country_code, region_id, home_city_name_en, home_city_id, home_region_id, home_country_code, oauth_access_token, oauth_id (all are optional) Todo: Consider swaggerizing:)
         * @summary Authenticate user by OAuth, create account if it doesn't exist
         * @param {createOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuth(params: createOAuthParams, options?: any) {
            return OAuthFp(configuration).createOAuth(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete a user's social network integration
         * @param {deleteOAuthParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuth(params: deleteOAuthParams, options?: any) {
            return OAuthFp(configuration).deleteOAuth(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Make auth url for given oauth provider
         * @param {makeOAuthUrlParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeOAuthUrl(params: makeOAuthUrlParams, options?: any) {
            return OAuthFp(configuration).makeOAuthUrl(params, options)(fetch, basePath);
        },
    };
};

/**
 * OAuth - object-oriented interface
 * @export
 * @class OAuth
 * @extends {BaseAPI}
 */
export class OAuth extends BaseAPI {
    /**
     * 1) If user is already signed in, we attempt to create a new oauth integration (e.g. link FB account) for the given user.  2) If user is not signed in, we attempt to sign the user in using oauth  3) If no account exists for the given oauth data, we attempt to create a new account -- if not enough info exists for a new account or some data is invalid, it is returned in the error response and the client should fix it and subsequently call createAccount.  NOTE: On error, the exception entity 'extra' field contains json_encode(['oauthData' => \\Model\\Virtual\\OauthUser::toArray()]) Those fields currently are: name, email_verified, email, sex, birthday, latitude, longitude, timezone, city_id, city_name_en, country_code, region_id, home_city_name_en, home_city_id, home_region_id, home_country_code, oauth_access_token, oauth_id (all are optional) Todo: Consider swaggerizing:)
     * @summary Authenticate user by OAuth, create account if it doesn't exist
     * @param {createOAuthParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth
     */
    public createOAuth(params: createOAuthParams, options?: any) {
        return OAuthFp(this.configuration).createOAuth(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete a user's social network integration
     * @param {deleteOAuthParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth
     */
    public deleteOAuth(params: deleteOAuthParams, options?: any) {
        return OAuthFp(this.configuration).deleteOAuth(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Make auth url for given oauth provider
     * @param {makeOAuthUrlParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth
     */
    public makeOAuthUrl(params: makeOAuthUrlParams, options?: any) {
        return OAuthFp(this.configuration).makeOAuthUrl(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Photo - fetch parameter creator
 * @export
 */
export const PhotoFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload and create new photo
         * @param {createPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoto(params: createPhotoParams, options?: any): FetchArgs {
            const localVarPath = `/photo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.use_token !== undefined) {
                localVarQueryParameter['use_token'] = params.use_token;
            }

            if (params.file !== undefined) {
                localVarFormParams.set('file', params.file as any);
            }

            if (params.link !== undefined) {
                localVarFormParams.set('link', params.link as any);
            }

            if (params.aid !== undefined) {
                localVarFormParams.set('aid', params.aid as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create square thumbnail by cropping based on top left corner coordinate and side length
         * @param {cropThumbParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cropThumb(params: cropThumbParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling cropThumb");
            }
            // verify required parameter "params.x" is set
            if (params.x == null) {
                throw new Error("Missing required parameter 'x' when calling cropThumb");
            }
            // verify required parameter "params.y" is set
            if (params.y == null) {
                throw new Error("Missing required parameter 'y' when calling cropThumb");
            }
            // verify required parameter "params.length" is set
            if (params.length == null) {
                throw new Error("Missing required parameter 'length' when calling cropThumb");
            }
            const localVarPath = `/photo/{id}/crop-thumb`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.x !== undefined) {
                localVarFormParams.set('x', params.x as any);
            }

            if (params.y !== undefined) {
                localVarFormParams.set('y', params.y as any);
            }

            if (params.length !== undefined) {
                localVarFormParams.set('length', params.length as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete photo by $id
         * @param {deletePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto(params: deletePhotoParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deletePhoto");
            }
            const localVarPath = `/photo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {emailBounceParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailBounce(params: emailBounceParams, options?: any): FetchArgs {
            // verify required parameter "params.token" is set
            if (params.token == null) {
                throw new Error("Missing required parameter 'token' when calling emailBounce");
            }
            // verify required parameter "params.format" is set
            if (params.format == null) {
                throw new Error("Missing required parameter 'format' when calling emailBounce");
            }
            // verify required parameter "params.data" is set
            if (params.data == null) {
                throw new Error("Missing required parameter 'data' when calling emailBounce");
            }
            const localVarPath = `/internal/email-bounce`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.token !== undefined) {
                localVarFormParams.set('token', params.token as any);
            }

            if (params.format !== undefined) {
                localVarFormParams.set('format', params.format as any);
            }

            if (params.data !== undefined) {
                localVarFormParams.set('data', params.data as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get likes/comments total for entity
         * @param {getLikeCommentTotalParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLikeCommentTotal(params: getLikeCommentTotalParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getLikeCommentTotal");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling getLikeCommentTotal");
            }
            const localVarPath = `/like-comment-total/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.entity_type !== undefined) {
                localVarQueryParameter['entity_type'] = params.entity_type;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get media status
         * @param {getMediaStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaStatus(params: getMediaStatusParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getMediaStatus");
            }
            const localVarPath = `/upload-status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get photo by $id
         * @param {getPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(params: getPhotoParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPhoto");
            }
            // verify required parameter "params.owner_id" is set
            if (params.owner_id == null) {
                throw new Error("Missing required parameter 'owner_id' when calling getPhoto");
            }
            const localVarPath = `/photo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.owner_id !== undefined) {
                localVarQueryParameter['owner_id'] = params.owner_id;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get photo comments
         * @param {getPhotoCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoComments(params: getPhotoCommentsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPhotoComments");
            }
            const localVarPath = `/photo/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.nest_replies !== undefined) {
                localVarQueryParameter['nest_replies'] = params.nest_replies;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get likes related with photo
         * @param {getPhotoLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoLikes(params: getPhotoLikesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPhotoLikes");
            }
            const localVarPath = `/photo/{id}/likes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploaderd generates a photo id, uploads the file to S3, then passes us the filename and id. If the photo is going into an album (as opposed to a private message), we get the album id too.  https://git.interpals.net/interpals/uploaderd
         * @summary Create a photo record, add to album, add to feed.
         * @param {photoUploadHookParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadHook(params: photoUploadHookParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling photoUploadHook");
            }
            // verify required parameter "params.filename" is set
            if (params.filename == null) {
                throw new Error("Missing required parameter 'filename' when calling photoUploadHook");
            }
            const localVarPath = `/photo/{id}/upload-hook`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.aid !== undefined) {
                localVarQueryParameter['aid'] = params.aid;
            }

            if (params.filename !== undefined) {
                localVarQueryParameter['filename'] = params.filename;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rotate image in specified direction
         * @param {rotatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotatePhoto(params: rotatePhotoParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling rotatePhoto");
            }
            // verify required parameter "params.direction" is set
            if (params.direction == null) {
                throw new Error("Missing required parameter 'direction' when calling rotatePhoto");
            }
            const localVarPath = `/photo/{id}/rotate`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.direction !== undefined) {
                localVarFormParams.set('direction', params.direction as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update photo description, album by id
         * @param {updatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoto(params: updatePhotoParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updatePhoto");
            }
            const localVarPath = `/photo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.album_id !== undefined) {
                localVarFormParams.set('album_id', params.album_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Photo - functional programming interface
 * @export
 */
export const PhotoFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload and create new photo
         * @param {createPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoto(params: createPhotoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MediaTokenEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).createPhoto(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create square thumbnail by cropping based on top left corner coordinate and side length
         * @param {cropThumbParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cropThumb(params: cropThumbParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotoEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).cropThumb(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete photo by $id
         * @param {deletePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto(params: deletePhotoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).deletePhoto(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary 
         * @param {emailBounceParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailBounce(params: emailBounceParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).emailBounce(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get likes/comments total for entity
         * @param {getLikeCommentTotalParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLikeCommentTotal(params: getLikeCommentTotalParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeCommentDataEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).getLikeCommentTotal(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get media status
         * @param {getMediaStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaStatus(params: getMediaStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MediaStatusEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).getMediaStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get photo by $id
         * @param {getPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(params: getPhotoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotoEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).getPhoto(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get photo comments
         * @param {getPhotoCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoComments(params: getPhotoCommentsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentListResponse> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).getPhotoComments(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get likes related with photo
         * @param {getPhotoLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoLikes(params: getPhotoLikesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).getPhotoLikes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Uploaderd generates a photo id, uploads the file to S3, then passes us the filename and id. If the photo is going into an album (as opposed to a private message), we get the album id too.  https://git.interpals.net/interpals/uploaderd
         * @summary Create a photo record, add to album, add to feed.
         * @param {photoUploadHookParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadHook(params: photoUploadHookParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotoEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).photoUploadHook(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Rotate image in specified direction
         * @param {rotatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotatePhoto(params: rotatePhotoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).rotatePhoto(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update photo description, album by id
         * @param {updatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoto(params: updatePhotoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotoEntity> {
            const localVarFetchArgs = PhotoFetchParamCreator(configuration).updatePhoto(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {any} [file] Photo to upload
 * @param {string} [link] URL of an external photo to import
 * @param {string} [aid] Album ID if uploading photo into an album (i.e. not messages)
 * @param {boolean} [use_token] Optional parameter to respond with a token instead of photo object
*/
export type createPhotoParams = {
    file?: any,
    link?: string,
    aid?: string,
    use_token?: boolean,
}

/**
 * @param {string} id Photo id
 * @param {number} x Coordinate x (Top left corner of crop area)
 * @param {number} y Coordinate y (Top left corner of crop area)
 * @param {number} length Length of the cropped thumb
*/
export type cropThumbParams = {
    id: string,
    x: number,
    y: number,
    length: number,
}

/**
 * @param {string} id Photo id
*/
export type deletePhotoParams = {
    id: string,
}

/**
 * @param {string} token internal api token
 * @param {'log' | 'email'} format bounce format
 * @param {string} data Bounce data
*/
export type emailBounceParams = {
    token: string,
    format: 'log' | 'email',
    data: string,
}

/**
 * @param {string} id Entity id
 * @param {'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry'} entity_type Entity type
 * @param {string} [fields] return only specified fields, csv
*/
export type getLikeCommentTotalParams = {
    id: string,
    entity_type: 'post' | 'comment' | 'photo' | 'album' | 'trip' | 'entry',
    fields?: string,
}

/**
 * @param {string} id JWT token linked to image processing job
*/
export type getMediaStatusParams = {
    id: string,
}

/**
 * @param {string} id Id of the photo
 * @param {string} owner_id Owner user id (for security);      *                   Requirement will be enforced by validation after MOBILE_FORCE_UPGRADE
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
*/
export type getPhotoParams = {
    id: string,
    owner_id: string,
    fields?: string,
    extra?: string,
    limit?: number,
}

/**
 * @param {string} id Photo id
 * @param {boolean} [nest_replies] Nest replies for comments that have them up to limit (applies to sum of comments + replies)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPhotoCommentsParams = {
    id: string,
    nest_replies?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the photo
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPhotoLikesParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Photo id
 * @param {string} filename Filename of file uploaded to S3, includes prefix: e.g. 58/ca/450x338_1152481234_8248.jpg
 * @param {number} [aid] Album id
*/
export type photoUploadHookParams = {
    id: string,
    filename: string,
    aid?: number,
}

/**
 * @param {string} id Photo id
 * @param {'left' | 'right'} direction Rotate left or right (clockwise or counter-clockwise)
*/
export type rotatePhotoParams = {
    id: string,
    direction: 'left' | 'right',
}

/**
 * @param {string} id Photo id
 * @param {string} [description] Photo description
 * @param {string} [album_id] New album id (optional)
*/
export type updatePhotoParams = {
    id: string,
    description?: string,
    album_id?: string,
}

/**
 * Photo - factory interface
 * @export
 */
export const PhotoFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Upload and create new photo
         * @param {createPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhoto(params: createPhotoParams, options?: any) {
            return PhotoFp(configuration).createPhoto(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create square thumbnail by cropping based on top left corner coordinate and side length
         * @param {cropThumbParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cropThumb(params: cropThumbParams, options?: any) {
            return PhotoFp(configuration).cropThumb(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete photo by $id
         * @param {deletePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePhoto(params: deletePhotoParams, options?: any) {
            return PhotoFp(configuration).deletePhoto(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary 
         * @param {emailBounceParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailBounce(params: emailBounceParams, options?: any) {
            return PhotoFp(configuration).emailBounce(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get likes/comments total for entity
         * @param {getLikeCommentTotalParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLikeCommentTotal(params: getLikeCommentTotalParams, options?: any) {
            return PhotoFp(configuration).getLikeCommentTotal(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get media status
         * @param {getMediaStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaStatus(params: getMediaStatusParams, options?: any) {
            return PhotoFp(configuration).getMediaStatus(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get photo by $id
         * @param {getPhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(params: getPhotoParams, options?: any) {
            return PhotoFp(configuration).getPhoto(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get photo comments
         * @param {getPhotoCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoComments(params: getPhotoCommentsParams, options?: any) {
            return PhotoFp(configuration).getPhotoComments(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get likes related with photo
         * @param {getPhotoLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoLikes(params: getPhotoLikesParams, options?: any) {
            return PhotoFp(configuration).getPhotoLikes(params, options)(fetch, basePath);
        },
        /**
         * Uploaderd generates a photo id, uploads the file to S3, then passes us the filename and id. If the photo is going into an album (as opposed to a private message), we get the album id too.  https://git.interpals.net/interpals/uploaderd
         * @summary Create a photo record, add to album, add to feed.
         * @param {photoUploadHookParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadHook(params: photoUploadHookParams, options?: any) {
            return PhotoFp(configuration).photoUploadHook(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Rotate image in specified direction
         * @param {rotatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotatePhoto(params: rotatePhotoParams, options?: any) {
            return PhotoFp(configuration).rotatePhoto(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update photo description, album by id
         * @param {updatePhotoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoto(params: updatePhotoParams, options?: any) {
            return PhotoFp(configuration).updatePhoto(params, options)(fetch, basePath);
        },
    };
};

/**
 * Photo - object-oriented interface
 * @export
 * @class Photo
 * @extends {BaseAPI}
 */
export class Photo extends BaseAPI {
    /**
     * 
     * @summary Upload and create new photo
     * @param {createPhotoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public createPhoto(params: createPhotoParams, options?: any) {
        return PhotoFp(this.configuration).createPhoto(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create square thumbnail by cropping based on top left corner coordinate and side length
     * @param {cropThumbParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public cropThumb(params: cropThumbParams, options?: any) {
        return PhotoFp(this.configuration).cropThumb(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete photo by $id
     * @param {deletePhotoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public deletePhoto(params: deletePhotoParams, options?: any) {
        return PhotoFp(this.configuration).deletePhoto(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary 
     * @param {emailBounceParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public emailBounce(params: emailBounceParams, options?: any) {
        return PhotoFp(this.configuration).emailBounce(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get likes/comments total for entity
     * @param {getLikeCommentTotalParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public getLikeCommentTotal(params: getLikeCommentTotalParams, options?: any) {
        return PhotoFp(this.configuration).getLikeCommentTotal(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get media status
     * @param {getMediaStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public getMediaStatus(params: getMediaStatusParams, options?: any) {
        return PhotoFp(this.configuration).getMediaStatus(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get photo by $id
     * @param {getPhotoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public getPhoto(params: getPhotoParams, options?: any) {
        return PhotoFp(this.configuration).getPhoto(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get photo comments
     * @param {getPhotoCommentsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public getPhotoComments(params: getPhotoCommentsParams, options?: any) {
        return PhotoFp(this.configuration).getPhotoComments(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get likes related with photo
     * @param {getPhotoLikesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public getPhotoLikes(params: getPhotoLikesParams, options?: any) {
        return PhotoFp(this.configuration).getPhotoLikes(params, options)(this.fetch, this.basePath);
    }

    /**
     * Uploaderd generates a photo id, uploads the file to S3, then passes us the filename and id. If the photo is going into an album (as opposed to a private message), we get the album id too.  https://git.interpals.net/interpals/uploaderd
     * @summary Create a photo record, add to album, add to feed.
     * @param {photoUploadHookParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public photoUploadHook(params: photoUploadHookParams, options?: any) {
        return PhotoFp(this.configuration).photoUploadHook(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Rotate image in specified direction
     * @param {rotatePhotoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public rotatePhoto(params: rotatePhotoParams, options?: any) {
        return PhotoFp(this.configuration).rotatePhoto(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update photo description, album by id
     * @param {updatePhotoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Photo
     */
    public updatePhoto(params: updatePhotoParams, options?: any) {
        return PhotoFp(this.configuration).updatePhoto(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Post - fetch parameter creator
 * @export
 */
export const PostFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create post
         * @param {createPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPost(params: createPostParams, options?: any): FetchArgs {
            // verify required parameter "params.feed_owner_id" is set
            if (params.feed_owner_id == null) {
                throw new Error("Missing required parameter 'feed_owner_id' when calling createPost");
            }
            // verify required parameter "params.feed_type" is set
            if (params.feed_type == null) {
                throw new Error("Missing required parameter 'feed_type' when calling createPost");
            }
            // verify required parameter "params.view_acl" is set
            if (params.view_acl == null) {
                throw new Error("Missing required parameter 'view_acl' when calling createPost");
            }
            const localVarPath = `/post`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            if (params.title !== undefined) {
                localVarFormParams.set('title', params.title as any);
            }

            if (params.feed_owner_id !== undefined) {
                localVarFormParams.set('feed_owner_id', params.feed_owner_id as any);
            }

            if (params.feed_type !== undefined) {
                localVarFormParams.set('feed_type', params.feed_type as any);
            }

            if (params.gif_url !== undefined) {
                localVarFormParams.set('gif_url', params.gif_url as any);
            }

            if (params.photo_ids !== undefined) {
                localVarFormParams.set('photo_ids', params.photo_ids as any);
            }

            if (params.pinned !== undefined) {
                localVarFormParams.set('pinned', params.pinned as any);
            }

            if (params.poster_is_group !== undefined) {
                localVarFormParams.set('poster_is_group', params.poster_is_group as any);
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete post by $id
         * @param {deletePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePost(params: deletePostParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deletePost");
            }
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.feed_owner_id !== undefined) {
                localVarQueryParameter['feed_owner_id'] = params.feed_owner_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get post by id
         * @param {getPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPost(params: getPostParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPost");
            }
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.feed_owner_id !== undefined) {
                localVarQueryParameter['feed_owner_id'] = params.feed_owner_id;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get post comments by post id and feed owner id
         * @param {getPostCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostComments(params: getPostCommentsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPostComments");
            }
            const localVarPath = `/post/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.feed_owner_id !== undefined) {
                localVarQueryParameter['feed_owner_id'] = params.feed_owner_id;
            }

            if (params.nest_replies !== undefined) {
                localVarQueryParameter['nest_replies'] = params.nest_replies;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get post likes by $id
         * @param {getPostLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostLikes(params: getPostLikesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPostLikes");
            }
            const localVarPath = `/post/{id}/likes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.feed_owner_id !== undefined) {
                localVarQueryParameter['feed_owner_id'] = params.feed_owner_id;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update post by $id
         * @param {updatePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePost(params: updatePostParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updatePost");
            }
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            if (params.title !== undefined) {
                localVarFormParams.set('title', params.title as any);
            }

            if (params.feed_owner_id !== undefined) {
                localVarFormParams.set('feed_owner_id', params.feed_owner_id as any);
            }

            if (params.gif_url !== undefined) {
                localVarFormParams.set('gif_url', params.gif_url as any);
            }

            if (params.photo_ids !== undefined) {
                localVarFormParams.set('photo_ids', params.photo_ids as any);
            }

            if (params.pinned !== undefined) {
                localVarFormParams.set('pinned', params.pinned as any);
            }

            if (params.poster_is_group !== undefined) {
                localVarFormParams.set('poster_is_group', params.poster_is_group as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Post - functional programming interface
 * @export
 */
export const PostFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create post
         * @param {createPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPost(params: createPostParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PostEntity> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).createPost(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete post by $id
         * @param {deletePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePost(params: deletePostParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).deletePost(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get post by id
         * @param {getPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPost(params: getPostParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PostEntity> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).getPost(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get post comments by post id and feed owner id
         * @param {getPostCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostComments(params: getPostCommentsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentListResponse> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).getPostComments(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get post likes by $id
         * @param {getPostLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostLikes(params: getPostLikesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).getPostLikes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update post by $id
         * @param {updatePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePost(params: updatePostParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PostEntity> {
            const localVarFetchArgs = PostFetchParamCreator(configuration).updatePost(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} feed_owner_id Self, user id or group id of feed to post on
 * @param {'user' | 'group'} feed_type Specify whether this post is going on a user or group feed
 * @param {'public' | 'users' | 'friends' | 'me' | 'none'} view_acl view_acl
 * @param {string} [message] Post body text. Required unless gif_url or photo_ids are specified.
 * @param {string} [title] Group post title (only for group posts), 
 * @param {string} [gif_url] Giphy URL, allowed only if no photo attachments are specified
 * @param {string} [photo_ids] Photo ids (csv) to attach to post. Must belong to user and not be in an album already.
 * @param {boolean} [pinned] Is group post pinned?
 * @param {boolean} [poster_is_group] Should the author of the post be displayed as the group itself? (group post only)
 * @param {string} [language] User-tagged language of post
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type createPostParams = {
    feed_owner_id: string,
    feed_type: 'user' | 'group',
    view_acl: 'public' | 'users' | 'friends' | 'me' | 'none',
    message?: string,
    title?: string,
    gif_url?: string,
    photo_ids?: string,
    pinned?: boolean,
    poster_is_group?: boolean,
    language?: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Post id
 * @param {string} [feed_owner_id]       *          Entity ID that contains feed.      *          Pass uid if want to delete own or foreign post      *          Pass gid if want to delete group post      *      
*/
export type deletePostParams = {
    id: string,
    feed_owner_id?: string,
}

/**
 * @param {string} id Post id
 * @param {string} [feed_owner_id] Feed owner uid
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type getPostParams = {
    id: string,
    feed_owner_id?: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Post id
 * @param {string} [feed_owner_id] Feed owner uid or group id
 * @param {boolean} [nest_replies] Nest replies for comments that have them up to limit (applies to sum of comments + replies)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPostCommentsParams = {
    id: string,
    feed_owner_id?: string,
    nest_replies?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Post id
 * @param {string} [feed_owner_id] Feed owner uid (may be the same as poster uid if user posted on their own feed)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getPostLikesParams = {
    id: string,
    feed_owner_id?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Post id
 * @param {string} [message] Post body
 * @param {string} [title] Group post title (only for group posts)
 * @param {string} [feed_owner_id]       *          Entity ID that contains feed.      *          Pass uid if want to update own or foreign post      *          Pass gid if want to update group post      *      
 * @param {string} [gif_url] Giphy URL, allowed only if no photo attachments are specified
 * @param {string} [photo_ids] Photo ids (csv) to attach to post. Must belong to user and not be in an album already.      *                  If this field omits any photo ids currently attached to the post, they will be deleted.
 * @param {boolean} [pinned] Is group post pinned?
 * @param {boolean} [poster_is_group] Should the author of the post be displayed as the group itself? (group post only)
 * @param {'public' | 'users' | 'friends' | 'me' | 'none'} [view_acl] view_acl, only for user posts, not for groups
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type updatePostParams = {
    id: string,
    message?: string,
    title?: string,
    feed_owner_id?: string,
    gif_url?: string,
    photo_ids?: string,
    pinned?: boolean,
    poster_is_group?: boolean,
    view_acl?: 'public' | 'users' | 'friends' | 'me' | 'none',
    fields?: string,
    extra?: string,
}

/**
 * Post - factory interface
 * @export
 */
export const PostFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create post
         * @param {createPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPost(params: createPostParams, options?: any) {
            return PostFp(configuration).createPost(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete post by $id
         * @param {deletePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePost(params: deletePostParams, options?: any) {
            return PostFp(configuration).deletePost(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get post by id
         * @param {getPostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPost(params: getPostParams, options?: any) {
            return PostFp(configuration).getPost(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get post comments by post id and feed owner id
         * @param {getPostCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostComments(params: getPostCommentsParams, options?: any) {
            return PostFp(configuration).getPostComments(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get post likes by $id
         * @param {getPostLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostLikes(params: getPostLikesParams, options?: any) {
            return PostFp(configuration).getPostLikes(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update post by $id
         * @param {updatePostParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePost(params: updatePostParams, options?: any) {
            return PostFp(configuration).updatePost(params, options)(fetch, basePath);
        },
    };
};

/**
 * Post - object-oriented interface
 * @export
 * @class Post
 * @extends {BaseAPI}
 */
export class Post extends BaseAPI {
    /**
     * 
     * @summary Create post
     * @param {createPostParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public createPost(params: createPostParams, options?: any) {
        return PostFp(this.configuration).createPost(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete post by $id
     * @param {deletePostParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public deletePost(params: deletePostParams, options?: any) {
        return PostFp(this.configuration).deletePost(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get post by id
     * @param {getPostParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public getPost(params: getPostParams, options?: any) {
        return PostFp(this.configuration).getPost(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get post comments by post id and feed owner id
     * @param {getPostCommentsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public getPostComments(params: getPostCommentsParams, options?: any) {
        return PostFp(this.configuration).getPostComments(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get post likes by $id
     * @param {getPostLikesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public getPostLikes(params: getPostLikesParams, options?: any) {
        return PostFp(this.configuration).getPostLikes(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update post by $id
     * @param {updatePostParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Post
     */
    public updatePost(params: updatePostParams, options?: any) {
        return PostFp(this.configuration).updatePost(params, options)(this.fetch, this.basePath);
    }

}

/**
 * PremiumStatus - fetch parameter creator
 * @export
 */
export const PremiumStatusFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find premium user info by $id
         * @param {getPremiumByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumById(params: getPremiumByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPremiumById");
            }
            const localVarPath = `/premium-status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PremiumStatus - functional programming interface
 * @export
 */
export const PremiumStatusFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find premium user info by $id
         * @param {getPremiumByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumById(params: getPremiumByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PremiumStatusEntity> {
            const localVarFetchArgs = PremiumStatusFetchParamCreator(configuration).getPremiumById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id $id of the user
*/
export type getPremiumByIdParams = {
    id: string,
}

/**
 * PremiumStatus - factory interface
 * @export
 */
export const PremiumStatusFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Find premium user info by $id
         * @param {getPremiumByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumById(params: getPremiumByIdParams, options?: any) {
            return PremiumStatusFp(configuration).getPremiumById(params, options)(fetch, basePath);
        },
    };
};

/**
 * PremiumStatus - object-oriented interface
 * @export
 * @class PremiumStatus
 * @extends {BaseAPI}
 */
export class PremiumStatus extends BaseAPI {
    /**
     * 
     * @summary Find premium user info by $id
     * @param {getPremiumByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumStatus
     */
    public getPremiumById(params: getPremiumByIdParams, options?: any) {
        return PremiumStatusFp(this.configuration).getPremiumById(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Profile - fetch parameter creator
 * @export
 */
export const ProfileFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find profile by $id
         * @param {getProfileByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileById(params: getProfileByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getProfileById");
            }
            const localVarPath = `/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.clicksource !== undefined) {
                localVarQueryParameter['clicksource'] = params.clicksource;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.XAppVersion !== undefined && params.XAppVersion !== null) {
                localVarHeaderParameter['X-APP-VERSION'] = String(params.XAppVersion);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Profile - functional programming interface
 * @export
 */
export const ProfileFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find profile by $id
         * @param {getProfileByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileById(params: getProfileByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfileEntity> {
            const localVarFetchArgs = ProfileFetchParamCreator(configuration).getProfileById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id $id of the specified
 * @param {'other' | 'search' | 'message' | 'profile' | 'views' | 'quick_search' | 'suggested' | 'feed' | 'friends' | 'bookmarks' | 'email' | 'online'} [clicksource] Source section of site from which user opened this profile
 * @param {string} [XAppVersion] Client platform &amp; version, e.g. android-0.1.2, ios-1.2.3
 * @param {string} [extra] return extra, non-default fields
*/
export type getProfileByIdParams = {
    id: string,
    clicksource?: 'other' | 'search' | 'message' | 'profile' | 'views' | 'quick_search' | 'suggested' | 'feed' | 'friends' | 'bookmarks' | 'email' | 'online',
    XAppVersion?: string,
    extra?: string,
}

/**
 * Profile - factory interface
 * @export
 */
export const ProfileFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Find profile by $id
         * @param {getProfileByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileById(params: getProfileByIdParams, options?: any) {
            return ProfileFp(configuration).getProfileById(params, options)(fetch, basePath);
        },
    };
};

/**
 * Profile - object-oriented interface
 * @export
 * @class Profile
 * @extends {BaseAPI}
 */
export class Profile extends BaseAPI {
    /**
     * 
     * @summary Find profile by $id
     * @param {getProfileByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Profile
     */
    public getProfileById(params: getProfileByIdParams, options?: any) {
        return ProfileFp(this.configuration).getProfileById(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Prompt - fetch parameter creator
 * @export
 */
export const PromptFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get prompt root
         * @param {getPromptRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptRoot(params: getPromptRootParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPromptRoot");
            }
            const localVarPath = `/prompt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrompts(params: getPromptsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPrompts");
            }
            const localVarPath = `/prompt/{id}/prompts`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.language !== undefined) {
                localVarFormParams.set('language', params.language as any);
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            if (params.order !== undefined) {
                localVarFormParams.set('order', params.order as any);
            }

            if (params.sort !== undefined) {
                localVarFormParams.set('sort', params.sort as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Prompt - functional programming interface
 * @export
 */
export const PromptFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get prompt root
         * @param {getPromptRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptRoot(params: getPromptRootParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PromptEntity> {
            const localVarFetchArgs = PromptFetchParamCreator(configuration).getPromptRoot(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrompts(params: getPromptsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PromptListResponse> {
            const localVarFetchArgs = PromptFetchParamCreator(configuration).getPrompts(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the prompt (not used)
*/
export type getPromptRootParams = {
    id: string,
}

/**
 * @param {string} id Id (not used)
 * @param {string} [language] entry language
 * @param {number} [limit] limit
 * @param {number} [offset] offset
 * @param {string} [order] order
 * @param {string} [sort] sort
*/
export type getPromptsParams = {
    id: string,
    language?: string,
    limit?: number,
    offset?: number,
    order?: string,
    sort?: string,
}

/**
 * Prompt - factory interface
 * @export
 */
export const PromptFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get prompt root
         * @param {getPromptRootParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptRoot(params: getPromptRootParams, options?: any) {
            return PromptFp(configuration).getPromptRoot(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrompts(params: getPromptsParams, options?: any) {
            return PromptFp(configuration).getPrompts(params, options)(fetch, basePath);
        },
    };
};

/**
 * Prompt - object-oriented interface
 * @export
 * @class Prompt
 * @extends {BaseAPI}
 */
export class Prompt extends BaseAPI {
    /**
     * 
     * @summary Get prompt root
     * @param {getPromptRootParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Prompt
     */
    public getPromptRoot(params: getPromptRootParams, options?: any) {
        return PromptFp(this.configuration).getPromptRoot(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get prompts
     * @param {getPromptsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Prompt
     */
    public getPrompts(params: getPromptsParams, options?: any) {
        return PromptFp(this.configuration).getPrompts(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Pubstream - fetch parameter creator
 * @export
 */
export const PubstreamFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger download of latest Pubstream ad framework bundle and create merge request. Must be GET.
         * @param {updatePubstreamBundleParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePubstreamBundle(options?: any): FetchArgs {
            const localVarPath = `/pubstream-update-bundle`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Pubstream - functional programming interface
 * @export
 */
export const PubstreamFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger download of latest Pubstream ad framework bundle and create merge request. Must be GET.
         * @param {updatePubstreamBundleParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePubstreamBundle(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = PubstreamFetchParamCreator(configuration).updatePubstreamBundle(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};



/**
 * Pubstream - factory interface
 * @export
 */
export const PubstreamFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Trigger download of latest Pubstream ad framework bundle and create merge request. Must be GET.
         * @param {updatePubstreamBundleParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePubstreamBundle(options?: any) {
            return PubstreamFp(configuration).updatePubstreamBundle(options)(fetch, basePath);
        },
    };
};

/**
 * Pubstream - object-oriented interface
 * @export
 * @class Pubstream
 * @extends {BaseAPI}
 */
export class Pubstream extends BaseAPI {
    /**
     * 
     * @summary Trigger download of latest Pubstream ad framework bundle and create merge request. Must be GET.
     * @param {updatePubstreamBundleParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Pubstream
     */
    public updatePubstreamBundle(options?: any) {
        return PubstreamFp(this.configuration).updatePubstreamBundle(options)(this.fetch, this.basePath);
    }

}

/**
 * PushToken - fetch parameter creator
 * @export
 */
export const PushTokenFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create PushToken
         * @param {createPushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPushToken(params: createPushTokenParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling createPushToken");
            }
            // verify required parameter "params.device_id" is set
            if (params.device_id == null) {
                throw new Error("Missing required parameter 'device_id' when calling createPushToken");
            }
            // verify required parameter "params.platform" is set
            if (params.platform == null) {
                throw new Error("Missing required parameter 'platform' when calling createPushToken");
            }
            const localVarPath = `/push-token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.id !== undefined) {
                localVarFormParams.set('id', params.id as any);
            }

            if (params.device_id !== undefined) {
                localVarFormParams.set('device_id', params.device_id as any);
            }

            if (params.platform !== undefined) {
                localVarFormParams.set('platform', params.platform as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete PushToken
         * @param {deletePushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushToken(params: deletePushTokenParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deletePushToken");
            }
            const localVarPath = `/push-token/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PushToken - functional programming interface
 * @export
 */
export const PushTokenFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create PushToken
         * @param {createPushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPushToken(params: createPushTokenParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PushTokenEntity> {
            const localVarFetchArgs = PushTokenFetchParamCreator(configuration).createPushToken(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete PushToken
         * @param {deletePushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushToken(params: deletePushTokenParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = PushTokenFetchParamCreator(configuration).deletePushToken(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Token
 * @param {string} device_id Device id
 * @param {'android' | 'ios'} platform Which platform?)
*/
export type createPushTokenParams = {
    id: string,
    device_id: string,
    platform: 'android' | 'ios',
}

/**
 * @param {string} id Token
*/
export type deletePushTokenParams = {
    id: string,
}

/**
 * PushToken - factory interface
 * @export
 */
export const PushTokenFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create PushToken
         * @param {createPushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPushToken(params: createPushTokenParams, options?: any) {
            return PushTokenFp(configuration).createPushToken(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete PushToken
         * @param {deletePushTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushToken(params: deletePushTokenParams, options?: any) {
            return PushTokenFp(configuration).deletePushToken(params, options)(fetch, basePath);
        },
    };
};

/**
 * PushToken - object-oriented interface
 * @export
 * @class PushToken
 * @extends {BaseAPI}
 */
export class PushToken extends BaseAPI {
    /**
     * 
     * @summary Create PushToken
     * @param {createPushTokenParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushToken
     */
    public createPushToken(params: createPushTokenParams, options?: any) {
        return PushTokenFp(this.configuration).createPushToken(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete PushToken
     * @param {deletePushTokenParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushToken
     */
    public deletePushToken(params: deletePushTokenParams, options?: any) {
        return PushTokenFp(this.configuration).deletePushToken(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Relation - fetch parameter creator
 * @export
 */
export const RelationFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Block user
         * @param {blockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserById(params: blockUserByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling blockUserById");
            }
            const localVarPath = `/relation/{id}/block`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get relation by Id
         * @param {getRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelation(params: getRelationParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getRelation");
            }
            const localVarPath = `/relation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unblock user
         * @param {unblockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserById(params: unblockUserByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling unblockUserById");
            }
            const localVarPath = `/relation/{id}/unblock`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update relation
         * @param {updateRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelation(params: updateRelationParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateRelation");
            }
            // verify required parameter "params.action" is set
            if (params.action == null) {
                throw new Error("Missing required parameter 'action' when calling updateRelation");
            }
            const localVarPath = `/relation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.action !== undefined) {
                localVarFormParams.set('action', params.action as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Relation - functional programming interface
 * @export
 */
export const RelationFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Block user
         * @param {blockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserById(params: blockUserByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RelationEntity> {
            const localVarFetchArgs = RelationFetchParamCreator(configuration).blockUserById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get relation by Id
         * @param {getRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelation(params: getRelationParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RelationEntity> {
            const localVarFetchArgs = RelationFetchParamCreator(configuration).getRelation(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Unblock user
         * @param {unblockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserById(params: unblockUserByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RelationEntity> {
            const localVarFetchArgs = RelationFetchParamCreator(configuration).unblockUserById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update relation
         * @param {updateRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelation(params: updateRelationParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RelationEntity> {
            const localVarFetchArgs = RelationFetchParamCreator(configuration).updateRelation(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the target user
*/
export type blockUserByIdParams = {
    id: string,
}

/**
 * @param {string} id Id of the target user
 * @param {string} [extra] return extra, non-default fields
*/
export type getRelationParams = {
    id: string,
    extra?: string,
}

/**
 * @param {string} id Id of the target user
*/
export type unblockUserByIdParams = {
    id: string,
}

/**
 * @param {string} id Id of the target user
 * @param {'add_friend' | 'accept_friend' | 'ignore_friend' | 'delete_friend' | 'cancel_friend_request'} action What type of relation you want to have with target user. Note: a counter sync notification      *  will arrive if the user's active friend request count has changed as a result of this action.
*/
export type updateRelationParams = {
    id: string,
    action: 'add_friend' | 'accept_friend' | 'ignore_friend' | 'delete_friend' | 'cancel_friend_request',
}

/**
 * Relation - factory interface
 * @export
 */
export const RelationFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Block user
         * @param {blockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserById(params: blockUserByIdParams, options?: any) {
            return RelationFp(configuration).blockUserById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get relation by Id
         * @param {getRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelation(params: getRelationParams, options?: any) {
            return RelationFp(configuration).getRelation(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Unblock user
         * @param {unblockUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserById(params: unblockUserByIdParams, options?: any) {
            return RelationFp(configuration).unblockUserById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update relation
         * @param {updateRelationParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelation(params: updateRelationParams, options?: any) {
            return RelationFp(configuration).updateRelation(params, options)(fetch, basePath);
        },
    };
};

/**
 * Relation - object-oriented interface
 * @export
 * @class Relation
 * @extends {BaseAPI}
 */
export class Relation extends BaseAPI {
    /**
     * 
     * @summary Block user
     * @param {blockUserByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Relation
     */
    public blockUserById(params: blockUserByIdParams, options?: any) {
        return RelationFp(this.configuration).blockUserById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get relation by Id
     * @param {getRelationParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Relation
     */
    public getRelation(params: getRelationParams, options?: any) {
        return RelationFp(this.configuration).getRelation(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Unblock user
     * @param {unblockUserByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Relation
     */
    public unblockUserById(params: unblockUserByIdParams, options?: any) {
        return RelationFp(this.configuration).unblockUserById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update relation
     * @param {updateRelationParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Relation
     */
    public updateRelation(params: updateRelationParams, options?: any) {
        return RelationFp(this.configuration).updateRelation(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Report - fetch parameter creator
 * @export
 */
export const ReportFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(params: createReportParams, options?: any): FetchArgs {
            // verify required parameter "params.target_id" is set
            if (params.target_id == null) {
                throw new Error("Missing required parameter 'target_id' when calling createReport");
            }
            // verify required parameter "params.entity_type" is set
            if (params.entity_type == null) {
                throw new Error("Missing required parameter 'entity_type' when calling createReport");
            }
            // verify required parameter "params.reason_sel" is set
            if (params.reason_sel == null) {
                throw new Error("Missing required parameter 'reason_sel' when calling createReport");
            }
            const localVarPath = `/report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.target_uid !== undefined) {
                localVarFormParams.set('target_uid', params.target_uid as any);
            }

            if (params.target_id !== undefined) {
                localVarFormParams.set('target_id', params.target_id as any);
            }

            if (params.entity_type !== undefined) {
                localVarFormParams.set('entity_type', params.entity_type as any);
            }

            if (params.reason !== undefined) {
                localVarFormParams.set('reason', params.reason as any);
            }

            if (params.reason_sel !== undefined) {
                localVarFormParams.set('reason_sel', params.reason_sel as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reports grouped by user
         * @param {getUserReportsGroupedByUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsGroupedByUser(params: getUserReportsGroupedByUserParams, options?: any): FetchArgs {
            const localVarPath = `/reports/by-user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.uid !== undefined) {
                localVarQueryParameter['uid'] = params.uid;
            }

            if (params.sort !== undefined) {
                localVarQueryParameter['sort'] = params.sort;
            }

            if (params.status !== undefined) {
                localVarQueryParameter['status'] = params.status;
            }

            if (params.entity_type !== undefined) {
                localVarQueryParameter['entity_type'] = params.entity_type;
            }

            if (params.reason_category !== undefined) {
                localVarQueryParameter['reason_category'] = params.reason_category;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update report record by $id
         * @param {updateReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReport(params: updateReportParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateReport");
            }
            // verify required parameter "params.status" is set
            if (params.status == null) {
                throw new Error("Missing required parameter 'status' when calling updateReport");
            }
            const localVarPath = `/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.status !== undefined) {
                localVarFormParams.set('status', params.status as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch update reports by reported user id
         * @param {updateReportsByReportedUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportsByReportedUid(params: updateReportsByReportedUidParams, options?: any): FetchArgs {
            // verify required parameter "params.uid" is set
            if (params.uid == null) {
                throw new Error("Missing required parameter 'uid' when calling updateReportsByReportedUid");
            }
            // verify required parameter "params.status" is set
            if (params.status == null) {
                throw new Error("Missing required parameter 'status' when calling updateReportsByReportedUid");
            }
            const localVarPath = `/reports`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.uid !== undefined) {
                localVarQueryParameter['uid'] = params.uid;
            }

            if (params.status !== undefined) {
                localVarFormParams.set('status', params.status as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Report - functional programming interface
 * @export
 */
export const ReportFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(params: createReportParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ReportFetchParamCreator(configuration).createReport(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get reports grouped by user
         * @param {getUserReportsGroupedByUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsGroupedByUser(params: getUserReportsGroupedByUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportsResponse> {
            const localVarFetchArgs = ReportFetchParamCreator(configuration).getUserReportsGroupedByUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update report record by $id
         * @param {updateReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReport(params: updateReportParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportEntity> {
            const localVarFetchArgs = ReportFetchParamCreator(configuration).updateReport(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Batch update reports by reported user id
         * @param {updateReportsByReportedUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportsByReportedUid(params: updateReportsByReportedUidParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ReportFetchParamCreator(configuration).updateReportsByReportedUid(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} target_id Entity which we want to report (msg, wall, user, etc.)
 * @param {'user' | 'photo' | 'message' | 'group' | 'post' | 'comment'} entity_type Type of what we can report
 * @param {'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs'} reason_sel Reason sel
 * @param {string} [target_uid] User we want to report, required for all entity types except group
 * @param {string} [reason] Reason
*/
export type createReportParams = {
    target_id: string,
    entity_type: 'user' | 'photo' | 'message' | 'group' | 'post' | 'comment',
    reason_sel: 'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs',
    target_uid?: string,
    reason?: string,
}

/**
 * @param {string} [uid] Filter by user id
 * @param {'quantity' | 'newest' | 'oldest'} [sort] Sort results by quantity of reports per user or latest report per user.      *           Default to quantity
 * @param {'active' | 'archived' | 'pending' | 'cleared' | 'escalated'} [status] Filter by report status
 * @param {'comment' | 'entry' | 'group' | 'message' | 'photo' | 'post' | 'prompt' | 'thread' | 'user' | 'wall'} [entity_type] 
 * @param {'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs'} [reason_category] Filter results by report category
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit, applies to users, not reports (all reports will be returned for each user)
 * @param {number} [offset] Offset, applies to users, not reports (all reports will be returned for each user)
*/
export type getUserReportsGroupedByUserParams = {
    uid?: string,
    sort?: 'quantity' | 'newest' | 'oldest',
    status?: 'active' | 'archived' | 'pending' | 'cleared' | 'escalated',
    entity_type?: 'comment' | 'entry' | 'group' | 'message' | 'photo' | 'post' | 'prompt' | 'thread' | 'user' | 'wall',
    reason_category?: 'harass' | 'nudity' | 'other' | 'spam' | 'sex' | 'obscenity' | 'drugs',
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the report
 * @param {'active' | 'archived' | 'pending' | 'cleared' | 'escalated'} status Report status
*/
export type updateReportParams = {
    id: string,
    status: 'active' | 'archived' | 'pending' | 'cleared' | 'escalated',
}

/**
 * @param {string} uid Reported user id for whom to update report statuses
 * @param {'active' | 'archived' | 'pending' | 'cleared' | 'escalated'} status New status for reports (e.g. 'cleared')
*/
export type updateReportsByReportedUidParams = {
    uid: string,
    status: 'active' | 'archived' | 'pending' | 'cleared' | 'escalated',
}

/**
 * Report - factory interface
 * @export
 */
export const ReportFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {createReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(params: createReportParams, options?: any) {
            return ReportFp(configuration).createReport(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get reports grouped by user
         * @param {getUserReportsGroupedByUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsGroupedByUser(params: getUserReportsGroupedByUserParams, options?: any) {
            return ReportFp(configuration).getUserReportsGroupedByUser(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update report record by $id
         * @param {updateReportParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReport(params: updateReportParams, options?: any) {
            return ReportFp(configuration).updateReport(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Batch update reports by reported user id
         * @param {updateReportsByReportedUidParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportsByReportedUid(params: updateReportsByReportedUidParams, options?: any) {
            return ReportFp(configuration).updateReportsByReportedUid(params, options)(fetch, basePath);
        },
    };
};

/**
 * Report - object-oriented interface
 * @export
 * @class Report
 * @extends {BaseAPI}
 */
export class Report extends BaseAPI {
    /**
     * 
     * @param {createReportParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Report
     */
    public createReport(params: createReportParams, options?: any) {
        return ReportFp(this.configuration).createReport(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get reports grouped by user
     * @param {getUserReportsGroupedByUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Report
     */
    public getUserReportsGroupedByUser(params: getUserReportsGroupedByUserParams, options?: any) {
        return ReportFp(this.configuration).getUserReportsGroupedByUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update report record by $id
     * @param {updateReportParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Report
     */
    public updateReport(params: updateReportParams, options?: any) {
        return ReportFp(this.configuration).updateReport(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Batch update reports by reported user id
     * @param {updateReportsByReportedUidParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Report
     */
    public updateReportsByReportedUid(params: updateReportsByReportedUidParams, options?: any) {
        return ReportFp(this.configuration).updateReportsByReportedUid(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Search - fetch parameter creator
 * @export
 */
export const SearchFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search user friends by their name or username
         * @param {findFriendsByNameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFriendsByName(params: findFriendsByNameParams, options?: any): FetchArgs {
            // verify required parameter "params.name" is set
            if (params.name == null) {
                throw new Error("Missing required parameter 'name' when calling findFriendsByName");
            }
            const localVarPath = `/search/friends`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.name !== undefined) {
                localVarQueryParameter['name'] = params.name;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Geo item search
         * @param {searchGeoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGeo(params: searchGeoParams, options?: any): FetchArgs {
            // verify required parameter "params.type" is set
            if (params.type == null) {
                throw new Error("Missing required parameter 'type' when calling searchGeo");
            }
            const localVarPath = `/search/geo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.type !== undefined) {
                localVarQueryParameter['type'] = params.type;
            }

            if (params.location !== undefined) {
                localVarQueryParameter['location'] = params.location;
            }

            if (params.radius !== undefined) {
                localVarQueryParameter['radius'] = params.radius;
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.sort !== undefined) {
                localVarQueryParameter['sort'] = params.sort;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users
         * @param {searchPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrompt(params: searchPromptParams, options?: any): FetchArgs {
            const localVarPath = `/search/prompt`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search tag object
         * @param {searchTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTag(params: searchTagParams, options?: any): FetchArgs {
            const localVarPath = `/search/tag`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.cat_id !== undefined) {
                localVarQueryParameter['cat_id'] = params.cat_id;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.AcceptLanguage !== undefined && params.AcceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(params.AcceptLanguage);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Filter user message threads
         * @param {searchThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreads(params: searchThreadsParams, options?: any): FetchArgs {
            // verify required parameter "params.text" is set
            if (params.text == null) {
                throw new Error("Missing required parameter 'text' when calling searchThreads");
            }
            const localVarPath = `/search/threads`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search trip travelers
         * @param {searchTripTravelersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTripTravelers(params: searchTripTravelersParams, options?: any): FetchArgs {
            const localVarPath = `/search/trip-travelers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.field !== undefined) {
                localVarQueryParameter['field'] = params.field;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.latitude !== undefined) {
                localVarQueryParameter['latitude'] = params.latitude;
            }

            if (params.longitude !== undefined) {
                localVarQueryParameter['longitude'] = params.longitude;
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.city !== undefined) {
                localVarQueryParameter['city'] = params.city;
            }

            if (params.country !== undefined) {
                localVarQueryParameter['country'] = params.country;
            }

            if (params.country_home !== undefined) {
                localVarQueryParameter['country_home'] = params.country_home;
            }

            if (params.sex !== undefined) {
                localVarQueryParameter['sex'] = params.sex;
            }

            if (params.arrival_date !== undefined) {
                localVarQueryParameter['arrival_date'] = params.arrival_date;
            }

            if (params.departure_date !== undefined) {
                localVarQueryParameter['departure_date'] = params.departure_date;
            }

            if (params.lfor_email !== undefined) {
                localVarQueryParameter['lfor_email'] = params.lfor_email;
            }

            if (params.lfor_meet !== undefined) {
                localVarQueryParameter['lfor_meet'] = params.lfor_meet;
            }

            if (params.lfor_friend !== undefined) {
                localVarQueryParameter['lfor_friend'] = params.lfor_friend;
            }

            if (params.lfor_relation !== undefined) {
                localVarQueryParameter['lfor_relation'] = params.lfor_relation;
            }

            if (params.lfor_snail !== undefined) {
                localVarQueryParameter['lfor_snail'] = params.lfor_snail;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search trips
         * @param {searchTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTrips(params: searchTripsParams, options?: any): FetchArgs {
            const localVarPath = `/search/trips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.field !== undefined) {
                localVarQueryParameter['field'] = params.field;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.latitude !== undefined) {
                localVarQueryParameter['latitude'] = params.latitude;
            }

            if (params.longitude !== undefined) {
                localVarQueryParameter['longitude'] = params.longitude;
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.city !== undefined) {
                localVarQueryParameter['city'] = params.city;
            }

            if (params.country !== undefined) {
                localVarQueryParameter['country'] = params.country;
            }

            if (params.country_home !== undefined) {
                localVarQueryParameter['country_home'] = params.country_home;
            }

            if (params.arrival_date !== undefined) {
                localVarQueryParameter['arrival_date'] = params.arrival_date;
            }

            if (params.departure_date !== undefined) {
                localVarQueryParameter['departure_date'] = params.departure_date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users
         * @param {searchUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(params: searchUserParams, options?: any): FetchArgs {
            const localVarPath = `/search/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.sort !== undefined) {
                localVarQueryParameter['sort'] = params.sort;
            }

            if (params.order !== undefined) {
                localVarQueryParameter['order'] = params.order;
            }

            if (params.sex !== undefined) {
                localVarQueryParameter['sex'] = params.sex;
            }

            if (params.countries !== undefined) {
                localVarQueryParameter['countries'] = params.countries;
            }

            if (params.home_countries !== undefined) {
                localVarQueryParameter['home_countries'] = params.home_countries;
            }

            if (params.continents !== undefined) {
                localVarQueryParameter['continents'] = params.continents;
            }

            if (params.city !== undefined) {
                localVarQueryParameter['city'] = params.city;
            }

            if (params.home_city !== undefined) {
                localVarQueryParameter['home_city'] = params.home_city;
            }

            if (params.location !== undefined) {
                localVarQueryParameter['location'] = params.location;
            }

            if (params.radius !== undefined) {
                localVarQueryParameter['radius'] = params.radius;
            }

            if (params.age1 !== undefined) {
                localVarQueryParameter['age1'] = params.age1;
            }

            if (params.age2 !== undefined) {
                localVarQueryParameter['age2'] = params.age2;
            }

            if (params.lfor_langex !== undefined) {
                localVarQueryParameter['lfor_langex'] = params.lfor_langex;
            }

            if (params.lfor_meet !== undefined) {
                localVarQueryParameter['lfor_meet'] = params.lfor_meet;
            }

            if (params.lfor_friend !== undefined) {
                localVarQueryParameter['lfor_friend'] = params.lfor_friend;
            }

            if (params.lfor_relation !== undefined) {
                localVarQueryParameter['lfor_relation'] = params.lfor_relation;
            }

            if (params.lfor_snail !== undefined) {
                localVarQueryParameter['lfor_snail'] = params.lfor_snail;
            }

            if (params.known !== undefined) {
                localVarQueryParameter['known'] = params.known;
            }

            if (params.knownlevelmin !== undefined) {
                localVarQueryParameter['knownlevelmin'] = params.knownlevelmin;
            }

            if (params.knownlevelmax !== undefined) {
                localVarQueryParameter['knownlevelmax'] = params.knownlevelmax;
            }

            if (params.learn !== undefined) {
                localVarQueryParameter['learn'] = params.learn;
            }

            if (params.learnlevelmin !== undefined) {
                localVarQueryParameter['learnlevelmin'] = params.learnlevelmin;
            }

            if (params.learnlevelmax !== undefined) {
                localVarQueryParameter['learnlevelmax'] = params.learnlevelmax;
            }

            if (params.username !== undefined) {
                localVarQueryParameter['username'] = params.username;
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.online !== undefined) {
                localVarQueryParameter['online'] = params.online;
            }

            if (params.new !== undefined) {
                localVarQueryParameter['new'] = params.new;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.photo !== undefined) {
                localVarQueryParameter['photo'] = params.photo;
            }

            if (params.tag_ids !== undefined) {
                localVarQueryParameter['tag_ids'] = params.tag_ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users by email (for moderation)
         * @param {searchUsersByEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByEmail(params: searchUsersByEmailParams, options?: any): FetchArgs {
            // verify required parameter "params.text" is set
            if (params.text == null) {
                throw new Error("Missing required parameter 'text' when calling searchUsersByEmail");
            }
            const localVarPath = `/search/users-by-email`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.active_only !== undefined) {
                localVarQueryParameter['active_only'] = params.active_only;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users by ip (for moderation)
         * @param {searchUsersByIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByIp(params: searchUsersByIpParams, options?: any): FetchArgs {
            // verify required parameter "params.ip" is set
            if (params.ip == null) {
                throw new Error("Missing required parameter 'ip' when calling searchUsersByIp");
            }
            const localVarPath = `/search/users-by-ip`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.ip !== undefined) {
                localVarQueryParameter['ip'] = params.ip;
            }

            if (params.active_only !== undefined) {
                localVarQueryParameter['active_only'] = params.active_only;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users by username. Separate from searchUsers because it      *  searches across all users including those that do not appear in normal search results.
         * @param {searchUsersByUsernameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByUsername(params: searchUsersByUsernameParams, options?: any): FetchArgs {
            // verify required parameter "params.text" is set
            if (params.text == null) {
                throw new Error("Missing required parameter 'text' when calling searchUsersByUsername");
            }
            const localVarPath = `/search/username`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.text !== undefined) {
                localVarQueryParameter['text'] = params.text;
            }

            if (params.active_only !== undefined) {
                localVarQueryParameter['active_only'] = params.active_only;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Search - functional programming interface
 * @export
 */
export const SearchFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search user friends by their name or username
         * @param {findFriendsByNameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFriendsByName(params: findFriendsByNameParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchFriendResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).findFriendsByName(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Geo item search
         * @param {searchGeoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGeo(params: searchGeoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GeoSearchResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchGeo(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search users
         * @param {searchPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrompt(params: searchPromptParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchPromptResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchPrompt(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search tag object
         * @param {searchTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTag(params: searchTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TagSearchResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Filter user message threads
         * @param {searchThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreads(params: searchThreadsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserThreadsResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchThreads(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search trip travelers
         * @param {searchTripTravelersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTripTravelers(params: searchTripTravelersParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchTripResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchTripTravelers(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search trips
         * @param {searchTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTrips(params: searchTripsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchTripResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchTrips(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search users
         * @param {searchUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(params: searchUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchUserResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search users by email (for moderation)
         * @param {searchUsersByEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByEmail(params: searchUsersByEmailParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UsersResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchUsersByEmail(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search users by ip (for moderation)
         * @param {searchUsersByIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByIp(params: searchUsersByIpParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UsersResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchUsersByIp(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search users by username. Separate from searchUsers because it      *  searches across all users including those that do not appear in normal search results.
         * @param {searchUsersByUsernameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByUsername(params: searchUsersByUsernameParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UsersResponse> {
            const localVarFetchArgs = SearchFetchParamCreator(configuration).searchUsersByUsername(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} name Friend name or username
*/
export type findFriendsByNameParams = {
    name: string,
}

/**
 * @param {'city' | 'region' | 'country'} type Geo item type filter
 * @param {string} [location] Lat,Lon
 * @param {number} [radius] Filter by distance from lat/lon point (in km)
 * @param {string} [text] Search text
 * @param {'population' | 'distance'} [sort] Sort by population desc or distance asc
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [AcceptLanguage] Preferred locales
*/
export type searchGeoParams = {
    type: 'city' | 'region' | 'country',
    location?: string,
    radius?: number,
    text?: string,
    sort?: 'population' | 'distance',
    limit?: number,
    offset?: number,
    AcceptLanguage?: string,
}

/**
 * @param {string} [text] Filter result by text on all fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type searchPromptParams = {
    text?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} [text] Search text
 * @param {string} [cat_id] Category id filter
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [AcceptLanguage] Preferred locales
*/
export type searchTagParams = {
    text?: string,
    cat_id?: string,
    limit?: number,
    offset?: number,
    AcceptLanguage?: string,
}

/**
 * @param {string} text Text to search for
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type searchThreadsParams = {
    text: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} [field] On what field resuls will be sorted
 * @param {'asc' | 'desc'} [order] What type of the sort
 * @param {number} [latitude] latitude (for location search)
 * @param {number} [longitude] longitude (for location search)
 * @param {string} [text] Filter result by text on description
 * @param {string} [city] city
 * @param {string} [country] country
 * @param {string} [country_home] country_home
 * @param {'male' | 'female'} [sex] Filter results by sex
 * @param {string} [arrival_date] arrival_date condition: '>&#x3D;2016-01-01', '>2016-01-01', '2016-01-01'
 * @param {string} [departure_date] departure_date condition: '>&#x3D;2016-01-01', '<2016-01-01', '2016-01-01'
 * @param {boolean} [lfor_email] Filter results by lfor_email
 * @param {boolean} [lfor_meet] Filter results by lfor_meet
 * @param {boolean} [lfor_friend] Filter results by lfor_friend
 * @param {boolean} [lfor_relation] Filter results by lfor_relation
 * @param {boolean} [lfor_snail] Filter results by lfor_snail
*/
export type searchTripTravelersParams = {
    field?: string,
    order?: 'asc' | 'desc',
    latitude?: number,
    longitude?: number,
    text?: string,
    city?: string,
    country?: string,
    country_home?: string,
    sex?: 'male' | 'female',
    arrival_date?: string,
    departure_date?: string,
    lfor_email?: boolean,
    lfor_meet?: boolean,
    lfor_friend?: boolean,
    lfor_relation?: boolean,
    lfor_snail?: boolean,
}

/**
 * @param {string} [field] On what field resuls will be sorted
 * @param {'asc' | 'desc'} [order] What type of the sort
 * @param {number} [latitude] latitude (for location search)
 * @param {number} [longitude] longitude (for location search)
 * @param {string} [text] Filter result by text on description
 * @param {string} [city] city
 * @param {string} [country] country
 * @param {string} [country_home] country_home
 * @param {string} [arrival_date] arrival_date condition: '>&#x3D;2016-01-01', '>2016-01-01', '2016-01-01'
 * @param {string} [departure_date] departure_date condition: '>&#x3D;2016-01-01', '<2016-01-01', '2016-01-01'
*/
export type searchTripsParams = {
    field?: string,
    order?: 'asc' | 'desc',
    latitude?: number,
    longitude?: number,
    text?: string,
    city?: string,
    country?: string,
    country_home?: string,
    arrival_date?: string,
    departure_date?: string,
}

/**
 * @param {'modified' | 'last_login' | 'signup' | 'distance'} [sort] Sort results by
 * @param {'asc' | 'desc'} [order] Direction of sort
 * @param {'male' | 'female'} [sex] Filter results by sex
 * @param {string} [countries] Filter results by current countries (2 char codes, csv)
 * @param {string} [home_countries] Filter results by home country (2 char codes, csv)
 * @param {string} [continents] Filter results by continents (2 char codes, csv)
 * @param {string} [city] Current city id (exact match or specify radius)
 * @param {string} [home_city] Home city id (exact match)
 * @param {string} [location] 'Lat,Lon' or 'self' for user location
 * @param {number} [radius] Radius in km from location, if specified, or city
 * @param {number} [age1] Filter results by minimal age
 * @param {number} [age2] Filter results by maximal age
 * @param {boolean} [lfor_langex] Show users looking for language exchange
 * @param {boolean} [lfor_meet] Show users looking to meet in person
 * @param {boolean} [lfor_friend] Show users looking for friends
 * @param {boolean} [lfor_relation] Show users looking for flirting/relationships
 * @param {boolean} [lfor_snail] Show users looking for postal pen pals
 * @param {string} [known] Filter results by known languages (who known this language(s)), csv
 * @param {number} [knownlevelmin] Minimal language level for known filter (gte)
 * @param {number} [knownlevelmax] Maximal language level for known filter (lte)
 * @param {string} [learn] Filter results by learn languages (who learn this language(s)), csv
 * @param {number} [learnlevelmin] Minimal language level for learn filter (gte)
 * @param {number} [learnlevelmax] Maximal language level for learn filter (lte)
 * @param {string} [username] Filter by username
 * @param {string} [text] Filter result by text on all fields
 * @param {boolean} [online] Filter users by online status
 * @param {boolean} [new] Only return new users (< 24h)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {boolean} [photo] Users with photo only
 * @param {string} [tag_ids] Tag IDs to search for. Comma separated.
*/
export type searchUserParams = {
    sort?: 'modified' | 'last_login' | 'signup' | 'distance',
    order?: 'asc' | 'desc',
    sex?: 'male' | 'female',
    countries?: string,
    home_countries?: string,
    continents?: string,
    city?: string,
    home_city?: string,
    location?: string,
    radius?: number,
    age1?: number,
    age2?: number,
    lfor_langex?: boolean,
    lfor_meet?: boolean,
    lfor_friend?: boolean,
    lfor_relation?: boolean,
    lfor_snail?: boolean,
    known?: string,
    knownlevelmin?: number,
    knownlevelmax?: number,
    learn?: string,
    learnlevelmin?: number,
    learnlevelmax?: number,
    username?: string,
    text?: string,
    online?: boolean,
    new?: boolean,
    limit?: number,
    offset?: number,
    photo?: boolean,
    tag_ids?: string,
}

/**
 * @param {string} text Filter result by email
 * @param {boolean} [active_only] Filter only active users
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type searchUsersByEmailParams = {
    text: string,
    active_only?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} ip Filter result by ip
 * @param {boolean} [active_only] Filter only active users
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type searchUsersByIpParams = {
    ip: string,
    active_only?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} text Filter result by username prefix
 * @param {boolean} [active_only] Filter only active users
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type searchUsersByUsernameParams = {
    text: string,
    active_only?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * Search - factory interface
 * @export
 */
export const SearchFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Search user friends by their name or username
         * @param {findFriendsByNameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFriendsByName(params: findFriendsByNameParams, options?: any) {
            return SearchFp(configuration).findFriendsByName(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Geo item search
         * @param {searchGeoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGeo(params: searchGeoParams, options?: any) {
            return SearchFp(configuration).searchGeo(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search users
         * @param {searchPromptParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrompt(params: searchPromptParams, options?: any) {
            return SearchFp(configuration).searchPrompt(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search tag object
         * @param {searchTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTag(params: searchTagParams, options?: any) {
            return SearchFp(configuration).searchTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Filter user message threads
         * @param {searchThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreads(params: searchThreadsParams, options?: any) {
            return SearchFp(configuration).searchThreads(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search trip travelers
         * @param {searchTripTravelersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTripTravelers(params: searchTripTravelersParams, options?: any) {
            return SearchFp(configuration).searchTripTravelers(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search trips
         * @param {searchTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTrips(params: searchTripsParams, options?: any) {
            return SearchFp(configuration).searchTrips(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search users
         * @param {searchUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(params: searchUserParams, options?: any) {
            return SearchFp(configuration).searchUser(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search users by email (for moderation)
         * @param {searchUsersByEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByEmail(params: searchUsersByEmailParams, options?: any) {
            return SearchFp(configuration).searchUsersByEmail(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search users by ip (for moderation)
         * @param {searchUsersByIpParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByIp(params: searchUsersByIpParams, options?: any) {
            return SearchFp(configuration).searchUsersByIp(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search users by username. Separate from searchUsers because it      *  searches across all users including those that do not appear in normal search results.
         * @param {searchUsersByUsernameParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersByUsername(params: searchUsersByUsernameParams, options?: any) {
            return SearchFp(configuration).searchUsersByUsername(params, options)(fetch, basePath);
        },
    };
};

/**
 * Search - object-oriented interface
 * @export
 * @class Search
 * @extends {BaseAPI}
 */
export class Search extends BaseAPI {
    /**
     * 
     * @summary Search user friends by their name or username
     * @param {findFriendsByNameParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public findFriendsByName(params: findFriendsByNameParams, options?: any) {
        return SearchFp(this.configuration).findFriendsByName(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Geo item search
     * @param {searchGeoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchGeo(params: searchGeoParams, options?: any) {
        return SearchFp(this.configuration).searchGeo(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search users
     * @param {searchPromptParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchPrompt(params: searchPromptParams, options?: any) {
        return SearchFp(this.configuration).searchPrompt(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search tag object
     * @param {searchTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchTag(params: searchTagParams, options?: any) {
        return SearchFp(this.configuration).searchTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Filter user message threads
     * @param {searchThreadsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchThreads(params: searchThreadsParams, options?: any) {
        return SearchFp(this.configuration).searchThreads(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search trip travelers
     * @param {searchTripTravelersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchTripTravelers(params: searchTripTravelersParams, options?: any) {
        return SearchFp(this.configuration).searchTripTravelers(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search trips
     * @param {searchTripsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchTrips(params: searchTripsParams, options?: any) {
        return SearchFp(this.configuration).searchTrips(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search users
     * @param {searchUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchUser(params: searchUserParams, options?: any) {
        return SearchFp(this.configuration).searchUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search users by email (for moderation)
     * @param {searchUsersByEmailParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchUsersByEmail(params: searchUsersByEmailParams, options?: any) {
        return SearchFp(this.configuration).searchUsersByEmail(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search users by ip (for moderation)
     * @param {searchUsersByIpParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchUsersByIp(params: searchUsersByIpParams, options?: any) {
        return SearchFp(this.configuration).searchUsersByIp(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search users by username. Separate from searchUsers because it      *  searches across all users including those that do not appear in normal search results.
     * @param {searchUsersByUsernameParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search
     */
    public searchUsersByUsername(params: searchUsersByUsernameParams, options?: any) {
        return SearchFp(this.configuration).searchUsersByUsername(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Settings - fetch parameter creator
 * @export
 */
export const SettingsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get settings by user $id
         * @param {getSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(params: getSettingsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getSettings");
            }
            const localVarPath = `/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update settings by user $id
         * @param {updateSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(params: updateSettingsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateSettings");
            }
            const localVarPath = `/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.freq_recv !== undefined) {
                localVarFormParams.set('freq_recv', params.freq_recv as any);
            }

            if (params.chatreq_recv !== undefined) {
                localVarFormParams.set('chatreq_recv', params.chatreq_recv as any);
            }

            if (params.msg_recv !== undefined) {
                localVarFormParams.set('msg_recv', params.msg_recv as any);
            }

            if (params.wall_write !== undefined) {
                localVarFormParams.set('wall_write', params.wall_write as any);
            }

            if (params.wall_view !== undefined) {
                localVarFormParams.set('wall_view', params.wall_view as any);
            }

            if (params.friends_view !== undefined) {
                localVarFormParams.set('friends_view', params.friends_view as any);
            }

            if (params.contact_rules_sex !== undefined) {
                localVarFormParams.set('contact_rules_sex', params.contact_rules_sex as any);
            }

            if (params.call_recv !== undefined) {
                localVarFormParams.set('call_recv', params.call_recv as any);
            }

            if (params.contact_rules_min_age !== undefined) {
                localVarFormParams.set('contact_rules_min_age', params.contact_rules_min_age as any);
            }

            if (params.contact_rules_max_age !== undefined) {
                localVarFormParams.set('contact_rules_max_age', params.contact_rules_max_age as any);
            }

            if (params.blocked_continents !== undefined) {
                localVarFormParams.set('blocked_continents', params.blocked_continents as any);
            }

            if (params.blocked_countries !== undefined) {
                localVarFormParams.set('blocked_countries', params.blocked_countries as any);
            }

            if (params.freq_require_contact !== undefined) {
                localVarFormParams.set('freq_require_contact', params.freq_require_contact as any);
            }

            if (params.noindex !== undefined) {
                localVarFormParams.set('noindex', params.noindex as any);
            }

            if (params.allowed_countries !== undefined) {
                localVarFormParams.set('allowed_countries', params.allowed_countries as any);
            }

            if (params.allowed_languages !== undefined) {
                localVarFormParams.set('allowed_languages', params.allowed_languages as any);
            }

            if (params.native_speakers_only !== undefined) {
                localVarFormParams.set('native_speakers_only', params.native_speakers_only as any);
            }

            if (params.lfor_required !== undefined) {
                localVarFormParams.set('lfor_required', params.lfor_required as any);
            }

            if (params.lfor_blocked !== undefined) {
                localVarFormParams.set('lfor_blocked', params.lfor_blocked as any);
            }

            if (params.incognito !== undefined) {
                localVarFormParams.set('incognito', params.incognito as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Settings - functional programming interface
 * @export
 */
export const SettingsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get settings by user $id
         * @param {getSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(params: getSettingsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SettingsEntity> {
            const localVarFetchArgs = SettingsFetchParamCreator(configuration).getSettings(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update settings by user $id
         * @param {updateSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(params: updateSettingsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SettingsEntity> {
            const localVarFetchArgs = SettingsFetchParamCreator(configuration).updateSettings(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the user
*/
export type getSettingsParams = {
    id: string,
}

/**
 * @param {string} id user id
 * @param {boolean} [freq_recv] receive friend requests
 * @param {'public' | 'users' | 'friends' | 'me'} [chatreq_recv] receive chat req from
 * @param {'public' | 'users' | 'friends' | 'me'} [msg_recv] receive messages from
 * @param {'public' | 'users' | 'friends' | 'me'} [wall_write] who can write on wall
 * @param {'public' | 'users' | 'friends' | 'me'} [wall_view] who can view wall
 * @param {'public' | 'users' | 'friends' | 'me'} [friends_view] who can view friends
 * @param {'everyone' | 'male' | 'female'} [contact_rules_sex] who can: everyone, male only, female only
 * @param {'public' | 'friends' | 'none'} [call_recv] receive calls from
 * @param {number} [contact_rules_min_age] who can contact: min
 * @param {number} [contact_rules_max_age] who can contact: max
 * @param {string} [blocked_continents] who can contact: cont list AF,NA,SA,EU,OC,AS
 * @param {string} [blocked_countries] who can contact: country list (RU,GB, etc)
 * @param {boolean} [freq_require_contact] require contact before friend req
 * @param {boolean} [noindex] 1 to exclude from Google search
 * @param {string} [allowed_countries] Whitelisted countries (csv)
 * @param {string} [allowed_languages] Whitelisted languages (csv)
 * @param {boolean} [native_speakers_only] Only allow native speakers of whitelisted languages?
 * @param {string} [lfor_required] Required looking for. CSV of: snail,langex,relation,friend,meet
 * @param {string} [lfor_blocked] Forbidden looking for. CSV of: snail,langex,relation,friend,meet
 * @param {boolean} [incognito] Moderation &amp; Premium only: Hide from view log
*/
export type updateSettingsParams = {
    id: string,
    freq_recv?: boolean,
    chatreq_recv?: 'public' | 'users' | 'friends' | 'me',
    msg_recv?: 'public' | 'users' | 'friends' | 'me',
    wall_write?: 'public' | 'users' | 'friends' | 'me',
    wall_view?: 'public' | 'users' | 'friends' | 'me',
    friends_view?: 'public' | 'users' | 'friends' | 'me',
    contact_rules_sex?: 'everyone' | 'male' | 'female',
    call_recv?: 'public' | 'friends' | 'none',
    contact_rules_min_age?: number,
    contact_rules_max_age?: number,
    blocked_continents?: string,
    blocked_countries?: string,
    freq_require_contact?: boolean,
    noindex?: boolean,
    allowed_countries?: string,
    allowed_languages?: string,
    native_speakers_only?: boolean,
    lfor_required?: string,
    lfor_blocked?: string,
    incognito?: boolean,
}

/**
 * Settings - factory interface
 * @export
 */
export const SettingsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get settings by user $id
         * @param {getSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(params: getSettingsParams, options?: any) {
            return SettingsFp(configuration).getSettings(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update settings by user $id
         * @param {updateSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(params: updateSettingsParams, options?: any) {
            return SettingsFp(configuration).updateSettings(params, options)(fetch, basePath);
        },
    };
};

/**
 * Settings - object-oriented interface
 * @export
 * @class Settings
 * @extends {BaseAPI}
 */
export class Settings extends BaseAPI {
    /**
     * 
     * @summary Get settings by user $id
     * @param {getSettingsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Settings
     */
    public getSettings(params: getSettingsParams, options?: any) {
        return SettingsFp(this.configuration).getSettings(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update settings by user $id
     * @param {updateSettingsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Settings
     */
    public updateSettings(params: updateSettingsParams, options?: any) {
        return SettingsFp(this.configuration).updateSettings(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Tag - fetch parameter creator
 * @export
 */
export const TagFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new user interest tag
         * @param {createTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(params: createTagParams, options?: any): FetchArgs {
            // verify required parameter "params.cat_id" is set
            if (params.cat_id == null) {
                throw new Error("Missing required parameter 'cat_id' when calling createTag");
            }
            // verify required parameter "params.name" is set
            if (params.name == null) {
                throw new Error("Missing required parameter 'name' when calling createTag");
            }
            const localVarPath = `/tag`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.cat_id !== undefined) {
                localVarFormParams.set('cat_id', params.cat_id as any);
            }

            if (params.id !== undefined) {
                localVarFormParams.set('id', params.id as any);
            }

            if (params.name !== undefined) {
                localVarFormParams.set('name', params.name as any);
            }

            if (params.locale !== undefined) {
                localVarFormParams.set('locale', params.locale as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete interest tag by id and locale(s)
         * @param {deleteTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(params: deleteTagParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteTag");
            }
            // verify required parameter "params.locale" is set
            if (params.locale == null) {
                throw new Error("Missing required parameter 'locale' when calling deleteTag");
            }
            const localVarPath = `/tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.locale !== undefined) {
                localVarQueryParameter['locale'] = params.locale;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user interest tag by id
         * @param {getTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(params: getTagParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTag");
            }
            const localVarPath = `/tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.locale !== undefined) {
                localVarQueryParameter['locale'] = params.locale;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Tag - functional programming interface
 * @export
 */
export const TagFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new user interest tag
         * @param {createTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(params: createTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TagEntity> {
            const localVarFetchArgs = TagFetchParamCreator(configuration).createTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete interest tag by id and locale(s)
         * @param {deleteTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(params: deleteTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TagFetchParamCreator(configuration).deleteTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user interest tag by id
         * @param {getTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(params: getTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TagEntity> {
            const localVarFetchArgs = TagFetchParamCreator(configuration).getTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} cat_id Category tag id
 * @param {string} name Tag name
 * @param {string} [id] Tag id of pre-existing en_US tag, used when adding a translation
 * @param {string} [locale] Locale of new tag text, if not en_US then an en_US tag must be created first
*/
export type createTagParams = {
    cat_id: string,
    name: string,
    id?: string,
    locale?: string,
}

/**
 * @param {string} id Tag id
 * @param {string} locale Locale(s) of tag to delete (csv) or '*' for all
*/
export type deleteTagParams = {
    id: string,
    locale: string,
}

/**
 * @param {string} id Id of the tag
 * @param {string} [locale] Locale or comma-separated list of locales
*/
export type getTagParams = {
    id: string,
    locale?: string,
}

/**
 * Tag - factory interface
 * @export
 */
export const TagFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create new user interest tag
         * @param {createTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(params: createTagParams, options?: any) {
            return TagFp(configuration).createTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete interest tag by id and locale(s)
         * @param {deleteTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(params: deleteTagParams, options?: any) {
            return TagFp(configuration).deleteTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user interest tag by id
         * @param {getTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(params: getTagParams, options?: any) {
            return TagFp(configuration).getTag(params, options)(fetch, basePath);
        },
    };
};

/**
 * Tag - object-oriented interface
 * @export
 * @class Tag
 * @extends {BaseAPI}
 */
export class Tag extends BaseAPI {
    /**
     * 
     * @summary Create new user interest tag
     * @param {createTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Tag
     */
    public createTag(params: createTagParams, options?: any) {
        return TagFp(this.configuration).createTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete interest tag by id and locale(s)
     * @param {deleteTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Tag
     */
    public deleteTag(params: deleteTagParams, options?: any) {
        return TagFp(this.configuration).deleteTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user interest tag by id
     * @param {getTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Tag
     */
    public getTag(params: getTagParams, options?: any) {
        return TagFp(this.configuration).getTag(params, options)(this.fetch, this.basePath);
    }

}

/**
 * TagList - fetch parameter creator
 * @export
 */
export const TagListFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tag list info
         * @param {getTagListInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagListInfo(params: getTagListInfoParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTagListInfo");
            }
            const localVarPath = `/tag-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns list of tags by tag list ID
         * @param {getTagsByListIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByListId(params: getTagsByListIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTagsByListId");
            }
            const localVarPath = `/tag-list/{id}/tags`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagList - functional programming interface
 * @export
 */
export const TagListFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tag list info
         * @param {getTagListInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagListInfo(params: getTagListInfoParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TagListFetchParamCreator(configuration).getTagListInfo(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns list of tags by tag list ID
         * @param {getTagsByListIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByListId(params: getTagsByListIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TagsResponse> {
            const localVarFetchArgs = TagListFetchParamCreator(configuration).getTagsByListId(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the tag
*/
export type getTagListInfoParams = {
    id: string,
}

/**
 * @param {string} id List ID (locale)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getTagsByListIdParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * TagList - factory interface
 * @export
 */
export const TagListFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get tag list info
         * @param {getTagListInfoParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagListInfo(params: getTagListInfoParams, options?: any) {
            return TagListFp(configuration).getTagListInfo(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns list of tags by tag list ID
         * @param {getTagsByListIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagsByListId(params: getTagsByListIdParams, options?: any) {
            return TagListFp(configuration).getTagsByListId(params, options)(fetch, basePath);
        },
    };
};

/**
 * TagList - object-oriented interface
 * @export
 * @class TagList
 * @extends {BaseAPI}
 */
export class TagList extends BaseAPI {
    /**
     * 
     * @summary Get tag list info
     * @param {getTagListInfoParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagList
     */
    public getTagListInfo(params: getTagListInfoParams, options?: any) {
        return TagListFp(this.configuration).getTagListInfo(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns list of tags by tag list ID
     * @param {getTagsByListIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagList
     */
    public getTagsByListId(params: getTagsByListIdParams, options?: any) {
        return TagListFp(this.configuration).getTagsByListId(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Test - fetch parameter creator
 * @export
 */
export const TestFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send test socket/push notification
         * @param {testNotifyParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotify(params: testNotifyParams, options?: any): FetchArgs {
            // verify required parameter "params.type" is set
            if (params.type == null) {
                throw new Error("Missing required parameter 'type' when calling testNotify");
            }
            const localVarPath = `/test/notify`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            if (params.username !== undefined) {
                localVarFormParams.set('username', params.username as any);
            }

            if (params.type !== undefined) {
                localVarFormParams.set('type', params.type as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Test - functional programming interface
 * @export
 */
export const TestFp = function(configuration?: Configuration) {
    return {
        /**
         * Send test socket/push notification
         * @param {testNotifyParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotify(params: testNotifyParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TestFetchParamCreator(configuration).testNotify(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'FRIEND_REQUEST_MESSAGE' | 'FRIEND_ACCEPT_MESSAGE' | 'FRIEND_JOINED_INTERPALS' | 'FRIEND_BIRTHDAY' | 'LIKE_PHOTO' | 'LIKE_COMMENT' | 'LIKE_POST' | 'LIKE_ALBUM' | 'LIKE_TRIP' | 'LIKE_ENTRY' | 'COMMENT_PHOTO' | 'COMMENT_POST' | 'COMMENT_ALBUM' | 'COMMENT_TRIP' | 'COMMENT_REPLY' | 'THREAD_NEW_MESSAGE' | 'THREAD_TYPING' | 'THREAD_SYNC_DELETED' | 'THREAD_SYNC_MESSAGE' | 'THREAD_VIEWED' | 'USER_HEARTBEAT' | 'SYNC_TOTAL_COUNTER' | 'FEED_SYNC_MESSAGE' | 'COUNTER_UPDATE' | 'FEED_NEW_POST' | 'PROFILE_VIEW' | 'GROUPED_PROFILE_VIEW'} type 
 * @param {string} [user_id] 
 * @param {string} [username] 
*/
export type testNotifyParams = {
    type: 'FRIEND_REQUEST_MESSAGE' | 'FRIEND_ACCEPT_MESSAGE' | 'FRIEND_JOINED_INTERPALS' | 'FRIEND_BIRTHDAY' | 'LIKE_PHOTO' | 'LIKE_COMMENT' | 'LIKE_POST' | 'LIKE_ALBUM' | 'LIKE_TRIP' | 'LIKE_ENTRY' | 'COMMENT_PHOTO' | 'COMMENT_POST' | 'COMMENT_ALBUM' | 'COMMENT_TRIP' | 'COMMENT_REPLY' | 'THREAD_NEW_MESSAGE' | 'THREAD_TYPING' | 'THREAD_SYNC_DELETED' | 'THREAD_SYNC_MESSAGE' | 'THREAD_VIEWED' | 'USER_HEARTBEAT' | 'SYNC_TOTAL_COUNTER' | 'FEED_SYNC_MESSAGE' | 'COUNTER_UPDATE' | 'FEED_NEW_POST' | 'PROFILE_VIEW' | 'GROUPED_PROFILE_VIEW',
    user_id?: string,
    username?: string,
}

/**
 * Test - factory interface
 * @export
 */
export const TestFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Send test socket/push notification
         * @param {testNotifyParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testNotify(params: testNotifyParams, options?: any) {
            return TestFp(configuration).testNotify(params, options)(fetch, basePath);
        },
    };
};

/**
 * Test - object-oriented interface
 * @export
 * @class Test
 * @extends {BaseAPI}
 */
export class Test extends BaseAPI {
    /**
     * Send test socket/push notification
     * @param {testNotifyParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Test
     */
    public testNotify(params: testNotifyParams, options?: any) {
        return TestFp(this.configuration).testNotify(params, options)(this.fetch, this.basePath);
    }

}

/**
 * TextFilters - fetch parameter creator
 * @export
 */
export const TextFiltersFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTextFilter(params: createTextFilterParams, options?: any): FetchArgs {
            // verify required parameter "params.pattern" is set
            if (params.pattern == null) {
                throw new Error("Missing required parameter 'pattern' when calling createTextFilter");
            }
            // verify required parameter "params.content_type" is set
            if (params.content_type == null) {
                throw new Error("Missing required parameter 'content_type' when calling createTextFilter");
            }
            // verify required parameter "params.rule_type" is set
            if (params.rule_type == null) {
                throw new Error("Missing required parameter 'rule_type' when calling createTextFilter");
            }
            // verify required parameter "params.comment" is set
            if (params.comment == null) {
                throw new Error("Missing required parameter 'comment' when calling createTextFilter");
            }
            const localVarPath = `/text-filters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.pattern !== undefined) {
                localVarFormParams.set('pattern', params.pattern as any);
            }

            if (params.content_type !== undefined) {
                localVarFormParams.set('content_type', params.content_type as any);
            }

            if (params.rule_type !== undefined) {
                localVarFormParams.set('rule_type', params.rule_type as any);
            }

            if (params.comment !== undefined) {
                localVarFormParams.set('comment', params.comment as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {deleteTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextFilter(params: deleteTextFilterParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteTextFilter");
            }
            const localVarPath = `/text-filters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.comment !== undefined) {
                localVarQueryParameter['comment'] = params.comment;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getTextFiltersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextFilters(params: getTextFiltersParams, options?: any): FetchArgs {
            const localVarPath = `/text-filters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextFilters - functional programming interface
 * @export
 */
export const TextFiltersFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {createTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTextFilter(params: createTextFilterParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TextFilterEntity> {
            const localVarFetchArgs = TextFiltersFetchParamCreator(configuration).createTextFilter(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {deleteTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextFilter(params: deleteTextFilterParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TextFiltersFetchParamCreator(configuration).deleteTextFilter(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getTextFiltersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextFilters(params: getTextFiltersParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TextFiltersResponse> {
            const localVarFetchArgs = TextFiltersFetchParamCreator(configuration).getTextFilters(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} pattern Pattern to match against
 * @param {'email' | 'content' | 'initial_msg' | 'msg' | 'profile'} content_type Type of content to filter
 * @param {'regex' | 'similarity'} rule_type 
 * @param {string} comment Log message
*/
export type createTextFilterParams = {
    pattern: string,
    content_type: 'email' | 'content' | 'initial_msg' | 'msg' | 'profile',
    rule_type: 'regex' | 'similarity',
    comment: string,
}

/**
 * @param {string} id Filter id
 * @param {string} [comment] Message to add to log
*/
export type deleteTextFilterParams = {
    id: string,
    comment?: string,
}

/**
 * @param {number} [offset] Offset
 * @param {number} [limit] Limit
*/
export type getTextFiltersParams = {
    offset?: number,
    limit?: number,
}

/**
 * TextFilters - factory interface
 * @export
 */
export const TextFiltersFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {createTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTextFilter(params: createTextFilterParams, options?: any) {
            return TextFiltersFp(configuration).createTextFilter(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {deleteTextFilterParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextFilter(params: deleteTextFilterParams, options?: any) {
            return TextFiltersFp(configuration).deleteTextFilter(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getTextFiltersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextFilters(params: getTextFiltersParams, options?: any) {
            return TextFiltersFp(configuration).getTextFilters(params, options)(fetch, basePath);
        },
    };
};

/**
 * TextFilters - object-oriented interface
 * @export
 * @class TextFilters
 * @extends {BaseAPI}
 */
export class TextFilters extends BaseAPI {
    /**
     * 
     * @param {createTextFilterParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextFilters
     */
    public createTextFilter(params: createTextFilterParams, options?: any) {
        return TextFiltersFp(this.configuration).createTextFilter(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {deleteTextFilterParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextFilters
     */
    public deleteTextFilter(params: deleteTextFilterParams, options?: any) {
        return TextFiltersFp(this.configuration).deleteTextFilter(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getTextFiltersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextFilters
     */
    public getTextFilters(params: getTextFiltersParams, options?: any) {
        return TextFiltersFp(this.configuration).getTextFilters(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Thread - fetch parameter creator
 * @export
 */
export const ThreadFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create thread. Deprecated, use createMessage instead
         * @param {createThreadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThread(params: createThreadParams, options?: any): FetchArgs {
            // verify required parameter "params.target_id" is set
            if (params.target_id == null) {
                throw new Error("Missing required parameter 'target_id' when calling createThread");
            }
            const localVarPath = `/thread`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.target_id !== undefined) {
                localVarFormParams.set('target_id', params.target_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete thread by $id
         * @param {deleteThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThreadById(params: deleteThreadByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteThreadById");
            }
            const localVarPath = `/thread/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find thread by id
         * @param {getThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadById(params: getThreadByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getThreadById");
            }
            const localVarPath = `/thread/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find thread messages by thread id
         * @param {getThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadMessagesById(params: getThreadMessagesByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getThreadMessagesById");
            }
            const localVarPath = `/thread/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark thread as viewed
         * @param {markThreadViewedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadViewed(params: markThreadViewedParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling markThreadViewed");
            }
            // verify required parameter "params.message_id" is set
            if (params.message_id == null) {
                throw new Error("Missing required parameter 'message_id' when calling markThreadViewed");
            }
            const localVarPath = `/thread/{id}/viewed`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.message_id !== undefined) {
                localVarFormParams.set('message_id', params.message_id as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find thread by id
         * @param {modGetThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadById(params: modGetThreadByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling modGetThreadById");
            }
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling modGetThreadById");
            }
            const localVarPath = `/mod-thread/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarQueryParameter['user_id'] = params.user_id;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find thread's messages by id
         * @param {modGetThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadMessagesById(params: modGetThreadMessagesByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling modGetThreadMessagesById");
            }
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling modGetThreadMessagesById");
            }
            const localVarPath = `/mod-thread/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarQueryParameter['user_id'] = params.user_id;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restore all messages in thread
         * @param {restoreThreadMessagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadMessages(params: restoreThreadMessagesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling restoreThreadMessages");
            }
            const localVarPath = `/thread/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save message draft for thread
         * @param {setThreadDraftParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setThreadDraft(params: setThreadDraftParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling setThreadDraft");
            }
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling setThreadDraft");
            }
            const localVarPath = `/thread/{id}/draft`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send typing to thread
         * @param {threadTypingParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadTyping(params: threadTypingParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling threadTyping");
            }
            const localVarPath = `/thread/{id}/typing`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.delay !== undefined) {
                localVarFormParams.set('delay', params.delay as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Thread - functional programming interface
 * @export
 */
export const ThreadFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create thread. Deprecated, use createMessage instead
         * @param {createThreadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThread(params: createThreadParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadEntity> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).createThread(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete thread by $id
         * @param {deleteThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThreadById(params: deleteThreadByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).deleteThreadById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find thread by id
         * @param {getThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadById(params: getThreadByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadEntity> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).getThreadById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find thread messages by thread id
         * @param {getThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadMessagesById(params: getThreadMessagesByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadMessagesResponse> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).getThreadMessagesById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Mark thread as viewed
         * @param {markThreadViewedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadViewed(params: markThreadViewedParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).markThreadViewed(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find thread by id
         * @param {modGetThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadById(params: modGetThreadByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadEntity> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).modGetThreadById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find thread's messages by id
         * @param {modGetThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadMessagesById(params: modGetThreadMessagesByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadMessagesResponse> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).modGetThreadMessagesById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Restore all messages in thread
         * @param {restoreThreadMessagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadMessages(params: restoreThreadMessagesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadRestoreResponse> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).restoreThreadMessages(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Save message draft for thread
         * @param {setThreadDraftParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setThreadDraft(params: setThreadDraftParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MessageDraftEntity> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).setThreadDraft(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Send typing to thread
         * @param {threadTypingParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadTyping(params: threadTypingParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ThreadFetchParamCreator(configuration).threadTyping(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} target_id Target user id
*/
export type createThreadParams = {
    target_id: string,
}

/**
 * @param {string} id Id of the thread
*/
export type deleteThreadByIdParams = {
    id: string,
}

/**
 * @param {string} id Thread id
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type getThreadByIdParams = {
    id: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Thread id
 * @param {number} [limit] Limit
 * @param {string} [offset] Offset of the page, as last message id!
*/
export type getThreadMessagesByIdParams = {
    id: string,
    limit?: number,
    offset?: string,
}

/**
 * @param {string} id thread id
 * @param {string} message_id Message ID from sender last message
*/
export type markThreadViewedParams = {
    id: string,
    message_id: string,
}

/**
 * @param {string} id Thread id
 * @param {string} user_id User id
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type modGetThreadByIdParams = {
    id: string,
    user_id: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Thread id
 * @param {string} user_id Thread owner id
 * @param {number} [limit] Limit
 * @param {string} [offset] Offset of the page as last message id!
*/
export type modGetThreadMessagesByIdParams = {
    id: string,
    user_id: string,
    limit?: number,
    offset?: string,
}

/**
 * @param {string} id Thread ID
 * @param {number} [limit] Limit
*/
export type restoreThreadMessagesParams = {
    id: string,
    limit?: number,
}

/**
 * @param {string} id thread id
 * @param {string} message Draft message
*/
export type setThreadDraftParams = {
    id: string,
    message: string,
}

/**
 * @param {string} id $id of the specified
 * @param {number} [delay] Delay for typing timer before stop typing
*/
export type threadTypingParams = {
    id: string,
    delay?: number,
}

/**
 * Thread - factory interface
 * @export
 */
export const ThreadFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create thread. Deprecated, use createMessage instead
         * @param {createThreadParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThread(params: createThreadParams, options?: any) {
            return ThreadFp(configuration).createThread(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete thread by $id
         * @param {deleteThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThreadById(params: deleteThreadByIdParams, options?: any) {
            return ThreadFp(configuration).deleteThreadById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find thread by id
         * @param {getThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadById(params: getThreadByIdParams, options?: any) {
            return ThreadFp(configuration).getThreadById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find thread messages by thread id
         * @param {getThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadMessagesById(params: getThreadMessagesByIdParams, options?: any) {
            return ThreadFp(configuration).getThreadMessagesById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Mark thread as viewed
         * @param {markThreadViewedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadViewed(params: markThreadViewedParams, options?: any) {
            return ThreadFp(configuration).markThreadViewed(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find thread by id
         * @param {modGetThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadById(params: modGetThreadByIdParams, options?: any) {
            return ThreadFp(configuration).modGetThreadById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find thread's messages by id
         * @param {modGetThreadMessagesByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreadMessagesById(params: modGetThreadMessagesByIdParams, options?: any) {
            return ThreadFp(configuration).modGetThreadMessagesById(params, options)(fetch, basePath);
        },
        /**
         * Restore all messages in thread
         * @param {restoreThreadMessagesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreThreadMessages(params: restoreThreadMessagesParams, options?: any) {
            return ThreadFp(configuration).restoreThreadMessages(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Save message draft for thread
         * @param {setThreadDraftParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setThreadDraft(params: setThreadDraftParams, options?: any) {
            return ThreadFp(configuration).setThreadDraft(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Send typing to thread
         * @param {threadTypingParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadTyping(params: threadTypingParams, options?: any) {
            return ThreadFp(configuration).threadTyping(params, options)(fetch, basePath);
        },
    };
};

/**
 * Thread - object-oriented interface
 * @export
 * @class Thread
 * @extends {BaseAPI}
 */
export class Thread extends BaseAPI {
    /**
     * 
     * @summary Create thread. Deprecated, use createMessage instead
     * @param {createThreadParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public createThread(params: createThreadParams, options?: any) {
        return ThreadFp(this.configuration).createThread(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete thread by $id
     * @param {deleteThreadByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public deleteThreadById(params: deleteThreadByIdParams, options?: any) {
        return ThreadFp(this.configuration).deleteThreadById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find thread by id
     * @param {getThreadByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public getThreadById(params: getThreadByIdParams, options?: any) {
        return ThreadFp(this.configuration).getThreadById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find thread messages by thread id
     * @param {getThreadMessagesByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public getThreadMessagesById(params: getThreadMessagesByIdParams, options?: any) {
        return ThreadFp(this.configuration).getThreadMessagesById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Mark thread as viewed
     * @param {markThreadViewedParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public markThreadViewed(params: markThreadViewedParams, options?: any) {
        return ThreadFp(this.configuration).markThreadViewed(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find thread by id
     * @param {modGetThreadByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public modGetThreadById(params: modGetThreadByIdParams, options?: any) {
        return ThreadFp(this.configuration).modGetThreadById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find thread's messages by id
     * @param {modGetThreadMessagesByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public modGetThreadMessagesById(params: modGetThreadMessagesByIdParams, options?: any) {
        return ThreadFp(this.configuration).modGetThreadMessagesById(params, options)(this.fetch, this.basePath);
    }

    /**
     * Restore all messages in thread
     * @param {restoreThreadMessagesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public restoreThreadMessages(params: restoreThreadMessagesParams, options?: any) {
        return ThreadFp(this.configuration).restoreThreadMessages(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Save message draft for thread
     * @param {setThreadDraftParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public setThreadDraft(params: setThreadDraftParams, options?: any) {
        return ThreadFp(this.configuration).setThreadDraft(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Send typing to thread
     * @param {threadTypingParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Thread
     */
    public threadTyping(params: threadTypingParams, options?: any) {
        return ThreadFp(this.configuration).threadTyping(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Token - fetch parameter creator
 * @export
 */
export const TokenFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get login token by username/email and password
         * @param {createTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(params: createTokenParams, options?: any): FetchArgs {
            // verify required parameter "params.username" is set
            if (params.username == null) {
                throw new Error("Missing required parameter 'username' when calling createToken");
            }
            // verify required parameter "params.password" is set
            if (params.password == null) {
                throw new Error("Missing required parameter 'password' when calling createToken");
            }
            const localVarPath = `/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.username !== undefined) {
                localVarFormParams.set('username', params.username as any);
            }

            if (params.password !== undefined) {
                localVarFormParams.set('password', params.password as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete token to log out user
         * @param {deleteTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToken(params: deleteTokenParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteToken");
            }
            const localVarPath = `/token/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Token - functional programming interface
 * @export
 */
export const TokenFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get login token by username/email and password
         * @param {createTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(params: createTokenParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TokenEntity> {
            const localVarFetchArgs = TokenFetchParamCreator(configuration).createToken(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete token to log out user
         * @param {deleteTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToken(params: deleteTokenParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TokenFetchParamCreator(configuration).deleteToken(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} username Username Or Email
 * @param {string} password Plain Password
*/
export type createTokenParams = {
    username: string,
    password: string,
}

/**
 * @param {string} id Token
*/
export type deleteTokenParams = {
    id: string,
}

/**
 * Token - factory interface
 * @export
 */
export const TokenFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get login token by username/email and password
         * @param {createTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(params: createTokenParams, options?: any) {
            return TokenFp(configuration).createToken(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete token to log out user
         * @param {deleteTokenParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToken(params: deleteTokenParams, options?: any) {
            return TokenFp(configuration).deleteToken(params, options)(fetch, basePath);
        },
    };
};

/**
 * Token - object-oriented interface
 * @export
 * @class Token
 * @extends {BaseAPI}
 */
export class Token extends BaseAPI {
    /**
     * 
     * @summary Get login token by username/email and password
     * @param {createTokenParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Token
     */
    public createToken(params: createTokenParams, options?: any) {
        return TokenFp(this.configuration).createToken(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete token to log out user
     * @param {deleteTokenParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Token
     */
    public deleteToken(params: deleteTokenParams, options?: any) {
        return TokenFp(this.configuration).deleteToken(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Total - fetch parameter creator
 * @export
 */
export const TotalFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get total number of user friends
         * @param {getTotalNumberOfUserFriendsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserFriends(params: getTotalNumberOfUserFriendsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTotalNumberOfUserFriends");
            }
            const localVarPath = `/total/{id}/friends`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get total number of user groups
         * @param {getTotalNumberOfUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserGroups(params: getTotalNumberOfUserGroupsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTotalNumberOfUserGroups");
            }
            const localVarPath = `/total/{id}/groups`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get total number of user photos
         * @param {getTotalNumberOfUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserPhotos(params: getTotalNumberOfUserPhotosParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTotalNumberOfUserPhotos");
            }
            const localVarPath = `/total/{id}/photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get total number of user trips
         * @param {getTotalNumberOfUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserTrips(params: getTotalNumberOfUserTripsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTotalNumberOfUserTrips");
            }
            const localVarPath = `/total/{id}/trips`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get size of user blocked list
         * @param {getUserBlockedCountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBlockedCount(params: getUserBlockedCountParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserBlockedCount");
            }
            const localVarPath = `/total/{id}/blocked`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Total - functional programming interface
 * @export
 */
export const TotalFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get total number of user friends
         * @param {getTotalNumberOfUserFriendsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserFriends(params: getTotalNumberOfUserFriendsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = TotalFetchParamCreator(configuration).getTotalNumberOfUserFriends(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get total number of user groups
         * @param {getTotalNumberOfUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserGroups(params: getTotalNumberOfUserGroupsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = TotalFetchParamCreator(configuration).getTotalNumberOfUserGroups(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get total number of user photos
         * @param {getTotalNumberOfUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserPhotos(params: getTotalNumberOfUserPhotosParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = TotalFetchParamCreator(configuration).getTotalNumberOfUserPhotos(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get total number of user trips
         * @param {getTotalNumberOfUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserTrips(params: getTotalNumberOfUserTripsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = TotalFetchParamCreator(configuration).getTotalNumberOfUserTrips(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get size of user blocked list
         * @param {getUserBlockedCountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBlockedCount(params: getUserBlockedCountParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = TotalFetchParamCreator(configuration).getUserBlockedCount(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User id
*/
export type getTotalNumberOfUserFriendsParams = {
    id: string,
}

/**
 * @param {string} id User id
*/
export type getTotalNumberOfUserGroupsParams = {
    id: string,
}

/**
 * @param {string} id User id
*/
export type getTotalNumberOfUserPhotosParams = {
    id: string,
}

/**
 * @param {string} id User id
*/
export type getTotalNumberOfUserTripsParams = {
    id: string,
}

/**
 * @param {string} id User id
*/
export type getUserBlockedCountParams = {
    id: string,
}

/**
 * Total - factory interface
 * @export
 */
export const TotalFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get total number of user friends
         * @param {getTotalNumberOfUserFriendsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserFriends(params: getTotalNumberOfUserFriendsParams, options?: any) {
            return TotalFp(configuration).getTotalNumberOfUserFriends(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get total number of user groups
         * @param {getTotalNumberOfUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserGroups(params: getTotalNumberOfUserGroupsParams, options?: any) {
            return TotalFp(configuration).getTotalNumberOfUserGroups(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get total number of user photos
         * @param {getTotalNumberOfUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserPhotos(params: getTotalNumberOfUserPhotosParams, options?: any) {
            return TotalFp(configuration).getTotalNumberOfUserPhotos(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get total number of user trips
         * @param {getTotalNumberOfUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalNumberOfUserTrips(params: getTotalNumberOfUserTripsParams, options?: any) {
            return TotalFp(configuration).getTotalNumberOfUserTrips(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get size of user blocked list
         * @param {getUserBlockedCountParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBlockedCount(params: getUserBlockedCountParams, options?: any) {
            return TotalFp(configuration).getUserBlockedCount(params, options)(fetch, basePath);
        },
    };
};

/**
 * Total - object-oriented interface
 * @export
 * @class Total
 * @extends {BaseAPI}
 */
export class Total extends BaseAPI {
    /**
     * 
     * @summary Get total number of user friends
     * @param {getTotalNumberOfUserFriendsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Total
     */
    public getTotalNumberOfUserFriends(params: getTotalNumberOfUserFriendsParams, options?: any) {
        return TotalFp(this.configuration).getTotalNumberOfUserFriends(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get total number of user groups
     * @param {getTotalNumberOfUserGroupsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Total
     */
    public getTotalNumberOfUserGroups(params: getTotalNumberOfUserGroupsParams, options?: any) {
        return TotalFp(this.configuration).getTotalNumberOfUserGroups(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get total number of user photos
     * @param {getTotalNumberOfUserPhotosParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Total
     */
    public getTotalNumberOfUserPhotos(params: getTotalNumberOfUserPhotosParams, options?: any) {
        return TotalFp(this.configuration).getTotalNumberOfUserPhotos(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get total number of user trips
     * @param {getTotalNumberOfUserTripsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Total
     */
    public getTotalNumberOfUserTrips(params: getTotalNumberOfUserTripsParams, options?: any) {
        return TotalFp(this.configuration).getTotalNumberOfUserTrips(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get size of user blocked list
     * @param {getUserBlockedCountParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Total
     */
    public getUserBlockedCount(params: getUserBlockedCountParams, options?: any) {
        return TotalFp(this.configuration).getUserBlockedCount(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Trip - fetch parameter creator
 * @export
 */
export const TripFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete trip by $id
         * @param {deleteTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(params: deleteTripParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteTrip");
            }
            const localVarPath = `/trip/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip by id
         * @param {getTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrip(params: getTripParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTrip");
            }
            const localVarPath = `/trip/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip comments
         * @param {getTripCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripComments(params: getTripCommentsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTripComments");
            }
            const localVarPath = `/trip/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.nest_replies !== undefined) {
                localVarQueryParameter['nest_replies'] = params.nest_replies;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip likes
         * @param {getTripLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripLikes(params: getTripLikesParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTripLikes");
            }
            const localVarPath = `/trip/{id}/likes`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user by $id
         * @param {updateTripByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripById(params: updateTripByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateTripById");
            }
            const localVarPath = `/trip/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.start_date !== undefined) {
                localVarFormParams.set('start_date', params.start_date as any);
            }

            if (params.end_date !== undefined) {
                localVarFormParams.set('end_date', params.end_date as any);
            }

            if (params.latitude !== undefined) {
                localVarFormParams.set('latitude', params.latitude as any);
            }

            if (params.longitude !== undefined) {
                localVarFormParams.set('longitude', params.longitude as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.country_code !== undefined) {
                localVarFormParams.set('country_code', params.country_code as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trip - functional programming interface
 * @export
 */
export const TripFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete trip by $id
         * @param {deleteTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(params: deleteTripParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TripFetchParamCreator(configuration).deleteTrip(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get trip by id
         * @param {getTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrip(params: getTripParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TripEntity> {
            const localVarFetchArgs = TripFetchParamCreator(configuration).getTrip(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get trip comments
         * @param {getTripCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripComments(params: getTripCommentsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CommentListResponse> {
            const localVarFetchArgs = TripFetchParamCreator(configuration).getTripComments(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get trip likes
         * @param {getTripLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripLikes(params: getTripLikesParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LikeListResponse> {
            const localVarFetchArgs = TripFetchParamCreator(configuration).getTripLikes(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update user by $id
         * @param {updateTripByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripById(params: updateTripByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TripEntity> {
            const localVarFetchArgs = TripFetchParamCreator(configuration).updateTripById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the trip
*/
export type deleteTripParams = {
    id: string,
}

/**
 * @param {string} id Trip id
*/
export type getTripParams = {
    id: string,
}

/**
 * @param {string} id Trip id
 * @param {boolean} [nest_replies] Nest replies for comments that have them up to limit (applies to sum of comments + replies)
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getTripCommentsParams = {
    id: string,
    nest_replies?: boolean,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Trip id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getTripLikesParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id $id of the specified trip
 * @param {string} [start_date] Trip start date
 * @param {string} [end_date] Trip end date
 * @param {number} [latitude] latitude
 * @param {number} [longitude] longitude
 * @param {string} [city_id] City id
 * @param {number} [view_acl] acl
 * @param {string} [description] description
 * @param {string} [country_code] country code
*/
export type updateTripByIdParams = {
    id: string,
    start_date?: string,
    end_date?: string,
    latitude?: number,
    longitude?: number,
    city_id?: string,
    view_acl?: number,
    description?: string,
    country_code?: string,
}

/**
 * Trip - factory interface
 * @export
 */
export const TripFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Delete trip by $id
         * @param {deleteTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(params: deleteTripParams, options?: any) {
            return TripFp(configuration).deleteTrip(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get trip by id
         * @param {getTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrip(params: getTripParams, options?: any) {
            return TripFp(configuration).getTrip(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get trip comments
         * @param {getTripCommentsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripComments(params: getTripCommentsParams, options?: any) {
            return TripFp(configuration).getTripComments(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get trip likes
         * @param {getTripLikesParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripLikes(params: getTripLikesParams, options?: any) {
            return TripFp(configuration).getTripLikes(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update user by $id
         * @param {updateTripByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripById(params: updateTripByIdParams, options?: any) {
            return TripFp(configuration).updateTripById(params, options)(fetch, basePath);
        },
    };
};

/**
 * Trip - object-oriented interface
 * @export
 * @class Trip
 * @extends {BaseAPI}
 */
export class Trip extends BaseAPI {
    /**
     * 
     * @summary Delete trip by $id
     * @param {deleteTripParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trip
     */
    public deleteTrip(params: deleteTripParams, options?: any) {
        return TripFp(this.configuration).deleteTrip(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get trip by id
     * @param {getTripParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trip
     */
    public getTrip(params: getTripParams, options?: any) {
        return TripFp(this.configuration).getTrip(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get trip comments
     * @param {getTripCommentsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trip
     */
    public getTripComments(params: getTripCommentsParams, options?: any) {
        return TripFp(this.configuration).getTripComments(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get trip likes
     * @param {getTripLikesParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trip
     */
    public getTripLikes(params: getTripLikesParams, options?: any) {
        return TripFp(this.configuration).getTripLikes(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update user by $id
     * @param {updateTripByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trip
     */
    public updateTripById(params: updateTripByIdParams, options?: any) {
        return TripFp(this.configuration).updateTripById(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Trips - fetch parameter creator
 * @export
 */
export const TripsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create trip
         * @param {createTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(params: createTripParams, options?: any): FetchArgs {
            // verify required parameter "params.start_date" is set
            if (params.start_date == null) {
                throw new Error("Missing required parameter 'start_date' when calling createTrip");
            }
            // verify required parameter "params.end_date" is set
            if (params.end_date == null) {
                throw new Error("Missing required parameter 'end_date' when calling createTrip");
            }
            // verify required parameter "params.city_id" is set
            if (params.city_id == null) {
                throw new Error("Missing required parameter 'city_id' when calling createTrip");
            }
            const localVarPath = `/trip`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.start_date !== undefined) {
                localVarFormParams.set('start_date', params.start_date as any);
            }

            if (params.end_date !== undefined) {
                localVarFormParams.set('end_date', params.end_date as any);
            }

            if (params.city_id !== undefined) {
                localVarFormParams.set('city_id', params.city_id as any);
            }

            if (params.view_acl !== undefined) {
                localVarFormParams.set('view_acl', params.view_acl as any);
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trips - functional programming interface
 * @export
 */
export const TripsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create trip
         * @param {createTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(params: createTripParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TripEntity> {
            const localVarFetchArgs = TripsFetchParamCreator(configuration).createTrip(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} start_date Trip start date
 * @param {string} end_date Trip end date
 * @param {string} city_id Destination city id
 * @param {'users' | 'friends' | 'me'} [view_acl] acl
 * @param {string} [description] description
*/
export type createTripParams = {
    start_date: string,
    end_date: string,
    city_id: string,
    view_acl?: 'users' | 'friends' | 'me',
    description?: string,
}

/**
 * Trips - factory interface
 * @export
 */
export const TripsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create trip
         * @param {createTripParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(params: createTripParams, options?: any) {
            return TripsFp(configuration).createTrip(params, options)(fetch, basePath);
        },
    };
};

/**
 * Trips - object-oriented interface
 * @export
 * @class Trips
 * @extends {BaseAPI}
 */
export class Trips extends BaseAPI {
    /**
     * 
     * @summary Create trip
     * @param {createTripParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trips
     */
    public createTrip(params: createTripParams, options?: any) {
        return TripsFp(this.configuration).createTrip(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Unsubscribe - fetch parameter creator
 * @export
 */
export const UnsubscribeFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resubscribe by email
         * @param {resubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmail(params: resubscribeEmailParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resubscribeEmail");
            }
            // verify required parameter "params.code" is set
            if (params.code == null) {
                throw new Error("Missing required parameter 'code' when calling resubscribeEmail");
            }
            const localVarPath = `/unsubscribe/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.code !== undefined) {
                localVarQueryParameter['code'] = params.code;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email verification with code to confirm resubscription request
         * @param {resubscribeEmailRequestParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmailRequest(params: resubscribeEmailRequestParams, options?: any): FetchArgs {
            // verify required parameter "params.email" is set
            if (params.email == null) {
                throw new Error("Missing required parameter 'email' when calling resubscribeEmailRequest");
            }
            const localVarPath = `/unsubscribe/resubscribe-request`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add email to unsubscribe list (do-not-contact)
         * @param {unsubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(params: unsubscribeEmailParams, options?: any): FetchArgs {
            // verify required parameter "params.email" is set
            if (params.email == null) {
                throw new Error("Missing required parameter 'email' when calling unsubscribeEmail");
            }
            // verify required parameter "params.code" is set
            if (params.code == null) {
                throw new Error("Missing required parameter 'code' when calling unsubscribeEmail");
            }
            const localVarPath = `/unsubscribe`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (params.email !== undefined) {
                localVarFormParams.set('email', params.email as any);
            }

            if (params.code !== undefined) {
                localVarFormParams.set('code', params.code as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Unsubscribe - functional programming interface
 * @export
 */
export const UnsubscribeFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resubscribe by email
         * @param {resubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmail(params: resubscribeEmailParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UnsubscribeFetchParamCreator(configuration).resubscribeEmail(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Send email verification with code to confirm resubscription request
         * @param {resubscribeEmailRequestParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmailRequest(params: resubscribeEmailRequestParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UnsubscribeFetchParamCreator(configuration).resubscribeEmailRequest(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Add email to unsubscribe list (do-not-contact)
         * @param {unsubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(params: unsubscribeEmailParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UnsubscribeFetchParamCreator(configuration).unsubscribeEmail(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Email address to resubscribe
 * @param {string} code code
*/
export type resubscribeEmailParams = {
    id: string,
    code: string,
}

/**
 * @param {string} email email
*/
export type resubscribeEmailRequestParams = {
    email: string,
}

/**
 * @param {string} email email
 * @param {string} code unsubscribe code
*/
export type unsubscribeEmailParams = {
    email: string,
    code: string,
}

/**
 * Unsubscribe - factory interface
 * @export
 */
export const UnsubscribeFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Resubscribe by email
         * @param {resubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmail(params: resubscribeEmailParams, options?: any) {
            return UnsubscribeFp(configuration).resubscribeEmail(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Send email verification with code to confirm resubscription request
         * @param {resubscribeEmailRequestParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeEmailRequest(params: resubscribeEmailRequestParams, options?: any) {
            return UnsubscribeFp(configuration).resubscribeEmailRequest(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Add email to unsubscribe list (do-not-contact)
         * @param {unsubscribeEmailParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeEmail(params: unsubscribeEmailParams, options?: any) {
            return UnsubscribeFp(configuration).unsubscribeEmail(params, options)(fetch, basePath);
        },
    };
};

/**
 * Unsubscribe - object-oriented interface
 * @export
 * @class Unsubscribe
 * @extends {BaseAPI}
 */
export class Unsubscribe extends BaseAPI {
    /**
     * 
     * @summary Resubscribe by email
     * @param {resubscribeEmailParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Unsubscribe
     */
    public resubscribeEmail(params: resubscribeEmailParams, options?: any) {
        return UnsubscribeFp(this.configuration).resubscribeEmail(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Send email verification with code to confirm resubscription request
     * @param {resubscribeEmailRequestParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Unsubscribe
     */
    public resubscribeEmailRequest(params: resubscribeEmailRequestParams, options?: any) {
        return UnsubscribeFp(this.configuration).resubscribeEmailRequest(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Add email to unsubscribe list (do-not-contact)
     * @param {unsubscribeEmailParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Unsubscribe
     */
    public unsubscribeEmail(params: unsubscribeEmailParams, options?: any) {
        return UnsubscribeFp(this.configuration).unsubscribeEmail(params, options)(this.fetch, this.basePath);
    }

}

/**
 * User - fetch parameter creator
 * @export
 */
export const UserFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get corrections for user
         * @param {getCorrectionsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrectionsUser(params: getCorrectionsUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getCorrectionsUser");
            }
            const localVarPath = `/user/{id}/corrections`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            if (params.order !== undefined) {
                localVarFormParams.set('order', params.order as any);
            }

            if (params.sort !== undefined) {
                localVarFormParams.set('sort', params.sort as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get entries
         * @param {getEntriesUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesUser(params: getEntriesUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getEntriesUser");
            }
            const localVarPath = `/user/{id}/entries`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            if (params.order !== undefined) {
                localVarFormParams.set('order', params.order as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptsUser(params: getPromptsUserParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getPromptsUser");
            }
            const localVarPath = `/user/{id}/prompts`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarFormParams.set('limit', params.limit as any);
            }

            if (params.offset !== undefined) {
                localVarFormParams.set('offset', params.offset as any);
            }

            if (params.order !== undefined) {
                localVarFormParams.set('order', params.order as any);
            }

            if (params.sort !== undefined) {
                localVarFormParams.set('sort', params.sort as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get relation
         * @param {getRelationByTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationByType(params: getRelationByTypeParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getRelationByType");
            }
            // verify required parameter "params.type" is set
            if (params.type == null) {
                throw new Error("Missing required parameter 'type' when calling getRelationByType");
            }
            const localVarPath = `/user/{id}/relations`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.type !== undefined) {
                localVarQueryParameter['type'] = params.type;
            }

            if (params.sort !== undefined) {
                localVarQueryParameter['sort'] = params.sort;
            }

            if (params.filter !== undefined) {
                localVarQueryParameter['filter'] = params.filter;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user friends from external social networks (for linked accounts)
         * @param {getSocialFriendsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialFriendsById(params: getSocialFriendsByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getSocialFriendsById");
            }
            const localVarPath = `/user/{id}/social-friends`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns random popular groups that user is not a member of
         * @param {getSuggestedGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedGroups(params: getSuggestedGroupsParams, options?: any): FetchArgs {
            const localVarPath = `/user/self/suggested-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user threads
         * @param {getThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreads(params: getThreadsParams, options?: any): FetchArgs {
            const localVarPath = `/user/self/threads`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.with_new_messages !== undefined) {
                localVarQueryParameter['with_new_messages'] = params.with_new_messages;
            }

            if (params.online !== undefined) {
                localVarQueryParameter['online'] = params.online;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user albums by user $id
         * @param {getUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAlbums(params: getUserAlbumsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserAlbums");
            }
            const localVarPath = `/user/{id}/albums`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user bookmarks by user $id
         * @param {getUserBookmarksParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBookmarks(params: getUserBookmarksParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserBookmarks");
            }
            const localVarPath = `/user/{id}/bookmarks`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user by id or username
         * @param {getUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(params: getUserByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserById");
            }
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get friends list of the user with sorted by birthdays [Deprecated - use getRelationsByType instead]
         * @param {getUserFriendsBirthdayParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFriendsBirthday(params: getUserFriendsBirthdayParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserFriendsBirthday");
            }
            const localVarPath = `/user/{id}/friends-birthday`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {getUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(params: getUserGroupsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserGroups");
            }
            const localVarPath = `/user/{id}/groups`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all user photos (privacy-permitting)
         * @param {getUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPhotos(params: getUserPhotosParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserPhotos");
            }
            const localVarPath = `/user/{id}/photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.fields !== undefined) {
                localVarQueryParameter['fields'] = params.fields;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user reports submitted by this user (not reports about them)
         * @param {getUserReportsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsById(params: getUserReportsByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserReportsById");
            }
            const localVarPath = `/user/{id}/reports`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user tag
         * @param {getUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTag(params: getUserTagParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserTag");
            }
            const localVarPath = `/user/{id}/tags`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user trips by user $id
         * @param {getUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrips(params: getUserTripsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserTrips");
            }
            const localVarPath = `/user/{id}/trips`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.type !== undefined) {
                localVarQueryParameter['type'] = params.type;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find user threads
         * @param {modGetThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreads(params: modGetThreadsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling modGetThreads");
            }
            const localVarPath = `/mod-messaging-user/{id}/threads`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.with_new_messages !== undefined) {
                localVarQueryParameter['with_new_messages'] = params.with_new_messages;
            }

            if (params.online !== undefined) {
                localVarQueryParameter['online'] = params.online;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * User - functional programming interface
 * @export
 */
export const UserFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get corrections for user
         * @param {getCorrectionsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrectionsUser(params: getCorrectionsUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EntryCorrectionListResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getCorrectionsUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get entries
         * @param {getEntriesUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesUser(params: getEntriesUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguageEntryListResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getEntriesUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptsUser(params: getPromptsUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PromptListResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getPromptsUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get relation
         * @param {getRelationByTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationByType(params: getRelationByTypeParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserRelationsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getRelationByType(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user friends from external social networks (for linked accounts)
         * @param {getSocialFriendsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialFriendsById(params: getSocialFriendsByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getSocialFriendsById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns random popular groups that user is not a member of
         * @param {getSuggestedGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedGroups(params: getSuggestedGroupsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserGroupsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getSuggestedGroups(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user threads
         * @param {getThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreads(params: getThreadsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserThreadsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getThreads(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user albums by user $id
         * @param {getUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAlbums(params: getUserAlbumsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserAlbumsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserAlbums(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user bookmarks by user $id
         * @param {getUserBookmarksParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBookmarks(params: getUserBookmarksParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserBookmarkResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserBookmarks(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user by id or username
         * @param {getUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(params: getUserByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserEntity> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get friends list of the user with sorted by birthdays [Deprecated - use getRelationsByType instead]
         * @param {getUserFriendsBirthdayParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFriendsBirthday(params: getUserFriendsBirthdayParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserFriendsBirthdayResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserFriendsBirthday(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {getUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(params: getUserGroupsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserGroupsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserGroups(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all user photos (privacy-permitting)
         * @param {getUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPhotos(params: getUserPhotosParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PhotosResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserPhotos(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user reports submitted by this user (not reports about them)
         * @param {getUserReportsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsById(params: getUserReportsByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserReportsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserReportsById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user tag
         * @param {getUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTag(params: getUserTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserTagsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user trips by user $id
         * @param {getUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrips(params: getUserTripsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserTripsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).getUserTrips(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Find user threads
         * @param {modGetThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreads(params: modGetThreadsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserThreadsResponse> {
            const localVarFetchArgs = UserFetchParamCreator(configuration).modGetThreads(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User id
 * @param {number} [limit] limit
 * @param {number} [offset] offset
 * @param {string} [order] order
 * @param {string} [sort] sort
*/
export type getCorrectionsUserParams = {
    id: string,
    limit?: number,
    offset?: number,
    order?: string,
    sort?: string,
}

/**
 * @param {string} id User id
 * @param {number} [limit] limit
 * @param {number} [offset] offset
 * @param {string} [order] order
*/
export type getEntriesUserParams = {
    id: string,
    limit?: number,
    offset?: number,
    order?: string,
}

/**
 * @param {string} id User id
 * @param {number} [limit] limit
 * @param {number} [offset] offset
 * @param {string} [order] order
 * @param {string} [sort] sort
*/
export type getPromptsUserParams = {
    id: string,
    limit?: number,
    offset?: number,
    order?: string,
    sort?: string,
}

/**
 * @param {string} id Id of the user
 * @param {'friends' | 'outgoing' | 'incoming' | 'blocked' | 'all'} type Type of the relations
 * @param {'birthday' | 'date-added'} [sort] Sort by condition
 * @param {'online'} [filter] Filter
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [extra] return extra, non-default fields
*/
export type getRelationByTypeParams = {
    id: string,
    type: 'friends' | 'outgoing' | 'incoming' | 'blocked' | 'all',
    sort?: 'birthday' | 'date-added',
    filter?: 'online',
    limit?: number,
    offset?: number,
    extra?: string,
}

/**
 * @param {string} id Id of the user
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getSocialFriendsByIdParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getSuggestedGroupsParams = {
    limit?: number,
    offset?: number,
}

/**
 * @param {boolean} [with_new_messages] Return threads with only new messages
 * @param {boolean} [online] Return online threads
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getThreadsParams = {
    with_new_messages?: boolean,
    online?: boolean,
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the specified
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [extra] return extra, non-default fields
 * @param {string} [fields] return only specified fields, csv
*/
export type getUserAlbumsParams = {
    id: string,
    limit?: number,
    offset?: number,
    extra?: string,
    fields?: string,
}

/**
 * @param {string} id $id of the specified
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getUserBookmarksParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User id or username
 * @param {string} [fields] return only specified fields, csv
 * @param {string} [extra] return extra, non-default fields
*/
export type getUserByIdParams = {
    id: string,
    fields?: string,
    extra?: string,
}

/**
 * @param {string} id Id of the user
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getUserFriendsBirthdayParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the user
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getUserGroupsParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id User id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
 * @param {string} [extra] return extra, non-default fields
 * @param {string} [fields] return only specified fields, csv
*/
export type getUserPhotosParams = {
    id: string,
    limit?: number,
    offset?: number,
    extra?: string,
    fields?: string,
}

/**
 * @param {string} id Reporting user uid
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getUserReportsByIdParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id Id of the user
*/
export type getUserTagParams = {
    id: string,
}

/**
 * @param {string} id Id of the specified
 * @param {number} [limit] Limit
 * @param {string} [type] type (upcoming|past|not specified)
 * @param {number} [offset] Offset
*/
export type getUserTripsParams = {
    id: string,
    limit?: number,
    type?: string,
    offset?: number,
}

/**
 * @param {string} id User id
 * @param {boolean} [with_new_messages] Return threads with only new messages
 * @param {boolean} [online] Return online threads
 * @param {string} [extra] return extra, non-default fields
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type modGetThreadsParams = {
    id: string,
    with_new_messages?: boolean,
    online?: boolean,
    extra?: string,
    limit?: number,
    offset?: number,
}

/**
 * User - factory interface
 * @export
 */
export const UserFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get corrections for user
         * @param {getCorrectionsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorrectionsUser(params: getCorrectionsUserParams, options?: any) {
            return UserFp(configuration).getCorrectionsUser(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get entries
         * @param {getEntriesUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntriesUser(params: getEntriesUserParams, options?: any) {
            return UserFp(configuration).getEntriesUser(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get prompts
         * @param {getPromptsUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptsUser(params: getPromptsUserParams, options?: any) {
            return UserFp(configuration).getPromptsUser(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get relation
         * @param {getRelationByTypeParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationByType(params: getRelationByTypeParams, options?: any) {
            return UserFp(configuration).getRelationByType(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user friends from external social networks (for linked accounts)
         * @param {getSocialFriendsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialFriendsById(params: getSocialFriendsByIdParams, options?: any) {
            return UserFp(configuration).getSocialFriendsById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns random popular groups that user is not a member of
         * @param {getSuggestedGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedGroups(params: getSuggestedGroupsParams, options?: any) {
            return UserFp(configuration).getSuggestedGroups(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user threads
         * @param {getThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreads(params: getThreadsParams, options?: any) {
            return UserFp(configuration).getThreads(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user albums by user $id
         * @param {getUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAlbums(params: getUserAlbumsParams, options?: any) {
            return UserFp(configuration).getUserAlbums(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user bookmarks by user $id
         * @param {getUserBookmarksParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBookmarks(params: getUserBookmarksParams, options?: any) {
            return UserFp(configuration).getUserBookmarks(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user by id or username
         * @param {getUserByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(params: getUserByIdParams, options?: any) {
            return UserFp(configuration).getUserById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get friends list of the user with sorted by birthdays [Deprecated - use getRelationsByType instead]
         * @param {getUserFriendsBirthdayParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFriendsBirthday(params: getUserFriendsBirthdayParams, options?: any) {
            return UserFp(configuration).getUserFriendsBirthday(params, options)(fetch, basePath);
        },
        /**
         * 
         * @param {getUserGroupsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(params: getUserGroupsParams, options?: any) {
            return UserFp(configuration).getUserGroups(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all user photos (privacy-permitting)
         * @param {getUserPhotosParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPhotos(params: getUserPhotosParams, options?: any) {
            return UserFp(configuration).getUserPhotos(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user reports submitted by this user (not reports about them)
         * @param {getUserReportsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReportsById(params: getUserReportsByIdParams, options?: any) {
            return UserFp(configuration).getUserReportsById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user tag
         * @param {getUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTag(params: getUserTagParams, options?: any) {
            return UserFp(configuration).getUserTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user trips by user $id
         * @param {getUserTripsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrips(params: getUserTripsParams, options?: any) {
            return UserFp(configuration).getUserTrips(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Find user threads
         * @param {modGetThreadsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetThreads(params: modGetThreadsParams, options?: any) {
            return UserFp(configuration).modGetThreads(params, options)(fetch, basePath);
        },
    };
};

/**
 * User - object-oriented interface
 * @export
 * @class User
 * @extends {BaseAPI}
 */
export class User extends BaseAPI {
    /**
     * 
     * @summary Get corrections for user
     * @param {getCorrectionsUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getCorrectionsUser(params: getCorrectionsUserParams, options?: any) {
        return UserFp(this.configuration).getCorrectionsUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get entries
     * @param {getEntriesUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getEntriesUser(params: getEntriesUserParams, options?: any) {
        return UserFp(this.configuration).getEntriesUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get prompts
     * @param {getPromptsUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getPromptsUser(params: getPromptsUserParams, options?: any) {
        return UserFp(this.configuration).getPromptsUser(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get relation
     * @param {getRelationByTypeParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getRelationByType(params: getRelationByTypeParams, options?: any) {
        return UserFp(this.configuration).getRelationByType(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user friends from external social networks (for linked accounts)
     * @param {getSocialFriendsByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getSocialFriendsById(params: getSocialFriendsByIdParams, options?: any) {
        return UserFp(this.configuration).getSocialFriendsById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns random popular groups that user is not a member of
     * @param {getSuggestedGroupsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getSuggestedGroups(params: getSuggestedGroupsParams, options?: any) {
        return UserFp(this.configuration).getSuggestedGroups(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user threads
     * @param {getThreadsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getThreads(params: getThreadsParams, options?: any) {
        return UserFp(this.configuration).getThreads(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user albums by user $id
     * @param {getUserAlbumsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserAlbums(params: getUserAlbumsParams, options?: any) {
        return UserFp(this.configuration).getUserAlbums(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user bookmarks by user $id
     * @param {getUserBookmarksParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserBookmarks(params: getUserBookmarksParams, options?: any) {
        return UserFp(this.configuration).getUserBookmarks(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user by id or username
     * @param {getUserByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserById(params: getUserByIdParams, options?: any) {
        return UserFp(this.configuration).getUserById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get friends list of the user with sorted by birthdays [Deprecated - use getRelationsByType instead]
     * @param {getUserFriendsBirthdayParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserFriendsBirthday(params: getUserFriendsBirthdayParams, options?: any) {
        return UserFp(this.configuration).getUserFriendsBirthday(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {getUserGroupsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserGroups(params: getUserGroupsParams, options?: any) {
        return UserFp(this.configuration).getUserGroups(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all user photos (privacy-permitting)
     * @param {getUserPhotosParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserPhotos(params: getUserPhotosParams, options?: any) {
        return UserFp(this.configuration).getUserPhotos(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user reports submitted by this user (not reports about them)
     * @param {getUserReportsByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserReportsById(params: getUserReportsByIdParams, options?: any) {
        return UserFp(this.configuration).getUserReportsById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user tag
     * @param {getUserTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserTag(params: getUserTagParams, options?: any) {
        return UserFp(this.configuration).getUserTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user trips by user $id
     * @param {getUserTripsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public getUserTrips(params: getUserTripsParams, options?: any) {
        return UserFp(this.configuration).getUserTrips(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Find user threads
     * @param {modGetThreadsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof User
     */
    public modGetThreads(params: modGetThreadsParams, options?: any) {
        return UserFp(this.configuration).modGetThreads(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserAbout - fetch parameter creator
 * @export
 */
export const UserAboutFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find user by $id
         * @param {getUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAboutById(params: getUserAboutByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserAboutById");
            }
            const localVarPath = `/user-about/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update profile by user id
         * @param {updateUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAboutById(params: updateUserAboutByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateUserAboutById");
            }
            const localVarPath = `/user-about/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.description !== undefined) {
                localVarFormParams.set('description', params.description as any);
            }

            if (params.langex_desc !== undefined) {
                localVarFormParams.set('langex_desc', params.langex_desc as any);
            }

            if (params.tv !== undefined) {
                localVarFormParams.set('tv', params.tv as any);
            }

            if (params.quotes !== undefined) {
                localVarFormParams.set('quotes', params.quotes as any);
            }

            if (params.movies !== undefined) {
                localVarFormParams.set('movies', params.movies as any);
            }

            if (params.music !== undefined) {
                localVarFormParams.set('music', params.music as any);
            }

            if (params.hobbies !== undefined) {
                localVarFormParams.set('hobbies', params.hobbies as any);
            }

            if (params.books !== undefined) {
                localVarFormParams.set('books', params.books as any);
            }

            if (params.requests !== undefined) {
                localVarFormParams.set('requests', params.requests as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAbout - functional programming interface
 * @export
 */
export const UserAboutFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find user by $id
         * @param {getUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAboutById(params: getUserAboutByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfilesTextEntity> {
            const localVarFetchArgs = UserAboutFetchParamCreator(configuration).getUserAboutById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update profile by user id
         * @param {updateUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAboutById(params: updateUserAboutByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountEntity> {
            const localVarFetchArgs = UserAboutFetchParamCreator(configuration).updateUserAboutById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id $id of the specified user
*/
export type getUserAboutByIdParams = {
    id: string,
}

/**
 * @param {string} id self or user id (if moderator)
 * @param {string} [description] description
 * @param {string} [langex_desc] langex_desc
 * @param {string} [tv] tv
 * @param {string} [quotes] quotes
 * @param {string} [movies] movies
 * @param {string} [music] music
 * @param {string} [hobbies] hobbies
 * @param {string} [books] books
 * @param {string} [requests] requests
*/
export type updateUserAboutByIdParams = {
    id: string,
    description?: string,
    langex_desc?: string,
    tv?: string,
    quotes?: string,
    movies?: string,
    music?: string,
    hobbies?: string,
    books?: string,
    requests?: string,
}

/**
 * UserAbout - factory interface
 * @export
 */
export const UserAboutFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Find user by $id
         * @param {getUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAboutById(params: getUserAboutByIdParams, options?: any) {
            return UserAboutFp(configuration).getUserAboutById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update profile by user id
         * @param {updateUserAboutByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAboutById(params: updateUserAboutByIdParams, options?: any) {
            return UserAboutFp(configuration).updateUserAboutById(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserAbout - object-oriented interface
 * @export
 * @class UserAbout
 * @extends {BaseAPI}
 */
export class UserAbout extends BaseAPI {
    /**
     * 
     * @summary Find user by $id
     * @param {getUserAboutByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAbout
     */
    public getUserAboutById(params: getUserAboutByIdParams, options?: any) {
        return UserAboutFp(this.configuration).getUserAboutById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update profile by user id
     * @param {updateUserAboutByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAbout
     */
    public updateUserAboutById(params: updateUserAboutByIdParams, options?: any) {
        return UserAboutFp(this.configuration).updateUserAboutById(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserCounters - fetch parameter creator
 * @export
 */
export const UserCountersFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get number of user albums
         * @param {getTotalUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUserAlbums(params: getTotalUserAlbumsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getTotalUserAlbums");
            }
            const localVarPath = `/total/{id}/albums`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user counters
         * @param {getUserCountersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCounters(options?: any): FetchArgs {
            const localVarPath = `/user-counters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserCounters - functional programming interface
 * @export
 */
export const UserCountersFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get number of user albums
         * @param {getTotalUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUserAlbums(params: getTotalUserAlbumsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalNumberResponse> {
            const localVarFetchArgs = UserCountersFetchParamCreator(configuration).getTotalUserAlbums(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get user counters
         * @param {getUserCountersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCounters(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserCountersEntity> {
            const localVarFetchArgs = UserCountersFetchParamCreator(configuration).getUserCounters(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User id or username
*/
export type getTotalUserAlbumsParams = {
    id: string,
}


/**
 * UserCounters - factory interface
 * @export
 */
export const UserCountersFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get number of user albums
         * @param {getTotalUserAlbumsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUserAlbums(params: getTotalUserAlbumsParams, options?: any) {
            return UserCountersFp(configuration).getTotalUserAlbums(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get user counters
         * @param {getUserCountersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCounters(options?: any) {
            return UserCountersFp(configuration).getUserCounters(options)(fetch, basePath);
        },
    };
};

/**
 * UserCounters - object-oriented interface
 * @export
 * @class UserCounters
 * @extends {BaseAPI}
 */
export class UserCounters extends BaseAPI {
    /**
     * 
     * @summary Get number of user albums
     * @param {getTotalUserAlbumsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCounters
     */
    public getTotalUserAlbums(params: getTotalUserAlbumsParams, options?: any) {
        return UserCountersFp(this.configuration).getTotalUserAlbums(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get user counters
     * @param {getUserCountersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCounters
     */
    public getUserCounters(options?: any) {
        return UserCountersFp(this.configuration).getUserCounters(options)(this.fetch, this.basePath);
    }

}

/**
 * UserLangs - fetch parameter creator
 * @export
 */
export const UserLangsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create user lang
         * @param {createUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserLang(params: createUserLangParams, options?: any): FetchArgs {
            // verify required parameter "params.lang_type" is set
            if (params.lang_type == null) {
                throw new Error("Missing required parameter 'lang_type' when calling createUserLang");
            }
            // verify required parameter "params.lang" is set
            if (params.lang == null) {
                throw new Error("Missing required parameter 'lang' when calling createUserLang");
            }
            // verify required parameter "params.level" is set
            if (params.level == null) {
                throw new Error("Missing required parameter 'level' when calling createUserLang");
            }
            const localVarPath = `/user-langs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.lang_type !== undefined) {
                localVarFormParams.set('lang_type', params.lang_type as any);
            }

            if (params.lang !== undefined) {
                localVarFormParams.set('lang', params.lang as any);
            }

            if (params.level !== undefined) {
                localVarFormParams.set('level', params.level as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user lang
         * @param {deleteUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserLang(params: deleteUserLangParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteUserLang");
            }
            // verify required parameter "params.lang_type" is set
            if (params.lang_type == null) {
                throw new Error("Missing required parameter 'lang_type' when calling deleteUserLang");
            }
            // verify required parameter "params.lang" is set
            if (params.lang == null) {
                throw new Error("Missing required parameter 'lang' when calling deleteUserLang");
            }
            const localVarPath = `/user-langs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.lang_type !== undefined) {
                localVarQueryParameter['lang_type'] = params.lang_type;
            }

            if (params.lang !== undefined) {
                localVarQueryParameter['lang'] = params.lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user language
         * @param {updateUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLang(params: updateUserLangParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateUserLang");
            }
            // verify required parameter "params.lang_type" is set
            if (params.lang_type == null) {
                throw new Error("Missing required parameter 'lang_type' when calling updateUserLang");
            }
            // verify required parameter "params.lang" is set
            if (params.lang == null) {
                throw new Error("Missing required parameter 'lang' when calling updateUserLang");
            }
            // verify required parameter "params.level" is set
            if (params.level == null) {
                throw new Error("Missing required parameter 'level' when calling updateUserLang");
            }
            const localVarPath = `/user-langs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.lang_type !== undefined) {
                localVarFormParams.set('lang_type', params.lang_type as any);
            }

            if (params.lang !== undefined) {
                localVarFormParams.set('lang', params.lang as any);
            }

            if (params.level !== undefined) {
                localVarFormParams.set('level', params.level as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLangs - functional programming interface
 * @export
 */
export const UserLangsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create user lang
         * @param {createUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserLang(params: createUserLangParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguageEntity> {
            const localVarFetchArgs = UserLangsFetchParamCreator(configuration).createUserLang(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete user lang
         * @param {deleteUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserLang(params: deleteUserLangParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UserLangsFetchParamCreator(configuration).deleteUserLang(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update user language
         * @param {updateUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLang(params: updateUserLangParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LanguageEntity> {
            const localVarFetchArgs = UserLangsFetchParamCreator(configuration).updateUserLang(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {'know' | 'learn'} lang_type Type of language (know or learn)
 * @param {string} lang lang (RU,EN,...)
 * @param {number} level level of knowledge
*/
export type createUserLangParams = {
    lang_type: 'know' | 'learn',
    lang: string,
    level: number,
}

/**
 * @param {string} id $id of the specified user
 * @param {'know' | 'learn'} lang_type Type of language (know or learn)
 * @param {string} lang $lang of the specified user
*/
export type deleteUserLangParams = {
    id: string,
    lang_type: 'know' | 'learn',
    lang: string,
}

/**
 * @param {string} id $id of the specified user
 * @param {'know' | 'learn'} lang_type Type of language (know or learn)
 * @param {string} lang lang (RU,EN,...)
 * @param {number} level level of knowledge
*/
export type updateUserLangParams = {
    id: string,
    lang_type: 'know' | 'learn',
    lang: string,
    level: number,
}

/**
 * UserLangs - factory interface
 * @export
 */
export const UserLangsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create user lang
         * @param {createUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserLang(params: createUserLangParams, options?: any) {
            return UserLangsFp(configuration).createUserLang(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete user lang
         * @param {deleteUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserLang(params: deleteUserLangParams, options?: any) {
            return UserLangsFp(configuration).deleteUserLang(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update user language
         * @param {updateUserLangParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLang(params: updateUserLangParams, options?: any) {
            return UserLangsFp(configuration).updateUserLang(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserLangs - object-oriented interface
 * @export
 * @class UserLangs
 * @extends {BaseAPI}
 */
export class UserLangs extends BaseAPI {
    /**
     * 
     * @summary Create user lang
     * @param {createUserLangParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLangs
     */
    public createUserLang(params: createUserLangParams, options?: any) {
        return UserLangsFp(this.configuration).createUserLang(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete user lang
     * @param {deleteUserLangParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLangs
     */
    public deleteUserLang(params: deleteUserLangParams, options?: any) {
        return UserLangsFp(this.configuration).deleteUserLang(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update user language
     * @param {updateUserLangParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLangs
     */
    public updateUserLang(params: updateUserLangParams, options?: any) {
        return UserLangsFp(this.configuration).updateUserLang(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserMatchSettings - fetch parameter creator
 * @export
 */
export const UserMatchSettingsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update user match settings
         * @param {updateUserMatchSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserMatchSettings(params: updateUserMatchSettingsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateUserMatchSettings");
            }
            const localVarPath = `/user-match-settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.allowed_sex !== undefined) {
                localVarFormParams.set('allowed_sex', params.allowed_sex as any);
            }

            if (params.allowed_age !== undefined) {
                localVarFormParams.set('allowed_age', params.allowed_age as any);
            }

            if (params.allowed_countries !== undefined) {
                localVarFormParams.set('allowed_countries', params.allowed_countries as any);
            }

            if (params.allowed_languages !== undefined) {
                localVarFormParams.set('allowed_languages', params.allowed_languages as any);
            }

            if (params.native_speakers_only !== undefined) {
                localVarFormParams.set('native_speakers_only', params.native_speakers_only as any);
            }

            if (params.lfor !== undefined) {
                localVarFormParams.set('lfor', params.lfor as any);
            }

            if (params.enabled_filters !== undefined) {
                localVarFormParams.set('enabled_filters', params.enabled_filters as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMatchSettings - functional programming interface
 * @export
 */
export const UserMatchSettingsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update user match settings
         * @param {updateUserMatchSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserMatchSettings(params: updateUserMatchSettingsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserMatchSettingsEntity> {
            const localVarFetchArgs = UserMatchSettingsFetchParamCreator(configuration).updateUserMatchSettings(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id self or user id (if moderator)
 * @param {string} [allowed_sex] Sex (male/female)
 * @param {string} [allowed_age] Min,Max allowed age
 * @param {string} [allowed_countries] Whitelisted countries
 * @param {string} [allowed_languages] Whitelisted languages
 * @param {boolean} [native_speakers_only] It will be match to native speakers only?
 * @param {string} [lfor] Looking for. Available values: snail,langex,relation,friend,meet. CSV.
 * @param {boolean} [enabled_filters] Enable or disable this settings
*/
export type updateUserMatchSettingsParams = {
    id: string,
    allowed_sex?: string,
    allowed_age?: string,
    allowed_countries?: string,
    allowed_languages?: string,
    native_speakers_only?: boolean,
    lfor?: string,
    enabled_filters?: boolean,
}

/**
 * UserMatchSettings - factory interface
 * @export
 */
export const UserMatchSettingsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Update user match settings
         * @param {updateUserMatchSettingsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserMatchSettings(params: updateUserMatchSettingsParams, options?: any) {
            return UserMatchSettingsFp(configuration).updateUserMatchSettings(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserMatchSettings - object-oriented interface
 * @export
 * @class UserMatchSettings
 * @extends {BaseAPI}
 */
export class UserMatchSettings extends BaseAPI {
    /**
     * 
     * @summary Update user match settings
     * @param {updateUserMatchSettingsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMatchSettings
     */
    public updateUserMatchSettings(params: updateUserMatchSettingsParams, options?: any) {
        return UserMatchSettingsFp(this.configuration).updateUserMatchSettings(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserStatus - fetch parameter creator
 * @export
 */
export const UserStatusFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update user status message
         * @param {updateUserStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(params: updateUserStatusParams, options?: any): FetchArgs {
            // verify required parameter "params.message" is set
            if (params.message == null) {
                throw new Error("Missing required parameter 'message' when calling updateUserStatus");
            }
            const localVarPath = `/user-status/self`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.message !== undefined) {
                localVarFormParams.set('message', params.message as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserStatus - functional programming interface
 * @export
 */
export const UserStatusFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update user status message
         * @param {updateUserStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(params: updateUserStatusParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserStatusEntity> {
            const localVarFetchArgs = UserStatusFetchParamCreator(configuration).updateUserStatus(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} message Set user status message, use empty string to delete existing status message
*/
export type updateUserStatusParams = {
    message: string,
}

/**
 * UserStatus - factory interface
 * @export
 */
export const UserStatusFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Update user status message
         * @param {updateUserStatusParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(params: updateUserStatusParams, options?: any) {
            return UserStatusFp(configuration).updateUserStatus(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserStatus - object-oriented interface
 * @export
 * @class UserStatus
 * @extends {BaseAPI}
 */
export class UserStatus extends BaseAPI {
    /**
     * 
     * @summary Update user status message
     * @param {updateUserStatusParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStatus
     */
    public updateUserStatus(params: updateUserStatusParams, options?: any) {
        return UserStatusFp(this.configuration).updateUserStatus(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserTag - fetch parameter creator
 * @export
 */
export const UserTagFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Add user interest tag
         * @param {createUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTag(params: createUserTagParams, options?: any): FetchArgs {
            const localVarPath = `/user-tag`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.tag_id !== undefined) {
                localVarFormParams.set('tag_id', params.tag_id as any);
            }

            if (params.tag_ids !== undefined) {
                localVarFormParams.set('tag_ids', params.tag_ids as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Delete user interest tag
         * @param {deleteUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTag(params: deleteUserTagParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteUserTag");
            }
            const localVarPath = `/user-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set user interest tags
         * @param {updateUserTagsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTags(params: updateUserTagsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling updateUserTags");
            }
            const localVarPath = `/user-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.tag_ids !== undefined) {
                localVarFormParams.set('tag_ids', params.tag_ids as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTag - functional programming interface
 * @export
 */
export const UserTagFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Add user interest tag
         * @param {createUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTag(params: createUserTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserTagsResponse> {
            const localVarFetchArgs = UserTagFetchParamCreator(configuration).createUserTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Delete user interest tag
         * @param {deleteUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTag(params: deleteUserTagParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UserTagFetchParamCreator(configuration).deleteUserTag(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Set user interest tags
         * @param {updateUserTagsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTags(params: updateUserTagsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserTagsResponse> {
            const localVarFetchArgs = UserTagFetchParamCreator(configuration).updateUserTags(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} [tag_id] Tag id or CSV of tag ids: DEPRECATED
 * @param {string} [tag_ids] Tag id or CSV of tag ids: will be required after tag_id is removed
*/
export type createUserTagParams = {
    tag_id?: string,
    tag_ids?: string,
}

/**
 * @param {string} id Tag id or CSV of tag ids
*/
export type deleteUserTagParams = {
    id: string,
}

/**
 * @param {string} id user id or self
 * @param {string} [tag_ids] CSV of user interest tags, any existing ones not included here will be deleted
*/
export type updateUserTagsParams = {
    id: string,
    tag_ids?: string,
}

/**
 * UserTag - factory interface
 * @export
 */
export const UserTagFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Add user interest tag
         * @param {createUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTag(params: createUserTagParams, options?: any) {
            return UserTagFp(configuration).createUserTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary DEPRECATED (use updateUserTags): Delete user interest tag
         * @param {deleteUserTagParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTag(params: deleteUserTagParams, options?: any) {
            return UserTagFp(configuration).deleteUserTag(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Set user interest tags
         * @param {updateUserTagsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserTags(params: updateUserTagsParams, options?: any) {
            return UserTagFp(configuration).updateUserTags(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserTag - object-oriented interface
 * @export
 * @class UserTag
 * @extends {BaseAPI}
 */
export class UserTag extends BaseAPI {
    /**
     * 
     * @summary DEPRECATED (use updateUserTags): Add user interest tag
     * @param {createUserTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTag
     */
    public createUserTag(params: createUserTagParams, options?: any) {
        return UserTagFp(this.configuration).createUserTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary DEPRECATED (use updateUserTags): Delete user interest tag
     * @param {deleteUserTagParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTag
     */
    public deleteUserTag(params: deleteUserTagParams, options?: any) {
        return UserTagFp(this.configuration).deleteUserTag(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Set user interest tags
     * @param {updateUserTagsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTag
     */
    public updateUserTags(params: updateUserTagsParams, options?: any) {
        return UserTagFp(this.configuration).updateUserTags(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserThread - fetch parameter creator
 * @export
 */
export const UserThreadFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get messages thread by user id
         * @param {getUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserThreadById(params: getUserThreadByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getUserThreadById");
            }
            const localVarPath = `/user-thread/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get messages thread by user id
         * @param {modGetUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetUserThreadById(params: modGetUserThreadByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling modGetUserThreadById");
            }
            // verify required parameter "params.owner_id" is set
            if (params.owner_id == null) {
                throw new Error("Missing required parameter 'owner_id' when calling modGetUserThreadById");
            }
            const localVarPath = `/mod-user-thread/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.owner_id !== undefined) {
                localVarQueryParameter['owner_id'] = params.owner_id;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserThread - functional programming interface
 * @export
 */
export const UserThreadFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get messages thread by user id
         * @param {getUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserThreadById(params: getUserThreadByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadEntity> {
            const localVarFetchArgs = UserThreadFetchParamCreator(configuration).getUserThreadById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get messages thread by user id
         * @param {modGetUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetUserThreadById(params: modGetUserThreadByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ThreadEntity> {
            const localVarFetchArgs = UserThreadFetchParamCreator(configuration).modGetUserThreadById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id User id
 * @param {string} [extra] return extra, non-default fields
*/
export type getUserThreadByIdParams = {
    id: string,
    extra?: string,
}

/**
 * @param {string} id Contact id
 * @param {string} owner_id User (owner) id
 * @param {string} [extra] return extra, non-default fields
*/
export type modGetUserThreadByIdParams = {
    id: string,
    owner_id: string,
    extra?: string,
}

/**
 * UserThread - factory interface
 * @export
 */
export const UserThreadFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get messages thread by user id
         * @param {getUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserThreadById(params: getUserThreadByIdParams, options?: any) {
            return UserThreadFp(configuration).getUserThreadById(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get messages thread by user id
         * @param {modGetUserThreadByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modGetUserThreadById(params: modGetUserThreadByIdParams, options?: any) {
            return UserThreadFp(configuration).modGetUserThreadById(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserThread - object-oriented interface
 * @export
 * @class UserThread
 * @extends {BaseAPI}
 */
export class UserThread extends BaseAPI {
    /**
     * 
     * @summary Get messages thread by user id
     * @param {getUserThreadByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserThread
     */
    public getUserThreadById(params: getUserThreadByIdParams, options?: any) {
        return UserThreadFp(this.configuration).getUserThreadById(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get messages thread by user id
     * @param {modGetUserThreadByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserThread
     */
    public modGetUserThreadById(params: modGetUserThreadByIdParams, options?: any) {
        return UserThreadFp(this.configuration).modGetUserThreadById(params, options)(this.fetch, this.basePath);
    }

}

/**
 * UserWarning - fetch parameter creator
 * @export
 */
export const UserWarningFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send warning to user, archive all reports on this user
         * @param {sendWarningToUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWarningToUser(params: sendWarningToUserParams, options?: any): FetchArgs {
            // verify required parameter "params.user_id" is set
            if (params.user_id == null) {
                throw new Error("Missing required parameter 'user_id' when calling sendWarningToUser");
            }
            // verify required parameter "params.warning_id" is set
            if (params.warning_id == null) {
                throw new Error("Missing required parameter 'warning_id' when calling sendWarningToUser");
            }
            const localVarPath = `/user-warning`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.user_id !== undefined) {
                localVarFormParams.set('user_id', params.user_id as any);
            }

            if (params.warning_id !== undefined) {
                localVarFormParams.set('warning_id', params.warning_id as any);
            }

            if (params.log_msg !== undefined) {
                localVarFormParams.set('log_msg', params.log_msg as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserWarning - functional programming interface
 * @export
 */
export const UserWarningFp = function(configuration?: Configuration) {
    return {
        /**
         * Send warning to user, archive all reports on this user
         * @param {sendWarningToUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWarningToUser(params: sendWarningToUserParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ModActionLogEntity> {
            const localVarFetchArgs = UserWarningFetchParamCreator(configuration).sendWarningToUser(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} user_id 
 * @param {string} warning_id 
 * @param {string} [log_msg] 
*/
export type sendWarningToUserParams = {
    user_id: string,
    warning_id: string,
    log_msg?: string,
}

/**
 * UserWarning - factory interface
 * @export
 */
export const UserWarningFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Send warning to user, archive all reports on this user
         * @param {sendWarningToUserParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWarningToUser(params: sendWarningToUserParams, options?: any) {
            return UserWarningFp(configuration).sendWarningToUser(params, options)(fetch, basePath);
        },
    };
};

/**
 * UserWarning - object-oriented interface
 * @export
 * @class UserWarning
 * @extends {BaseAPI}
 */
export class UserWarning extends BaseAPI {
    /**
     * Send warning to user, archive all reports on this user
     * @param {sendWarningToUserParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserWarning
     */
    public sendWarningToUser(params: sendWarningToUserParams, options?: any) {
        return UserWarningFp(this.configuration).sendWarningToUser(params, options)(this.fetch, this.basePath);
    }

}

/**
 * Views - fetch parameter creator
 * @export
 */
export const ViewsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete view: users can only delete views from viewers who viewed them - not vice versa
         * @param {deleteViewParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteView(params: deleteViewParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling deleteView");
            }
            const localVarPath = `/views/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recently viewed users
         * @param {getRecentlyViewedUsersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentlyViewedUsers(params: getRecentlyViewedUsersParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getRecentlyViewedUsers");
            }
            const localVarPath = `/views/{id}/recently-viewed`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get views by $id
         * @param {getViewsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViews(params: getViewsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getViews");
            }
            const localVarPath = `/views/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            if (params.limit !== undefined) {
                localVarQueryParameter['limit'] = params.limit;
            }

            if (params.offset !== undefined) {
                localVarQueryParameter['offset'] = params.offset;
            }

            if (params.skipReset !== undefined) {
                localVarQueryParameter['skipReset'] = params.skipReset;
            }

            if (params.extra !== undefined) {
                localVarQueryParameter['extra'] = params.extra;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdDeprecatedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsByIdDeprecated(params: resetViewsByIdDeprecatedParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resetViewsByIdDeprecated");
            }
            const localVarPath = `/views/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Views - functional programming interface
 * @export
 */
export const ViewsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete view: users can only delete views from viewers who viewed them - not vice versa
         * @param {deleteViewParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteView(params: deleteViewParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ViewsFetchParamCreator(configuration).deleteView(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get recently viewed users
         * @param {getRecentlyViewedUsersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentlyViewedUsers(params: getRecentlyViewedUsersParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RecentlyViewedResponse> {
            const localVarFetchArgs = ViewsFetchParamCreator(configuration).getRecentlyViewedUsers(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get views by $id
         * @param {getViewsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViews(params: getViewsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfileViewResponse> {
            const localVarFetchArgs = ViewsFetchParamCreator(configuration).getViews(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdDeprecatedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsByIdDeprecated(params: resetViewsByIdDeprecatedParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ViewsFetchParamCreator(configuration).resetViewsByIdDeprecated(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id Id of the target user
*/
export type deleteViewParams = {
    id: string,
}

/**
 * @param {string} id User ID of viewer
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset
*/
export type getRecentlyViewedUsersParams = {
    id: string,
    limit?: number,
    offset?: number,
}

/**
 * @param {string} id id
 * @param {number} [limit] Limit
 * @param {number} [offset] Offset of the page
 * @param {boolean} [skipReset] DEPRECATED: Whether to skip recent viewer counter reset
 * @param {string} [extra] return extra, non-default fields
*/
export type getViewsParams = {
    id: string,
    limit?: number,
    offset?: number,
    skipReset?: boolean,
    extra?: string,
}

/**
 * @param {string} id Id of the target user
*/
export type resetViewsByIdDeprecatedParams = {
    id: string,
}

/**
 * Views - factory interface
 * @export
 */
export const ViewsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Delete view: users can only delete views from viewers who viewed them - not vice versa
         * @param {deleteViewParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteView(params: deleteViewParams, options?: any) {
            return ViewsFp(configuration).deleteView(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get recently viewed users
         * @param {getRecentlyViewedUsersParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentlyViewedUsers(params: getRecentlyViewedUsersParams, options?: any) {
            return ViewsFp(configuration).getRecentlyViewedUsers(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get views by $id
         * @param {getViewsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViews(params: getViewsParams, options?: any) {
            return ViewsFp(configuration).getViews(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdDeprecatedParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsByIdDeprecated(params: resetViewsByIdDeprecatedParams, options?: any) {
            return ViewsFp(configuration).resetViewsByIdDeprecated(params, options)(fetch, basePath);
        },
    };
};

/**
 * Views - object-oriented interface
 * @export
 * @class Views
 * @extends {BaseAPI}
 */
export class Views extends BaseAPI {
    /**
     * 
     * @summary Delete view: users can only delete views from viewers who viewed them - not vice versa
     * @param {deleteViewParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Views
     */
    public deleteView(params: deleteViewParams, options?: any) {
        return ViewsFp(this.configuration).deleteView(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get recently viewed users
     * @param {getRecentlyViewedUsersParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Views
     */
    public getRecentlyViewedUsers(params: getRecentlyViewedUsersParams, options?: any) {
        return ViewsFp(this.configuration).getRecentlyViewedUsers(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get views by $id
     * @param {getViewsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Views
     */
    public getViews(params: getViewsParams, options?: any) {
        return ViewsFp(this.configuration).getViews(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary reset views
     * @param {resetViewsByIdDeprecatedParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Views
     */
    public resetViewsByIdDeprecated(params: resetViewsByIdDeprecatedParams, options?: any) {
        return ViewsFp(this.configuration).resetViewsByIdDeprecated(params, options)(this.fetch, this.basePath);
    }

}

/**
 * ViewsStats - fetch parameter creator
 * @export
 */
export const ViewsStatsFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get views stats by $id
         * @param {getViewsStatsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewsStats(params: getViewsStatsParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling getViewsStats");
            }
            const localVarPath = `/views-stats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsById(params: resetViewsByIdParams, options?: any): FetchArgs {
            // verify required parameter "params.id" is set
            if (params.id == null) {
                throw new Error("Missing required parameter 'id' when calling resetViewsById");
            }
            const localVarPath = `/views-stats/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(params.id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("X-AUTH-TOKEN")
					: configuration.apiKey;
                if (localVarApiKeyValue !== undefined) {
                    localVarHeaderParameter["X-AUTH-TOKEN"] = localVarApiKeyValue;
                }
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options?.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, { ...localVarHeaderParameter, ...configuration.headers }, options?.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewsStats - functional programming interface
 * @export
 */
export const ViewsStatsFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get views stats by $id
         * @param {getViewsStatsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewsStats(params: getViewsStatsParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ViewsStatEntity> {
            const localVarFetchArgs = ViewsStatsFetchParamCreator(configuration).getViewsStats(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsById(params: resetViewsByIdParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ViewsStatsFetchParamCreator(configuration).resetViewsById(params, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};


/**
 * @param {string} id id
*/
export type getViewsStatsParams = {
    id: string,
}

/**
 * @param {string} id Self or user id
*/
export type resetViewsByIdParams = {
    id: string,
}

/**
 * ViewsStats - factory interface
 * @export
 */
export const ViewsStatsFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get views stats by $id
         * @param {getViewsStatsParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewsStats(params: getViewsStatsParams, options?: any) {
            return ViewsStatsFp(configuration).getViewsStats(params, options)(fetch, basePath);
        },
        /**
         * 
         * @summary reset views
         * @param {resetViewsByIdParams} [params]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetViewsById(params: resetViewsByIdParams, options?: any) {
            return ViewsStatsFp(configuration).resetViewsById(params, options)(fetch, basePath);
        },
    };
};

/**
 * ViewsStats - object-oriented interface
 * @export
 * @class ViewsStats
 * @extends {BaseAPI}
 */
export class ViewsStats extends BaseAPI {
    /**
     * 
     * @summary Get views stats by $id
     * @param {getViewsStatsParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewsStats
     */
    public getViewsStats(params: getViewsStatsParams, options?: any) {
        return ViewsStatsFp(this.configuration).getViewsStats(params, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary reset views
     * @param {resetViewsByIdParams} [params]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewsStats
     */
    public resetViewsById(params: resetViewsByIdParams, options?: any) {
        return ViewsStatsFp(this.configuration).resetViewsById(params, options)(this.fetch, this.basePath);
    }

}

